function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9a76"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9a76"] = parcelRequire;
}
parcelRequire.register("f3ZL4", function(module, exports) {

$parcel$export(module.exports, "default", () => $af770abdaf769dee$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");

var $kcGKx = parcelRequire("kcGKx");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $2mpFt.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $kcGKx.default);
var $af770abdaf769dee$export$2e2bcd8739ae039 = isBuffer;

});
parcelRequire.register("2mpFt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b818bf49f333098$export$2e2bcd8739ae039);

var $4kWvg = parcelRequire("4kWvg");
/** Detect free variable `self`. */ var $1b818bf49f333098$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1b818bf49f333098$var$root = (0, $4kWvg.default) || $1b818bf49f333098$var$freeSelf || Function("return this")();
var $1b818bf49f333098$export$2e2bcd8739ae039 = $1b818bf49f333098$var$root;

});
parcelRequire.register("4kWvg", function(module, exports) {

$parcel$export(module.exports, "default", () => $32866938ab70cc57$export$2e2bcd8739ae039);
/** Detect free variable `global` from Node.js. */ var $32866938ab70cc57$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $32866938ab70cc57$export$2e2bcd8739ae039 = $32866938ab70cc57$var$freeGlobal;

});


parcelRequire.register("kcGKx", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb5616d4c933d058$export$2e2bcd8739ae039);
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $eb5616d4c933d058$var$stubFalse() {
    return false;
}
var $eb5616d4c933d058$export$2e2bcd8739ae039 = $eb5616d4c933d058$var$stubFalse;

});


parcelRequire.register("lFXqE", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc7b86a02b9b077f$export$2e2bcd8739ae039);

var $4kWvg = parcelRequire("4kWvg");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $4kWvg.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
var $fc7b86a02b9b077f$export$2e2bcd8739ae039 = nodeUtil;

});

parcelRequire.register("gqoYg", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf5271c040a1f410$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $2mpFt.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $bf5271c040a1f410$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRequire.register("f1q41", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['’]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "Ā": "A",
        "Ă": "A",
        "Ą": "A",
        "ā": "a",
        "ă": "a",
        "ą": "a",
        "Ć": "C",
        "Ĉ": "C",
        "Ċ": "C",
        "Č": "C",
        "ć": "c",
        "ĉ": "c",
        "ċ": "c",
        "č": "c",
        "Ď": "D",
        "Đ": "D",
        "ď": "d",
        "đ": "d",
        "Ē": "E",
        "Ĕ": "E",
        "Ė": "E",
        "Ę": "E",
        "Ě": "E",
        "ē": "e",
        "ĕ": "e",
        "ė": "e",
        "ę": "e",
        "ě": "e",
        "Ĝ": "G",
        "Ğ": "G",
        "Ġ": "G",
        "Ģ": "G",
        "ĝ": "g",
        "ğ": "g",
        "ġ": "g",
        "ģ": "g",
        "Ĥ": "H",
        "Ħ": "H",
        "ĥ": "h",
        "ħ": "h",
        "Ĩ": "I",
        "Ī": "I",
        "Ĭ": "I",
        "Į": "I",
        "İ": "I",
        "ĩ": "i",
        "ī": "i",
        "ĭ": "i",
        "į": "i",
        "ı": "i",
        "Ĵ": "J",
        "ĵ": "j",
        "Ķ": "K",
        "ķ": "k",
        "ĸ": "k",
        "Ĺ": "L",
        "Ļ": "L",
        "Ľ": "L",
        "Ŀ": "L",
        "Ł": "L",
        "ĺ": "l",
        "ļ": "l",
        "ľ": "l",
        "ŀ": "l",
        "ł": "l",
        "Ń": "N",
        "Ņ": "N",
        "Ň": "N",
        "Ŋ": "N",
        "ń": "n",
        "ņ": "n",
        "ň": "n",
        "ŋ": "n",
        "Ō": "O",
        "Ŏ": "O",
        "Ő": "O",
        "ō": "o",
        "ŏ": "o",
        "ő": "o",
        "Ŕ": "R",
        "Ŗ": "R",
        "Ř": "R",
        "ŕ": "r",
        "ŗ": "r",
        "ř": "r",
        "Ś": "S",
        "Ŝ": "S",
        "Ş": "S",
        "Š": "S",
        "ś": "s",
        "ŝ": "s",
        "ş": "s",
        "š": "s",
        "Ţ": "T",
        "Ť": "T",
        "Ŧ": "T",
        "ţ": "t",
        "ť": "t",
        "ŧ": "t",
        "Ũ": "U",
        "Ū": "U",
        "Ŭ": "U",
        "Ů": "U",
        "Ű": "U",
        "Ų": "U",
        "ũ": "u",
        "ū": "u",
        "ŭ": "u",
        "ů": "u",
        "ű": "u",
        "ų": "u",
        "Ŵ": "W",
        "ŵ": "w",
        "Ŷ": "Y",
        "ŷ": "y",
        "Ÿ": "Y",
        "Ź": "Z",
        "Ż": "Z",
        "Ž": "Z",
        "ź": "z",
        "ż": "z",
        "ž": "z",
        "Ĳ": "IJ",
        "ĳ": "ij",
        "Œ": "Oe",
        "œ": "oe",
        "ŉ": "'n",
        "ſ": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

"use strict";
"use strict";
var $ca3e1754e676956d$exports = {};
"use strict";
var $55b335199d6e6d5d$exports = {};
"use strict";
var $55b335199d6e6d5d$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$55b335199d6e6d5d$exports = // eslint-disable-next-line es/no-global-this -- safe
$55b335199d6e6d5d$var$check(typeof globalThis == "object" && globalThis) || $55b335199d6e6d5d$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$55b335199d6e6d5d$var$check(typeof self == "object" && self) || $55b335199d6e6d5d$var$check(typeof $parcel$global == "object" && $parcel$global) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || $55b335199d6e6d5d$exports || Function("return this")();


// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $6d99163b6684d050$export$2d1720544b23b823;
"use strict";
var $ef322a7f89c3ed41$exports = {};
"use strict";
var $6140c9fa18232846$exports = {};
"use strict";
$6140c9fa18232846$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$ef322a7f89c3ed41$exports = !$6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $881ad37dbe259e8f$exports = {};
"use strict";
var $bcbe62e89adc7d37$exports = {};
"use strict";

$bcbe62e89adc7d37$exports = !$6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});


var $881ad37dbe259e8f$var$call = Function.prototype.call;
$881ad37dbe259e8f$exports = $bcbe62e89adc7d37$exports ? $881ad37dbe259e8f$var$call.bind($881ad37dbe259e8f$var$call) : function() {
    return $881ad37dbe259e8f$var$call.apply($881ad37dbe259e8f$var$call, arguments);
};


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $1e0782be6903ea7b$export$2d1720544b23b823;
"use strict";
var $1e0782be6903ea7b$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $1e0782be6903ea7b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $1e0782be6903ea7b$var$NASHORN_BUG = $1e0782be6903ea7b$var$getOwnPropertyDescriptor && !$1e0782be6903ea7b$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$1e0782be6903ea7b$export$2d1720544b23b823 = $1e0782be6903ea7b$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $1e0782be6903ea7b$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $1e0782be6903ea7b$var$$propertyIsEnumerable;


var $b66966b48674609b$exports = {};
"use strict";
$b66966b48674609b$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $4d273c9d7e1bdf46$exports = {};
"use strict";
var $8239f4c7c6082668$exports = {};
"use strict";
var $43b18aa2f1faac44$exports = {};
"use strict";

var $43b18aa2f1faac44$var$FunctionPrototype = Function.prototype;
var $43b18aa2f1faac44$var$call = $43b18aa2f1faac44$var$FunctionPrototype.call;
var $43b18aa2f1faac44$var$uncurryThisWithBind = $bcbe62e89adc7d37$exports && $43b18aa2f1faac44$var$FunctionPrototype.bind.bind($43b18aa2f1faac44$var$call, $43b18aa2f1faac44$var$call);
$43b18aa2f1faac44$exports = $bcbe62e89adc7d37$exports ? $43b18aa2f1faac44$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $43b18aa2f1faac44$var$call.apply(fn, arguments);
    };
};



var $b0ba63bfbfb16088$exports = {};
"use strict";

var $b0ba63bfbfb16088$var$toString = $43b18aa2f1faac44$exports({}.toString);
var $b0ba63bfbfb16088$var$stringSlice = $43b18aa2f1faac44$exports("".slice);
$b0ba63bfbfb16088$exports = function(it) {
    return $b0ba63bfbfb16088$var$stringSlice($b0ba63bfbfb16088$var$toString(it), 8, -1);
};


var $8239f4c7c6082668$var$$Object = Object;
var $8239f4c7c6082668$var$split = $43b18aa2f1faac44$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$8239f4c7c6082668$exports = $6140c9fa18232846$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$8239f4c7c6082668$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $b0ba63bfbfb16088$exports(it) === "String" ? $8239f4c7c6082668$var$split(it, "") : $8239f4c7c6082668$var$$Object(it);
} : $8239f4c7c6082668$var$$Object;


var $c378177673193450$exports = {};
"use strict";
var $7ce250ddf7b42d4d$exports = {};
"use strict";
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$7ce250ddf7b42d4d$exports = function(it) {
    return it === null || it === undefined;
};


var $c378177673193450$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$c378177673193450$exports = function(it) {
    if ($7ce250ddf7b42d4d$exports(it)) throw new $c378177673193450$var$$TypeError("Can't call method on " + it);
    return it;
};


$4d273c9d7e1bdf46$exports = function(it) {
    return $8239f4c7c6082668$exports($c378177673193450$exports(it));
};


var $7f19acfe53927f5c$exports = {};
"use strict";
var $8ffb6b36a733d3c0$exports = {};
"use strict";

var $6a130d390db46c8e$exports = {};
"use strict";
var $70e34a5a2021f756$exports = {};
"use strict";
var $910be17eaa566f2e$exports = {};
"use strict";
var $910be17eaa566f2e$var$documentAll = typeof document == "object" && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var $910be17eaa566f2e$var$IS_HTMLDDA = typeof $910be17eaa566f2e$var$documentAll == "undefined" && $910be17eaa566f2e$var$documentAll !== undefined;
$910be17eaa566f2e$exports = {
    all: $910be17eaa566f2e$var$documentAll,
    IS_HTMLDDA: $910be17eaa566f2e$var$IS_HTMLDDA
};


var $70e34a5a2021f756$var$documentAll = $910be17eaa566f2e$exports.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
$70e34a5a2021f756$exports = $910be17eaa566f2e$exports.IS_HTMLDDA ? function(argument) {
    return typeof argument == "function" || argument === $70e34a5a2021f756$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};



var $6a130d390db46c8e$var$documentAll = $910be17eaa566f2e$exports.all;
$6a130d390db46c8e$exports = $910be17eaa566f2e$exports.IS_HTMLDDA ? function(it) {
    return typeof it == "object" ? it !== null : $70e34a5a2021f756$exports(it) || it === $6a130d390db46c8e$var$documentAll;
} : function(it) {
    return typeof it == "object" ? it !== null : $70e34a5a2021f756$exports(it);
};


var $0b429cc7792c7d26$exports = {};
"use strict";
var $a5217dbd1b0d33ce$exports = {};
"use strict";


var $a5217dbd1b0d33ce$var$aFunction = function(argument) {
    return $70e34a5a2021f756$exports(argument) ? argument : undefined;
};
$a5217dbd1b0d33ce$exports = function(namespace, method) {
    return arguments.length < 2 ? $a5217dbd1b0d33ce$var$aFunction($55b335199d6e6d5d$exports[namespace]) : $55b335199d6e6d5d$exports[namespace] && $55b335199d6e6d5d$exports[namespace][method];
};



var $41cc576e850a251e$exports = {};
"use strict";

$41cc576e850a251e$exports = $43b18aa2f1faac44$exports({}.isPrototypeOf);


var $47f18b427c2fbabf$exports = {};
"use strict";
var $4a39565fee8fe980$exports = {};
"use strict";
var $998d968a5e32cd49$exports = {};
"use strict";

var $492c6dc902f2bf18$exports = {};
"use strict";
$492c6dc902f2bf18$exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";


var $998d968a5e32cd49$var$process = $55b335199d6e6d5d$exports.process;
var $998d968a5e32cd49$var$Deno = $55b335199d6e6d5d$exports.Deno;
var $998d968a5e32cd49$var$versions = $998d968a5e32cd49$var$process && $998d968a5e32cd49$var$process.versions || $998d968a5e32cd49$var$Deno && $998d968a5e32cd49$var$Deno.version;
var $998d968a5e32cd49$var$v8 = $998d968a5e32cd49$var$versions && $998d968a5e32cd49$var$versions.v8;
var $998d968a5e32cd49$var$match, $998d968a5e32cd49$var$version;
if ($998d968a5e32cd49$var$v8) {
    $998d968a5e32cd49$var$match = $998d968a5e32cd49$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $998d968a5e32cd49$var$version = $998d968a5e32cd49$var$match[0] > 0 && $998d968a5e32cd49$var$match[0] < 4 ? 1 : +($998d968a5e32cd49$var$match[0] + $998d968a5e32cd49$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$998d968a5e32cd49$var$version && $492c6dc902f2bf18$exports) {
    $998d968a5e32cd49$var$match = $492c6dc902f2bf18$exports.match(/Edge\/(\d+)/);
    if (!$998d968a5e32cd49$var$match || $998d968a5e32cd49$var$match[1] >= 74) {
        $998d968a5e32cd49$var$match = $492c6dc902f2bf18$exports.match(/Chrome\/(\d+)/);
        if ($998d968a5e32cd49$var$match) $998d968a5e32cd49$var$version = +$998d968a5e32cd49$var$match[1];
    }
}
$998d968a5e32cd49$exports = $998d968a5e32cd49$var$version;




var $4a39565fee8fe980$var$$String = $55b335199d6e6d5d$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$4a39565fee8fe980$exports = !!Object.getOwnPropertySymbols && !$6140c9fa18232846$exports(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$4a39565fee8fe980$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $998d968a5e32cd49$exports && $998d968a5e32cd49$exports < 41;
});


$47f18b427c2fbabf$exports = $4a39565fee8fe980$exports && !Symbol.sham && typeof Symbol.iterator == "symbol";


var $0b429cc7792c7d26$var$$Object = Object;
$0b429cc7792c7d26$exports = $47f18b427c2fbabf$exports ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $a5217dbd1b0d33ce$exports("Symbol");
    return $70e34a5a2021f756$exports($Symbol) && $41cc576e850a251e$exports($Symbol.prototype, $0b429cc7792c7d26$var$$Object(it));
};


var $eb80dcd0b8a5698c$exports = {};
"use strict";
var $ae485921c5498156$exports = {};
"use strict";

var $8f0ebae34f61e14c$exports = {};
"use strict";
var $8f0ebae34f61e14c$var$$String = String;
$8f0ebae34f61e14c$exports = function(argument) {
    try {
        return $8f0ebae34f61e14c$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $ae485921c5498156$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$ae485921c5498156$exports = function(argument) {
    if ($70e34a5a2021f756$exports(argument)) return argument;
    throw new $ae485921c5498156$var$$TypeError($8f0ebae34f61e14c$exports(argument) + " is not a function");
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$eb80dcd0b8a5698c$exports = function(V, P) {
    var func = V[P];
    return $7ce250ddf7b42d4d$exports(func) ? undefined : $ae485921c5498156$exports(func);
};


var $b0f812e443807cb5$exports = {};
"use strict";



var $b0f812e443807cb5$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$b0f812e443807cb5$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $70e34a5a2021f756$exports(fn = input.toString) && !$6a130d390db46c8e$exports(val = $881ad37dbe259e8f$exports(fn, input))) return val;
    if ($70e34a5a2021f756$exports(fn = input.valueOf) && !$6a130d390db46c8e$exports(val = $881ad37dbe259e8f$exports(fn, input))) return val;
    if (pref !== "string" && $70e34a5a2021f756$exports(fn = input.toString) && !$6a130d390db46c8e$exports(val = $881ad37dbe259e8f$exports(fn, input))) return val;
    throw new $b0f812e443807cb5$var$$TypeError("Can't convert object to primitive value");
};


var $842f8f0a18746212$exports = {};
"use strict";

var $1946b9b54b48e7fd$exports = {};
"use strict";
var $e0409817d4e03fc4$exports = {};
"use strict";
$e0409817d4e03fc4$exports = false;


var $d00d03e557d638db$exports = {};
"use strict";

var $4ce407c7007beb63$exports = {};
"use strict";

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $4ce407c7007beb63$var$defineProperty = Object.defineProperty;
$4ce407c7007beb63$exports = function(key, value) {
    try {
        $4ce407c7007beb63$var$defineProperty($55b335199d6e6d5d$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $55b335199d6e6d5d$exports[key] = value;
    }
    return value;
};


var $d00d03e557d638db$var$SHARED = "__core-js_shared__";
var $d00d03e557d638db$var$store = $55b335199d6e6d5d$exports[$d00d03e557d638db$var$SHARED] || $4ce407c7007beb63$exports($d00d03e557d638db$var$SHARED, {});
$d00d03e557d638db$exports = $d00d03e557d638db$var$store;


($1946b9b54b48e7fd$exports = function(key, value) {
    return $d00d03e557d638db$exports[key] || ($d00d03e557d638db$exports[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.33.0",
    mode: $e0409817d4e03fc4$exports ? "pure" : "global",
    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.33.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
});


var $1f868a26fd901990$exports = {};
"use strict";

var $a2f3ebb5da11db12$exports = {};
"use strict";

var $a2f3ebb5da11db12$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$a2f3ebb5da11db12$exports = function(argument) {
    return $a2f3ebb5da11db12$var$$Object($c378177673193450$exports(argument));
};


var $1f868a26fd901990$var$hasOwnProperty = $43b18aa2f1faac44$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$1f868a26fd901990$exports = Object.hasOwn || function hasOwn(it, key) {
    return $1f868a26fd901990$var$hasOwnProperty($a2f3ebb5da11db12$exports(it), key);
};


var $5e0a1e292f79defc$exports = {};
"use strict";

var $5e0a1e292f79defc$var$id = 0;
var $5e0a1e292f79defc$var$postfix = Math.random();
var $5e0a1e292f79defc$var$toString = $43b18aa2f1faac44$exports(1.0.toString);
$5e0a1e292f79defc$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $5e0a1e292f79defc$var$toString(++$5e0a1e292f79defc$var$id + $5e0a1e292f79defc$var$postfix, 36);
};




var $842f8f0a18746212$var$Symbol = $55b335199d6e6d5d$exports.Symbol;
var $842f8f0a18746212$var$WellKnownSymbolsStore = $1946b9b54b48e7fd$exports("wks");
var $842f8f0a18746212$var$createWellKnownSymbol = $47f18b427c2fbabf$exports ? $842f8f0a18746212$var$Symbol["for"] || $842f8f0a18746212$var$Symbol : $842f8f0a18746212$var$Symbol && $842f8f0a18746212$var$Symbol.withoutSetter || $5e0a1e292f79defc$exports;
$842f8f0a18746212$exports = function(name) {
    if (!$1f868a26fd901990$exports($842f8f0a18746212$var$WellKnownSymbolsStore, name)) $842f8f0a18746212$var$WellKnownSymbolsStore[name] = $4a39565fee8fe980$exports && $1f868a26fd901990$exports($842f8f0a18746212$var$Symbol, name) ? $842f8f0a18746212$var$Symbol[name] : $842f8f0a18746212$var$createWellKnownSymbol("Symbol." + name);
    return $842f8f0a18746212$var$WellKnownSymbolsStore[name];
};


var $8ffb6b36a733d3c0$var$$TypeError = TypeError;
var $8ffb6b36a733d3c0$var$TO_PRIMITIVE = $842f8f0a18746212$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$8ffb6b36a733d3c0$exports = function(input, pref) {
    if (!$6a130d390db46c8e$exports(input) || $0b429cc7792c7d26$exports(input)) return input;
    var exoticToPrim = $eb80dcd0b8a5698c$exports(input, $8ffb6b36a733d3c0$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $881ad37dbe259e8f$exports(exoticToPrim, input, pref);
        if (!$6a130d390db46c8e$exports(result) || $0b429cc7792c7d26$exports(result)) return result;
        throw new $8ffb6b36a733d3c0$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $b0f812e443807cb5$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$7f19acfe53927f5c$exports = function(argument) {
    var key = $8ffb6b36a733d3c0$exports(argument, "string");
    return $0b429cc7792c7d26$exports(key) ? key : key + "";
};



var $d45526d8245cb22c$exports = {};
"use strict";


var $15c0c414b89100b1$exports = {};
"use strict";


var $15c0c414b89100b1$var$document = $55b335199d6e6d5d$exports.document;
// typeof document.createElement is 'object' in old IE
var $15c0c414b89100b1$var$EXISTS = $6a130d390db46c8e$exports($15c0c414b89100b1$var$document) && $6a130d390db46c8e$exports($15c0c414b89100b1$var$document.createElement);
$15c0c414b89100b1$exports = function(it) {
    return $15c0c414b89100b1$var$EXISTS ? $15c0c414b89100b1$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$d45526d8245cb22c$exports = !$ef322a7f89c3ed41$exports && !$6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($15c0c414b89100b1$exports("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $6d99163b6684d050$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$6d99163b6684d050$export$2d1720544b23b823 = $ef322a7f89c3ed41$exports ? $6d99163b6684d050$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $4d273c9d7e1bdf46$exports(O);
    P = $7f19acfe53927f5c$exports(P);
    if ($d45526d8245cb22c$exports) try {
        return $6d99163b6684d050$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($1f868a26fd901990$exports(O, P)) return $b66966b48674609b$exports(!$881ad37dbe259e8f$exports($1e0782be6903ea7b$export$2d1720544b23b823, O, P), O[P]);
};


var $ca3e1754e676956d$require$getOwnPropertyDescriptor = $6d99163b6684d050$export$2d1720544b23b823;
var $8693737507995841$exports = {};
"use strict";

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $2d0ac3aa5e39584b$export$2d1720544b23b823;
"use strict";


var $161a89d67c436ccf$exports = {};
"use strict";


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$161a89d67c436ccf$exports = $ef322a7f89c3ed41$exports && $6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $c845d421b7b0e630$exports = {};
"use strict";

var $c845d421b7b0e630$var$$String = String;
var $c845d421b7b0e630$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$c845d421b7b0e630$exports = function(argument) {
    if ($6a130d390db46c8e$exports(argument)) return argument;
    throw new $c845d421b7b0e630$var$$TypeError($c845d421b7b0e630$var$$String(argument) + " is not an object");
};



var $2d0ac3aa5e39584b$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $2d0ac3aa5e39584b$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $2d0ac3aa5e39584b$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $2d0ac3aa5e39584b$var$ENUMERABLE = "enumerable";
var $2d0ac3aa5e39584b$var$CONFIGURABLE = "configurable";
var $2d0ac3aa5e39584b$var$WRITABLE = "writable";
$2d0ac3aa5e39584b$export$2d1720544b23b823 = $ef322a7f89c3ed41$exports ? $161a89d67c436ccf$exports ? function defineProperty(O, P, Attributes) {
    $c845d421b7b0e630$exports(O);
    P = $7f19acfe53927f5c$exports(P);
    $c845d421b7b0e630$exports(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $2d0ac3aa5e39584b$var$WRITABLE in Attributes && !Attributes[$2d0ac3aa5e39584b$var$WRITABLE]) {
        var current = $2d0ac3aa5e39584b$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$2d0ac3aa5e39584b$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $2d0ac3aa5e39584b$var$CONFIGURABLE in Attributes ? Attributes[$2d0ac3aa5e39584b$var$CONFIGURABLE] : current[$2d0ac3aa5e39584b$var$CONFIGURABLE],
                enumerable: $2d0ac3aa5e39584b$var$ENUMERABLE in Attributes ? Attributes[$2d0ac3aa5e39584b$var$ENUMERABLE] : current[$2d0ac3aa5e39584b$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $2d0ac3aa5e39584b$var$$defineProperty(O, P, Attributes);
} : $2d0ac3aa5e39584b$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $c845d421b7b0e630$exports(O);
    P = $7f19acfe53927f5c$exports(P);
    $c845d421b7b0e630$exports(Attributes);
    if ($d45526d8245cb22c$exports) try {
        return $2d0ac3aa5e39584b$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $2d0ac3aa5e39584b$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};



$8693737507995841$exports = $ef322a7f89c3ed41$exports ? function(object, key, value) {
    return $2d0ac3aa5e39584b$export$2d1720544b23b823(object, key, $b66966b48674609b$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


var $40e957865125f98f$exports = {};
"use strict";


var $09c56ff2ae09b2d7$exports = {};
"use strict";





var $81c64883d194e3b4$exports = {};
"use strict";


var $81c64883d194e3b4$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $81c64883d194e3b4$var$getDescriptor = $ef322a7f89c3ed41$exports && Object.getOwnPropertyDescriptor;
var $81c64883d194e3b4$var$EXISTS = $1f868a26fd901990$exports($81c64883d194e3b4$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $81c64883d194e3b4$var$PROPER = $81c64883d194e3b4$var$EXISTS && (function something() {}).name === "something";
var $81c64883d194e3b4$var$CONFIGURABLE = $81c64883d194e3b4$var$EXISTS && (!$ef322a7f89c3ed41$exports || $ef322a7f89c3ed41$exports && $81c64883d194e3b4$var$getDescriptor($81c64883d194e3b4$var$FunctionPrototype, "name").configurable);
$81c64883d194e3b4$exports = {
    EXISTS: $81c64883d194e3b4$var$EXISTS,
    PROPER: $81c64883d194e3b4$var$PROPER,
    CONFIGURABLE: $81c64883d194e3b4$var$CONFIGURABLE
};


var $09c56ff2ae09b2d7$require$CONFIGURABLE_FUNCTION_NAME = $81c64883d194e3b4$exports.CONFIGURABLE;
var $9990f6f719f26a96$exports = {};
"use strict";



var $9990f6f719f26a96$var$functionToString = $43b18aa2f1faac44$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$70e34a5a2021f756$exports($d00d03e557d638db$exports.inspectSource)) $d00d03e557d638db$exports.inspectSource = function(it) {
    return $9990f6f719f26a96$var$functionToString(it);
};
$9990f6f719f26a96$exports = $d00d03e557d638db$exports.inspectSource;


var $3a8bcef306e86159$exports = {};
"use strict";
var $47d53bb84a8f3c5b$exports = {};
"use strict";


var $47d53bb84a8f3c5b$var$WeakMap = $55b335199d6e6d5d$exports.WeakMap;
$47d53bb84a8f3c5b$exports = $70e34a5a2021f756$exports($47d53bb84a8f3c5b$var$WeakMap) && /native code/.test(String($47d53bb84a8f3c5b$var$WeakMap));







var $834abcf0f8f3f871$exports = {};
"use strict";


var $834abcf0f8f3f871$var$keys = $1946b9b54b48e7fd$exports("keys");
$834abcf0f8f3f871$exports = function(key) {
    return $834abcf0f8f3f871$var$keys[key] || ($834abcf0f8f3f871$var$keys[key] = $5e0a1e292f79defc$exports(key));
};


var $9f571a3f3d135e31$exports = {};
"use strict";
$9f571a3f3d135e31$exports = {};


var $3a8bcef306e86159$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $3a8bcef306e86159$var$TypeError = $55b335199d6e6d5d$exports.TypeError;
var $3a8bcef306e86159$var$WeakMap = $55b335199d6e6d5d$exports.WeakMap;
var $3a8bcef306e86159$var$set, $3a8bcef306e86159$var$get, $3a8bcef306e86159$var$has;
var $3a8bcef306e86159$var$enforce = function(it) {
    return $3a8bcef306e86159$var$has(it) ? $3a8bcef306e86159$var$get(it) : $3a8bcef306e86159$var$set(it, {});
};
var $3a8bcef306e86159$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$6a130d390db46c8e$exports(it) || (state = $3a8bcef306e86159$var$get(it)).type !== TYPE) throw new $3a8bcef306e86159$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($47d53bb84a8f3c5b$exports || $d00d03e557d638db$exports.state) {
    var $3a8bcef306e86159$var$store = $d00d03e557d638db$exports.state || ($d00d03e557d638db$exports.state = new $3a8bcef306e86159$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $3a8bcef306e86159$var$store.get = $3a8bcef306e86159$var$store.get;
    $3a8bcef306e86159$var$store.has = $3a8bcef306e86159$var$store.has;
    $3a8bcef306e86159$var$store.set = $3a8bcef306e86159$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $3a8bcef306e86159$var$set = function(it, metadata) {
        if ($3a8bcef306e86159$var$store.has(it)) throw new $3a8bcef306e86159$var$TypeError($3a8bcef306e86159$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $3a8bcef306e86159$var$store.set(it, metadata);
        return metadata;
    };
    $3a8bcef306e86159$var$get = function(it) {
        return $3a8bcef306e86159$var$store.get(it) || {};
    };
    $3a8bcef306e86159$var$has = function(it) {
        return $3a8bcef306e86159$var$store.has(it);
    };
} else {
    var $3a8bcef306e86159$var$STATE = $834abcf0f8f3f871$exports("state");
    $9f571a3f3d135e31$exports[$3a8bcef306e86159$var$STATE] = true;
    $3a8bcef306e86159$var$set = function(it, metadata) {
        if ($1f868a26fd901990$exports(it, $3a8bcef306e86159$var$STATE)) throw new $3a8bcef306e86159$var$TypeError($3a8bcef306e86159$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $8693737507995841$exports(it, $3a8bcef306e86159$var$STATE, metadata);
        return metadata;
    };
    $3a8bcef306e86159$var$get = function(it) {
        return $1f868a26fd901990$exports(it, $3a8bcef306e86159$var$STATE) ? it[$3a8bcef306e86159$var$STATE] : {};
    };
    $3a8bcef306e86159$var$has = function(it) {
        return $1f868a26fd901990$exports(it, $3a8bcef306e86159$var$STATE);
    };
}
$3a8bcef306e86159$exports = {
    set: $3a8bcef306e86159$var$set,
    get: $3a8bcef306e86159$var$get,
    has: $3a8bcef306e86159$var$has,
    enforce: $3a8bcef306e86159$var$enforce,
    getterFor: $3a8bcef306e86159$var$getterFor
};


var $09c56ff2ae09b2d7$var$enforceInternalState = $3a8bcef306e86159$exports.enforce;
var $09c56ff2ae09b2d7$var$getInternalState = $3a8bcef306e86159$exports.get;
var $09c56ff2ae09b2d7$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $09c56ff2ae09b2d7$var$defineProperty = Object.defineProperty;
var $09c56ff2ae09b2d7$var$stringSlice = $43b18aa2f1faac44$exports("".slice);
var $09c56ff2ae09b2d7$var$replace = $43b18aa2f1faac44$exports("".replace);
var $09c56ff2ae09b2d7$var$join = $43b18aa2f1faac44$exports([].join);
var $09c56ff2ae09b2d7$var$CONFIGURABLE_LENGTH = $ef322a7f89c3ed41$exports && !$6140c9fa18232846$exports(function() {
    return $09c56ff2ae09b2d7$var$defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $09c56ff2ae09b2d7$var$TEMPLATE = String(String).split("String");
var $09c56ff2ae09b2d7$var$makeBuiltIn = $09c56ff2ae09b2d7$exports = function(value, name, options) {
    if ($09c56ff2ae09b2d7$var$stringSlice($09c56ff2ae09b2d7$var$$String(name), 0, 7) === "Symbol(") name = "[" + $09c56ff2ae09b2d7$var$replace($09c56ff2ae09b2d7$var$$String(name), /^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$1f868a26fd901990$exports(value, "name") || $09c56ff2ae09b2d7$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($ef322a7f89c3ed41$exports) $09c56ff2ae09b2d7$var$defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($09c56ff2ae09b2d7$var$CONFIGURABLE_LENGTH && options && $1f868a26fd901990$exports(options, "arity") && value.length !== options.arity) $09c56ff2ae09b2d7$var$defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && $1f868a26fd901990$exports(options, "constructor") && options.constructor) {
            if ($ef322a7f89c3ed41$exports) $09c56ff2ae09b2d7$var$defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $09c56ff2ae09b2d7$var$enforceInternalState(value);
    if (!$1f868a26fd901990$exports(state, "source")) state.source = $09c56ff2ae09b2d7$var$join($09c56ff2ae09b2d7$var$TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $09c56ff2ae09b2d7$var$makeBuiltIn(function toString() {
    return $70e34a5a2021f756$exports(this) && $09c56ff2ae09b2d7$var$getInternalState(this).source || $9990f6f719f26a96$exports(this);
}, "toString");



$40e957865125f98f$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($70e34a5a2021f756$exports(value)) $09c56ff2ae09b2d7$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $4ce407c7007beb63$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $2d0ac3aa5e39584b$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $ef14b437ba65973a$exports = {};
"use strict";

var $339f2419d379e6c2$exports = {};
"use strict";


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $f6c32256739dd9b5$export$2d1720544b23b823;
"use strict";
var $c4fba4611365c4f5$exports = {};
"use strict";



var $f00609c516640f24$exports = {};
"use strict";

var $1ef9432c43157f41$exports = {};
"use strict";
var $b5bb21648546ce5b$exports = {};
"use strict";
var $5395b5a4913a5e32$exports = {};
"use strict";
var $5395b5a4913a5e32$var$ceil = Math.ceil;
var $5395b5a4913a5e32$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$5395b5a4913a5e32$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $5395b5a4913a5e32$var$floor : $5395b5a4913a5e32$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$b5bb21648546ce5b$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $5395b5a4913a5e32$exports(number);
};


var $1ef9432c43157f41$var$max = Math.max;
var $1ef9432c43157f41$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$1ef9432c43157f41$exports = function(index, length) {
    var integer = $b5bb21648546ce5b$exports(index);
    return integer < 0 ? $1ef9432c43157f41$var$max(integer + length, 0) : $1ef9432c43157f41$var$min(integer, length);
};


var $04c91bd3815cd64a$exports = {};
"use strict";
var $4aba983aae3daed3$exports = {};
"use strict";

var $4aba983aae3daed3$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$4aba983aae3daed3$exports = function(argument) {
    return argument > 0 ? $4aba983aae3daed3$var$min($b5bb21648546ce5b$exports(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$04c91bd3815cd64a$exports = function(obj) {
    return $4aba983aae3daed3$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $f00609c516640f24$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $4d273c9d7e1bdf46$exports($this);
        var length = $04c91bd3815cd64a$exports(O);
        var index = $1ef9432c43157f41$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$f00609c516640f24$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $f00609c516640f24$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $f00609c516640f24$var$createMethod(false)
};


var $c4fba4611365c4f5$require$indexOf = $f00609c516640f24$exports.indexOf;

var $c4fba4611365c4f5$var$push = $43b18aa2f1faac44$exports([].push);
$c4fba4611365c4f5$exports = function(object, names) {
    var O = $4d273c9d7e1bdf46$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$1f868a26fd901990$exports($9f571a3f3d135e31$exports, key) && $1f868a26fd901990$exports(O, key) && $c4fba4611365c4f5$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($1f868a26fd901990$exports(O, key = names[i++])) ~$c4fba4611365c4f5$require$indexOf(result, key) || $c4fba4611365c4f5$var$push(result, key);
    return result;
};


var $e73f13f1d8a17cad$exports = {};
"use strict";
// IE8- don't enum bug keys
$e73f13f1d8a17cad$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


var $f6c32256739dd9b5$var$hiddenKeys = $e73f13f1d8a17cad$exports.concat("length", "prototype");
$f6c32256739dd9b5$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $c4fba4611365c4f5$exports(O, $f6c32256739dd9b5$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $0ed66cde5c449819$export$2d1720544b23b823;
"use strict";
$0ed66cde5c449819$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $339f2419d379e6c2$var$concat = $43b18aa2f1faac44$exports([].concat);
// all object keys, includes non-enumerable and symbols
$339f2419d379e6c2$exports = $a5217dbd1b0d33ce$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $f6c32256739dd9b5$export$2d1720544b23b823($c845d421b7b0e630$exports(it));
    var getOwnPropertySymbols = $0ed66cde5c449819$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $339f2419d379e6c2$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$ef14b437ba65973a$exports = function(target, source, exceptions) {
    var keys = $339f2419d379e6c2$exports(source);
    var defineProperty = $2d0ac3aa5e39584b$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $6d99163b6684d050$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$1f868a26fd901990$exports(target, key) && !(exceptions && $1f868a26fd901990$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $ca268db110e9e457$exports = {};
"use strict";


var $ca268db110e9e457$var$replacement = /#|\.prototype\./;
var $ca268db110e9e457$var$isForced = function(feature, detection) {
    var value = $ca268db110e9e457$var$data[$ca268db110e9e457$var$normalize(feature)];
    return value === $ca268db110e9e457$var$POLYFILL ? true : value === $ca268db110e9e457$var$NATIVE ? false : $70e34a5a2021f756$exports(detection) ? $6140c9fa18232846$exports(detection) : !!detection;
};
var $ca268db110e9e457$var$normalize = $ca268db110e9e457$var$isForced.normalize = function(string) {
    return String(string).replace($ca268db110e9e457$var$replacement, ".").toLowerCase();
};
var $ca268db110e9e457$var$data = $ca268db110e9e457$var$isForced.data = {};
var $ca268db110e9e457$var$NATIVE = $ca268db110e9e457$var$isForced.NATIVE = "N";
var $ca268db110e9e457$var$POLYFILL = $ca268db110e9e457$var$isForced.POLYFILL = "P";
$ca268db110e9e457$exports = $ca268db110e9e457$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $ca3e1754e676956d$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $55b335199d6e6d5d$exports;
    else if (STATIC) target = $55b335199d6e6d5d$exports[TARGET] || $4ce407c7007beb63$exports(TARGET, {});
    else target = ($55b335199d6e6d5d$exports[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $ca3e1754e676956d$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $ca268db110e9e457$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $ef14b437ba65973a$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $8693737507995841$exports(sourceProperty, "sham", true);
        $40e957865125f98f$exports(target, key, sourceProperty, options);
    }
};



var $a393da0e05d61ed1$exports = {};
"use strict";

var $3cdb2ef65d8e3cb5$exports = {};
"use strict";

var $3cdb2ef65d8e3cb5$var$FunctionPrototype = Function.prototype;
var $3cdb2ef65d8e3cb5$var$apply = $3cdb2ef65d8e3cb5$var$FunctionPrototype.apply;
var $3cdb2ef65d8e3cb5$var$call = $3cdb2ef65d8e3cb5$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$3cdb2ef65d8e3cb5$exports = typeof Reflect == "object" && Reflect.apply || ($bcbe62e89adc7d37$exports ? $3cdb2ef65d8e3cb5$var$call.bind($3cdb2ef65d8e3cb5$var$apply) : function() {
    return $3cdb2ef65d8e3cb5$var$call.apply($3cdb2ef65d8e3cb5$var$apply, arguments);
});


var $43284f0171045916$exports = {};
"use strict";
var $4828cb1b4c7586c8$exports = {};
"use strict";


$4828cb1b4c7586c8$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($b0ba63bfbfb16088$exports(fn) === "Function") return $43b18aa2f1faac44$exports(fn);
};




var $43284f0171045916$var$bind = $4828cb1b4c7586c8$exports($4828cb1b4c7586c8$exports.bind);
// optional / simple context binding
$43284f0171045916$exports = function(fn, that) {
    $ae485921c5498156$exports(fn);
    return that === undefined ? fn : $bcbe62e89adc7d37$exports ? $43284f0171045916$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $b8ce1ad1b6b1e7c1$exports = {};
"use strict";

$b8ce1ad1b6b1e7c1$exports = $a5217dbd1b0d33ce$exports("document", "documentElement");


var $0709cba658bb4ed6$exports = {};
"use strict";

$0709cba658bb4ed6$exports = $43b18aa2f1faac44$exports([].slice);



var $7d824954c5058f7d$exports = {};
"use strict";
var $7d824954c5058f7d$var$$TypeError = TypeError;
$7d824954c5058f7d$exports = function(passed, required) {
    if (passed < required) throw new $7d824954c5058f7d$var$$TypeError("Not enough arguments");
    return passed;
};


var $05f68a2417343639$exports = {};
"use strict";

// eslint-disable-next-line redos/no-vulnerable -- safe
$05f68a2417343639$exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($492c6dc902f2bf18$exports);


var $3f8bc2b5488269f3$exports = {};
"use strict";


$3f8bc2b5488269f3$exports = $b0ba63bfbfb16088$exports($55b335199d6e6d5d$exports.process) === "process";


var $a393da0e05d61ed1$var$set = $55b335199d6e6d5d$exports.setImmediate;
var $a393da0e05d61ed1$var$clear = $55b335199d6e6d5d$exports.clearImmediate;
var $a393da0e05d61ed1$var$process = $55b335199d6e6d5d$exports.process;
var $a393da0e05d61ed1$var$Dispatch = $55b335199d6e6d5d$exports.Dispatch;
var $a393da0e05d61ed1$var$Function = $55b335199d6e6d5d$exports.Function;
var $a393da0e05d61ed1$var$MessageChannel = $55b335199d6e6d5d$exports.MessageChannel;
var $a393da0e05d61ed1$var$String = $55b335199d6e6d5d$exports.String;
var $a393da0e05d61ed1$var$counter = 0;
var $a393da0e05d61ed1$var$queue = {};
var $a393da0e05d61ed1$var$ONREADYSTATECHANGE = "onreadystatechange";
var $a393da0e05d61ed1$var$$location, $a393da0e05d61ed1$var$defer, $a393da0e05d61ed1$var$channel, $a393da0e05d61ed1$var$port;
$6140c9fa18232846$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $a393da0e05d61ed1$var$$location = $55b335199d6e6d5d$exports.location;
});
var $a393da0e05d61ed1$var$run = function(id) {
    if ($1f868a26fd901990$exports($a393da0e05d61ed1$var$queue, id)) {
        var fn = $a393da0e05d61ed1$var$queue[id];
        delete $a393da0e05d61ed1$var$queue[id];
        fn();
    }
};
var $a393da0e05d61ed1$var$runner = function(id) {
    return function() {
        $a393da0e05d61ed1$var$run(id);
    };
};
var $a393da0e05d61ed1$var$eventListener = function(event) {
    $a393da0e05d61ed1$var$run(event.data);
};
var $a393da0e05d61ed1$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $55b335199d6e6d5d$exports.postMessage($a393da0e05d61ed1$var$String(id), $a393da0e05d61ed1$var$$location.protocol + "//" + $a393da0e05d61ed1$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$a393da0e05d61ed1$var$set || !$a393da0e05d61ed1$var$clear) {
    $a393da0e05d61ed1$var$set = function setImmediate(handler) {
        $7d824954c5058f7d$exports(arguments.length, 1);
        var fn = $70e34a5a2021f756$exports(handler) ? handler : $a393da0e05d61ed1$var$Function(handler);
        var args = $0709cba658bb4ed6$exports(arguments, 1);
        $a393da0e05d61ed1$var$queue[++$a393da0e05d61ed1$var$counter] = function() {
            $3cdb2ef65d8e3cb5$exports(fn, undefined, args);
        };
        $a393da0e05d61ed1$var$defer($a393da0e05d61ed1$var$counter);
        return $a393da0e05d61ed1$var$counter;
    };
    $a393da0e05d61ed1$var$clear = function clearImmediate(id) {
        delete $a393da0e05d61ed1$var$queue[id];
    };
    // Node.js 0.8-
    if ($3f8bc2b5488269f3$exports) $a393da0e05d61ed1$var$defer = function(id) {
        $a393da0e05d61ed1$var$process.nextTick($a393da0e05d61ed1$var$runner(id));
    };
    else if ($a393da0e05d61ed1$var$Dispatch && $a393da0e05d61ed1$var$Dispatch.now) $a393da0e05d61ed1$var$defer = function(id) {
        $a393da0e05d61ed1$var$Dispatch.now($a393da0e05d61ed1$var$runner(id));
    };
    else if ($a393da0e05d61ed1$var$MessageChannel && !$05f68a2417343639$exports) {
        $a393da0e05d61ed1$var$channel = new $a393da0e05d61ed1$var$MessageChannel();
        $a393da0e05d61ed1$var$port = $a393da0e05d61ed1$var$channel.port2;
        $a393da0e05d61ed1$var$channel.port1.onmessage = $a393da0e05d61ed1$var$eventListener;
        $a393da0e05d61ed1$var$defer = $43284f0171045916$exports($a393da0e05d61ed1$var$port.postMessage, $a393da0e05d61ed1$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($55b335199d6e6d5d$exports.addEventListener && $70e34a5a2021f756$exports($55b335199d6e6d5d$exports.postMessage) && !$55b335199d6e6d5d$exports.importScripts && $a393da0e05d61ed1$var$$location && $a393da0e05d61ed1$var$$location.protocol !== "file:" && !$6140c9fa18232846$exports($a393da0e05d61ed1$var$globalPostMessageDefer)) {
        $a393da0e05d61ed1$var$defer = $a393da0e05d61ed1$var$globalPostMessageDefer;
        $55b335199d6e6d5d$exports.addEventListener("message", $a393da0e05d61ed1$var$eventListener, false);
    // IE8-
    } else if ($a393da0e05d61ed1$var$ONREADYSTATECHANGE in $15c0c414b89100b1$exports("script")) $a393da0e05d61ed1$var$defer = function(id) {
        $b8ce1ad1b6b1e7c1$exports.appendChild($15c0c414b89100b1$exports("script"))[$a393da0e05d61ed1$var$ONREADYSTATECHANGE] = function() {
            $b8ce1ad1b6b1e7c1$exports.removeChild(this);
            $a393da0e05d61ed1$var$run(id);
        };
    };
    else $a393da0e05d61ed1$var$defer = function(id) {
        setTimeout($a393da0e05d61ed1$var$runner(id), 0);
    };
}
$a393da0e05d61ed1$exports = {
    set: $a393da0e05d61ed1$var$set,
    clear: $a393da0e05d61ed1$var$clear
};


var $99b55bbd56d52729$require$clearImmediate = $a393da0e05d61ed1$exports.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$ca3e1754e676956d$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $55b335199d6e6d5d$exports.clearImmediate !== $99b55bbd56d52729$require$clearImmediate
}, {
    clearImmediate: $99b55bbd56d52729$require$clearImmediate
});


"use strict";



var $e55ac54d5aaa2e1c$require$setTask = $a393da0e05d61ed1$exports.set;
var $f112a170991e44cc$exports = {};
"use strict";



var $99637759dc933969$exports = {};
"use strict";
/* global Bun -- Deno case */ $99637759dc933969$exports = typeof Bun == "function" && Bun && typeof Bun.version == "string";





var $f112a170991e44cc$var$Function = $55b335199d6e6d5d$exports.Function;
// dirty IE9- and Bun 0.3.0- checks
var $f112a170991e44cc$var$WRAP = /MSIE .\./.test($492c6dc902f2bf18$exports) || $99637759dc933969$exports && function() {
    var version = $55b335199d6e6d5d$exports.Bun.version.split(".");
    return version.length < 3 || version[0] === "0" && (version[1] < 3 || version[1] === "3" && version[2] === "0");
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
$f112a170991e44cc$exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $f112a170991e44cc$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $7d824954c5058f7d$exports(arguments.length, 1) > firstParamIndex;
        var fn = $70e34a5a2021f756$exports(handler) ? handler : $f112a170991e44cc$var$Function(handler);
        var params = boundArgs ? $0709cba658bb4ed6$exports(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $3cdb2ef65d8e3cb5$exports(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};


// https://github.com/oven-sh/bun/issues/1633
var $e55ac54d5aaa2e1c$var$setImmediate = $55b335199d6e6d5d$exports.setImmediate ? $f112a170991e44cc$exports($e55ac54d5aaa2e1c$require$setTask, false) : $e55ac54d5aaa2e1c$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$ca3e1754e676956d$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $55b335199d6e6d5d$exports.setImmediate !== $e55ac54d5aaa2e1c$var$setImmediate
}, {
    setImmediate: $e55ac54d5aaa2e1c$var$setImmediate
});




const $ba30e20475feac5a$export$37b96ba04a8c05d1 = "https://journalinghub.ddns.net/api/";
const $ba30e20475feac5a$export$5b9e5fe02326903d = [
    "grateful-for",
    "happenings",
    "action-items",
    "intentions"
];
const $ba30e20475feac5a$export$e7d23b4e9333127f = `
Document your life - daily happenings, special occasions,
and reflections on your goals. Categorize entries with
tags and automatically capture the date.
<br />
<br />
↓ Click through the different database tabs to filter
entries by a specific category such as daily or personal.
`;
const $ba30e20475feac5a$export$3e0682185d2331c3 = 24;
const $ba30e20475feac5a$export$65c9bf95558790f6 = "(max-width: 1008px)";
const $ba30e20475feac5a$export$bcd5792a294b918c = "(max-width: 1008px)";
const $ba30e20475feac5a$export$418e7017e024d51c = "(max-width:800px)";
const $ba30e20475feac5a$export$5de39269fe3b794d = 14;
const $ba30e20475feac5a$export$1fa8a855c3fa5df8 = "Table";
const $ba30e20475feac5a$export$32db47f5115d9b9f = 4;
const $ba30e20475feac5a$export$98d0bcf59e8eba1e = 1; //seconds
const $ba30e20475feac5a$export$1dd83cd16a72b5 = "No result";
const $ba30e20475feac5a$export$74f24093aa91ad17 = "en-US";
const $ba30e20475feac5a$export$4f2ee02a9a578f69 = "This select option already exists.";
const $ba30e20475feac5a$export$c6bea31caa55fd32 = "Are you sure you want to remove this option?";
const $ba30e20475feac5a$export$3c216b31aa0f6ba8 = "Copied property to Clipboard";
const $ba30e20475feac5a$export$4d8370550bad0e65 = "Empty. Click to add a row.";
const $ba30e20475feac5a$export$70effd399f9b6579 = "No filter results. Click to add a row.";
const $ba30e20475feac5a$export$7d0590e3d596f061 = 15;
const $ba30e20475feac5a$export$fdca5029119b1439 = [
    "All entries",
    "Daily entries",
    "Personal entries"
];
const $ba30e20475feac5a$export$4548e099e938ee5 = 135;
const $ba30e20475feac5a$export$227dd4c68037d33c = {
    properties: [
        {
            text: "Filter",
            icon: "filter",
            class: "table-filter"
        },
        {
            text: "Sort",
            icon: "sort",
            class: "table-sort"
        },
        {
            text: "New",
            icon: "plus",
            class: "table-button-content"
        }
    ]
};
const $ba30e20475feac5a$export$ee96ddcc77a4b958 = {
    properties: [
        {
            text: "Name",
            icon: "alphabet-icon"
        },
        {
            text: "Created",
            icon: "clock"
        },
        {
            text: "Tags",
            icon: "list-icon"
        }
    ]
};
const $ba30e20475feac5a$export$2fbac60a8fede0ac = {
    tags: [
        {
            text: "Daily",
            color: "color-gray"
        },
        {
            text: "Personal",
            color: "color-green"
        },
        {
            text: "Urgent",
            color: "color-red"
        },
        {
            text: "Work",
            color: "color-army-green"
        }
    ]
};
const $ba30e20475feac5a$export$8f01201217c59cf3 = {
    colors: [
        {
            color: "Off Gray",
            color_value: "color-gray"
        },
        {
            color: "Midnight Green",
            color_value: "color-green"
        },
        {
            color: "Wine Red",
            color_value: "color-red"
        },
        {
            color: "Army Green",
            color_value: "color-army-green"
        },
        {
            color: "Yellow",
            color_value: "color-yellow"
        },
        {
            color: "Light Blue",
            color_value: "color-blue"
        },
        {
            color: "Peach",
            color_value: "color-peach"
        },
        {
            color: "Teal",
            color_value: "color-teal"
        },
        {
            color: "Deep Purple",
            color_value: "color-purple"
        },
        {
            color: "Brown",
            color_value: "color-brown"
        }
    ]
};
const $ba30e20475feac5a$export$2cb856a3d1493fda = [
    {
        condition: "Is not",
        name: true,
        tags: false
    },
    {
        condition: "Is",
        name: true,
        tags: false
    },
    {
        condition: "Contains",
        name: true,
        tags: true
    },
    {
        condition: "Does not contain",
        name: true,
        tags: true
    },
    {
        condition: "Starts with",
        name: true,
        tags: false
    },
    {
        condition: "Ends with",
        name: true,
        tags: false
    },
    {
        condition: "Is empty",
        name: true,
        tags: true
    },
    {
        condition: "Is not empty",
        name: true,
        tags: true
    }
];
const $ba30e20475feac5a$export$7db8a6d9638b83c = [
    {
        text: "Ascending",
        icon: "ascend-icon"
    },
    {
        text: "Descending",
        icon: "descend-icon"
    }
];
const $ba30e20475feac5a$export$ef83a296d35c3be3 = 36;
const $ba30e20475feac5a$export$aaab090273d3239c = 10;
const $ba30e20475feac5a$export$70e52e314dd3934f = 5;
const $ba30e20475feac5a$export$9175ce0e1c95daf2 = 5;
const $ba30e20475feac5a$export$f960febbf0f9955e = "Passwords Do Not Match";
const $ba30e20475feac5a$export$dd3f9e1f49e4b04 = "Space not Expected in Name Field";
const $ba30e20475feac5a$export$d014f8f30ebed911 = "Space not Expected in Username Field";
const $ba30e20475feac5a$export$3924b5c7d59faf31 = 204;
const $ba30e20475feac5a$export$480de9ed980a5f14 = [
    400,
    401,
    404
];
const $ba30e20475feac5a$export$f3d2dfdfe73d876c = "Email or Password Incorrect";
const $ba30e20475feac5a$export$83bce1aa6715d4a0 = "Invalid Data Supplied";
const $ba30e20475feac5a$export$8969b9a133925ee1 = {
    login: (placeholder)=>"Authentication Successful",
    create: (placeholder)=>"Account Created Successfully",
    loadTodos: (placeholder)=>"Data Loading Completed",
    updatePwd: (placeholder)=>"Password Changed Successfully",
    updateInfo: (placeholder)=>"User Info Updated Successfully",
    resetPwd: (APIResp)=>`${APIResp}\n Please fill in the form with the email details`,
    resetConfirmPwd: (APIResp)=>APIResp,
    getJournal: (APIResp)=>"Loading completed",
    getActiveTable: (APIResp)=>APIResp
};
const $ba30e20475feac5a$export$df866a82be182ca9 = [
    "create",
    "getJournal",
    "getActiveTable",
    "createTableItem",
    "updateTableItem",
    "createTag",
    "deleteTag",
    "updateTag",
    "deleteTableItem",
    "batchAddTags",
    "batchDeleteActivities",
    "duplicateTableItems",
    "updateTableName",
    "deleteTable",
    "duplicateTable",
    "createNewTable",
    "updateJournal",
    "updateJournalInfo",
    "updateInfo",
    "updatePwd",
    "batchTags"
];


var $11025e9b749ca6f8$exports = {};

$11025e9b749ca6f8$exports = new URL((parcelRequire("jUSBR")).resolve("eyyUD"), import.meta.url).toString();


const $bd02c871d9c5ba8e$var$pass = ()=>{};
const $bd02c871d9c5ba8e$export$9a00dee1beb8f576 = (value)=>{
    return value.slice(0, 1).toUpperCase() + value.slice(1);
};
const $bd02c871d9c5ba8e$export$900f2655bf6750e9 = (tagText)=>{
    if (tagText.length > (0, $ba30e20475feac5a$export$ef83a296d35c3be3)) return tagText.slice(0, (0, $ba30e20475feac5a$export$ef83a296d35c3be3)) + "...";
    return tagText;
};
const $bd02c871d9c5ba8e$export$782f00d935ef8172 = (tableId, tableFuncModel)=>{
    tableFuncModel[tableId] = {
        filter: {},
        sort: {}
    };
};
const $bd02c871d9c5ba8e$export$83e74882c5df8fe1 = (sec, actionType, fn)=>{
    return new Promise((_, reject)=>{
        setTimeout(()=>{
            const error = new Error(`Could not ${actionType} at this moment, Please try again later!`);
            reject(fn ? fn() && error : error);
        }, sec * 1000);
    });
};
const $bd02c871d9c5ba8e$export$3f5afbe3d2e2afe5 = (s, fn)=>{
    setTimeout(()=>fn(), s * 1000);
};
const $bd02c871d9c5ba8e$export$2aa76edf31d1ffa4 = (val, state)=>{
    let duplicateNums = [];
    state.tables.forEach((table)=>{
        const tempTable = table.tableTitle.split("(");
        const occurenceExists = tempTable[0].trim() === val.split("(")[0].trim() && tempTable[1]?.split(")")[0];
        //if the occurence number from the tables, push to dup array
        if (occurenceExists) duplicateNums.push(occurenceExists);
        if (!occurenceExists) duplicateNums.push(0);
    });
    const maxNum = duplicateNums.reduce((acc, nums)=>acc > nums ? acc : nums, 0);
    return maxNum;
};
const $bd02c871d9c5ba8e$export$aea217a45095ce11 = (identifier, nodeObj)=>{
    if (nodeObj) return nodeObj.querySelector(identifier);
    if (!nodeObj) return document.querySelector(identifier);
};
const $bd02c871d9c5ba8e$export$b0cf5a82061b8f99 = (e, className, evType)=>{
    if (!evType) return e.target.classList.contains(className) || e.target.closest(`.${className}`);
    if (evType) return e.type === evType && e.target.classList.contains(className) || e.target.closest(`.${className}`);
};
const $bd02c871d9c5ba8e$export$6a60b1c4474426 = (val, state)=>{
    const occurrence = state.tables.reduce((acc, table)=>table.tableTitle.split("(")[0].trim() === val.split("(")[0].trim() ? acc + 1 : acc + 0, 0);
    return occurrence;
};
const $bd02c871d9c5ba8e$export$2bcb3130099de669 = (occurrence, duplicateName)=>`${duplicateName} (${+occurrence + 1})`;
const $bd02c871d9c5ba8e$export$b434509d4a847712 = (date)=>{
    const dateTimeOptions = {
        hour: "2-digit",
        minute: "2-digit",
        month: "long",
        day: "2-digit",
        year: "numeric",
        timeZone: "UTC"
    };
    const formattedDate = new Intl.DateTimeFormat((0, $ba30e20475feac5a$export$74f24093aa91ad17), dateTimeOptions).format(date);
    return formattedDate.replace("at", ",");
};
const $bd02c871d9c5ba8e$export$82bb5aadcb51fd83 = (tagsToFormat)=>{
    const formattedTag = [];
    tagsToFormat.forEach((tags)=>{
        const tagObj = {};
        tags.classList.forEach((tag)=>tag.startsWith("color") ? tagObj.color = tag : $bd02c871d9c5ba8e$var$pass());
        tagObj.text = tags.textContent.trim();
        formattedTag.push(tagObj);
    });
    return formattedTag;
};
const $bd02c871d9c5ba8e$export$2fb4720fbf51caf0 = (tagHtmlData, state)=>{
    let tagIds = [];
    let tagsWithId = tagHtmlData.tags.map((tag)=>tag.dataset?.id ? Number(tag.dataset.id) : $bd02c871d9c5ba8e$var$pass()).filter((tagId)=>isFinite(tagId));
    //add the tags with id to the return array
    tagIds.push(...tagsWithId);
    //add tags without id
    $bd02c871d9c5ba8e$export$a7d3715ebfc4ab5b(tagIds, tagHtmlData, state, "tags");
    return tagIds;
};
const $bd02c871d9c5ba8e$export$da1e021e040b8232 = (tagToCreate, addMeta = false, tagMeta)=>{
    let formattedTags;
    if (!addMeta) formattedTags = {
        "tag_name": tagToCreate.text,
        "tag_color": tagToCreate.tagColor.color,
        "tag_class": tagToCreate.tagColor.color_value
    };
    if (addMeta) {
        const tagMetaObj = tagMeta.find((meta)=>meta.color_value.toLowerCase() === tagToCreate.color.toLowerCase());
        formattedTags = {
            "tag_name": tagToCreate.text,
            "tag_color": tagMetaObj.color,
            "tag_class": tagMetaObj.color_value
        };
        if (tagToCreate.id) formattedTags.id = tagToCreate.id;
    }
    return formattedTags;
};
const $bd02c871d9c5ba8e$export$4e823a815a183f47 = (string)=>{
    let hash = 0;
    if (string.length == 0) return hash;
    Array.from(string).forEach((str, i)=>{
        const char = string.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash;
    });
    return hash;
};
const $bd02c871d9c5ba8e$export$b2c0185dbf29dc67 = (item, i, pos)=>{
    return String(pos).includes("-") ? item[i - 1] : item[i + 1];
};
const $bd02c871d9c5ba8e$export$1cbff4cb65f2ce8b = (i, pos)=>String(pos).includes("-") ? i - 1 : i + 1;
const $bd02c871d9c5ba8e$export$b895d9282c5668b2 = (value, len)=>{
    if (value.length < len) return value;
    if (value.length === len) return value + "...";
    if (value.length > len) return value.slice(0, len) + "...";
};
const $bd02c871d9c5ba8e$export$ea06af93a82ca6d = (items, itemToAdd)=>{
    items.splice(3, 0, itemToAdd);
    items.reverse();
    const valueIndex = items.findIndex((item)=>item[1] === itemToAdd[1]);
    items.splice(valueIndex, 1);
    items.reverse();
    return items;
};
const $bd02c871d9c5ba8e$export$3c6dd118695d0c81 = (items, itemToSwapId)=>{
    const itemLength = items.length;
    if (itemLength > 4) {
        const itemToSwapIndex = items.findIndex((item)=>item[1] === itemToSwapId);
        if (itemToSwapIndex > 3) {
            const itemToSwap = items.splice(itemToSwapIndex, 1)[0];
            items.splice(3, 0, itemToSwap);
        }
    }
    return items;
};
const $bd02c871d9c5ba8e$export$4b9d67a8dfcf66c6 = (currentTableId, itemId, i)=>{
    if (!currentTableId & i < 1) return "table-row-active";
    if (currentTableId) return currentTableId && itemId === currentTableId ? "table-row-active" : "";
};
const $bd02c871d9c5ba8e$export$576702248a2b11e2 = (classList, fragId)=>{
    return `
    <div class="svg-icon-box ${classList}">
      <svg class="svg-icon">
        <use href="${0, (/*@__PURE__*/$parcel$interopDefault($11025e9b749ca6f8$exports))}#${fragId}"></use>
      </svg>
    </div>
  `;
};
const $bd02c871d9c5ba8e$export$1cb11c76e8737f84 = (ev, className)=>{
    //on selects based on thee classlist and not with closest
    if (ev.target.classList.contains(className)) return true;
};
const $bd02c871d9c5ba8e$export$a621ca3319930c36 = (ev, className, optional)=>{
    if (ev.target.classList.contains(className) || ev.target.closest(`.${className}`)) return true;
    if (optional && ev.target.nodeName.toLowerCase() === optional) return true;
};
const $bd02c871d9c5ba8e$export$b6519d8066b4f30a = (ev, id, optional)=>{
    if (ev.target.id === id || ev.target.closest(`#${id}`)) return true;
};
const $bd02c871d9c5ba8e$export$1b32400f7b0a64cc = (ev, className)=>{
    if (ev.target.querySelector(`.${className}`)) return true;
};
const $bd02c871d9c5ba8e$export$85cbb009eead2583 = (ev, className, optional)=>{
    const condition = ev.key === "Escape" || ev.type === "click";
    if (condition) return $bd02c871d9c5ba8e$export$a621ca3319930c36(ev, className, optional);
};
const $bd02c871d9c5ba8e$export$a9405bec26d98673 = function(APIResp, type) {
    let formatList = [];
    if (APIResp.length > 1 || APIResp.length === 1) {
        APIResp.forEach((resp)=>formatList.push($bd02c871d9c5ba8e$export$8c27844e107da08(resp, type)));
        return formatList;
    }
    return APIResp;
};
const $bd02c871d9c5ba8e$export$6cbb15e4ad71b87b = function(APIResp, type) {
    let formatList = [];
    if (APIResp.length > 1 || APIResp.length === 1) {
        APIResp.forEach((resp)=>formatList.push(+resp.dataset.id));
        return formatList;
    }
    return APIResp;
};
const $bd02c871d9c5ba8e$export$7e2f5a5c02c1c762 = function(payload, type) {
    let formattedRequest;
    if (type === "tagsValue") {
        formattedRequest = {
            "tag_class": payload.tag.color,
            "tag_name": payload.tag.text,
            "tag_color": (0, $ba30e20475feac5a$export$8f01201217c59cf3).colors.find((color)=>color.color_value == payload.tag.color).color
        };
        if (payload.tag.id) formattedRequest["id"] = payload.tag.id;
    }
    return formattedRequest;
};
const $bd02c871d9c5ba8e$export$224e4749c4a088cf = function(APIResp, type) {
    let formattedData = [];
    if (APIResp.length > 0) {
        APIResp.forEach((resp)=>{
            let formatAPITableItem = {
                "id": resp.id,
                "itemTitle": resp.name,
                "itemTags": $bd02c871d9c5ba8e$export$a9405bec26d98673(resp.tags, "tags"),
                "actionItems": $bd02c871d9c5ba8e$export$a9405bec26d98673(resp.action_items, "actionItems"),
                "intentions": $bd02c871d9c5ba8e$export$a9405bec26d98673(resp.intentions, "intentions"),
                "happenings": $bd02c871d9c5ba8e$export$a9405bec26d98673(resp.happenings, "happenings"),
                "gratefulFor": $bd02c871d9c5ba8e$export$a9405bec26d98673(resp.grateful_for, "gratefulFor"),
                "created": Date.now(resp.created)
            };
            formattedData.push(formatAPITableItem);
        });
        return formattedData;
    }
    if (!APIResp.length > 0) return APIResp;
};
const $bd02c871d9c5ba8e$export$8c27844e107da08 = function(APIResp, type) {
    let formattedData;
    if (type === "journal") formattedData = {
        "id": APIResp.id,
        "name": APIResp.journal_name,
        "description": APIResp.journal_description,
        "tableHeads": APIResp.journal_tables,
        "currentTable": APIResp.current_table,
        "tags": $bd02c871d9c5ba8e$export$a9405bec26d98673(APIResp.tags, "apiTags"),
        "tableFunc": APIResp.journal_table_func,
        "username": APIResp.username
    };
    if (type === "apiTags") formattedData = {
        "id": APIResp.id,
        "text": APIResp.tag_name,
        "color": APIResp.tag_class
    };
    if (type === "journalTables") formattedData = {
        "id": APIResp.id,
        "tableTitle": APIResp.table_name,
        "tableItems": $bd02c871d9c5ba8e$export$224e4749c4a088cf(APIResp.activities, "activities")
    };
    if (type === "actionItems") formattedData = {
        "id": APIResp.id,
        "text": APIResp.action_item,
        "checkbox": true,
        "checked": APIResp.checked
    };
    if (type === "intentions") formattedData = {
        "id": APIResp.id,
        "text": APIResp.intention
    };
    if (type === "happenings") formattedData = {
        "id": APIResp.id,
        "text": APIResp.happening
    };
    if (type === "gratefulFor") formattedData = {
        "id": APIResp.id,
        "text": APIResp.grateful_for
    };
    if (type === "tags") formattedData = APIResp.id;
    return formattedData;
};
const $bd02c871d9c5ba8e$var$getSubModelField = (submodel)=>{
    if (submodel !== "grateful_for") return submodel.slice(0, submodel.length - 1);
    return submodel;
};
const $bd02c871d9c5ba8e$var$createSubModelPayload = function(payload, submodel) {
    let formattedRequest = {};
    const subModelField = $bd02c871d9c5ba8e$var$getSubModelField(submodel);
    //submodel value
    formattedRequest[submodel] = {
        activity: payload.itemId,
        update_and_create: payload?.modelProperty?.property?.updateAndAddProperty,
        update_only: payload?.modelProperty?.updateProperty,
        type: submodel,
        delete_only: payload?.modelProperty?.property?.delete ? true : false
    };
    //add update value
    payload?.modelProperty?.property?.update && (formattedRequest[submodel].update = {
        id: payload?.modelProperty?.property?.update?.propertyId.length > 0 ? Number(payload?.modelProperty?.property?.update?.propertyId) : null
    });
    //add subfield value
    if (formattedRequest[submodel].update) formattedRequest[submodel].update[subModelField] = payload?.modelProperty?.property?.update?.value ?? null;
    //add create value
    payload?.modelProperty?.property?.create ? formattedRequest[submodel].create = {
        relative_item: payload?.modelProperty?.property?.create?.relativeProperty,
        ordering: payload?.modelProperty?.property?.create?.ordering
    } : formattedRequest[submodel].create = null;
    if (formattedRequest[submodel]?.create) formattedRequest[submodel].create[subModelField] = payload?.modelProperty?.property?.create?.value;
    //add ordering list value
    if (payload?.modelProperty?.property?.orderingList) formattedRequest[submodel].ordering_list = payload.modelProperty.property.orderingList;
    //add action item checkbox
    if (payload?.modelProperty?.property?.updateActionItem) formattedRequest[submodel].update_action_item_checked = {
        checked: payload?.modelProperty.property.updateActionItem.checked,
        key: payload?.modelProperty.property.updateActionItem.key,
        id: Number(payload?.modelProperty.property.updateActionItem.propertyId),
        update_checked: true,
        type: "action_items"
    };
    if (payload?.modelProperty?.property?.delete) formattedRequest[submodel].delete = {
        id: payload.modelProperty.property.delete.propertyId
    };
    return formattedRequest;
};
const $bd02c871d9c5ba8e$var$getIdsFromTagsDiv = (tags)=>{
    const tagsWithId = tags.map((tag)=>tag?.dataset?.id ? +tag.dataset.id : $bd02c871d9c5ba8e$var$pass()).filter((tag)=>tag);
    return tagsWithId;
};
const $bd02c871d9c5ba8e$export$484d39074d488c85 = function(payload, type) {
    let formattedRequest;
    if (type === "title") formattedRequest = {
        "name": payload?.title ?? ""
    };
    if (type === "tags") formattedRequest = $bd02c871d9c5ba8e$var$getIdsFromTagsDiv(payload.tags);
    if (type === "selectTags") formattedRequest = {
        "activities_list": [
            {
                "ids": payload.itemIds.map((id)=>+id),
                "tags": $bd02c871d9c5ba8e$var$getIdsFromTagsDiv(payload.tags)
            }
        ]
    };
    if (type === "deleteTableItems") formattedRequest = {
        "delete_list": payload.items.map((id)=>+id)
    };
    if (type === "duplicateTableItems") formattedRequest = {
        "duplicate_list": [
            {
                "ids": payload.items.map((id)=>+id)
            }
        ]
    };
    if (type === "intentions") formattedRequest = $bd02c871d9c5ba8e$var$createSubModelPayload(payload, "intentions");
    if (type === "happenings") formattedRequest = $bd02c871d9c5ba8e$var$createSubModelPayload(payload, "happenings");
    if (type === "actionItems") formattedRequest = $bd02c871d9c5ba8e$var$createSubModelPayload(payload, "action_items");
    if (type === "gratefulFor") formattedRequest = $bd02c871d9c5ba8e$var$createSubModelPayload(payload, "grateful_for");
    return formattedRequest;
};
const $bd02c871d9c5ba8e$export$a7d3715ebfc4ab5b = function(returnPayload, payload, state, type) {
    if (type === "tags") {
        const tagsWithoutId = payload.tags.map((tag)=>tag.dataset?.id === "undefined" ? tag : $bd02c871d9c5ba8e$var$pass()).filter((tag)=>tag);
        tagsWithoutId.forEach((tagObj)=>{
            const objExistInTableTags = state.tags.find((tag)=>tag.text.toLowerCase() === tagObj.textContent.replaceAll("\n", "").trim().toLowerCase());
            if (objExistInTableTags) returnPayload?.tags?.push(objExistInTableTags.id) ?? returnPayload.push(objExistInTableTags.id);
        });
    }
};
const $bd02c871d9c5ba8e$export$ea0a2d2ae29ba628 = function() {
    return new Date(Date.now()).toISOString();
};
const $bd02c871d9c5ba8e$export$69aa05a054234e1c = function(createRelativeProperty) {
    let incrementOrderingIndex = false;
    let createItemOrdering = null;
    const itemsOrdering = Array.from(document.querySelectorAll(`.row-actions-handler-container`)).map((item, i)=>{
        if (createRelativeProperty && Number(item.dataset.id) === createRelativeProperty) {
            incrementOrderingIndex = true;
            createItemOrdering = i + 2;
            return {
                id: Number(item.dataset.id),
                ordering: i + 1
            };
        }
        return {
            id: Number(item.dataset.id),
            ordering: incrementOrderingIndex ? i + 2 : i + 1
        };
    });
    return {
        create_item_ordering: createItemOrdering,
        table_items_ordering: itemsOrdering
    };
};
const $bd02c871d9c5ba8e$export$4b9b5189b0a2dc1f = function(currentTable, relativeItem = false) {
    const payload = {
        "name": "",
        "journal_table": currentTable.id
    };
    if (relativeItem) payload["ordering_list"] = $bd02c871d9c5ba8e$export$69aa05a054234e1c(relativeItem);
    return payload;
};
const $bd02c871d9c5ba8e$export$370b585cd97e8589 = (username)=>{
    const headingName = `${username.slice(0, 1).toUpperCase() + username.slice(1)}'s Journal`;
    return `${headingName.slice(0, 15)}...`;
};
const $bd02c871d9c5ba8e$export$dad11d50b7e7c865 = ()=>{};
const $bd02c871d9c5ba8e$export$afb3565a72efce83 = ()=>{};




class $d2866451d1c7a9c0$var$ComponentOptionsView {
    _overlayCount = 0;
    _overlayContainer = document.querySelector(".overlay-container");
    static _convertHTMLStringToElement(html) {
        const template = document.createElement("template");
        html = html.trim();
        template.innerHTML = html;
        return template.content.firstChild;
    }
    static createHTMLElement(html) {
        return $d2866451d1c7a9c0$var$ComponentOptionsView._convertHTMLStringToElement(html);
    }
    _componentRender(componentObj) {
        const container = document.querySelector(componentObj.container);
        const componentContainer = document.querySelector(componentObj.componentContainer);
        container.insertAdjacentHTML(componentObj.insertPosition, componentObj.markup);
        const component = container.querySelector(componentObj.selector);
        //toggle the component active on the container
        componentObj?.toggle && container.classList.toggle(componentObj.toggle);
        return component;
    }
    _addOverlayDefault(componentObj, overlay, overlayCount, disableOverlayInterceptor) {
        //content styling
        overlay.querySelector(".overlay-content").setAttribute("style", `top: ${componentObj.top}px; left: ${componentObj.left}px;`);
        //content filler styling
        overlay.querySelector(".overlay-content-fill").setAttribute("style", `width: ${componentObj.width + "px"}; height: ${overlayCount > 1 ? componentObj.height : "0px"}`);
        if (!disableOverlayInterceptor) overlay.querySelector(".overlay-filler").classList.toggle("fill");
    }
    _addOverlayNotifier(overlay, disableOverlayInterceptor) {
        if (!disableOverlayInterceptor) {
            overlay.querySelector(".overlay-filler").style.backgroundColor = "rgba(15, 15, 15, 0.6)";
            overlay.querySelector(".overlay-filler").classList.toggle("fill");
        }
        overlay.querySelector(".overlay-content").setAttribute("style", "top: 40%; left: 40%");
    }
    _componentOverlay(componentObj, disableOverlayInterceptor = false) {
        this._overlayCount < 1 ? this._overlayCount = 1 : this._overlayCount++;
        const overlayMarkup = this._generateOverlayMarkup(componentObj.markup);
        const overlay = this.constructor._convertHTMLStringToElement(overlayMarkup);
        //set the positioning of
        this._overlayCount === 1 ? overlay.style.zIndex = 1 : overlay.style.zIndex = this._overlayCount;
        if (componentObj.notify) this._addOverlayNotifier(overlay, disableOverlayInterceptor);
        if (!componentObj.notify) this._addOverlayDefault(componentObj, overlay, this._overlayCount, disableOverlayInterceptor);
        this._overlayContainer.insertAdjacentElement("beforeend", overlay);
        const component = overlay.querySelector(componentObj.selector);
        const overlayInterceptor = overlay.querySelector(".overlay-filler");
        return {
            overlay: overlay,
            overlayInterceptor: overlayInterceptor,
            component: component
        };
    }
    _componentRemover(componentObj, component, mutate = true) {
        if (componentObj.componentInput) {
            componentObj.component.textContent = componentObj.componentInput.textContent;
            componentObj.componentInput.remove();
            componentObj.overlay.remove();
            //an empty update obj as to be passed with the updateModel function
            componentObj.updateObj.title = componentObj.component.textContent;
        }
        if (!componentObj.componentInput) {
            if (componentObj.updateTag) {
                const addedTags = componentObj.component.querySelector(".tags-items");
                componentObj.updateObj.tags = Array.from(addedTags.children).slice(0, -1);
            }
            componentObj.component?.remove() ?? component?.remove();
            componentObj.overlay.remove();
        }
        if (mutate) {
            if (componentObj.callBack) Array.isArray(componentObj.callBack) ? componentObj.callBack.forEach((cb)=>cb()) : componentObj.callBack();
            if (componentObj.updateModel) //update model gets called with the bounded updateObj
            componentObj.updateModel();
        }
        //reset overlayCount relative to the overlays on page
        this._overlayCount > 0 ? this._overlayCount-- : this._overlayCount;
    }
    _updateOverlayCounter() {
        this._overlayCount > 0 ? this._overlayCount-- : this._overlayCount;
    }
    _removeElements(...elements) {
        elements.forEach((el)=>el.remove());
    }
    _generateOverlayMarkup(optionsMarkup) {
        return `
        <div class="overlay">
          <div>
            <div class="overlay-filler">
            </div>
            <div class="overlay-content">
              <div class="overlay-content-fill">
              </div>
              <div class="overlay-content-holder">
                <div class="overlay-content-content">
                  ${optionsMarkup}
                </div>
              </div>
            </div>
          </div>
        </div>
      `;
    }
}
const $d2866451d1c7a9c0$export$721ff339e60fcc47 = {
    cls: $d2866451d1c7a9c0$var$ComponentOptionsView,
    import: ()=>new $d2866451d1c7a9c0$var$ComponentOptionsView(),
    object: null
};


class $09d840f20da32b41$export$c6fdb837b070b4ff {
    _eventListeners = [
        "click",
        "keyup"
    ];
    _componentHandler = (0, $d2866451d1c7a9c0$export$721ff339e60fcc47).cls;
    constructor(contentComponent, disableEvents = false, position, extraClassName = false){
        this.contentComponent = contentComponent;
        this.positionEl = document.querySelector("body");
        this.position = position;
        this.extraClassName = extraClassName;
        this._component = this.component();
        this.disableEvents = disableEvents;
    }
    component() {
        this._component = this._componentHandler.createHTMLElement(this._generateMarkup());
        // this.overlay = this._component.querySelector(".login-overlay")
        const overlayContent = this._component.querySelector(`${this.extraClassName ? ".form-container-above" : ".form-container"}`);
        //change content position based on defined params
        if (this.position) this._modifyPosition(this.position, overlayContent);
        overlayContent.insertAdjacentElement("beforeend", this.contentComponent.getComponent());
        return this._component;
    }
    render() {
        const cls = this;
        this.positionEl.insertAdjacentElement("beforeend", this._component);
        if (!this.disableEvents) {
            this._component.addEventListener(cls._eventListeners[0], cls._handleEvents.bind(cls));
            window.addEventListener(cls._eventListeners[1], cls._handleEvents.bind(cls));
        }
    }
    _modifyPosition(modifyObj, node) {
        node.style.top = `${modifyObj.top}%`;
        node.style.left = `${modifyObj.left}%`;
    }
    _handleEvents(ev) {
        if ((0, $bd02c871d9c5ba8e$export$85cbb009eead2583)(ev, "login-overlay-bkg", "body")) this.remove();
        if ((0, $bd02c871d9c5ba8e$export$85cbb009eead2583)(ev, "close-form", "body")) this.remove();
    }
    _generateMarkup() {
        return `
            <div class="login-overlay">
                <div class="login-overlay-bkg"></div>
                <div class="${this.extraClassName ? "form-container-above" : "form-container"}">
                    
                </div>
            </div>
        `;
    }
    remove() {
        const cls = this;
        if (!this.disableEvents) {
            this._eventListeners.forEach((ev)=>{
                this._component.removeEventListener(ev, cls._handleEvents);
                window.removeEventListener(ev, cls._handleEvents);
            });
            //remove content component
            this.contentComponent.remove(true);
        }
        this._component.remove();
        delete this;
    }
}



class $6d26a31173b096a8$export$3b0d6d7590275603 {
    constructor(timeout, actionType, syncMsg = false){
        this.timeout = timeout;
        this.syncMsg = syncMsg;
    }
    component() {
        this._component = (0, $d2866451d1c7a9c0$export$721ff339e60fcc47).cls.createHTMLElement(this._generateMarkup());
        this.overlay = new (0, $09d840f20da32b41$export$c6fdb837b070b4ff)(this, true, {
            top: 40,
            left: 49
        }, true);
        this.overlay.render();
    }
    getComponent() {
        return this._component;
    }
    _generateMarkup() {
        if (this.syncMsg) return `
                <div>
                    <div class="custom-loader"></div>
                    <div class="loader-sync-msg">Syncing Data Please Wait ...</div>
                </div>
            `;
        if (!this.syncMsg) return `
                <div>
                    <div class="custom-loader"></div>
                </div>
            `;
    }
    remove() {
        this.overlay.remove();
        this._component.remove();
        delete this;
    }
}




class $c2721d55d807f8b0$export$caec2af78bcc877f {
    _eventListeners = [
        "click"
    ];
    timeout = 3 // 1 sec to timeout
    ;
    constructor(msg, timeout, alertType){
        this.msg = msg;
        this.timeout = timeout ?? this.timeout;
        this.alertType = alertType;
    }
    component() {
        const cls = this;
        this._component = (0, $d2866451d1c7a9c0$export$721ff339e60fcc47).cls.createHTMLElement(this._generateMarkup());
        this._eventListeners.forEach((ev)=>this._component.addEventListener(ev, cls._handleEvents.bind(cls)));
        (0, $bd02c871d9c5ba8e$export$aea217a45095ce11)("body").insertAdjacentElement("afterbegin", this._component);
        //remove component after set timeout
        (0, $bd02c871d9c5ba8e$export$3f5afbe3d2e2afe5)(this.timeout, this.remove.bind(cls));
    }
    _handleEvents(ev) {
        if ((0, $bd02c871d9c5ba8e$export$a621ca3319930c36)(ev, "alert")) this.remove();
    }
    _generateMarkup(success = false) {
        return `
            <div class="alert">
                <div class="alert-icon alert-${this.alertType}">
                    ${this._svgMarkup(this.alertType)}
                </div>
                <div class="alert-msg">
                    ${this.msg}
                </div>
            </div>
        `;
    }
    _svgMarkup(alertType) {
        if (alertType === "success") return `
                <svg class="alert-${this.alertType}-icon" xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
                    <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                </svg>
            `;
        else return `
                <svg class="alert-${this.alertType}-icon" xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512">
                    <path d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/>
                </svg>
            `;
    }
    remove() {
        const cls = this;
        this._eventListeners.forEach((ev)=>this._component.removeEventListener(ev, cls._handleEvents.bind(cls)));
        this._component.remove();
        delete this;
    }
}


class $db1f432b457e32b4$export$2c4e825dc9120f87 {
    static APIEnum = {
        USER: {
            CREATE: "user/create/",
            GET: "user/me/",
            PUT: "user/me/",
            PATCH: "user/me/",
            TOKEN: "user/token/",
            UPDATE_INFO: "user/update_info/",
            UPDATE_PWD: "user/change_password/",
            RESET_PWD: "user/password-reset/",
            RESET_PWD_CONFIRM: "user/password-reset-confirm/"
        },
        JOURNAL: {
            CREATE: "journal/journals/",
            LIST: "journal/journals/",
            // BATCH_CREATE: "todo/todos/batch_create/",
            GET: (journalId)=>`journal/journals/${journalId}/`,
            PUT: (journalId)=>`journal/journals/${journalId}/`,
            PATCH: (journalId)=>`journal/journals/${journalId}/`,
            // BATCH_UPDATE_ORDERING: "todo/todos/batch_update_ordering/",
            // BATCH_UPDATE: "todo/todos/batch_update/",
            DELETE: (journalId)=>`journal/journals/${journalId}/`
        },
        JOURNAL_TABLES: {
            CREATE: "journal/journal-tables/",
            LIST: "journal/journal-tables/",
            // BATCH_CREATE: "todo/todos/batch_create/",
            GET: (tableId)=>`journal/journal-tables/${tableId}/`,
            PUT: (tableId)=>`journal/journal-tables/${tableId}/`,
            PATCH: (tableId)=>`journal/journal-tables/${tableId}/`,
            // BATCH_UPDATE_ORDERING: "todo/todos/batch_update_ordering/",
            // BATCH_UPDATE: "todo/todos/batch_update/",
            DELETE: (tableId)=>`journal/journal-tables/${tableId}/`
        },
        TAG: {
            CREATE: "journal/tags/",
            CREATED: "journal/kljdaslkfjdl",
            LIST: "journal/tags/",
            BATCH_TAG: "journal/tags/batch_tag_processor/",
            // BATCH_CREATE: "todo/todos/batch_create/",
            GET: (tagId)=>`journal/tags/${tagId}/`,
            PUT: (tagId)=>`journal/tags/${tagId}/`,
            PATCH: (tagId)=>`journal/tags/${tagId}/`,
            PATCHED: "journal/tags/lkdjiovjafdadf/",
            // BATCH_UPDATE_ORDERING: "todo/todos/batch_update_ordering/",
            // BATCH_UPDATE: "todo/todos/batch_update/",
            DELETE: (tagId)=>`journal/tags/${tagId}/`,
            DELETED: "journal/tags/kldsjflkasdjfdfs/"
        },
        ACTIVITIES: {
            CREATE: "journal/activities/",
            LIST: "journal/activities/",
            // BATCH_CREATE: "todo/todos/batch_create/",
            GET: (activityId)=>`journal/activities/${activityId}/`,
            PUT: (activityId)=>`journal/activities/${activityId}/`,
            PATCH: (activityId)=>`journal/activities/${activityId}/`,
            PATCHED: "journal/activities/kdjfalsdfasddf/",
            BATCH_UPDATE_ACTIVITIES: "journal/activities/batch_update_activities/",
            BATCH_DELETE_ACTIVITIES: "journal/activities/batch_delete_activities/",
            BATCH_DUPLICATE_ACTIVITIES: "journal/activities/batch_duplicate_activities/",
            DELETE: (activityId)=>`journal/activities/${activityId}/`
        },
        SUBMODEL: {
            CREATE: (subModel, subModelId)=>`journal/${subModel}/`,
            LIST: (subModel, subModelId)=>`journal/${subModel}/`,
            GET: (subModel, subModelId)=>`journal/${subModel}/${subModelId}/`,
            PUT: (subModel, subModelId)=>`journal/${subModel}/${subModelId}/`,
            PATCH: (subModel, subModelId)=>`journal/${subModel}/${subModelId}/`,
            DELETE: (subModel, subModelId)=>`journal/${subModel}/${subModelId}/`,
            DELETED: "journal/djfldsjflakdfsdfd/dsfkasdfjdsfdsfdf/"
        }
    };
    static timeout = 20 //timeout in 20s
    ;
    static getSubmodelEndpoint(subModel, method, subModelId) {
        return $db1f432b457e32b4$export$2c4e825dc9120f87.APIEnum.SUBMODEL[method](subModel, subModelId);
    }
    static getBatchEndpoint(type) {
        if (type === "selectTags") return $db1f432b457e32b4$export$2c4e825dc9120f87.APIEnum.ACTIVITIES.BATCH_UPDATE_ACTIVITIES;
        if (type === "deleteTableItems") return $db1f432b457e32b4$export$2c4e825dc9120f87.APIEnum.ACTIVITIES.BATCH_DELETE_ACTIVITIES;
    }
    static queryAPI(queryObj) {
        //switch the timeout secs if null
        queryObj.sec = queryObj.sec ?? $db1f432b457e32b4$export$2c4e825dc9120f87.timeout;
        //create the loader based on the queryObj
        $db1f432b457e32b4$export$2c4e825dc9120f87.loaderCreator(queryObj);
        (async ()=>await $db1f432b457e32b4$export$2c4e825dc9120f87.querier(queryObj))().then((returnData)=>{
            if (returnData) {
                queryObj.loader && queryObj.loader.remove();
                if (queryObj.successAlert) queryObj.alert && new (0, $c2721d55d807f8b0$export$caec2af78bcc877f)((0, $ba30e20475feac5a$export$8969b9a133925ee1)[queryObj.actionType](returnData), null, "success").component();
                if (queryObj.callBack) queryObj.callBack(returnData, queryObj.callBackParam ?? true);
                queryObj = {};
            }
            if (!returnData && queryObj.callBack) queryObj.callBack();
            //call the fallback to handle thee failure
            //if token expired render credeential issues msg and logout user
            if (queryObj.resStatus === 401) {
                new (0, $c2721d55d807f8b0$export$caec2af78bcc877f)((0, $ba30e20475feac5a$export$8969b9a133925ee1)[queryObj.actionType](returnData), null, "success").component();
                (0, $bd02c871d9c5ba8e$export$3f5afbe3d2e2afe5)(2, $db1f432b457e32b4$export$2c4e825dc9120f87.logoutUser);
            }
        });
    }
    static async querier(queryObj) {
        let data = null;
        try {
            const res = await Promise.race([
                $db1f432b457e32b4$export$2c4e825dc9120f87.makeRequest(queryObj),
                (0, $bd02c871d9c5ba8e$export$83e74882c5df8fe1)(queryObj.sec, queryObj.actionType)
            ]) //TODO: Add fns to the timeout function
            ;
            const resContent = res.status !== (0, $ba30e20475feac5a$export$3924b5c7d59faf31) ? await res.json() : {};
            if (!res.ok) throw new Error(`${(0, $ba30e20475feac5a$export$480de9ed980a5f14).find((s)=>s === res.status) ? $db1f432b457e32b4$export$2c4e825dc9120f87.getResponseToRender(resContent, queryObj, res.status) : res.message} (${res.status})`);
            if (!resContent.non_field_errors) data = $db1f432b457e32b4$export$2c4e825dc9120f87.destructureSuccessResponse(resContent, queryObj);
        } catch (err) {
            if (queryObj.loader) await queryObj.loader.remove();
            if (queryObj.alert) await new (0, $c2721d55d807f8b0$export$caec2af78bcc877f)(!queryObj.successAlert ? queryObj.actionType === "deleteTable" ? err.message : "Request Failed Please try again later" : err.message ?? err, null, "error").component();
        // if(queryObj.resStatus === 401) API.logoutUser()
        } finally{
            return data;
        }
    }
    static getResponseToRender(response, queryObj, resStatus) {
        if (!queryObj.alert) return;
        //set the resStatus on the queryObj
        if (resStatus) queryObj.resStatus = resStatus;
        if (response.non_field_errors) return 0, $ba30e20475feac5a$export$f3d2dfdfe73d876c;
        if (response instanceof Array) return response[0];
        const formError = Object.getOwnPropertyNames(response);
        const formErrorsLength = Object.getOwnPropertyNames(response).length;
        if (formErrorsLength > 0) return (()=>{
            // const formDataRequests = ["login","updatePwd","updateInfo","create","resetPwd","resetConfirmPwd"]
            if (queryObj.callBack) queryObj.callBack(response);
            return formErrorsLength >= 1 ? $db1f432b457e32b4$export$2c4e825dc9120f87.destructureError(response[formError[0]], formError[0]) : queryObj.actionType === "create" ? (0, $ba30e20475feac5a$export$83bce1aa6715d4a0) : $db1f432b457e32b4$export$2c4e825dc9120f87.destructureError(response[formError[0]], formError[0]);
        })();
    }
    static loaderCreator(queryObj) {
        if (queryObj.spinner) {
            //add the loader to the queryObj
            queryObj.loader = new (0, $6d26a31173b096a8$export$3b0d6d7590275603)(queryObj.sec);
            queryObj.loader.component();
        }
    }
    static destructureError(error, key) {
        if (error instanceof Object) return error[key] ?? error.join("\n");
        if (error instanceof Array) return error.join("\n");
        return error;
    }
    static destructureSuccessResponse(resp, queryObj) {
        const preventDestructureList = (0, $ba30e20475feac5a$export$df866a82be182ca9);
        let preventDestructure = false;
        //if theres an empty data value returned as an empty array reeturn it
        if (resp instanceof Array && resp.length === 0) return resp;
        //if its not empty destructure
        if (resp instanceof Object) {
            preventDestructure = preventDestructureList.some((listItem)=>listItem === queryObj.actionType);
            if (!preventDestructure) {
                const respKey = Object.keys(resp);
                return resp[respKey[0]];
            }
        }
        return resp;
    }
    static makeRequest(queryObj) {
        switch(queryObj.type){
            case "POST":
                return $db1f432b457e32b4$export$2c4e825dc9120f87.requestJSON(queryObj);
            case "PATCH":
                return $db1f432b457e32b4$export$2c4e825dc9120f87.requestJSON(queryObj);
            case "DELETE":
                return $db1f432b457e32b4$export$2c4e825dc9120f87.requestJSON(queryObj);
            case "PUT":
                return $db1f432b457e32b4$export$2c4e825dc9120f87.requestJSON(queryObj);
            case "GET":
                return $db1f432b457e32b4$export$2c4e825dc9120f87.requestJSON(queryObj);
            default:
                return fetch(`${(0, $ba30e20475feac5a$export$37b96ba04a8c05d1)}${queryObj.endpoint}`, queryObj.queryData);
        }
    }
    static requestJSON(queryObj) {
        const fetchParams = {
            method: queryObj.type,
            headers: {
                "Content-Type": "application/json"
            }
        };
        if (queryObj.queryData) fetchParams.body = JSON.stringify(queryObj.queryData);
        if (queryObj.token) fetchParams.headers.Authorization = `Token ${queryObj.token}`;
        return fetch(`${(0, $ba30e20475feac5a$export$37b96ba04a8c05d1)}${queryObj.endpoint}`, fetchParams);
    }
    static logoutUser() {
        localStorage.removeItem("token");
        window.location.reload();
    }
}




/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $cb8ececfecd0309c$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $cb8ececfecd0309c$export$2e2bcd8739ae039 = $cb8ececfecd0309c$var$listCacheClear;


/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $fa799df2e830873c$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $fa799df2e830873c$export$2e2bcd8739ae039 = $fa799df2e830873c$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $ae20ab4a6778d088$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $fa799df2e830873c$export$2e2bcd8739ae039)(array[length][0], key)) return length;
    }
    return -1;
}
var $ae20ab4a6778d088$export$2e2bcd8739ae039 = $ae20ab4a6778d088$var$assocIndexOf;


/** Used for built-in method references. */ var $9f105a2cb198cf75$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $9f105a2cb198cf75$var$splice = $9f105a2cb198cf75$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9f105a2cb198cf75$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $ae20ab4a6778d088$export$2e2bcd8739ae039)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $9f105a2cb198cf75$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $9f105a2cb198cf75$export$2e2bcd8739ae039 = $9f105a2cb198cf75$var$listCacheDelete;



/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $a69a48810b4d495b$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $ae20ab4a6778d088$export$2e2bcd8739ae039)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $a69a48810b4d495b$export$2e2bcd8739ae039 = $a69a48810b4d495b$var$listCacheGet;



/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $40b84863e34edf18$var$listCacheHas(key) {
    return (0, $ae20ab4a6778d088$export$2e2bcd8739ae039)(this.__data__, key) > -1;
}
var $40b84863e34edf18$export$2e2bcd8739ae039 = $40b84863e34edf18$var$listCacheHas;



/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $474f7d7f66ed40d6$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $ae20ab4a6778d088$export$2e2bcd8739ae039)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $474f7d7f66ed40d6$export$2e2bcd8739ae039 = $474f7d7f66ed40d6$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f3bb2bde4f3d2e10$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$f3bb2bde4f3d2e10$var$ListCache.prototype.clear = (0, $cb8ececfecd0309c$export$2e2bcd8739ae039);
$f3bb2bde4f3d2e10$var$ListCache.prototype["delete"] = (0, $9f105a2cb198cf75$export$2e2bcd8739ae039);
$f3bb2bde4f3d2e10$var$ListCache.prototype.get = (0, $a69a48810b4d495b$export$2e2bcd8739ae039);
$f3bb2bde4f3d2e10$var$ListCache.prototype.has = (0, $40b84863e34edf18$export$2e2bcd8739ae039);
$f3bb2bde4f3d2e10$var$ListCache.prototype.set = (0, $474f7d7f66ed40d6$export$2e2bcd8739ae039);
var $f3bb2bde4f3d2e10$export$2e2bcd8739ae039 = $f3bb2bde4f3d2e10$var$ListCache;



/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $926693c1c5aa1b3b$var$stackClear() {
    this.__data__ = new (0, $f3bb2bde4f3d2e10$export$2e2bcd8739ae039);
    this.size = 0;
}
var $926693c1c5aa1b3b$export$2e2bcd8739ae039 = $926693c1c5aa1b3b$var$stackClear;


/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44217bb0c3913906$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
var $44217bb0c3913906$export$2e2bcd8739ae039 = $44217bb0c3913906$var$stackDelete;


/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fabb8c13d7ec2da0$var$stackGet(key) {
    return this.__data__.get(key);
}
var $fabb8c13d7ec2da0$export$2e2bcd8739ae039 = $fabb8c13d7ec2da0$var$stackGet;


/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $8121243fb2037ab0$var$stackHas(key) {
    return this.__data__.has(key);
}
var $8121243fb2037ab0$export$2e2bcd8739ae039 = $8121243fb2037ab0$var$stackHas;




var $2mpFt = parcelRequire("2mpFt");
/** Built-in value references. */ var $f302ffc9a48734c4$var$Symbol = (0, $2mpFt.default).Symbol;
var $f302ffc9a48734c4$export$2e2bcd8739ae039 = $f302ffc9a48734c4$var$Symbol;



/** Used for built-in method references. */ var $59fc01f5e412f819$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $59fc01f5e412f819$var$hasOwnProperty = $59fc01f5e412f819$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $59fc01f5e412f819$var$nativeObjectToString = $59fc01f5e412f819$var$objectProto.toString;
/** Built-in value references. */ var $59fc01f5e412f819$var$symToStringTag = (0, $f302ffc9a48734c4$export$2e2bcd8739ae039) ? (0, $f302ffc9a48734c4$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $59fc01f5e412f819$var$getRawTag(value) {
    var isOwn = $59fc01f5e412f819$var$hasOwnProperty.call(value, $59fc01f5e412f819$var$symToStringTag), tag = value[$59fc01f5e412f819$var$symToStringTag];
    try {
        value[$59fc01f5e412f819$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $59fc01f5e412f819$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$59fc01f5e412f819$var$symToStringTag] = tag;
        else delete value[$59fc01f5e412f819$var$symToStringTag];
    }
    return result;
}
var $59fc01f5e412f819$export$2e2bcd8739ae039 = $59fc01f5e412f819$var$getRawTag;


/** Used for built-in method references. */ var $94199a1861e07064$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $94199a1861e07064$var$nativeObjectToString = $94199a1861e07064$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $94199a1861e07064$var$objectToString(value) {
    return $94199a1861e07064$var$nativeObjectToString.call(value);
}
var $94199a1861e07064$export$2e2bcd8739ae039 = $94199a1861e07064$var$objectToString;


/** `Object#toString` result references. */ var $ccdb19c7f0a62300$var$nullTag = "[object Null]", $ccdb19c7f0a62300$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $ccdb19c7f0a62300$var$symToStringTag = (0, $f302ffc9a48734c4$export$2e2bcd8739ae039) ? (0, $f302ffc9a48734c4$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $ccdb19c7f0a62300$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $ccdb19c7f0a62300$var$undefinedTag : $ccdb19c7f0a62300$var$nullTag;
    return $ccdb19c7f0a62300$var$symToStringTag && $ccdb19c7f0a62300$var$symToStringTag in Object(value) ? (0, $59fc01f5e412f819$export$2e2bcd8739ae039)(value) : (0, $94199a1861e07064$export$2e2bcd8739ae039)(value);
}
var $ccdb19c7f0a62300$export$2e2bcd8739ae039 = $ccdb19c7f0a62300$var$baseGetTag;


/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $dd0c70c8150db920$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $dd0c70c8150db920$export$2e2bcd8739ae039 = $dd0c70c8150db920$var$isObject;


/** `Object#toString` result references. */ var $397b12740d7995ef$var$asyncTag = "[object AsyncFunction]", $397b12740d7995ef$var$funcTag = "[object Function]", $397b12740d7995ef$var$genTag = "[object GeneratorFunction]", $397b12740d7995ef$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $397b12740d7995ef$var$isFunction(value) {
    if (!(0, $dd0c70c8150db920$export$2e2bcd8739ae039)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $ccdb19c7f0a62300$export$2e2bcd8739ae039)(value);
    return tag == $397b12740d7995ef$var$funcTag || tag == $397b12740d7995ef$var$genTag || tag == $397b12740d7995ef$var$asyncTag || tag == $397b12740d7995ef$var$proxyTag;
}
var $397b12740d7995ef$export$2e2bcd8739ae039 = $397b12740d7995ef$var$isFunction;



var $2mpFt = parcelRequire("2mpFt");
/** Used to detect overreaching core-js shims. */ var $bfc02efb2c4f5b86$var$coreJsData = (0, $2mpFt.default)["__core-js_shared__"];
var $bfc02efb2c4f5b86$export$2e2bcd8739ae039 = $bfc02efb2c4f5b86$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $b7e8b9239f02cfcb$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $bfc02efb2c4f5b86$export$2e2bcd8739ae039) && (0, $bfc02efb2c4f5b86$export$2e2bcd8739ae039).keys && (0, $bfc02efb2c4f5b86$export$2e2bcd8739ae039).keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $b7e8b9239f02cfcb$var$isMasked(func) {
    return !!$b7e8b9239f02cfcb$var$maskSrcKey && $b7e8b9239f02cfcb$var$maskSrcKey in func;
}
var $b7e8b9239f02cfcb$export$2e2bcd8739ae039 = $b7e8b9239f02cfcb$var$isMasked;



/** Used for built-in method references. */ var $3c5a435f91273845$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $3c5a435f91273845$var$funcToString = $3c5a435f91273845$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $3c5a435f91273845$var$toSource(func) {
    if (func != null) {
        try {
            return $3c5a435f91273845$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
var $3c5a435f91273845$export$2e2bcd8739ae039 = $3c5a435f91273845$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $ce7d4e19db8c5f74$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $ce7d4e19db8c5f74$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $ce7d4e19db8c5f74$var$funcProto = Function.prototype, $ce7d4e19db8c5f74$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $ce7d4e19db8c5f74$var$funcToString = $ce7d4e19db8c5f74$var$funcProto.toString;
/** Used to check objects for own properties. */ var $ce7d4e19db8c5f74$var$hasOwnProperty = $ce7d4e19db8c5f74$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $ce7d4e19db8c5f74$var$reIsNative = RegExp("^" + $ce7d4e19db8c5f74$var$funcToString.call($ce7d4e19db8c5f74$var$hasOwnProperty).replace($ce7d4e19db8c5f74$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $ce7d4e19db8c5f74$var$baseIsNative(value) {
    if (!(0, $dd0c70c8150db920$export$2e2bcd8739ae039)(value) || (0, $b7e8b9239f02cfcb$export$2e2bcd8739ae039)(value)) return false;
    var pattern = (0, $397b12740d7995ef$export$2e2bcd8739ae039)(value) ? $ce7d4e19db8c5f74$var$reIsNative : $ce7d4e19db8c5f74$var$reIsHostCtor;
    return pattern.test((0, $3c5a435f91273845$export$2e2bcd8739ae039)(value));
}
var $ce7d4e19db8c5f74$export$2e2bcd8739ae039 = $ce7d4e19db8c5f74$var$baseIsNative;


/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $8048bad1174acf1d$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $8048bad1174acf1d$export$2e2bcd8739ae039 = $8048bad1174acf1d$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $e64d313d457435ee$var$getNative(object, key) {
    var value = (0, $8048bad1174acf1d$export$2e2bcd8739ae039)(object, key);
    return (0, $ce7d4e19db8c5f74$export$2e2bcd8739ae039)(value) ? value : undefined;
}
var $e64d313d457435ee$export$2e2bcd8739ae039 = $e64d313d457435ee$var$getNative;



var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $b3fc56271887eaf3$var$Map = (0, $e64d313d457435ee$export$2e2bcd8739ae039)((0, $2mpFt.default), "Map");
var $b3fc56271887eaf3$export$2e2bcd8739ae039 = $b3fc56271887eaf3$var$Map;



/* Built-in method references that are verified to be native. */ var $8e057c2da47d85b2$var$nativeCreate = (0, $e64d313d457435ee$export$2e2bcd8739ae039)(Object, "create");
var $8e057c2da47d85b2$export$2e2bcd8739ae039 = $8e057c2da47d85b2$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $f37803ed33a1d3d1$var$hashClear() {
    this.__data__ = (0, $8e057c2da47d85b2$export$2e2bcd8739ae039) ? (0, $8e057c2da47d85b2$export$2e2bcd8739ae039)(null) : {};
    this.size = 0;
}
var $f37803ed33a1d3d1$export$2e2bcd8739ae039 = $f37803ed33a1d3d1$var$hashClear;


/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $2c3b841be68d9967$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $2c3b841be68d9967$export$2e2bcd8739ae039 = $2c3b841be68d9967$var$hashDelete;



/** Used to stand-in for `undefined` hash values. */ var $fb1e2001932a20de$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $fb1e2001932a20de$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fb1e2001932a20de$var$hasOwnProperty = $fb1e2001932a20de$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fb1e2001932a20de$var$hashGet(key) {
    var data = this.__data__;
    if (0, $8e057c2da47d85b2$export$2e2bcd8739ae039) {
        var result = data[key];
        return result === $fb1e2001932a20de$var$HASH_UNDEFINED ? undefined : result;
    }
    return $fb1e2001932a20de$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $fb1e2001932a20de$export$2e2bcd8739ae039 = $fb1e2001932a20de$var$hashGet;



/** Used for built-in method references. */ var $fdba09ea24ad742a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fdba09ea24ad742a$var$hasOwnProperty = $fdba09ea24ad742a$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fdba09ea24ad742a$var$hashHas(key) {
    var data = this.__data__;
    return (0, $8e057c2da47d85b2$export$2e2bcd8739ae039) ? data[key] !== undefined : $fdba09ea24ad742a$var$hasOwnProperty.call(data, key);
}
var $fdba09ea24ad742a$export$2e2bcd8739ae039 = $fdba09ea24ad742a$var$hashHas;



/** Used to stand-in for `undefined` hash values. */ var $7d2e036616ad2fb6$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $7d2e036616ad2fb6$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $8e057c2da47d85b2$export$2e2bcd8739ae039) && value === undefined ? $7d2e036616ad2fb6$var$HASH_UNDEFINED : value;
    return this;
}
var $7d2e036616ad2fb6$export$2e2bcd8739ae039 = $7d2e036616ad2fb6$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $fed14e894961a2f6$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$fed14e894961a2f6$var$Hash.prototype.clear = (0, $f37803ed33a1d3d1$export$2e2bcd8739ae039);
$fed14e894961a2f6$var$Hash.prototype["delete"] = (0, $2c3b841be68d9967$export$2e2bcd8739ae039);
$fed14e894961a2f6$var$Hash.prototype.get = (0, $fb1e2001932a20de$export$2e2bcd8739ae039);
$fed14e894961a2f6$var$Hash.prototype.has = (0, $fdba09ea24ad742a$export$2e2bcd8739ae039);
$fed14e894961a2f6$var$Hash.prototype.set = (0, $7d2e036616ad2fb6$export$2e2bcd8739ae039);
var $fed14e894961a2f6$export$2e2bcd8739ae039 = $fed14e894961a2f6$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $8708ff73733b2f97$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new (0, $fed14e894961a2f6$export$2e2bcd8739ae039),
        "map": new ((0, $b3fc56271887eaf3$export$2e2bcd8739ae039) || (0, $f3bb2bde4f3d2e10$export$2e2bcd8739ae039)),
        "string": new (0, $fed14e894961a2f6$export$2e2bcd8739ae039)
    };
}
var $8708ff73733b2f97$export$2e2bcd8739ae039 = $8708ff73733b2f97$var$mapCacheClear;


/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $399fee9a556f4b4d$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var $399fee9a556f4b4d$export$2e2bcd8739ae039 = $399fee9a556f4b4d$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $6ec4556484e81801$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $399fee9a556f4b4d$export$2e2bcd8739ae039)(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var $6ec4556484e81801$export$2e2bcd8739ae039 = $6ec4556484e81801$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $3b6f39a956fe6a39$var$mapCacheDelete(key) {
    var result = (0, $6ec4556484e81801$export$2e2bcd8739ae039)(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $3b6f39a956fe6a39$export$2e2bcd8739ae039 = $3b6f39a956fe6a39$var$mapCacheDelete;



/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $2efdcea83805e55c$var$mapCacheGet(key) {
    return (0, $6ec4556484e81801$export$2e2bcd8739ae039)(this, key).get(key);
}
var $2efdcea83805e55c$export$2e2bcd8739ae039 = $2efdcea83805e55c$var$mapCacheGet;



/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e8a97a3ac9920cdd$var$mapCacheHas(key) {
    return (0, $6ec4556484e81801$export$2e2bcd8739ae039)(this, key).has(key);
}
var $e8a97a3ac9920cdd$export$2e2bcd8739ae039 = $e8a97a3ac9920cdd$var$mapCacheHas;



/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $457a144fcd79754e$var$mapCacheSet(key, value) {
    var data = (0, $6ec4556484e81801$export$2e2bcd8739ae039)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $457a144fcd79754e$export$2e2bcd8739ae039 = $457a144fcd79754e$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $55dda8022ba8f51a$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$55dda8022ba8f51a$var$MapCache.prototype.clear = (0, $8708ff73733b2f97$export$2e2bcd8739ae039);
$55dda8022ba8f51a$var$MapCache.prototype["delete"] = (0, $3b6f39a956fe6a39$export$2e2bcd8739ae039);
$55dda8022ba8f51a$var$MapCache.prototype.get = (0, $2efdcea83805e55c$export$2e2bcd8739ae039);
$55dda8022ba8f51a$var$MapCache.prototype.has = (0, $e8a97a3ac9920cdd$export$2e2bcd8739ae039);
$55dda8022ba8f51a$var$MapCache.prototype.set = (0, $457a144fcd79754e$export$2e2bcd8739ae039);
var $55dda8022ba8f51a$export$2e2bcd8739ae039 = $55dda8022ba8f51a$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $d350707940985b27$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $d350707940985b27$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $f3bb2bde4f3d2e10$export$2e2bcd8739ae039)) {
        var pairs = data.__data__;
        if (!(0, $b3fc56271887eaf3$export$2e2bcd8739ae039) || pairs.length < $d350707940985b27$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $55dda8022ba8f51a$export$2e2bcd8739ae039)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $d350707940985b27$export$2e2bcd8739ae039 = $d350707940985b27$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $73c8979051c99f66$var$Stack(entries) {
    var data = this.__data__ = new (0, $f3bb2bde4f3d2e10$export$2e2bcd8739ae039)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$73c8979051c99f66$var$Stack.prototype.clear = (0, $926693c1c5aa1b3b$export$2e2bcd8739ae039);
$73c8979051c99f66$var$Stack.prototype["delete"] = (0, $44217bb0c3913906$export$2e2bcd8739ae039);
$73c8979051c99f66$var$Stack.prototype.get = (0, $fabb8c13d7ec2da0$export$2e2bcd8739ae039);
$73c8979051c99f66$var$Stack.prototype.has = (0, $8121243fb2037ab0$export$2e2bcd8739ae039);
$73c8979051c99f66$var$Stack.prototype.set = (0, $d350707940985b27$export$2e2bcd8739ae039);
var $73c8979051c99f66$export$2e2bcd8739ae039 = $73c8979051c99f66$var$Stack;


/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $d91b623631254979$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $d91b623631254979$export$2e2bcd8739ae039 = $d91b623631254979$var$arrayEach;



var $15c038100f8779dc$var$defineProperty = function() {
    try {
        var func = (0, $e64d313d457435ee$export$2e2bcd8739ae039)(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
var $15c038100f8779dc$export$2e2bcd8739ae039 = $15c038100f8779dc$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $a06a9a17329ff8a6$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && (0, $15c038100f8779dc$export$2e2bcd8739ae039)) (0, $15c038100f8779dc$export$2e2bcd8739ae039)(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
var $a06a9a17329ff8a6$export$2e2bcd8739ae039 = $a06a9a17329ff8a6$var$baseAssignValue;



/** Used for built-in method references. */ var $75aad50ec93ed496$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $75aad50ec93ed496$var$hasOwnProperty = $75aad50ec93ed496$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $75aad50ec93ed496$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($75aad50ec93ed496$var$hasOwnProperty.call(object, key) && (0, $fa799df2e830873c$export$2e2bcd8739ae039)(objValue, value)) || value === undefined && !(key in object)) (0, $a06a9a17329ff8a6$export$2e2bcd8739ae039)(object, key, value);
}
var $75aad50ec93ed496$export$2e2bcd8739ae039 = $75aad50ec93ed496$var$assignValue;




/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $2df21abc8bda85fc$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $a06a9a17329ff8a6$export$2e2bcd8739ae039)(object, key, newValue);
        else (0, $75aad50ec93ed496$export$2e2bcd8739ae039)(object, key, newValue);
    }
    return object;
}
var $2df21abc8bda85fc$export$2e2bcd8739ae039 = $2df21abc8bda85fc$var$copyObject;


/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $25c66d2c4e8fadd1$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $25c66d2c4e8fadd1$export$2e2bcd8739ae039 = $25c66d2c4e8fadd1$var$baseTimes;



/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $af254ed7460d123e$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $af254ed7460d123e$export$2e2bcd8739ae039 = $af254ed7460d123e$var$isObjectLike;


/** `Object#toString` result references. */ var $ddc0844e7eecdb52$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $ddc0844e7eecdb52$var$baseIsArguments(value) {
    return (0, $af254ed7460d123e$export$2e2bcd8739ae039)(value) && (0, $ccdb19c7f0a62300$export$2e2bcd8739ae039)(value) == $ddc0844e7eecdb52$var$argsTag;
}
var $ddc0844e7eecdb52$export$2e2bcd8739ae039 = $ddc0844e7eecdb52$var$baseIsArguments;



/** Used for built-in method references. */ var $44fca59879666c41$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $44fca59879666c41$var$hasOwnProperty = $44fca59879666c41$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $44fca59879666c41$var$propertyIsEnumerable = $44fca59879666c41$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $44fca59879666c41$var$isArguments = (0, $ddc0844e7eecdb52$export$2e2bcd8739ae039)(function() {
    return arguments;
}()) ? (0, $ddc0844e7eecdb52$export$2e2bcd8739ae039) : function(value) {
    return (0, $af254ed7460d123e$export$2e2bcd8739ae039)(value) && $44fca59879666c41$var$hasOwnProperty.call(value, "callee") && !$44fca59879666c41$var$propertyIsEnumerable.call(value, "callee");
};
var $44fca59879666c41$export$2e2bcd8739ae039 = $44fca59879666c41$var$isArguments;


/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $c8d4506109b88831$var$isArray = Array.isArray;
var $c8d4506109b88831$export$2e2bcd8739ae039 = $c8d4506109b88831$var$isArray;



var $f3ZL4 = parcelRequire("f3ZL4");
/** Used as references for various `Number` constants. */ var $92e841cef318fb91$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $92e841cef318fb91$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $92e841cef318fb91$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $92e841cef318fb91$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $92e841cef318fb91$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $92e841cef318fb91$export$2e2bcd8739ae039 = $92e841cef318fb91$var$isIndex;



/** Used as references for various `Number` constants. */ var $d43fbbcf5bc665de$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $d43fbbcf5bc665de$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $d43fbbcf5bc665de$var$MAX_SAFE_INTEGER;
}
var $d43fbbcf5bc665de$export$2e2bcd8739ae039 = $d43fbbcf5bc665de$var$isLength;



/** `Object#toString` result references. */ var $a51ff94e4fd33486$var$argsTag = "[object Arguments]", $a51ff94e4fd33486$var$arrayTag = "[object Array]", $a51ff94e4fd33486$var$boolTag = "[object Boolean]", $a51ff94e4fd33486$var$dateTag = "[object Date]", $a51ff94e4fd33486$var$errorTag = "[object Error]", $a51ff94e4fd33486$var$funcTag = "[object Function]", $a51ff94e4fd33486$var$mapTag = "[object Map]", $a51ff94e4fd33486$var$numberTag = "[object Number]", $a51ff94e4fd33486$var$objectTag = "[object Object]", $a51ff94e4fd33486$var$regexpTag = "[object RegExp]", $a51ff94e4fd33486$var$setTag = "[object Set]", $a51ff94e4fd33486$var$stringTag = "[object String]", $a51ff94e4fd33486$var$weakMapTag = "[object WeakMap]";
var $a51ff94e4fd33486$var$arrayBufferTag = "[object ArrayBuffer]", $a51ff94e4fd33486$var$dataViewTag = "[object DataView]", $a51ff94e4fd33486$var$float32Tag = "[object Float32Array]", $a51ff94e4fd33486$var$float64Tag = "[object Float64Array]", $a51ff94e4fd33486$var$int8Tag = "[object Int8Array]", $a51ff94e4fd33486$var$int16Tag = "[object Int16Array]", $a51ff94e4fd33486$var$int32Tag = "[object Int32Array]", $a51ff94e4fd33486$var$uint8Tag = "[object Uint8Array]", $a51ff94e4fd33486$var$uint8ClampedTag = "[object Uint8ClampedArray]", $a51ff94e4fd33486$var$uint16Tag = "[object Uint16Array]", $a51ff94e4fd33486$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $a51ff94e4fd33486$var$typedArrayTags = {};
$a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$float32Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$float64Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int8Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int16Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int32Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint8Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint8ClampedTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint16Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint32Tag] = true;
$a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$argsTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$arrayTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$arrayBufferTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$boolTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$dataViewTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$dateTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$errorTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$funcTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$mapTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$numberTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$objectTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$regexpTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$setTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$stringTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $a51ff94e4fd33486$var$baseIsTypedArray(value) {
    return (0, $af254ed7460d123e$export$2e2bcd8739ae039)(value) && (0, $d43fbbcf5bc665de$export$2e2bcd8739ae039)(value.length) && !!$a51ff94e4fd33486$var$typedArrayTags[(0, $ccdb19c7f0a62300$export$2e2bcd8739ae039)(value)];
}
var $a51ff94e4fd33486$export$2e2bcd8739ae039 = $a51ff94e4fd33486$var$baseIsTypedArray;


/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $c8139f05a61e038a$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $c8139f05a61e038a$export$2e2bcd8739ae039 = $c8139f05a61e038a$var$baseUnary;



var $lFXqE = parcelRequire("lFXqE");
/* Node.js helper references. */ var $901262b1d4441a58$var$nodeIsTypedArray = (0, $lFXqE.default) && (0, $lFXqE.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $901262b1d4441a58$var$isTypedArray = $901262b1d4441a58$var$nodeIsTypedArray ? (0, $c8139f05a61e038a$export$2e2bcd8739ae039)($901262b1d4441a58$var$nodeIsTypedArray) : (0, $a51ff94e4fd33486$export$2e2bcd8739ae039);
var $901262b1d4441a58$export$2e2bcd8739ae039 = $901262b1d4441a58$var$isTypedArray;


/** Used for built-in method references. */ var $09822de5e5cf749f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $09822de5e5cf749f$var$hasOwnProperty = $09822de5e5cf749f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $09822de5e5cf749f$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $c8d4506109b88831$export$2e2bcd8739ae039)(value), isArg = !isArr && (0, $44fca59879666c41$export$2e2bcd8739ae039)(value), isBuff = !isArr && !isArg && (0, $f3ZL4.default)(value), isType = !isArr && !isArg && !isBuff && (0, $901262b1d4441a58$export$2e2bcd8739ae039)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $25c66d2c4e8fadd1$export$2e2bcd8739ae039)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $09822de5e5cf749f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    (0, $92e841cef318fb91$export$2e2bcd8739ae039)(key, length)))) result.push(key);
    return result;
}
var $09822de5e5cf749f$export$2e2bcd8739ae039 = $09822de5e5cf749f$var$arrayLikeKeys;


/** Used for built-in method references. */ var $5271b3ac6403835d$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $5271b3ac6403835d$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $5271b3ac6403835d$var$objectProto;
    return value === proto;
}
var $5271b3ac6403835d$export$2e2bcd8739ae039 = $5271b3ac6403835d$var$isPrototype;


/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $5abe0bf7e062106b$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $5abe0bf7e062106b$export$2e2bcd8739ae039 = $5abe0bf7e062106b$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $329b8ad85e05c8eb$var$nativeKeys = (0, $5abe0bf7e062106b$export$2e2bcd8739ae039)(Object.keys, Object);
var $329b8ad85e05c8eb$export$2e2bcd8739ae039 = $329b8ad85e05c8eb$var$nativeKeys;


/** Used for built-in method references. */ var $ff094f04b4f9f6ca$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ff094f04b4f9f6ca$var$hasOwnProperty = $ff094f04b4f9f6ca$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $ff094f04b4f9f6ca$var$baseKeys(object) {
    if (!(0, $5271b3ac6403835d$export$2e2bcd8739ae039)(object)) return (0, $329b8ad85e05c8eb$export$2e2bcd8739ae039)(object);
    var result = [];
    for(var key in Object(object))if ($ff094f04b4f9f6ca$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
var $ff094f04b4f9f6ca$export$2e2bcd8739ae039 = $ff094f04b4f9f6ca$var$baseKeys;




/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $fb8472aba17743fc$var$isArrayLike(value) {
    return value != null && (0, $d43fbbcf5bc665de$export$2e2bcd8739ae039)(value.length) && !(0, $397b12740d7995ef$export$2e2bcd8739ae039)(value);
}
var $fb8472aba17743fc$export$2e2bcd8739ae039 = $fb8472aba17743fc$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $6105a42c6332ca51$var$keys(object) {
    return (0, $fb8472aba17743fc$export$2e2bcd8739ae039)(object) ? (0, $09822de5e5cf749f$export$2e2bcd8739ae039)(object) : (0, $ff094f04b4f9f6ca$export$2e2bcd8739ae039)(object);
}
var $6105a42c6332ca51$export$2e2bcd8739ae039 = $6105a42c6332ca51$var$keys;


/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $595eb7f7a07807be$var$baseAssign(object, source) {
    return object && (0, $2df21abc8bda85fc$export$2e2bcd8739ae039)(source, (0, $6105a42c6332ca51$export$2e2bcd8739ae039)(source), object);
}
var $595eb7f7a07807be$export$2e2bcd8739ae039 = $595eb7f7a07807be$var$baseAssign;






/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $768f82a6c66c1e5e$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $768f82a6c66c1e5e$export$2e2bcd8739ae039 = $768f82a6c66c1e5e$var$nativeKeysIn;


/** Used for built-in method references. */ var $18d88030c379da98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $18d88030c379da98$var$hasOwnProperty = $18d88030c379da98$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $18d88030c379da98$var$baseKeysIn(object) {
    if (!(0, $dd0c70c8150db920$export$2e2bcd8739ae039)(object)) return (0, $768f82a6c66c1e5e$export$2e2bcd8739ae039)(object);
    var isProto = (0, $5271b3ac6403835d$export$2e2bcd8739ae039)(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$18d88030c379da98$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $18d88030c379da98$export$2e2bcd8739ae039 = $18d88030c379da98$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $8e8d0ca4619e1205$var$keysIn(object) {
    return (0, $fb8472aba17743fc$export$2e2bcd8739ae039)(object) ? (0, $09822de5e5cf749f$export$2e2bcd8739ae039)(object, true) : (0, $18d88030c379da98$export$2e2bcd8739ae039)(object);
}
var $8e8d0ca4619e1205$export$2e2bcd8739ae039 = $8e8d0ca4619e1205$var$keysIn;


/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $28e447985d6ff998$var$baseAssignIn(object, source) {
    return object && (0, $2df21abc8bda85fc$export$2e2bcd8739ae039)(source, (0, $8e8d0ca4619e1205$export$2e2bcd8739ae039)(source), object);
}
var $28e447985d6ff998$export$2e2bcd8739ae039 = $28e447985d6ff998$var$baseAssignIn;



var $gqoYg = parcelRequire("gqoYg");
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $e88dc98a9c0b5c36$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $e88dc98a9c0b5c36$export$2e2bcd8739ae039 = $e88dc98a9c0b5c36$var$copyArray;



/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $84dbc91852227c49$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $84dbc91852227c49$export$2e2bcd8739ae039 = $84dbc91852227c49$var$arrayFilter;


/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $245eab4238d1191b$var$stubArray() {
    return [];
}
var $245eab4238d1191b$export$2e2bcd8739ae039 = $245eab4238d1191b$var$stubArray;


/** Used for built-in method references. */ var $02956b8552c88dad$var$objectProto = Object.prototype;
/** Built-in value references. */ var $02956b8552c88dad$var$propertyIsEnumerable = $02956b8552c88dad$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $02956b8552c88dad$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $02956b8552c88dad$var$getSymbols = !$02956b8552c88dad$var$nativeGetSymbols ? (0, $245eab4238d1191b$export$2e2bcd8739ae039) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $84dbc91852227c49$export$2e2bcd8739ae039)($02956b8552c88dad$var$nativeGetSymbols(object), function(symbol) {
        return $02956b8552c88dad$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $02956b8552c88dad$export$2e2bcd8739ae039 = $02956b8552c88dad$var$getSymbols;


/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $60596c5c5ae95246$var$copySymbols(source, object) {
    return (0, $2df21abc8bda85fc$export$2e2bcd8739ae039)(source, (0, $02956b8552c88dad$export$2e2bcd8739ae039)(source), object);
}
var $60596c5c5ae95246$export$2e2bcd8739ae039 = $60596c5c5ae95246$var$copySymbols;



/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $4e7ed5991d883ad6$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $4e7ed5991d883ad6$export$2e2bcd8739ae039 = $4e7ed5991d883ad6$var$arrayPush;



/** Built-in value references. */ var $86d5c19d81d423c4$var$getPrototype = (0, $5abe0bf7e062106b$export$2e2bcd8739ae039)(Object.getPrototypeOf, Object);
var $86d5c19d81d423c4$export$2e2bcd8739ae039 = $86d5c19d81d423c4$var$getPrototype;




/* Built-in method references for those with the same name as other `lodash` methods. */ var $cd71f33290dd3540$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $cd71f33290dd3540$var$getSymbolsIn = !$cd71f33290dd3540$var$nativeGetSymbols ? (0, $245eab4238d1191b$export$2e2bcd8739ae039) : function(object) {
    var result = [];
    while(object){
        (0, $4e7ed5991d883ad6$export$2e2bcd8739ae039)(result, (0, $02956b8552c88dad$export$2e2bcd8739ae039)(object));
        object = (0, $86d5c19d81d423c4$export$2e2bcd8739ae039)(object);
    }
    return result;
};
var $cd71f33290dd3540$export$2e2bcd8739ae039 = $cd71f33290dd3540$var$getSymbolsIn;


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $586fcd2cd99597f5$var$copySymbolsIn(source, object) {
    return (0, $2df21abc8bda85fc$export$2e2bcd8739ae039)(source, (0, $cd71f33290dd3540$export$2e2bcd8739ae039)(source), object);
}
var $586fcd2cd99597f5$export$2e2bcd8739ae039 = $586fcd2cd99597f5$var$copySymbolsIn;




/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $cf47ca2fc3f4de6e$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $c8d4506109b88831$export$2e2bcd8739ae039)(object) ? result : (0, $4e7ed5991d883ad6$export$2e2bcd8739ae039)(result, symbolsFunc(object));
}
var $cf47ca2fc3f4de6e$export$2e2bcd8739ae039 = $cf47ca2fc3f4de6e$var$baseGetAllKeys;




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $04a5ed8d1a69f13e$var$getAllKeys(object) {
    return (0, $cf47ca2fc3f4de6e$export$2e2bcd8739ae039)(object, (0, $6105a42c6332ca51$export$2e2bcd8739ae039), (0, $02956b8552c88dad$export$2e2bcd8739ae039));
}
var $04a5ed8d1a69f13e$export$2e2bcd8739ae039 = $04a5ed8d1a69f13e$var$getAllKeys;





/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $53b118d05aedad9a$var$getAllKeysIn(object) {
    return (0, $cf47ca2fc3f4de6e$export$2e2bcd8739ae039)(object, (0, $8e8d0ca4619e1205$export$2e2bcd8739ae039), (0, $cd71f33290dd3540$export$2e2bcd8739ae039));
}
var $53b118d05aedad9a$export$2e2bcd8739ae039 = $53b118d05aedad9a$var$getAllKeysIn;




var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $a1648453896f67d2$var$DataView = (0, $e64d313d457435ee$export$2e2bcd8739ae039)((0, $2mpFt.default), "DataView");
var $a1648453896f67d2$export$2e2bcd8739ae039 = $a1648453896f67d2$var$DataView;





var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $768c3ff3ee4df356$var$Promise = (0, $e64d313d457435ee$export$2e2bcd8739ae039)((0, $2mpFt.default), "Promise");
var $768c3ff3ee4df356$export$2e2bcd8739ae039 = $768c3ff3ee4df356$var$Promise;




var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $d81f7aa452e6e637$var$Set = (0, $e64d313d457435ee$export$2e2bcd8739ae039)((0, $2mpFt.default), "Set");
var $d81f7aa452e6e637$export$2e2bcd8739ae039 = $d81f7aa452e6e637$var$Set;




var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $11f94673ff7d99d8$var$WeakMap = (0, $e64d313d457435ee$export$2e2bcd8739ae039)((0, $2mpFt.default), "WeakMap");
var $11f94673ff7d99d8$export$2e2bcd8739ae039 = $11f94673ff7d99d8$var$WeakMap;




/** `Object#toString` result references. */ var $34aa59a61c7ccccb$var$mapTag = "[object Map]", $34aa59a61c7ccccb$var$objectTag = "[object Object]", $34aa59a61c7ccccb$var$promiseTag = "[object Promise]", $34aa59a61c7ccccb$var$setTag = "[object Set]", $34aa59a61c7ccccb$var$weakMapTag = "[object WeakMap]";
var $34aa59a61c7ccccb$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $34aa59a61c7ccccb$var$dataViewCtorString = (0, $3c5a435f91273845$export$2e2bcd8739ae039)((0, $a1648453896f67d2$export$2e2bcd8739ae039)), $34aa59a61c7ccccb$var$mapCtorString = (0, $3c5a435f91273845$export$2e2bcd8739ae039)((0, $b3fc56271887eaf3$export$2e2bcd8739ae039)), $34aa59a61c7ccccb$var$promiseCtorString = (0, $3c5a435f91273845$export$2e2bcd8739ae039)((0, $768c3ff3ee4df356$export$2e2bcd8739ae039)), $34aa59a61c7ccccb$var$setCtorString = (0, $3c5a435f91273845$export$2e2bcd8739ae039)((0, $d81f7aa452e6e637$export$2e2bcd8739ae039)), $34aa59a61c7ccccb$var$weakMapCtorString = (0, $3c5a435f91273845$export$2e2bcd8739ae039)((0, $11f94673ff7d99d8$export$2e2bcd8739ae039));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $34aa59a61c7ccccb$var$getTag = (0, $ccdb19c7f0a62300$export$2e2bcd8739ae039);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $a1648453896f67d2$export$2e2bcd8739ae039) && $34aa59a61c7ccccb$var$getTag(new (0, $a1648453896f67d2$export$2e2bcd8739ae039)(new ArrayBuffer(1))) != $34aa59a61c7ccccb$var$dataViewTag || (0, $b3fc56271887eaf3$export$2e2bcd8739ae039) && $34aa59a61c7ccccb$var$getTag(new (0, $b3fc56271887eaf3$export$2e2bcd8739ae039)) != $34aa59a61c7ccccb$var$mapTag || (0, $768c3ff3ee4df356$export$2e2bcd8739ae039) && $34aa59a61c7ccccb$var$getTag((0, $768c3ff3ee4df356$export$2e2bcd8739ae039).resolve()) != $34aa59a61c7ccccb$var$promiseTag || (0, $d81f7aa452e6e637$export$2e2bcd8739ae039) && $34aa59a61c7ccccb$var$getTag(new (0, $d81f7aa452e6e637$export$2e2bcd8739ae039)) != $34aa59a61c7ccccb$var$setTag || (0, $11f94673ff7d99d8$export$2e2bcd8739ae039) && $34aa59a61c7ccccb$var$getTag(new (0, $11f94673ff7d99d8$export$2e2bcd8739ae039)) != $34aa59a61c7ccccb$var$weakMapTag) $34aa59a61c7ccccb$var$getTag = function(value) {
    var result = (0, $ccdb19c7f0a62300$export$2e2bcd8739ae039)(value), Ctor = result == $34aa59a61c7ccccb$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $3c5a435f91273845$export$2e2bcd8739ae039)(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $34aa59a61c7ccccb$var$dataViewCtorString:
            return $34aa59a61c7ccccb$var$dataViewTag;
        case $34aa59a61c7ccccb$var$mapCtorString:
            return $34aa59a61c7ccccb$var$mapTag;
        case $34aa59a61c7ccccb$var$promiseCtorString:
            return $34aa59a61c7ccccb$var$promiseTag;
        case $34aa59a61c7ccccb$var$setCtorString:
            return $34aa59a61c7ccccb$var$setTag;
        case $34aa59a61c7ccccb$var$weakMapCtorString:
            return $34aa59a61c7ccccb$var$weakMapTag;
    }
    return result;
};
var $34aa59a61c7ccccb$export$2e2bcd8739ae039 = $34aa59a61c7ccccb$var$getTag;


/** Used for built-in method references. */ var $7103088c29fc4f0b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7103088c29fc4f0b$var$hasOwnProperty = $7103088c29fc4f0b$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $7103088c29fc4f0b$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $7103088c29fc4f0b$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $7103088c29fc4f0b$export$2e2bcd8739ae039 = $7103088c29fc4f0b$var$initCloneArray;



var $2mpFt = parcelRequire("2mpFt");
/** Built-in value references. */ var $a00bfcf041d47533$var$Uint8Array = (0, $2mpFt.default).Uint8Array;
var $a00bfcf041d47533$export$2e2bcd8739ae039 = $a00bfcf041d47533$var$Uint8Array;


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $6e620930bc6a5ada$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $a00bfcf041d47533$export$2e2bcd8739ae039)(result).set(new (0, $a00bfcf041d47533$export$2e2bcd8739ae039)(arrayBuffer));
    return result;
}
var $6e620930bc6a5ada$export$2e2bcd8739ae039 = $6e620930bc6a5ada$var$cloneArrayBuffer;



/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $6e35bd0ad6403ada$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $6e620930bc6a5ada$export$2e2bcd8739ae039)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $6e35bd0ad6403ada$export$2e2bcd8739ae039 = $6e35bd0ad6403ada$var$cloneDataView;


/** Used to match `RegExp` flags from their coerced string values. */ var $bbfabb74c4bdb037$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $bbfabb74c4bdb037$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $bbfabb74c4bdb037$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $bbfabb74c4bdb037$export$2e2bcd8739ae039 = $bbfabb74c4bdb037$var$cloneRegExp;



/** Used to convert symbols to primitives and strings. */ var $f6fcecf8c6eee3b2$var$symbolProto = (0, $f302ffc9a48734c4$export$2e2bcd8739ae039) ? (0, $f302ffc9a48734c4$export$2e2bcd8739ae039).prototype : undefined, $f6fcecf8c6eee3b2$var$symbolValueOf = $f6fcecf8c6eee3b2$var$symbolProto ? $f6fcecf8c6eee3b2$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $f6fcecf8c6eee3b2$var$cloneSymbol(symbol) {
    return $f6fcecf8c6eee3b2$var$symbolValueOf ? Object($f6fcecf8c6eee3b2$var$symbolValueOf.call(symbol)) : {};
}
var $f6fcecf8c6eee3b2$export$2e2bcd8739ae039 = $f6fcecf8c6eee3b2$var$cloneSymbol;



/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $2eb64e5339c21018$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $6e620930bc6a5ada$export$2e2bcd8739ae039)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $2eb64e5339c21018$export$2e2bcd8739ae039 = $2eb64e5339c21018$var$cloneTypedArray;


/** `Object#toString` result references. */ var $d8c6c80dd3650253$var$boolTag = "[object Boolean]", $d8c6c80dd3650253$var$dateTag = "[object Date]", $d8c6c80dd3650253$var$mapTag = "[object Map]", $d8c6c80dd3650253$var$numberTag = "[object Number]", $d8c6c80dd3650253$var$regexpTag = "[object RegExp]", $d8c6c80dd3650253$var$setTag = "[object Set]", $d8c6c80dd3650253$var$stringTag = "[object String]", $d8c6c80dd3650253$var$symbolTag = "[object Symbol]";
var $d8c6c80dd3650253$var$arrayBufferTag = "[object ArrayBuffer]", $d8c6c80dd3650253$var$dataViewTag = "[object DataView]", $d8c6c80dd3650253$var$float32Tag = "[object Float32Array]", $d8c6c80dd3650253$var$float64Tag = "[object Float64Array]", $d8c6c80dd3650253$var$int8Tag = "[object Int8Array]", $d8c6c80dd3650253$var$int16Tag = "[object Int16Array]", $d8c6c80dd3650253$var$int32Tag = "[object Int32Array]", $d8c6c80dd3650253$var$uint8Tag = "[object Uint8Array]", $d8c6c80dd3650253$var$uint8ClampedTag = "[object Uint8ClampedArray]", $d8c6c80dd3650253$var$uint16Tag = "[object Uint16Array]", $d8c6c80dd3650253$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $d8c6c80dd3650253$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $d8c6c80dd3650253$var$arrayBufferTag:
            return (0, $6e620930bc6a5ada$export$2e2bcd8739ae039)(object);
        case $d8c6c80dd3650253$var$boolTag:
        case $d8c6c80dd3650253$var$dateTag:
            return new Ctor(+object);
        case $d8c6c80dd3650253$var$dataViewTag:
            return (0, $6e35bd0ad6403ada$export$2e2bcd8739ae039)(object, isDeep);
        case $d8c6c80dd3650253$var$float32Tag:
        case $d8c6c80dd3650253$var$float64Tag:
        case $d8c6c80dd3650253$var$int8Tag:
        case $d8c6c80dd3650253$var$int16Tag:
        case $d8c6c80dd3650253$var$int32Tag:
        case $d8c6c80dd3650253$var$uint8Tag:
        case $d8c6c80dd3650253$var$uint8ClampedTag:
        case $d8c6c80dd3650253$var$uint16Tag:
        case $d8c6c80dd3650253$var$uint32Tag:
            return (0, $2eb64e5339c21018$export$2e2bcd8739ae039)(object, isDeep);
        case $d8c6c80dd3650253$var$mapTag:
            return new Ctor;
        case $d8c6c80dd3650253$var$numberTag:
        case $d8c6c80dd3650253$var$stringTag:
            return new Ctor(object);
        case $d8c6c80dd3650253$var$regexpTag:
            return (0, $bbfabb74c4bdb037$export$2e2bcd8739ae039)(object);
        case $d8c6c80dd3650253$var$setTag:
            return new Ctor;
        case $d8c6c80dd3650253$var$symbolTag:
            return (0, $f6fcecf8c6eee3b2$export$2e2bcd8739ae039)(object);
    }
}
var $d8c6c80dd3650253$export$2e2bcd8739ae039 = $d8c6c80dd3650253$var$initCloneByTag;



/** Built-in value references. */ var $ec12acf7896f0d70$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $ec12acf7896f0d70$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $dd0c70c8150db920$export$2e2bcd8739ae039)(proto)) return {};
        if ($ec12acf7896f0d70$var$objectCreate) return $ec12acf7896f0d70$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $ec12acf7896f0d70$export$2e2bcd8739ae039 = $ec12acf7896f0d70$var$baseCreate;




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $55872b451e11a8ad$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !(0, $5271b3ac6403835d$export$2e2bcd8739ae039)(object) ? (0, $ec12acf7896f0d70$export$2e2bcd8739ae039)((0, $86d5c19d81d423c4$export$2e2bcd8739ae039)(object)) : {};
}
var $55872b451e11a8ad$export$2e2bcd8739ae039 = $55872b451e11a8ad$var$initCloneObject;




var $f3ZL4 = parcelRequire("f3ZL4");


/** `Object#toString` result references. */ var $9c2364d1ace94eb9$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $9c2364d1ace94eb9$var$baseIsMap(value) {
    return (0, $af254ed7460d123e$export$2e2bcd8739ae039)(value) && (0, $34aa59a61c7ccccb$export$2e2bcd8739ae039)(value) == $9c2364d1ace94eb9$var$mapTag;
}
var $9c2364d1ace94eb9$export$2e2bcd8739ae039 = $9c2364d1ace94eb9$var$baseIsMap;




var $lFXqE = parcelRequire("lFXqE");
/* Node.js helper references. */ var $42712e4fe0b60e59$var$nodeIsMap = (0, $lFXqE.default) && (0, $lFXqE.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $42712e4fe0b60e59$var$isMap = $42712e4fe0b60e59$var$nodeIsMap ? (0, $c8139f05a61e038a$export$2e2bcd8739ae039)($42712e4fe0b60e59$var$nodeIsMap) : (0, $9c2364d1ace94eb9$export$2e2bcd8739ae039);
var $42712e4fe0b60e59$export$2e2bcd8739ae039 = $42712e4fe0b60e59$var$isMap;





/** `Object#toString` result references. */ var $37ad91635d9ff11e$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $37ad91635d9ff11e$var$baseIsSet(value) {
    return (0, $af254ed7460d123e$export$2e2bcd8739ae039)(value) && (0, $34aa59a61c7ccccb$export$2e2bcd8739ae039)(value) == $37ad91635d9ff11e$var$setTag;
}
var $37ad91635d9ff11e$export$2e2bcd8739ae039 = $37ad91635d9ff11e$var$baseIsSet;




var $lFXqE = parcelRequire("lFXqE");
/* Node.js helper references. */ var $39af7a8fe30b5013$var$nodeIsSet = (0, $lFXqE.default) && (0, $lFXqE.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $39af7a8fe30b5013$var$isSet = $39af7a8fe30b5013$var$nodeIsSet ? (0, $c8139f05a61e038a$export$2e2bcd8739ae039)($39af7a8fe30b5013$var$nodeIsSet) : (0, $37ad91635d9ff11e$export$2e2bcd8739ae039);
var $39af7a8fe30b5013$export$2e2bcd8739ae039 = $39af7a8fe30b5013$var$isSet;




/** Used to compose bitmasks for cloning. */ var $bc81bf84e8d65dab$var$CLONE_DEEP_FLAG = 1, $bc81bf84e8d65dab$var$CLONE_FLAT_FLAG = 2, $bc81bf84e8d65dab$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $bc81bf84e8d65dab$var$argsTag = "[object Arguments]", $bc81bf84e8d65dab$var$arrayTag = "[object Array]", $bc81bf84e8d65dab$var$boolTag = "[object Boolean]", $bc81bf84e8d65dab$var$dateTag = "[object Date]", $bc81bf84e8d65dab$var$errorTag = "[object Error]", $bc81bf84e8d65dab$var$funcTag = "[object Function]", $bc81bf84e8d65dab$var$genTag = "[object GeneratorFunction]", $bc81bf84e8d65dab$var$mapTag = "[object Map]", $bc81bf84e8d65dab$var$numberTag = "[object Number]", $bc81bf84e8d65dab$var$objectTag = "[object Object]", $bc81bf84e8d65dab$var$regexpTag = "[object RegExp]", $bc81bf84e8d65dab$var$setTag = "[object Set]", $bc81bf84e8d65dab$var$stringTag = "[object String]", $bc81bf84e8d65dab$var$symbolTag = "[object Symbol]", $bc81bf84e8d65dab$var$weakMapTag = "[object WeakMap]";
var $bc81bf84e8d65dab$var$arrayBufferTag = "[object ArrayBuffer]", $bc81bf84e8d65dab$var$dataViewTag = "[object DataView]", $bc81bf84e8d65dab$var$float32Tag = "[object Float32Array]", $bc81bf84e8d65dab$var$float64Tag = "[object Float64Array]", $bc81bf84e8d65dab$var$int8Tag = "[object Int8Array]", $bc81bf84e8d65dab$var$int16Tag = "[object Int16Array]", $bc81bf84e8d65dab$var$int32Tag = "[object Int32Array]", $bc81bf84e8d65dab$var$uint8Tag = "[object Uint8Array]", $bc81bf84e8d65dab$var$uint8ClampedTag = "[object Uint8ClampedArray]", $bc81bf84e8d65dab$var$uint16Tag = "[object Uint16Array]", $bc81bf84e8d65dab$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $bc81bf84e8d65dab$var$cloneableTags = {};
$bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$argsTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$arrayTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$arrayBufferTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$dataViewTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$boolTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$dateTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$float32Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$float64Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$int8Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$int16Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$int32Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$mapTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$numberTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$objectTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$regexpTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$setTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$stringTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$symbolTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint8Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint8ClampedTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint16Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint32Tag] = true;
$bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$errorTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$funcTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $bc81bf84e8d65dab$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $bc81bf84e8d65dab$var$CLONE_DEEP_FLAG, isFlat = bitmask & $bc81bf84e8d65dab$var$CLONE_FLAT_FLAG, isFull = bitmask & $bc81bf84e8d65dab$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $dd0c70c8150db920$export$2e2bcd8739ae039)(value)) return value;
    var isArr = (0, $c8d4506109b88831$export$2e2bcd8739ae039)(value);
    if (isArr) {
        result = (0, $7103088c29fc4f0b$export$2e2bcd8739ae039)(value);
        if (!isDeep) return (0, $e88dc98a9c0b5c36$export$2e2bcd8739ae039)(value, result);
    } else {
        var tag = (0, $34aa59a61c7ccccb$export$2e2bcd8739ae039)(value), isFunc = tag == $bc81bf84e8d65dab$var$funcTag || tag == $bc81bf84e8d65dab$var$genTag;
        if ((0, $f3ZL4.default)(value)) return (0, $gqoYg.default)(value, isDeep);
        if (tag == $bc81bf84e8d65dab$var$objectTag || tag == $bc81bf84e8d65dab$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $55872b451e11a8ad$export$2e2bcd8739ae039)(value);
            if (!isDeep) return isFlat ? (0, $586fcd2cd99597f5$export$2e2bcd8739ae039)(value, (0, $28e447985d6ff998$export$2e2bcd8739ae039)(result, value)) : (0, $60596c5c5ae95246$export$2e2bcd8739ae039)(value, (0, $595eb7f7a07807be$export$2e2bcd8739ae039)(result, value));
        } else {
            if (!$bc81bf84e8d65dab$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $d8c6c80dd3650253$export$2e2bcd8739ae039)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $73c8979051c99f66$export$2e2bcd8739ae039));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $39af7a8fe30b5013$export$2e2bcd8739ae039)(value)) value.forEach(function(subValue) {
        result.add($bc81bf84e8d65dab$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $42712e4fe0b60e59$export$2e2bcd8739ae039)(value)) value.forEach(function(subValue, key) {
        result.set(key, $bc81bf84e8d65dab$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $53b118d05aedad9a$export$2e2bcd8739ae039) : (0, $04a5ed8d1a69f13e$export$2e2bcd8739ae039) : isFlat ? (0, $8e8d0ca4619e1205$export$2e2bcd8739ae039) : (0, $6105a42c6332ca51$export$2e2bcd8739ae039);
    var props = isArr ? undefined : keysFunc(value);
    (0, $d91b623631254979$export$2e2bcd8739ae039)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $75aad50ec93ed496$export$2e2bcd8739ae039)(result, key, $bc81bf84e8d65dab$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $bc81bf84e8d65dab$export$2e2bcd8739ae039 = $bc81bf84e8d65dab$var$baseClone;


/** Used to compose bitmasks for cloning. */ var $8f13c87c1500733f$var$CLONE_DEEP_FLAG = 1, $8f13c87c1500733f$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $8f13c87c1500733f$var$cloneDeep(value) {
    return (0, $bc81bf84e8d65dab$export$2e2bcd8739ae039)(value, $8f13c87c1500733f$var$CLONE_DEEP_FLAG | $8f13c87c1500733f$var$CLONE_SYMBOLS_FLAG);
}
var $8f13c87c1500733f$export$2e2bcd8739ae039 = $8f13c87c1500733f$var$cloneDeep;


const $7ffc1f94643dc7e4$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7ffc1f94643dc7e4$export$2e2bcd8739ae039 = {
    randomUUID: $7ffc1f94643dc7e4$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $568f4ee4022ba00e$var$getRandomValues;
const $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $568f4ee4022ba00e$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}


var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === "string" && (0, $32c496bfb6c27b56$export$2e2bcd8739ae039).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $1d0137947e8554ce$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$1d0137947e8554ce$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $1d0137947e8554ce$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]];
}
function $1d0137947e8554ce$var$stringify(arr, offset = 0) {
    const uuid = $1d0137947e8554ce$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $46d323206dcbf256$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;


function $3fa3ae484854b431$var$v4(options, buf, offset) {
    if ((0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $568f4ee4022ba00e$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $1d0137947e8554ce$export$8fb373d660548968)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;


let $0f1d4402dffacf5b$export$ca000e230c0caa3e = {
    name: "",
    description: (0, $ba30e20475feac5a$export$e7d23b4e9333127f),
    tables: [],
    tableHeads: [],
    tags: (0, $ba30e20475feac5a$export$2fbac60a8fede0ac).tags,
    tagsColor: (0, $ba30e20475feac5a$export$8f01201217c59cf3).colors
};
let $0f1d4402dffacf5b$export$a37e3c603d7117e5 = {
    tableItemToCreate: [],
    tableItemToUpdate: [],
    tableItemToDelete: [],
    tableItemToDuplicate: [],
    journalInfoToUpdate: [],
    tagToDelete: [],
    tagsToUpdate: [],
    tagsToCreate: [],
    submodelToCreate: [],
    submodelToUpdate: [],
    submodelToDelete: [],
    tableToUpdate: [],
    tableToCreate: [],
    tableToDuplicate: [],
    tableToDelete: [],
    diffActive: false
};
let $0f1d4402dffacf5b$export$72cf72d213e5d45 = {
};
let $0f1d4402dffacf5b$export$9e1725a4cfeada27 = {};
const $0f1d4402dffacf5b$var$pass = ()=>{};
const $0f1d4402dffacf5b$export$5409961cf12fff85 = (payload)=>{
    if (payload?.name?.length >= 0) $0f1d4402dffacf5b$export$ca000e230c0caa3e.name = payload.name;
    if (payload?.description?.length >= 0) $0f1d4402dffacf5b$export$ca000e230c0caa3e.description = payload.description;
    $0f1d4402dffacf5b$var$persistData();
};
const $0f1d4402dffacf5b$export$a8d54db9d8ae6ee7 = (tableId)=>{
    //returns current table or tableId passed into it
    const currentTable = $0f1d4402dffacf5b$export$ca000e230c0caa3e.tables.find((table)=>table.id === tableId || table.id === $0f1d4402dffacf5b$export$ca000e230c0caa3e.currentTable);
    return currentTable;
};
const $0f1d4402dffacf5b$export$8d21f17684deada9 = (currentTable)=>{
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.currentTable = currentTable;
    $0f1d4402dffacf5b$var$persistData();
};
//deprc
const $0f1d4402dffacf5b$var$checkForAndAddNewTag = (updateObj)=>{
    updateObj.forEach((obj)=>{
        const objExistInTableTags = $0f1d4402dffacf5b$export$ca000e230c0caa3e.tags.find((tag)=>tag.text.toLowerCase() === obj.text.toLowerCase());
        if (!objExistInTableTags) $0f1d4402dffacf5b$export$ca000e230c0caa3e.tags.push(obj);
    });
};
const $0f1d4402dffacf5b$export$897cf354c93223ff = (payload)=>{
    let tagToUpdate = $0f1d4402dffacf5b$export$ca000e230c0caa3e.tags.find((tag)=>tag.id === payload.id && tag.text.toLowerCase() === payload.text.toLowerCase());
    //FIXME: make sure obj is replaced
    if (tagToUpdate) tagToUpdate = payload;
};
const $0f1d4402dffacf5b$var$getItemFromTableItems = (table, item, index = false, convert = true)=>{
    if (!index) return table.tableItems.find((tableItem)=>tableItem.id === (convert ? Number(item) : item));
    if (index) return table.tableItems.findIndex((tableItem)=>tableItem.id === (convert ? Number(item) : item));
};
const $0f1d4402dffacf5b$var$createTable = function(table, i, date) {
    const tableObj = {
        id: date ? Number(date) + Number(new Date().getMilliseconds() + (i ? i : 0)) : Number(Date.now()),
        tableTitle: table,
        tableItems: []
    };
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.tables.push(tableObj);
    //set initial active table
    i === 0 ? $0f1d4402dffacf5b$export$ca000e230c0caa3e.currentTable = tableObj.id : $0f1d4402dffacf5b$var$pass();
    $0f1d4402dffacf5b$var$persistData();
    return tableObj.id;
};
const $0f1d4402dffacf5b$var$createTableItem = function(title = "", payload) {
    const itemTitle = payload?.action && payload.action !== "createEmpty" ? payload.itemTitle : title;
    const itemTags = payload?.itemTags ? payload.itemTags : [];
    const itemObj = {
        id: Date.now(),
        itemTitle: itemTitle,
        itemTags: itemTags,
        intentions: [
            {
                id: (0, $3fa3ae484854b431$export$2e2bcd8739ae039)(),
                text: ""
            }
        ],
        happenings: [
            {
                id: (0, $3fa3ae484854b431$export$2e2bcd8739ae039)(),
                text: ""
            }
        ],
        gratefulFor: [
            {
                id: (0, $3fa3ae484854b431$export$2e2bcd8739ae039)(),
                text: ""
            }
        ],
        actionItems: [
            {
                id: (0, $3fa3ae484854b431$export$2e2bcd8739ae039)(),
                text: "",
                checkbox: true,
                checked: false
            }
        ]
    };
    $0f1d4402dffacf5b$var$persistData();
    return itemObj;
};
const $0f1d4402dffacf5b$export$b3980c840b43297a = function(table, itemId, position, tableLength = false) {
    if (!position && !tableLength) return table.tableItems.find((item)=>{
        return item.id === itemId;
    });
    if (!position && tableLength) {
        const itemIdIndex = table.tableItems.findIndex((item)=>{
            return item.id === itemId;
        });
        const positionNext = table.tableItems.length - itemIdIndex >= 2 ? 1 : 0;
        const positionPrev = table.tableItems.length - itemIdIndex < table.tableItems.length - 1 ? -1 : -2;
        const positionItemTwoLengthNext = !positionNext ? table.tableItems.length - itemIdIndex === 1 ? 0 : -1 : null;
        const positionItemTwoLengthPrev = positionPrev === -2 ? table.tableItems.length - itemIdIndex === table.tableItems.length - 1 ? -1 : 0 : null;
        if (positionItemTwoLengthNext || positionItemTwoLengthPrev === -1) //applies only when positionNext || positionPrev is null
        return {
            item: table.tableItems[itemIdIndex],
            position: positionItemTwoLengthNext || positionItemTwoLengthPrev
        };
        if (!positionNext && positionPrev === -2 && table.tableItems.length > 1) return {
            item: table.tableItems[itemIdIndex],
            position: null
        };
        if (!positionNext && positionPrev === -2 && table.tableItems.length === 1) return {
            item: table.tableItems[itemIdIndex],
            position: "only"
        };
        if (positionNext || positionPrev) return {
            item: table.tableItems[itemIdIndex],
            position: positionNext || positionPrev
        };
    }
    if (position) {
        const itemIdIndex = table.tableItems.findIndex((item)=>{
            return item.id === itemId;
        });
        const indexToReturn = (0, $bd02c871d9c5ba8e$export$1cbff4cb65f2ce8b)(itemIdIndex, position);
        if (// positionalValues.some((val) => val === position) &&
        table.tableItems.length - (indexToReturn + 1) >= 1 && table.tableItems.length - indexToReturn - 1 < table.tableItems.length - 1) return {
            item: (0, $bd02c871d9c5ba8e$export$b2c0185dbf29dc67)(table.tableItems, itemIdIndex, position),
            position: null
        };
        if (position === 1 && table.tableItems.length - (itemIdIndex + 1) > 1) return {
            item: table.tableItems[itemIdIndex + 1],
            position: position
        };
        if (position === 1 && table.tableItems.length - (itemIdIndex + 1) === 1) return {
            item: table.tableItems[itemIdIndex + 1],
            position: 0
        };
        // if (
        //   position === -1 &&
        //   table.tableItems.length - (itemIdIndex - 1) < table.tableItems.length
        // ) {
        //   return { item: table.tableItems[itemIdIndex - 1], position };
        // }
        if (position === -1 && table.tableItems.length - (itemIdIndex - 1) === table.tableItems.length) return {
            item: table.tableItems[itemIdIndex - 1],
            position: -2
        };
    }
};
const $0f1d4402dffacf5b$export$1d31bd7424f68508 = function(table, itemsId) {
    const filteredTableItems = [];
    itemsId.forEach((itemId)=>{
        const item = table.tableItems.find((item)=>item.id === Number(itemId));
        if (item) filteredTableItems.push(item);
    });
    return filteredTableItems.reduce((acc, item)=>acc.itemTags.length > item.itemTags.length ? acc : item, filteredTableItems[0]);
};
const $0f1d4402dffacf5b$export$fb2abcfc348c747 = function(...args) {
    const [formData, journalId] = args;
    const journalToUpdate = $0f1d4402dffacf5b$export$ca000e230c0caa3e.tables.find((journal)=>journal.id === journalId);
    journalToUpdate.tableTitle = formData;
    $0f1d4402dffacf5b$var$persistData();
};
const $0f1d4402dffacf5b$export$a352e0616d49fce0 = function(journalId) {
    const TableToClone = $0f1d4402dffacf5b$export$ca000e230c0caa3e.tables.find((journal)=>journal.id === journalId);
    const clone = (0, $8f13c87c1500733f$export$2e2bcd8739ae039)(TableToClone);
    //update clone id
    clone.id = Number(Date.now());
    //get clone occurences
    // const occurrence = occurences(cloneTable);
    const [occurrence, duplicateNum] = [
        (0, $bd02c871d9c5ba8e$export$6a60b1c4474426)(TableToClone.tableTitle, $0f1d4402dffacf5b$export$ca000e230c0caa3e),
        (0, $bd02c871d9c5ba8e$export$2aa76edf31d1ffa4)(TableToClone.tableTitle, $0f1d4402dffacf5b$export$ca000e230c0caa3e)
    ];
    //construct clone name
    clone.tableTitle = (0, $bd02c871d9c5ba8e$export$2bcb3130099de669)(occurrence > duplicateNum ? occurrence : duplicateNum, clone.tableTitle);
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.tables.push(clone);
    $0f1d4402dffacf5b$var$persistData();
    return clone.id;
};
const $0f1d4402dffacf5b$export$ee0f503fde5c3c2d = function(journalId) {
    //delete journal data
    const tableToDelete = $0f1d4402dffacf5b$export$ca000e230c0caa3e.tables.findIndex((journal)=>journal.id === journalId);
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.tables.splice(tableToDelete, 1);
    $0f1d4402dffacf5b$var$persistData();
};
const $0f1d4402dffacf5b$export$ce9ab8fb56ac6a88 = function() {
    const occurrence = (0, $bd02c871d9c5ba8e$export$6a60b1c4474426)((0, $ba30e20475feac5a$export$1fa8a855c3fa5df8), $0f1d4402dffacf5b$export$ca000e230c0caa3e);
    const journalName = (0, $bd02c871d9c5ba8e$export$2bcb3130099de669)(occurrence, (0, $ba30e20475feac5a$export$1fa8a855c3fa5df8));
    const createdTableId = $0f1d4402dffacf5b$var$createTable(journalName, undefined);
    $0f1d4402dffacf5b$var$persistData();
    return createdTableId;
};
const $0f1d4402dffacf5b$export$7ab2b02c37be05a8 = function(payload, relativeItem, APIResp = false) {
    let tableItem;
    const currentTable = $0f1d4402dffacf5b$export$a8d54db9d8ae6ee7();
    if (!APIResp) tableItem = $0f1d4402dffacf5b$var$createTableItem("", payload);
    if (APIResp) tableItem = payload;
    if (!relativeItem) currentTable.tableItems.push(tableItem);
    if (relativeItem) {
        const relativeItemIndex = $0f1d4402dffacf5b$var$getItemFromTableItems(currentTable, relativeItem, true);
        const insertIndex = relativeItemIndex - 1 === 0 || relativeItemIndex === 0 ? relativeItemIndex + 1 : relativeItemIndex + 1;
        currentTable.tableItems.splice(insertIndex, 0, tableItem);
    }
    $0f1d4402dffacf5b$var$persistData();
    return tableItem.id;
};
const $0f1d4402dffacf5b$export$2895d72886bc0b68 = function(tagId) {
    const tagToDelete = $0f1d4402dffacf5b$export$ca000e230c0caa3e.tags.findIndex((tag)=>String(tag.id) === String(tagId));
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.tags.splice(tagToDelete, 1);
};
const $0f1d4402dffacf5b$export$88107ff569e983a5 = function(payload) {
    const tableToDeleteFrom = $0f1d4402dffacf5b$export$a8d54db9d8ae6ee7(payload.tableId);
    if (payload?.items) payload.items.forEach((item)=>{
        const itemToDelete = $0f1d4402dffacf5b$var$getItemFromTableItems(tableToDeleteFrom, item, true);
        tableToDeleteFrom.tableItems.splice(itemToDelete, 1);
    });
    //delete side peek addeed properties
    if (payload?.modelProperty) {
        const deleteVal = payload.modelProperty.property.delete;
        const itemToDeleteFrom = $0f1d4402dffacf5b$var$getItemFromTableItems(tableToDeleteFrom, payload.itemId, false, false);
        const itemIndex = itemToDeleteFrom[deleteVal.key].findIndex((item)=>item.id === deleteVal.propertyId);
        const itemGreaterThanOne = itemToDeleteFrom[deleteVal.key].length > 1;
        if (itemGreaterThanOne) itemToDeleteFrom[deleteVal.key].splice(itemIndex, 1);
        if (!itemGreaterThanOne) //clear the item value
        itemToDeleteFrom[deleteVal.key][itemIndex].text = "";
    }
    $0f1d4402dffacf5b$var$persistData();
};
const $0f1d4402dffacf5b$export$a2655955a6576097 = function(payload) {
    //triggers only for fallback tag create
    //create temp id for tag
    payload.id = (0, $bd02c871d9c5ba8e$export$4e823a815a183f47)(payload.tag_name);
    let formatFailedRequestPayload = (0, $bd02c871d9c5ba8e$export$8c27844e107da08)(payload, "apiTags");
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.tags.push(formatFailedRequestPayload);
    formatFailedRequestPayload = {};
    $0f1d4402dffacf5b$var$persistData();
    return payload.id;
};
const $0f1d4402dffacf5b$export$97a438877dd4f86f = function(payload, api = true, tableId) {
    const updateSingleItem = payload?.id;
    const updateMultipleItems = payload?.itemIds;
    const tableToUpdate = $0f1d4402dffacf5b$export$a8d54db9d8ae6ee7(tableId ?? null);
    if (updateSingleItem) {
        //logic runs for single item update
        if (api) {
            //FIXME: make sure implementation doesn't contradict with any other interfacee implementation
            //replace value with api value
            const tableAPIItem = $0f1d4402dffacf5b$var$getItemFromTableItems(tableToUpdate, payload.id, true, true);
            tableToUpdate.tableItems.splice(tableAPIItem, 1);
            tableToUpdate.tableItems.splice(tableAPIItem, 0, payload);
            $0f1d4402dffacf5b$var$persistData();
            return;
        }
        const itemToUpdate = $0f1d4402dffacf5b$export$b3980c840b43297a(tableToUpdate, payload.id);
        payload?.itemTitle ? itemToUpdate.itemTitle = payload.itemTitle : $0f1d4402dffacf5b$var$pass();
        payload?.itemTags ? itemToUpdate.itemTags = payload.itemTags : $0f1d4402dffacf5b$var$pass();
        //create new tag object if it doesn't exist in the tag table
        //TODO: use the createtagendpoint to update the journal tags or a fallback
        //TODO: implement prev logic with check against model update
        // payload.tags ? checkForAndAddNewTag(formattedTags) : pass();
        if (payload.modelProperty) {
            if (payload.modelProperty.property.update) {
                const updateValue = payload.modelProperty.property.update;
                const propertyToUpdate = itemToUpdate[updateValue.key].find((propItem)=>propItem.id === updateValue.propertyId);
                if (propertyToUpdate) {
                    propertyToUpdate.text = updateValue.value;
                    propertyToUpdate.checkbox ? (propertyToUpdate.checkbox = payload.modelProperty.checkedProperty.checkbox) && (propertyToUpdate.checked = payload.modelProperty.checkedProperty.checked) : $0f1d4402dffacf5b$var$pass();
                }
            }
            if (payload.modelProperty.property.create) {
                const payloadValue = payload.modelProperty.property.create;
                const updateObj = {
                    id: (0, $3fa3ae484854b431$export$2e2bcd8739ae039)(),
                    text: payloadValue.value
                };
                const hasCheckbox = payload.modelProperty.checkedProperty.checkbox;
                hasCheckbox ? (updateObj.checkbox = true, updateObj.checked = false) : $0f1d4402dffacf5b$var$pass();
                if (payloadValue.relativeProperty) {
                    const relativePropertyIndex = itemToUpdate[payload.modelProperty.property.key].findIndex((property)=>property.id === payloadValue.relativeProperty);
                    itemToUpdate[payload.modelProperty.property.key].splice(relativePropertyIndex + 1, 0, updateObj);
                } else itemToUpdate[payload.modelProperty.property.key].push(updateObj);
            }
            if (payload.modelProperty.property.updateActionItem) {
                const updateValue = payload.modelProperty.property.updateActionItem;
                const propertyToUpdate = itemToUpdate[updateValue.key].find((propItem)=>propItem.id === updateValue.propertyId);
                propertyToUpdate.text = updateValue.value;
                propertyToUpdate.checked = updateValue.checked;
            }
        }
    }
    if (!updateSingleItem && updateMultipleItems) {
        const formattedTags = payload?.tags ? (0, $bd02c871d9c5ba8e$export$82bb5aadcb51fd83)(payload?.tags) : $0f1d4402dffacf5b$var$pass();
        //create new tag object if it doesn't exist in the tag table
        payload?.tags ? $0f1d4402dffacf5b$var$checkForAndAddNewTag(formattedTags) : $0f1d4402dffacf5b$var$pass();
        const itemsToUpdate = payload.itemIds.map((item)=>$0f1d4402dffacf5b$var$getItemFromTableItems(tableToUpdate, Number(item)));
        itemsToUpdate.forEach((item)=>item.itemTags = [
                ...formattedTags
            ]);
    }
    $0f1d4402dffacf5b$var$persistData();
};
const $0f1d4402dffacf5b$export$6a523b692fa68049 = function(payload) {
    const updateSingleItem = payload?.itemId;
    const updateMultipleItems = payload?.itemIds;
    const tableToUpdate = $0f1d4402dffacf5b$export$a8d54db9d8ae6ee7(payload?.tableId);
    if (updateSingleItem) {
        //logic runs for single item update
        let itemToUpdate = $0f1d4402dffacf5b$export$b3980c840b43297a(tableToUpdate, payload.itemId);
        payload?.title ? itemToUpdate.itemTitle = payload.title : $0f1d4402dffacf5b$var$pass();
        //get the tags from the model state
        const getTagsId = payload?.tags ? (0, $bd02c871d9c5ba8e$export$2fb4720fbf51caf0)(payload, $0f1d4402dffacf5b$export$ca000e230c0caa3e) : $0f1d4402dffacf5b$var$pass();
        //add the tag to the item to update
        getTagsId?.length > 0 ? itemToUpdate.itemTags = getTagsId : $0f1d4402dffacf5b$var$pass();
        if (payload.modelProperty) {
            if (payload.modelProperty.property.update) {
                const updateValue = payload.modelProperty.property.update;
                const propertyToUpdate = itemToUpdate[updateValue.key].find((propItem)=>propItem.id === updateValue.propertyId);
                //add the update item id to the payload
                payload.updatedItemId = updateValue.propertyId;
                //FIXME: check against the updatedItem being null to add as create for the diff
                if (propertyToUpdate) {
                    propertyToUpdate.text = updateValue.value;
                    propertyToUpdate.checkbox ? (propertyToUpdate.checkbox = payload.modelProperty.checkedProperty.checkbox) && (propertyToUpdate.checked = payload.modelProperty.checkedProperty.checked) : $0f1d4402dffacf5b$var$pass();
                }
            }
            if (payload.modelProperty.property.create) {
                const payloadValue = payload.modelProperty.property.create;
                const updateObj = {
                    id: (0, $3fa3ae484854b431$export$2e2bcd8739ae039)(),
                    text: payloadValue.value
                };
                //add the create submodel id to the payload for the diff
                payload.createdItemId = updateObj.id;
                const hasCheckbox = payload.modelProperty.checkedProperty.checkbox;
                hasCheckbox ? (updateObj.checkbox = true, updateObj.checked = false) : $0f1d4402dffacf5b$var$pass();
                if (payloadValue.relativeProperty) {
                    const relativePropertyIndex = itemToUpdate[payload.modelProperty.property.key].findIndex((property)=>property.id === payloadValue.relativeProperty);
                    itemToUpdate[payload.modelProperty.property.key].splice(relativePropertyIndex + 1, 0, updateObj);
                } else itemToUpdate[payload.modelProperty.property.key].push(updateObj);
            }
            if (payload.modelProperty.property.updateActionItem) {
                const updateValue = payload.modelProperty.property.updateActionItem;
                const propertyToUpdate = itemToUpdate[updateValue.key].find((propItem)=>propItem.id === updateValue.propertyId);
                if (propertyToUpdate) {
                    //TODO: make sure values are getting updated
                    propertyToUpdate.text = updateValue.value;
                    propertyToUpdate.checked = updateValue.checked;
                }
            }
        }
    }
    if (!updateSingleItem && updateMultipleItems) {
        const formattedTags = payload?.tags ? (0, $bd02c871d9c5ba8e$export$82bb5aadcb51fd83)(payload?.tags) : $0f1d4402dffacf5b$var$pass();
        //create new tag object if it doesn't exist in the tag table
        payload?.tags ? $0f1d4402dffacf5b$var$checkForAndAddNewTag(formattedTags) : $0f1d4402dffacf5b$var$pass();
        const itemsToUpdate = payload.itemIds.map((item)=>$0f1d4402dffacf5b$var$getItemFromTableItems(tableToUpdate, Number(item)));
        itemsToUpdate.forEach((item)=>item.itemTags = [
                ...formattedTags
            ]);
    }
    $0f1d4402dffacf5b$var$persistData();
};
const $0f1d4402dffacf5b$export$1639f31f29ee55b2 = function(payload) {
    const tableToDuplicateItem = $0f1d4402dffacf5b$export$a8d54db9d8ae6ee7(payload.tableId);
    const duplicateCreateList = [];
    payload.items.forEach((item)=>{
        const itemToDuplicate = (0, $8f13c87c1500733f$export$2e2bcd8739ae039)($0f1d4402dffacf5b$var$getItemFromTableItems(tableToDuplicateItem, item));
        itemToDuplicate.id = Date.now();
        //list to be returned to the controller
        duplicateCreateList.push(itemToDuplicate);
        tableToDuplicateItem.tableItems.push(itemToDuplicate);
    });
    $0f1d4402dffacf5b$var$persistData();
    return duplicateCreateList;
};
const $0f1d4402dffacf5b$var$persistData = ()=>{
    localStorage.setItem("userJournal", JSON.stringify($0f1d4402dffacf5b$export$ca000e230c0caa3e));
};
const $0f1d4402dffacf5b$export$89dfc02f4e66af51 = function() {
    localStorage.setItem("token", JSON.stringify($0f1d4402dffacf5b$export$9e1725a4cfeada27));
};
const $0f1d4402dffacf5b$export$942d31fad4d7fb27 = ()=>{
    localStorage.setItem("diffState", JSON.stringify($0f1d4402dffacf5b$export$a37e3c603d7117e5));
};
const $0f1d4402dffacf5b$export$91159f5f50f54fc1 = ()=>{
    localStorage.setItem("funcState", JSON.stringify($0f1d4402dffacf5b$export$72cf72d213e5d45));
};
const $0f1d4402dffacf5b$var$getPersistedFunc = ()=>{
    const funcFromDb = localStorage.getItem("funcState");
    return JSON.parse(funcFromDb);
};
const $0f1d4402dffacf5b$var$getPersistedData = ()=>{
    const stateFromDb = localStorage.getItem("userJournal");
    return JSON.parse(stateFromDb);
};
const $0f1d4402dffacf5b$var$getPersistedDiffData = ()=>{
    const diffFromDb = localStorage.getItem("diffState");
    return JSON.parse(diffFromDb);
};
const $0f1d4402dffacf5b$export$1718d02e8422300d = ()=>{
    const storedToken = localStorage.getItem("token");
    if (storedToken) $0f1d4402dffacf5b$export$9e1725a4cfeada27 = JSON.parse(storedToken);
};
const $0f1d4402dffacf5b$export$7e6499f51ff337f6 = function(tableItem) {
    const currentTable = $0f1d4402dffacf5b$export$a8d54db9d8ae6ee7();
    const currentTableTableItemIndex = $0f1d4402dffacf5b$var$getItemFromTableItems(currentTable, tableItem.id, true);
    const formatAPITableItem = (0, $bd02c871d9c5ba8e$export$224e4749c4a088cf)(tableItem, "activities");
    currentTable.tableItems.splice(currentTableTableItemIndex, 1);
    currentTable.tableItems.splice(currentTableTableItemIndex, 0, formatAPITableItem);
};
// const replace
const $0f1d4402dffacf5b$var$requestJournalTableCallback = function(callBack, journalTableAPIResp, requestState) {
    let tableItems = [];
    if (requestState) {
        journalTableAPIResp.forEach((tableItem)=>tableItems.push((0, $bd02c871d9c5ba8e$export$8c27844e107da08)(tableItem, "journalTables")));
        //replace state data with api data
        $0f1d4402dffacf5b$var$replaceStateJournalDataWithAPIData(tableItems, "journalTables");
        //re-call the model init
        callBack();
    }
};
const $0f1d4402dffacf5b$var$replaceStateJournalDataWithAPIData = function(formattedAPIData, type) {
    if (type === "journal") {
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.name = formattedAPIData.name;
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.description = formattedAPIData.description;
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.tableHeads = formattedAPIData.tableHeads;
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.currentTable = formattedAPIData.currentTable;
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.tags = formattedAPIData.tags;
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.id = formattedAPIData.id;
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.username = formattedAPIData.username;
        $0f1d4402dffacf5b$export$72cf72d213e5d45 = formattedAPIData.tableFunc;
    }
    if (type === "journalTables") {
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.tables.splice(0, $0f1d4402dffacf5b$export$ca000e230c0caa3e.tables.length);
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.tables.push(...formattedAPIData);
    }
};
const $0f1d4402dffacf5b$var$requestJournalTableData = function(callBack, journalAPIResp, requestState) {
    if (requestState) {
        const queryObjJournalActiveTable = {
            endpoint: (0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.JOURNAL_TABLES.LIST,
            token: $0f1d4402dffacf5b$export$9e1725a4cfeada27.value,
            sec: null,
            actionType: "getActiveTable",
            // queryData
            spinner: true,
            alert: false,
            type: "GET",
            callBack: $0f1d4402dffacf5b$var$requestJournalTableCallback.bind(null, callBack),
            callBackParam: true
        };
        (0, $db1f432b457e32b4$export$2c4e825dc9120f87).queryAPI(queryObjJournalActiveTable);
        const formattedJournalAPIResp = (0, $bd02c871d9c5ba8e$export$8c27844e107da08)(...journalAPIResp, "journal");
        //replace state data for journal
        $0f1d4402dffacf5b$var$replaceStateJournalDataWithAPIData(formattedJournalAPIResp, "journal");
    }
};
const $0f1d4402dffacf5b$var$requestJournalData = function(callBack) {
    const queryObjJournal = {
        endpoint: (0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.JOURNAL.LIST,
        token: $0f1d4402dffacf5b$export$9e1725a4cfeada27.value,
        sec: null,
        actionType: "getJournal",
        spinner: true,
        alert: true,
        type: "GET",
        callBack: $0f1d4402dffacf5b$var$requestJournalTableData.bind(null, callBack),
        callBackParam: true
    };
    (0, $db1f432b457e32b4$export$2c4e825dc9120f87).queryAPI(queryObjJournal);
};
const $0f1d4402dffacf5b$export$2cd8252107eb640b = function(controllerInit, loadController = false) {
    if (!loadController) {
        const dataLoadedFromDb = $0f1d4402dffacf5b$var$getPersistedData();
        if (dataLoadedFromDb) {
            $0f1d4402dffacf5b$export$ca000e230c0caa3e = dataLoadedFromDb;
            if (!$0f1d4402dffacf5b$export$9e1725a4cfeada27.value) $0f1d4402dffacf5b$export$1718d02e8422300d();
            const initCallBack = $0f1d4402dffacf5b$export$2cd8252107eb640b.bind(null, controllerInit, true);
            $0f1d4402dffacf5b$var$requestJournalData(initCallBack);
        }
        if (!dataLoadedFromDb) {
            //create default tables
            const initCallBack = $0f1d4402dffacf5b$export$2cd8252107eb640b.bind(null, controllerInit, true);
            $0f1d4402dffacf5b$var$requestJournalData(initCallBack);
        }
    }
    if (loadController) {
        //load the table persisted func
        const funcState = $0f1d4402dffacf5b$var$getPersistedFunc();
        if (funcState) $0f1d4402dffacf5b$export$72cf72d213e5d45 = funcState;
        //load the UI
        controllerInit(false);
    }
};



var $a3598ccf6feb4bd8$exports = {};

$a3598ccf6feb4bd8$exports = new URL((parcelRequire("jUSBR")).resolve("3xFAK"), import.meta.url).toString();


const $69ae69596111f54f$var$loginImg = new URL($a3598ccf6feb4bd8$exports);
class $69ae69596111f54f$export$54c8ec317c198e64 {
    static template() {
        return `
            <div class="login-container">
                <header>
                  <nav class="login-header">
                    <ul>
                      <li class="cta-btn cta-btn-login">Login</li>
                      <li class="cta-btn cta-btn-signup">Sign Up</li>
                    </ul>
                  </nav>
                </header>
                <div class="login-content">
                  <div class="login-heading-row">
                    <div class="login-content-heading">
                      Start your Journaling journey Today
                    </div>
                    <p class="login-content-text">
                      Take your Daily Experiences to an accountable level. Keep track of the momentums that got you to where you are now. Start Today!
                    </p>
                  </div>
                  <div class="login-content-row">
                    <div class="login-content-outline">
                      <div class="content-outlines">
                        <div class="content-outline">
                          <div class="outline-heading">
                            1. Start writing
                          </div>
                          <div class="outline-text">
                            Get your experiences written down. Budget time to reflect on your day.
                          </div>
                        </div>
                        <div class="content-outline">
                          <div class="outline-heading">
                            2. Tag it
                          </div>
                          <div class="outline-text">
                            Create tags to culminate your experience to keep track of it.
                          </div>
                        </div>
                        <div class="content-outline">
                          <div class="outline-heading">
                            3. Reflect and grow
                          </div>
                          <div class="outline-text">
                            Get to reflect on your experiences and daily activities for growth.
                          </div>
                      
                        </div>
                      </div>
                      <div class="content-img">
                        <div class="content-img-box">
                        
                          <img src="${$69ae69596111f54f$var$loginImg.href}" alt="Diaries for Journaling stacked on each other">
                          <div class="img-overlay">
                            <ul>
                              <li class="cta-btn cta-btn-login">Login</li>
                              <li class="cta-btn cta-btn-signup">Sign Up</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        `;
    }
    static templateStyling() {
        document.querySelector("html").style.fontSize = "100%";
    }
}



const $a260c124cbafa3c3$var$actionOptions = [];
class $a260c124cbafa3c3$export$c6dda8e9cdb07ecc {
    static template() {
        return `
            <main>
                <div class="container">
                  <div class="nav-sidebar"></div>
                  <div class="content-container">
                    <div class="row">
                      <div class="container-main-content">
                        <div class="row row-scroller">
                          <div class="table-container">
                            <div class="main-table">
                              <div class="row row-scroller-table">
                                <div class="main-table-head">
                                  <div class="main-table-head-box">
                                  </div>
                                </div>

                                <!-- start view option markup -->
                                                        
                                <!-- end view option markup -->
                            
                                <div class="property-container">
                                  <div class="property-actions"></div>
                                  <div class="div-filler"></div>
                                </div>
                                <div class="main-table-row">
                                  <!-- swith table to div start -->
                                
                                  <div role="tablerow" aria-label="Journals">
                                    <div role="tablehead">
                                      <div class="tableInput-container">
                                        <label class="tableInput">
                                          <input
                                            type="checkbox"
                                            name=""
                                            id="checkboxInput"
                                            class="checkboxInput"
                                          />
                                        </label>
                                      </div>
                                      <div role="rowgroup">
                                        <div role="row">
                                          <span role="columnhead">
                                            <div class="action-filter-content">
                                              <div class="action-filter-icon">
                                                ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("filter-icon", "alphabet-icon")}
                                              </div>
                                              <div class="action-filter-text">Name</div>
                                            </div>
                                          </span>
                                          <span role="columnhead">
                                            <div class="action-filter-content">
                                              <div class="action-filter-icon">
                                                ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("filter-icon", "clock")}
                                              </div>
                                          
                                              <div class="action-filter-text">
                                                Created
                                              </div>
                                            </div>
                                          </span>
                                          <span role="columnhead">
                                            <div class="action-filter-content">
                                              <div class="action-filter-icon">
                                                ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("filter-icon", "list-icon")}
                                              </div>
                                              <div class="action-filter-text">Tags</div>
                                            </div>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                              
                                  <!-- table row adder -->
                                  <!-- switch table to div end -->
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="overlay-container">
                  <div class="overlay-container-base">
                    <div class="overlay">
                      <div>
                        <div class="overlay-filler"></div>
                        <div class="overlay-content" style="top: 200px; left: 900px">
                          <div></div>
                          <div class="overlay-content-holder">
                            <div class="overlay-content-content"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="alert-box">
                  <div class="alert-msg">ksdlfjsldf</div>
                </div> -->
            </main>
        `;
    }
    static templateStyling() {
        document.querySelector("html").style.fontSize = "62.5%";
    }
}


// import journalInfoComponentView from "../views/journalInfoComponentView";
// import tableComponentView from "../views/tableComponentView";
class $b2b83d5c51b10d56$var$ContentContainerListener {
    _parentElement = document.querySelector(".content-container");
    _events = [
        "click",
        "keyup"
    ];
    init(journalInfoComponentView, tableComponentView) {
        this.journalInfoComponentView = journalInfoComponentView;
        this.tableComponentView = tableComponentView;
        this.activateListener();
    }
    activateListener() {
        const cls = this;
        this._events.forEach((ev)=>this._parentElement.addEventListener(ev, this._registerSubscribers.bind(cls)));
    }
    _registerSubscribers(e) {
        e.stopPropagation();
        if (e.type === "click") this.tableComponentView.addDelegationEventListener(e);
        if (this.journalInfoComponentView._events.find((ev)=>ev === e.type)) this.journalInfoComponentView.addDelegationEventListener(e);
    }
    _subscribers() {}
}
const $b2b83d5c51b10d56$export$72b89280ca08eaee = {
    import: ()=>new $b2b83d5c51b10d56$var$ContentContainerListener(),
    object: null
};




// import tableBodyContainerListener from "./listeners/tableBodyContainerListener";



// import componentOptionsView from "./componentOptionsView.js";


class $6807a0d6351af8d6$export$2e2bcd8739ae039 {
    _componentHandler = (0, $d2866451d1c7a9c0$export$721ff339e60fcc47).object;
    _state;
    _events = [
        "click"
    ];
    constructor(state){
        this._state = state;
    }
    _generateNotificationConfirmationMarkup() {
        return `
      <div class="notification-btn notification-confirm-btn">okay</div>
    `;
    }
    _generateNotificationDeleteBtnMarkup() {
        return `
    <div class="notification-action-container">
      <div class="notification-btn notification-cancel-btn hover-deep-dull">Cancel</div>
      <div class="notification-btn notification-delete-btn hover-tomato">Remove</div>
    </div>
    `;
    }
    _generateMarkup(text, btnMarkup) {
        return `
        <div class="notification-render">
          <div class="notification-render-box">
            <div class="notification-text">
              ${text}
            </div>
           ${btnMarkup}
          </div>
        </div>
    `;
    }
    render() {
        const cls = this;
        const markupArgs = this._state.deleter ? [
            (0, $ba30e20475feac5a$export$c6bea31caa55fd32),
            this._generateNotificationDeleteBtnMarkup()
        ] : [
            (0, $ba30e20475feac5a$export$4f2ee02a9a578f69),
            this._generateNotificationConfirmationMarkup()
        ];
        this._state.markup = this._generateMarkup(...markupArgs);
        const { overlay: overlay, overlayInterceptor: overlayInterceptor, component: component } = this._componentHandler._componentOverlay(this._state);
        this._state = {
            ...this._state,
            overlay: overlay,
            overlayInterceptor: overlayInterceptor,
            component: component
        };
        //overlay component handles its event
        overlayInterceptor.addEventListener("click", function(e) {
            cls._componentHandler._componentRemover(cls._state);
        }, {
            once: true
        });
        //component handles its event
        this._events.forEach((ev)=>{
            component.addEventListener(ev, this._handleEvents.bind(cls));
        });
    }
    _handleEvents(e) {
        if (this._handleNotificationDeleteMatchStrategy(e)) this._handleNotificationDeleteEvent(e);
        if (this._handleNotificationCancelMatchStrategy(e)) this._handleNotificationCancelEvent(e);
        if (this._handleNotificationConfirmationMatchStrategy(e)) this._componentHandler._componentRemover(this._state, this._state.component, false);
    }
    _handleNotificationDeleteMatchStrategy(e) {
        const matchStrategy = e.target.classList.contains("notification-delete-btn");
        return matchStrategy;
    }
    _handleNotificationConfirmationMatchStrategy(e) {
        const matchStrategy = e.target.classList.contains("notification-confirm-btn") || e.target.closest(".notification-confirm-btn");
        return matchStrategy;
    }
    _handleNotificationCancelMatchStrategy(e) {
        const matchStrategy = e.target.classList.contains("notification-cancel-btn") || e.target.closest(".notification-cancel-btn");
        return matchStrategy;
    }
    _handleNotificationDeleteEvent(e) {
        this.remove(true);
    }
    _handleNotificationCancelEvent(e) {
        this._state.overlay.remove();
    }
    remove(callBack = false) {
        const cls = this;
        if (callBack) this._state.callBack(true);
        this._state.overlayInterceptor.click();
        this._events.forEach((ev)=>this._state.component.removeEventListener(ev, cls._handleEvents, true));
        this._state.parentOverlay.remove();
    }
}




class $f24e63269063d04d$export$2e2bcd8739ae039 {
    _componentHandler = (0, $d2866451d1c7a9c0$export$721ff339e60fcc47).object;
    _state;
    _events = [
        "click",
        "keyup"
    ];
    constructor(state){
        this._state = state;
    }
    _generateCheckmarkMarkup() {
        return `
          <div class="color-row-icon">
            ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("row-icon icon-md", "checkmark")}
          </div>
        `;
    }
    _generateTagsColorOptionsMarkup(tagToEdit) {
        let colorOptionsMarkup = "";
        this._state.tagsColors.forEach((color)=>{
            const checkmarkMarkup = color.color_value.toLowerCase() === tagToEdit.color.toLowerCase() ? this._generateCheckmarkMarkup() : "";
            colorOptionsMarkup += `
            <div class="colors">
              <div class="color ${color.color_value}"></div>
              <div class="color-text">${color.color}</div>
              ${checkmarkMarkup}
            </div>
          `;
        });
        return colorOptionsMarkup;
    }
    _generateMarkup(tagToEdit) {
        return `
          <div class="row-tag-options">
            <div class="row-tag-options-box">
              <div class="row-tag-edit-actions">
                
                <input
                  type="text"
                  class="tag-edit component-form" value="${tagToEdit.text}"
                />
                
                <div class="row-tag-delete">
                  <div class="row-tag-icon">
                    ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("row-icon", "trashcan-icon")}
                  </div>
                  <div class="row-tag-text">
                    Delete
                  </div>
                </div>
              </div>
              <div class="row-tag-colors">
                <div class="colors-info">
                  COLORS
                </div>
                <div class="colors-picker">
                  ${this._generateTagsColorOptionsMarkup(tagToEdit)}
                </div>
              </div>
            </div>
          </div>
        `;
    }
    render() {
        const cls = this;
        this._state.markup = this._generateMarkup(this._state.tagToEdit);
        const { overlay: overlay, overlayInterceptor: overlayInterceptor, component: component } = this._componentHandler._componentOverlay(this._state);
        this._state = {
            ...this._state,
            overlay: overlay,
            overlayInterceptor: overlayInterceptor,
            component: component
        };
        //overlay component handles its event
        overlayInterceptor.addEventListener("click", function(e) {
            cls._componentHandler._componentRemover(cls._state);
        }, {
            once: true
        });
        //component handles its event
        this._events.forEach((ev)=>{
            component.addEventListener(ev, this._handleEvents.bind(cls));
        });
    }
    _handleEvents(e) {
        if (this._optionsOptionColorSelectMatchStrategy(e)) this._handleOptionsOptionColorSelectEvent(e);
        if (this._optionsOptionDeleteMatchStrategy(e)) this._handleDeleteOptionsOptionEvent(e);
        if (this._optionsOptionEnterMatchStrategy(e)) this._handleOptionsOptionEnterEvent(e);
    }
    _optionsOptionDeleteMatchStrategy(e) {
        if (e.type === "click") {
            const matchStrategy = e.target.classList.contains("row-tag-delete") || e.target.closest(".row-tag-delete");
            return matchStrategy;
        }
    }
    _optionsOptionColorSelectMatchStrategy(e) {
        if (e.type === "click") {
            const matchStrategy = e.target.classList.contains("colors") || e.target.closest(".colors");
            return matchStrategy;
        }
    }
    _optionsOptionEnterMatchStrategy(e) {
        if (e.type === "keyup" && e.key === "Enter") {
            const matchStrategy = e.target.classList.contains("tag-edit") || e.target.closest(".tag-edit");
            return matchStrategy;
        }
    }
    _handleOptionsOptionColorSelectEvent(e) {
        const allColorContainer = document.querySelectorAll(".colors");
        const colorContainer = e.target.closest(".colors");
        //remove and add checkmark
        const selectedColorIsChecked = colorContainer.querySelector(".color-row-icon");
        const selectedColor = colorContainer.querySelector(".color").classList[1].trim();
        if (!selectedColorIsChecked) //the color value is changed based on the API resolve value
        this.updateTagAndNotifyCallers(null, this._selectColor.bind(this, allColorContainer, colorContainer), selectedColor);
    }
    _handleOptionsOptionEnterEvent(e) {
        const inputEl = e.currentTarget.querySelector(".tag-edit");
        if (inputEl.value.length > 0) this.updateTagAndNotifyCallers();
        this._componentHandler._componentRemover(this._state, this._state.component, false);
    }
    _handleDeleteOptionsOptionEvent(e) {
        const componentObj = {
            deleter: true,
            selector: ".notification-render",
            callBack: this.updateTagAndNotifyCallers.bind(this),
            parentOverlay: this._state.overlay,
            currentTarget: this._state.currentTarget,
            notify: true
        };
        const component = new (0, $6807a0d6351af8d6$export$2e2bcd8739ae039)(componentObj).render();
    }
    _selectColor(allColorContainer, colorContainer) {
        allColorContainer.forEach((color)=>color.querySelector(".color-row-icon")?.remove());
        colorContainer.insertAdjacentHTML("beforeend", this._generateCheckmarkMarkup());
    }
    _deleteElFromOptionContainer(el) {
        el.forEach((elm)=>{
            if (elm) {
                if (elm.classList.contains("row-tag-tag")) elm.closest(".tags-option").remove();
                if (elm.classList.contains("tag-tag")) elm.remove();
            }
        });
    }
    _deleteTag(tagId, el) {
        this._state.eventHandlers.tableItemControllers.controlDeleteTag(tagId, this._deleteElFromOptionContainer.bind(this, el));
    }
    _updateElClassAndText(inputVal, colorVal, el, tag) {
        el.forEach((elm)=>{
            if (elm) {
                elm.classList.remove(tag.color);
                elm.classList.add(colorVal);
                const elmDeleteIcon = elm.querySelector(".row-tag-icon");
                elm.textContent = inputVal.value.trim();
                if (elmDeleteIcon) elm.insertAdjacentElement("beforeend", elmDeleteIcon);
            }
        });
    }
    updateTagAndNotifyCallers(deleteTag, eventCallBack, selectedColor) {
        const cls = this;
        let cloneTagBeforeUpdate = null;
        //options item
        const updateParentOptionItemTag = this._tagItemSelector(this._state.currentTarget);
        const updateParentOptionTag = this._state.currentTarget.querySelector(".tags-available").querySelector(`[data-id="${this._state.tagToEdit.id}"]`);
        if (deleteTag) {
            this._deleteTag(this._state.tagToEdit.id, [
                updateParentOptionItemTag,
                updateParentOptionTag
            ]);
            return;
        }
        const tagInput = this._state.component.querySelector(".tag-edit");
        const tagSelectedColor = this._tagColorSelector(selectedColor);
        const tagInputChanged = tagInput.value.trim().toLowerCase() !== this._state.tagToEdit.text.toLowerCase();
        const tagColorChanged = tagSelectedColor.toLowerCase() !== this._state.tagToEdit.color.toLowerCase();
        if (tagInputChanged || tagColorChanged || eventCallBack) {
            //check for existing tag with similar tag name
            const similarNamedTag = this._state.tags.find((tg)=>tg.text.toLowerCase() === tagInput.value.trim().toLowerCase());
            if (similarNamedTag) {
                if (String(similarNamedTag.id) != String(this._state.tagToEdit.id)) {
                    //render notification overlay
                    const componentObj = {
                        selector: ".notification-render",
                        currentTarget: this._state.currentTarget,
                        notify: true
                    };
                    const component = new (0, $6807a0d6351af8d6$export$2e2bcd8739ae039)(componentObj).render();
                    return;
                }
            }
            cloneTagBeforeUpdate = (0, $8f13c87c1500733f$export$2e2bcd8739ae039)(this._state.tagToEdit);
            //format the update object
            const updateObj = {
                tag: this._createTagUpdateObj({
                    inputChanged: tagInputChanged,
                    colorChanged: tagColorChanged,
                    tagInput: tagInput,
                    tagColor: tagSelectedColor
                }),
                updateTag: true,
                tagBeforeUpdate: cloneTagBeforeUpdate
            };
            this._state.eventHandlers.tableItemControllers.controlUpdateTag(updateObj, "tagsValue", this._updateUI.bind(this, {
                eventCallBack: eventCallBack,
                tagInput: tagInput,
                tagSelectedColor: tagSelectedColor,
                updateParentOptionItemTag: updateParentOptionItemTag,
                updateParentOptionTag: updateParentOptionTag
            }));
        }
    }
    _updateUI(options) {
        //resolve any callback for any other event passed that updates the UI
        if (options.eventCallBack) options.eventCallBack();
        //change the color and text content of the elements
        this._updateElClassAndText(options.tagInput, options.tagSelectedColor, [
            options.updateParentOptionItemTag,
            options.updateParentOptionTag
        ], this._state.tagToEdit);
        //update the tag
        //updates the model as well
        [this._state.tagToEdit.color, this._state.tagToEdit.text] = [
            options.tagSelectedColor,
            options.tagInput.value
        ];
        //free mem
        options = {};
    }
    _createTagUpdateObj(dataObj) {
        const updateObj = {
            id: this._state.tagToEdit.id
        };
        if (dataObj.inputChanged) updateObj.text = dataObj.tagInput.value.trim();
        if (dataObj.colorChanged) updateObj.color = dataObj.tagColor;
        else updateObj.color = this._state.tagToEdit.color;
        return updateObj;
    }
    _tagItemSelector(container) {
        return container.querySelector(".tags-items").querySelector(`[data-id="${this._state.tagToEdit.id}"]`) ?? Array.from(container.querySelector(".tags-items").querySelectorAll(".tag-tag")).find((div)=>div.textContent.trim().toLowerCase() === this._state.tagToEdit.text.toLowerCase());
    }
    _tagColorSelector(selectedColor) {
        return selectedColor ?? Array.from(this._state.component.querySelector(".color-row-icon").closest(".colors").querySelector(".color").classList).find((color)=>color.startsWith("color-"));
    }
    //use for search sanitization
    _inputEscaper(inputValue, attribs) {
        const ESC_MAP = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
        };
        return inputValue.replace(attribs ? /[&<>'"]/g : /[&<>]/g, function(c) {
            return ESC_MAP[c];
        });
    }
}


// import containerSidePeekComponentView from "../containerSidePeekComponentView";
//Controls passing state between different components if
const $97dbb4b1f2916e69$export$a1546ac3b9a8c061 = {};
//Methods
/*
tagItemMarkupFactory : generates tagItem markups
tagItemFactory
filterTagList: holds a list of current tags that are being filtered
tagItemFactory: generates a tagItem object and Its markup which can be gotten from using the tagItemMarkupFactory
conditional: holds the conditional for the current filter applied at a table
filterMethod: method for filtering the tableItems and holds the most recent filter
sortMethod: method for sorting the tableItems and holds the most recent sorter
renderTableItem: method for rerendering the table items, clone of tableComponent method
*/ //State Holder
/*
filterTagOptionActive: notifies other component that the filter is using the tag option
sideBarListActive: notifies tableActionProcess if sideBarList is active to update Tables
hoverEl: holds the hoverEl on eventListener Instantiation
eventHandlers: holds access to all controller methods available to all components
 */ //returns a containerSidePeekComponentObj to instantiate a side peek
$97dbb4b1f2916e69$export$a1546ac3b9a8c061.containerSidePeekComponentObj = (itemId, itemData, position)=>{
    const currentTable = document.querySelector(".table-row-active");
    const callUpdateItemHandler = $97dbb4b1f2916e69$export$a1546ac3b9a8c061.eventHandlers.tableItemControllers.controlUpdateTableItem;
    const getItemData = itemData ?? $97dbb4b1f2916e69$export$a1546ac3b9a8c061.eventHandlers.tableItemControllers.controlGetTableItem(+currentTable.dataset.id, +itemId);
    const updateObj = {
        tableId: +currentTable.dataset.id,
        itemId: +itemId
    };
    const componentObj = {
        itemData: getItemData,
        position: position,
        insertPosition: "beforeend",
        container: ".container",
        componentContainer: ".content-container .row",
        selector: ".container-slide-template",
        toggle: "side-peek",
        tableId: +currentTable.dataset.id,
        itemId: +itemId,
        tags: $97dbb4b1f2916e69$export$a1546ac3b9a8c061.tags,
        tagsColors: $97dbb4b1f2916e69$export$a1546ac3b9a8c061.tagsColor,
        modelControllers: {
            callUpdateItemHandler: callUpdateItemHandler
        },
        eventHandlers: $97dbb4b1f2916e69$export$a1546ac3b9a8c061.eventHandlers
    };
    return componentObj;
};






class $ab9fdfa0df6d04fe$export$2e2bcd8739ae039 {
    _componentHandler = (0, $d2866451d1c7a9c0$export$721ff339e60fcc47).object;
    _state;
    _events = [
        "click",
        "keyup"
    ];
    _signals = (0, $c5e51a03d827fa5f$export$df67e14a9d881936).object;
    _inputCounter = 0;
    constructor(state){
        this._state = state;
    }
    pass() {}
    _createAPITag(payload, refreshCallBack) {
        this._state.eventHandlers.tableItemControllers.controlAddTag(payload, refreshCallBack);
    }
    _createTagForCurrentItem(tag, refreshCallBack, tagInput) {
        const tagClass = Array.from(tag.classList).find((cls1)=>cls1.startsWith("color"));
        const tagColor = this._state.tagsColors.find((color)=>color.color_value === tagClass.trim());
        const tagText = tagInput ?? tag.textContent.trim();
        const tagObj = {
            color: tagClass,
            text: tagText,
            id: tag.dataset.id,
            tagColor: tagColor
        };
        //markup to be immediately returned to the caller
        const createTagMarkup = this._generateTagAddMarkup(tagObj, true);
        if (!tagObj.id) {
            const tagAPIRequestPayload = (0, $bd02c871d9c5ba8e$export$da1e021e040b8232)(tagObj);
            this._createAPITag(tagAPIRequestPayload, refreshCallBack.bind(null, tagObj));
        }
        return {
            createTagMarkup: createTagMarkup,
            tagObj: tagObj
        };
    }
    _getRandomColor() {
        const randomColor = Math.trunc(Math.random() * 9) + 1;
        return this._state.tagsColors[randomColor].color_value;
    }
    _generateTagAddMarkup(tag, addXmark = false) {
        return `
      <div class=" ${addXmark ? "tag-tag" : "row-tag-tag"} ${tag.color}" data-id=${tag.id}>
        ${(0, $bd02c871d9c5ba8e$export$900f2655bf6750e9)(tag.text)}

        ${addXmark ? `
          <div class="row-tag-icon">
            ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("tags-items-icon", "xmark")}
          </div>
          ` : ""}
      </div>
    `;
    }
    _generateCreateOptionsTagMarkup(inputVal) {
        let breakInputVal;
        if (inputVal.length > 25 && !inputVal.includes(" ")) breakInputVal = inputVal.slice(0, 25) + "</br>" + inputVal.slice(25);
        else breakInputVal = inputVal;
        return `
      <div class="tag-create">
        Create 
        <div class="tag-tag ${this._getRandomColor()}">
          ${(0, $bd02c871d9c5ba8e$export$900f2655bf6750e9)(breakInputVal)}
        </div>
      </div>
    `;
    }
    _generateTagsOptionsNudge() {
        return `
      <div class="row-option-icon">
        ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("row-icon icon-md", "ellipsis")}
      </div>
    `;
    }
    _generateTagsOptions(tags) {
        let tagsOptionsMarkup = "";
        tags.forEach((tag)=>{
            tagsOptionsMarkup += `
        <div class="tags-option">
          <div class="row-drag-icon">
            ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("row-icon icon-md", "drag-icon")}
          </div>
          <div class="row-option-tag">
            ${this._generateTagAddMarkup(tag)}
          </div>
          ${this._state.disableOptionsNudge ? "" : this._generateTagsOptionsNudge()}
        </div>
      `;
        });
        return tagsOptionsMarkup;
    }
    _generateTagInput(tagItemsMarkup) {
        return `
      <div class="tag-input-container">
        <div class="tag-input">
          <div class="tags-items">
            ${tagItemsMarkup}
            <input
              type="text"
              class="tag-input-input"
              placeholder="Search or create tag..."
            />
          </div>
        </div>
      </div>

    `;
    }
    _generateMarkup(tagItems, itemId) {
        //restrict the item tags markup to only when the itemId is provided
        let tagItemsMarkup = "";
        if (tagItems) {
            const tagItemsExists = tagItems.length > 0;
            if (tagItemsExists) tagItemsMarkup = tagItems.map((tag, i)=>{
                const tagProperty = (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).tags.find((modelTag)=>modelTag.id === tag);
                if (!tagProperty || tagProperty === -1) {
                    tagItems.splice(i, 1);
                    return "";
                }
                return this._generateTagAddMarkup(tagProperty, true);
            }).join("");
            if (!tagItemsExists) tagItemsMarkup = "";
        }
        const tagInputMarkup = this._state.disableInput ? "" : this._generateTagInput(tagItemsMarkup);
        return `
          <div class="row-tag-popup options-markup" data-id="${itemId}">
            <div class="row-tag-box">
              ${tagInputMarkup}
              <div class="tags-box">
                <div class="tags-info">Select an option or create one</div>
                <div class="tags-available">
                  ${this._generateTagsOptions(this._state.tags)}
                </div>
              </div>
            </div>
          </div>
        `;
    }
    render() {
        const cls1 = this;
        this._state.markup = this._generateMarkup(this._state.tagItems, this._state.itemId);
        const { overlay: overlay, overlayInterceptor: overlayInterceptor, component: component } = this._componentHandler._componentOverlay(this._state);
        this._state = {
            ...this._state,
            overlay: overlay,
            overlayInterceptor: overlayInterceptor,
            component: component
        };
        this._handleUpdateModelIfFilterActive();
        //overlay component handles its event
        overlayInterceptor.addEventListener("click", function(e) {
            cls1._componentHandler._componentRemover(cls1._state);
        }, {
            once: true
        });
        //component handles its event
        this._events.forEach((ev)=>{
            component.addEventListener(ev, this._handleEvents.bind(cls1));
        });
    }
    _handleEvents(e) {
        //form listener event, tag selection and tag creation markup
        if (this._createTagOrTagMatchStrategy(e)) this._handleCreateTagOrTagSelectEvent(e);
        //tag create and add tag to tag item
        if (this._createTagItemMatchStrategy(e)) this._handleCreateTagItem(e);
        //tag add event
        if (this._addTagMatchStrategy(e)) this._handleAddTagToItemEvent(e);
        //remove tag click event
        if (this._removeTagClickMatchStrategy(e)) this._handleRemoveTagClickEvent(e);
        //remove tag key event
        if (this._removeTagKeyMatchStrategy(e)) this._handleRemoveTagKeyEvent(e);
        //tags options options render event
        if (this._renderTagOptionOptionsMatchStrategy(e)) this._handleTagOptionOptionsRenderEvent(e);
    }
    _createTagOrTagMatchStrategy(e) {
        if (e.type === "keyup") {
            const matchStrategy = e.target.classList.contains("tag-input-input");
            return matchStrategy;
        }
    }
    _createTagItemMatchStrategy(e) {
        if (e.type === "click") {
            const matchStrategy = e.target.classList.contains("tag-create") || e.target.closest(".tag-create");
            return matchStrategy;
        }
        if (e.type === "keyup" && e.key === "Enter") {
            const matchStrategy = e.target.classList.contains("tag-input-input") || e.target.closest(".tag-input-input");
            return matchStrategy;
        }
    }
    _addTagMatchStrategy(e) {
        if (e.type === "click") {
            // debugger;
            const matchStrategy = e.target.classList.contains("row-tag-tag") || e.target.classList.contains("tags-option") || e.target.closest(".row-option-tag");
            if (matchStrategy) {
                //implements the signals observer here
                if ((0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterTagOptionActive) {
                    (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).tagItemFactory = this._createTagForCurrentItem.bind(this);
                    (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).tagItemMarkupFactory = this._generateTagAddMarkup.bind(this);
                    //observe for add events to route to filter view if active
                    this._signals.observe(e, "tagadd");
                }
                //if tags not active somewhere else, deliver to its handler
                if (!(0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterTagOptionActive) return matchStrategy;
            }
        }
    }
    _removeTagClickMatchStrategy(e) {
        if (e.type === "click") {
            const matchStrategy = e.target.classList.contains("tags-items-icon") || e.target.closest(".tags-items-icon");
            return matchStrategy;
        }
    }
    _removeTagKeyMatchStrategy(e) {
        if (e.type === "keyup") {
            const matchStrategy = e.key === "Backspace";
            return matchStrategy;
        }
    }
    _renderTagOptionOptionsMatchStrategy(e) {
        if (e.type === "click") {
            const matchStrategy = e.target.classList.contains("row-icon") || //(e.target.classList.contains("svg-icon") &&
            e.target.closest(".row-option-icon");
            return matchStrategy;
        }
    }
    _handleCreateTagOrTagSelectEvent(e) {
        const cls1 = this;
        const tagsAvailableContainer = e.currentTarget.querySelector(".tags-available");
        const inputContainer = e.currentTarget.querySelector(".tag-input-input");
        const filteredTags = this._state.tags.filter((tag)=>tag.text.toLowerCase().includes(inputContainer.value.trim().toLowerCase()));
        const findEqualTag = this._state.tags.find((tag)=>tag.text.toLowerCase() === inputContainer.value.trim().toLowerCase());
        const filteredTagsExists = filteredTags.length > 0;
        const createTagMarkup = this._generateCreateOptionsTagMarkup(inputContainer.value.trim());
        tagsAvailableContainer.innerHTML = "";
        if (filteredTagsExists) {
            //prevent tag creation and only select tag
            const filteredTagsMarkup = this._generateTagsOptions(filteredTags);
            // tagsAvailableContainer.innerHTML = "";
            tagsAvailableContainer.insertAdjacentHTML("beforeend", filteredTagsMarkup);
        }
        if (!findEqualTag && inputContainer.value.length > 0) //allow tag creation if it doesn't exist
        tagsAvailableContainer.insertAdjacentHTML("beforeend", createTagMarkup);
    }
    _handleCreateTagItem(e) {
        const tagsAvailableContainer = e.currentTarget.querySelector(".tags-available");
        const inputContainer = e.currentTarget.querySelector(".tag-input-input");
        const tagInputValue = inputContainer.value.trim();
        //guard clause against empty input val
        const inputValExists = inputContainer?.value.trim().length > 0;
        if (!inputValExists) return;
        //clear input
        inputContainer.value = "";
        // e.target.closest(".tag-tag")
        const tagContainer = e.currentTarget.querySelector(".tag-create .tag-tag");
        const { createTagMarkup: createdTagItem, tagObj: tagObj } = this._createTagForCurrentItem(tagContainer, this._tagsOptionsMarkupReRender.bind(this, tagsAvailableContainer), tagInputValue);
    }
    _tagsOptionsMarkupReRender(tagsAvailableContainer, createdTagObj, createdTagObjAPIId) {
        //create the created tag and add its id from the api resp
        createdTagObj.id = createdTagObjAPIId;
        this._tagItemAdder(this._generateTagAddMarkup(createdTagObj, true));
        //render tags
        const tagsMarkup = this._generateTagsOptions(this._state.tags);
        tagsAvailableContainer.innerHTML = "";
        tagsAvailableContainer.insertAdjacentHTML("beforeend", tagsMarkup);
    }
    _handleRemoveTagClickEvent(e) {
        const tag = e.target.closest(".tag-tag");
        tag.remove();
    }
    _handleRemoveTagKeyEvent(e) {
        const inputContainer = e.currentTarget.querySelector(".tag-input-input");
        //logic to keep track of key presses
        this._inputCounter > 0 ? this.pass() : inputContainer.value.length > 0 ? this._inputCounter = inputContainer.value.length + 1 : this.pass();
        this._inputCounter--;
        //protect against key delete deleting tags if input has text values
        if (this._inputCounter > -1) return;
        const tagItemsContainer = e.target.closest(".tags-items");
        const tagsArray = Array.from(tagItemsContainer.children);
        tagsArray.length < 2 ? this.pass() : tagsArray.at(-2).remove();
    }
    _handleAddTagToItemEvent(e) {
        const tagToAdd = e.target.closest(".row-tag-tag") || e.target.querySelector(".row-tag-tag");
        //
        const tagsAvailableContainer = e.currentTarget.querySelector(".tags-available");
        const inputContainer = e.currentTarget.querySelector(".tag-input-input");
        const tagItemsContainer = document.querySelector(".tags-items");
        const addedTagItems = Array.from(tagItemsContainer.children).map((tagItem)=>tagItem.textContent.trim()).filter((tagItem)=>tagItem.length > 0);
        const { createTagMarkup: createdTagItem, tagObj: tagObj } = this._createTagForCurrentItem(tagToAdd, this._tagsOptionsMarkupReRender.bind(this, tagsAvailableContainer));
        //check if tag in addedTags
        const duplicateCheck = addedTagItems.length > 0 && addedTagItems.find((tag)=>tag.toLowerCase() === tagObj.text.toLowerCase());
        //prevents duplicate addition of tag to tag items
        if (!duplicateCheck) {
            inputContainer.value = "";
            this._tagItemAdder(createdTagItem);
            const tagsMarkup = this._generateTagsOptions(this._state.tags);
            tagsAvailableContainer.innerHTML = "";
            tagsAvailableContainer.insertAdjacentHTML("beforeend", tagsMarkup);
        }
    }
    _handleTagOptionOptionsRenderEvent(e) {
        const state = this._state;
        const currentTarget = e.currentTarget;
        const cls1 = this;
        const itemId = e.currentTarget.dataset.id;
        const tagName = e.target.closest(".tags-option").querySelector(".row-tag-tag");
        const tagToEdit = this._state.tags.find((tag)=>String(tag.id) === tagName.dataset.id);
        const optionNudge = e.target.closest(".row-option-icon");
        let { top: top, left: left, width: width, height: height } = optionNudge.getBoundingClientRect();
        const layoutPositioner = window.matchMedia((0, $ba30e20475feac5a$export$418e7017e024d51c));
        if (layoutPositioner.matches) left = `${parseInt(left) - 200}`;
        const componentObj = {
            callBack: state.subComponentCallback,
            selector: ".row-tag-options",
            top: top,
            left: left,
            width: width,
            height: height,
            tags: state.tags,
            eventHandlers: this._state.eventHandlers,
            tagsColors: state.tagsColors,
            table: state.table,
            itemId: +currentTarget.dataset.id,
            tagToEdit: tagToEdit,
            currentTarget: currentTarget
        };
        const component = new (0, $f24e63269063d04d$export$2e2bcd8739ae039)(componentObj);
        component.render();
    }
    _tagItemAdder(createdItemTag) {
        const tagsAddContainer = document.querySelector(".tags-items");
        //clone input
        const tagAddInputClone = document.querySelector(".tag-input-input").cloneNode(true);
        //remove input
        document.querySelector(".tag-input-input").remove();
        //add tag and cloned input
        tagsAddContainer.insertAdjacentHTML("beforeend", createdItemTag);
        tagsAddContainer.insertAdjacentElement("beforeend", tagAddInputClone);
    }
    _handleUpdateModelIfFilterActive() {
        let updateModel;
        if ((0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterMethod) {
            updateModel = this._state.updateModel?.bind(null, (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterMethod, (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).sortMethod, this._state.payloadType ?? "tags");
            this._state.updateModel = updateModel;
        }
        if ((0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).sortMethod && !(0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterMethod) {
            updateModel = this._state.updateModel?.bind(null, (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterMethod, (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).sortMethod, this._state.payloadType ?? "tags");
            this._state.updateModel = updateModel;
        }
        if (!(0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).sortMethod && !(0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterMethod) {
            updateModel = this._state.updateModel?.bind(null, (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterMethod, (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).sortMethod, this._state.payloadType ?? "tags");
            this._state.updateModel = updateModel;
        }
    }
    remove() {
        this._state?.overlay?.click();
        this._events.forEach((ev)=>this._state?.component?.removeEventListener(ev, cls._handleEvents, true));
    }
}




class $9556d49524119337$export$2e2bcd8739ae039 {
    _componentHandler = (0, $d2866451d1c7a9c0$export$721ff339e60fcc47).object;
    _state;
    _events = [
        "keydown"
    ];
    constructor(state){
        this._state = state;
    }
    _generateMarkup() {
        return `
      <div class="row-actions-text-input" contenteditable="true"></div>
    `;
    }
    render() {
        const cls = this;
        this._state.markup = this._generateMarkup();
        const { overlay: overlay, overlayInterceptor: overlayInterceptor, component: componentInput } = this._componentHandler._componentOverlay(this._state);
        this._state = {
            ...this._state,
            overlay: overlay,
            overlayInterceptor: overlayInterceptor,
            componentInput: componentInput
        };
        this._handleUpdateModelIfFilterActive();
        //overlay component handles its event
        overlayInterceptor.addEventListener("click", function(e) {
            cls._componentHandler._componentRemover(cls._state);
        }, {
            once: true
        });
        //render existing text in text container into input
        if (this._state.table.textContent.length > 0) this._state.componentInput.textContent = this._state.component.textContent;
        //component handles its event
        this._events.forEach((ev)=>{
            componentInput.addEventListener(ev, this._handleEvents.bind(cls));
        });
    }
    _handleEvents(e) {
        //listen for enter from the textinput
        if (e.key === "Enter") {
            //adds the filter to be used when updating the item
            this._handleUpdateModelIfFilterActive();
            this._componentHandler._componentRemover(this._state);
        }
    }
    _handleUpdateModelIfFilterActive() {
        const updateModel = this._state.updateModel.bind(null, (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterMethod, (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).sortMethod, "title" //add the payload type
        );
        this._state.updateModel = updateModel;
    }
}









class $176e612a1ce8accd$export$2e2bcd8739ae039 {
    _componentHandler = (0, $d2866451d1c7a9c0$export$721ff339e60fcc47).object;
    _state;
    _events = [
        "click",
        "keyup",
        "keydown"
    ];
    _updateAndAddTriggeredBeforeUpdateDelay = false;
    _deleteEventActivated = false;
    constructor(state){
        this._state = state;
    }
    _generateInput(inputType, type, checkbox = false) {
        const checkboxMarkup = `
      <div class="slide-action-item">
        <input
          type="checkbox"
          class="slide-action-items-checkbox"
          ${type?.checked ? "checked" : ""}
        />
      </div>
    `;
        const inputMarkup = `<div class="slide-${inputType}-input slide-input" placeholder="List" contenteditable="true">${type?.text ?? ""}</div>`;
        const strikeThroughMarkup = `<s>${inputMarkup}</s>`;
        return `
      <li data-id="${type?.id ?? ""}">
        ${checkbox ? checkboxMarkup : ""}
        ${type?.checked ? strikeThroughMarkup : inputMarkup}
      </li>
    `;
    }
    _generateInputContent(tableItem, inputType, checkbox = false) {
        let inputTypeMarkup = "";
        const queryInputType = inputType.includes("-") ? this._formatInputTypeCamelCase(inputType) : inputType;
        const inputTypeExists = tableItem?.[queryInputType]?.length > 0;
        if (inputTypeExists) inputTypeMarkup += tableItem[queryInputType].map((type)=>this._generateInput(inputType, type, checkbox)).join("");
        if (!inputTypeExists) inputTypeMarkup += this._generateInput(inputType, null, checkbox);
        return inputTypeMarkup;
    }
    _generateSlideContentProperties(tableItem) {
        return `
      <div class="container-slide-content">
        <div class="slide-intentions">
          <h1 class="slide-headings">Intentions</h1>
          <div class="slide-intentions-options slide-options">
            <ol class="slide-intentions-list slide-list">
            ${this._generateInputContent(tableItem, "intentions")}
            </ol>
          </div>
        </div>
        <div class="slide-happenings">
          <h1 class="slide-headings">Happenings</h1>
          <div class="slide-happenings-options slide-options">
            <ul class="slide-happenings-list slide-list">
            ${this._generateInputContent(tableItem, "happenings")}
            </ul>
          </div>
        </div>

        <div class="slide-grateful-for">
          <h1 class="slide-headings">Grateful for</h1>
          <div class="slide-grateful-for-options slide-options">
            <ol class="slide-grateful-for-list slide-list">
              ${this._generateInputContent(tableItem, "grateful-for")}
            </ol>
          </div>
        </div>
        <div class="slide-action-items">
          <h1 class="slide-headings">Action items</h1>
          <div class="slide-action-items-options slide-options">
            <ol class="slide-action-items-list slide-list">
            ${this._generateInputContent(tableItem, "action-items", true)}
            </ol>
          </div>
        </div>
      </div>
    `;
    }
    _generateSlideContent(tableItem, tableItemTags) {
        return `
      <div class="slide-title-box">
        <h1 class="slide-title">
          <input
            type="text"
            placeholder="Untitled"
            class="slide-title-input"
            value="${tableItem.itemTitle ?? ""}"
          />
        </h1>
      </div>
      <div class="slide-properties-box">
        <div class="slide-properties">
          <div class="slide-property-box">
            <div class="slide-property slide-tag">
              <div class="slide-property-content slide-tag-content hover">
                <div class="slide-tag-icon">
                  ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("slide-icon", "list-icon")}
                </div>
                <div class="slide-tag-text--box">
                  <div class="slide-property-text slide-tag-text">Tags</div>
                </div>
              </div>
              <div class="slide-tag-text--box">
                <div class="slide-property-text slide-tag-text hover ${tableItemTags !== "Empty" ? "active" : ""}">${tableItemTags}</div>
              </div>
            </div>
          </div>
          <div class="slide-property-box">
            <div class="slide-property slide-created">
              <div class="slide-property-content slide-created-content hover">
                <div class="slide-property-icon">
                  ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("slide-icon", "clock")}
                </div>
                <div class="slide-created-text--box">
                  <div class="slide-property-text slide-created-text">Created</div>
                </div>
              </div>
              <div class="slide-created-text--box">
                <div class="slide-property-text slide-created-text ${tableItem.id ? "active" : ""}">${(0, $bd02c871d9c5ba8e$export$b434509d4a847712)(tableItem.id ?? "Empty")}
                </div>
                <div class="row-actions-render">
                      <div class="row-actions-render-icon">
                        ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("row-icon", "copy")}
                      </div>
                      <div class="row-actions-tooltip">
                        <div class="tooltip-text">
                          Copy to Clipboard
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>

     ${this._generateSlideContentProperties(tableItem)}
    `;
    }
    _generateSlideTagsMarkup(tableItem) {
        const tagExists = tableItem.itemTags.length > 0;
        if (tagExists) {
            const markup = tableItem.itemTags.map((tag)=>{
                const tagProperties = (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).tags.find((modelTag)=>modelTag.id === tag);
                return (0, $ab9fdfa0df6d04fe$export$2e2bcd8739ae039).prototype._generateTagAddMarkup(tagProperties);
            }).join("");
            return markup;
        }
        if (!tagExists) return "Empty";
    }
    _generateMarkup(tableItem) {
        tableItem = tableItem ? tableItem : "";
        const tableItemTags = this._generateSlideTagsMarkup(tableItem);
        return `
      <div class="container-slide-template">
        <div class="container-slide">
          <div class="slide-nav">
            <div class="slide-nav-actions">
              <div class="nav-nav-icon slide-nav-close hover">
                ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("icon-md nav-icon nav-icon-active", "angles-right")}
              </div>

              <div class="nav-nav-icon slide-nav-next hover">
                ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)(`icon-md ${this._state.position === -1 || this._state.position === 0 || this._state.position === "only" ? "nav-icon-inactive" : "nav-icon-active"}`, "arrow-down")}
              </div>
              <div class="nav-nav-icon slide-nav-prev hover">
                ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)(`icon-md ${this._state.position === -2 || this._state.position === 1 || this._state.position === "only" ? "nav-icon-inactive" : "nav-icon-active"}`, "arrow-up")}
              </div>
            </div>
          </div>

          <div class="slide-content">
            ${this._generateSlideContent(tableItem, tableItemTags)}
          </div>
        </div>
      </div>
    `;
    }
    render() {
        const cls = this;
        this._state.markup = this._generateMarkup(this._state.itemData);
        //implement url change
        // window.history.pushState(null,"",`${ this._state.tableId } /${this._state.itemId}`)
        const component = this._componentHandler._componentRender(this._state);
        this._state = {
            ...this._state,
            component: component
        };
        //component handles its event
        this._events.forEach((ev)=>{
            component.addEventListener(ev, this._handleEvents.bind(cls));
        });
    }
    setDeleteActivatedState(value) {
        this._deleteEventActivated = value;
    }
    setItemDataState(value) {
        this._state.itemData = value;
    }
    getDeleteActivatedState() {
        return this._deleteEventActivated;
    }
    _handleEvents(e) {
        if (this._updateTitleMatchStrategy(e)) this._handleUpdateTitleEvent(e);
        if (this._copyToClipboardMatchStrategy(e)) this._handleCopyToClipboardEvent(e);
        if (this._tagAddMatchStrategy(e)) this._handleTagAddEvent(e);
        if (this._inputAddMatchStrategy(e)) this._handleInputUpdateAndAddEvent(e);
        if (this._inputUpdateMatchStrategy(e)) this._handleInputUpdateEventDelay(e); //this._handleInputUpdateEvent(e);
        if (this._inputDeleteMatchStrategy(e)) this._handleInputDeleteEvent(e);
        if (this._inputCheckboxMatchStrategy(e)) this._handleInputCheckboxEvent(e);
        //nav events
        if (this._closeSliderMatchStrategy(e)) this._handleCloseSliderEvent(e);
        if (this._nextSliderMatchStrategy(e)) this._handleNextSliderEvent(e);
        if (this._prevSliderMatchStrategy(e)) this._handlePrevSliderEvent(e);
    }
    _updateTitleMatchStrategy(e) {
        if (e.type === "keyup") {
            const matchStrategy = e.target.classList.contains("slide-title-input") || e.target.closest(".slide-title-input");
            return matchStrategy;
        }
    }
    _copyToClipboardMatchStrategy(e) {
        if (e.type === "click") {
            const matchStrategy = e.target.classList.contains("row-actions-render") || e.target.closest(".row-actions-render");
            return matchStrategy;
        }
    }
    _tagAddMatchStrategy(e) {
        if (e.type === "click") {
            const matchStrategy = e.target.classList.contains("slide-tag-text") || e.target.closest(".slide-tag-text");
            return matchStrategy;
        }
    }
    _inputAddMatchStrategy(e) {
        if (e.type === "keyup" && e.key === "Enter") {
            const matchStrategy = e.target.classList.contains("slide-input") || e.target.closest(".slide-input");
            return matchStrategy;
        }
    }
    _inputUpdateMatchStrategy(e) {
        if (e.type === "keyup" && e.key !== "Enter") {
            const matchStrategy = e.target.classList.contains("slide-input") || e.target.closest(".slide-input");
            return matchStrategy;
        }
    }
    _inputDeleteMatchStrategy(e) {
        if (e.type === "keydown" && e.key === "Backspace") {
            const matchStrategy = e.target.classList.contains("slide-input") && e.target.closest(".slide-input");
            if (matchStrategy && !matchStrategy.textContent.trim().toLowerCase().length > 0) return matchStrategy;
        }
    }
    _inputCheckboxMatchStrategy(e) {
        if (e.type === "click") {
            const matchStrategy = e.target.classList.contains("slide-action-items-checkbox") || e.target.closest(".slide-action-items-checkbox");
            return matchStrategy;
        }
    }
    _closeSliderMatchStrategy(e) {
        const matchStrategy = e.target.classList.contains("slide-nav-close") || e.target.closest(".slide-nav-close");
        return matchStrategy;
    }
    _nextSliderMatchStrategy(e) {
        const matchStrategy = e.target.classList.contains("slide-nav-next") || e.target.closest(".slide-nav-next");
        if (matchStrategy && !e.target.closest(".slide-nav-next").children[0].classList.contains("nav-icon-inactive")) return matchStrategy;
    }
    _prevSliderMatchStrategy(e) {
        const matchStrategy = e.target.classList.contains("slide-nav-prev") || e.target.closest(".slide-nav-prev");
        if (matchStrategy && !e.target.closest(".slide-nav-prev").children[0].classList.contains("nav-icon-inactive")) return matchStrategy;
    }
    _handleUpdateTitleEvent(e) {
        const cls = this;
        const inputVal = e.target.closest(".slide-title-input");
        const payload = {
            itemId: this._state.itemId,
            tableId: this._state.tableId,
            title: inputVal.value
        };
        this._state.eventHandlers.tableItemControllers.controlUpdateTableItem(payload, null, null, "title");
    }
    _handleCopyToClipboardEvent(e) {
        const copyContent = e.target.closest(".row-actions-render").previousElementSibling;
        navigator.clipboard.writeText(copyContent.textContent.trim());
        new (0, $c2721d55d807f8b0$export$caec2af78bcc877f)((0, $ba30e20475feac5a$export$3c216b31aa0f6ba8), null, "success").component();
    }
    _handleTagAddEvent(e) {
        const cls = this;
        const tagViewportHolder = e.target.closest(".slide-tag-text");
        const { top: top, left: left, width: width, height: height } = tagViewportHolder.getBoundingClientRect();
        const updateObj = {
            tableId: cls._state.tableId,
            itemId: cls._state.itemId,
            refreshCallBack: this.refreshContent.bind(cls),
            getUpdatedData: true
        };
        const componentObj = {
            top: `${parseInt(top) + 50}`,
            left: left,
            width: width,
            height: height,
            selector: ".options-markup",
            table: tagViewportHolder,
            updateModel: this._state.modelControllers.callUpdateItemHandler.bind(null, updateObj),
            subComponentCallback: this._state.modelControllers.callUpdateItemHandler,
            getUpdatedData: this._state.eventHandlers.tableItemControllers.controlGetTableItem.bind(null, cls._state.tableId, cls._state.itemId),
            eventHandlers: this._state.eventHandlers,
            // refreshCaller: this.refreshContent.bind(cls),
            updateTag: true,
            updateObj: updateObj,
            tagItems: cls._state.itemData.itemTags,
            itemId: cls._state.itemId,
            tags: cls._state.tags,
            tagsColors: cls._state.tagsColors
        };
        const component = new (0, $ab9fdfa0df6d04fe$export$2e2bcd8739ae039)(componentObj);
        component.render();
    }
    _handleInputUpdateAndAddEvent(e) {
        const inputType = this._getInputType(e);
        const [inputContainer, checkedValue, updateVal, updateId] = this._getInputAndChecked(e, inputType);
        const nextElInput = e.target.closest("li").nextElementSibling?.querySelector(`.slide-${inputType}-input`);
        const selectionAnchorOffset = document.getSelection().anchorOffset;
        const inputSelection = document.getSelection().getRangeAt(0).startContainer?.data;
        const inputSelectionExists = inputSelection?.length > 0;
        this._setUpdateValueTextContent(updateVal, inputSelectionExists, inputSelection, selectionAnchorOffset);
        const inputModelKey = this._formatInputTypeCamelCase(inputType);
        const inputContainsCheckbox = inputType === "action-items" ? true : false;
        const checkedProperty = this._constructCheckedProperty(inputContainsCheckbox, checkedValue);
        const update = this._constructUpdateProperty(updateVal, inputModelKey, updateId);
        const createRelativeProperty = inputSelectionExists || nextElInput ? updateId : null;
        //get the ordering value of each item from the UI
        const { createItemOrdering: createItemOrdering, itemsOrdering: itemsOrdering } = this._getItemsOrdering(inputType, createRelativeProperty);
        const payload = {
            itemId: this._state.itemId,
            tableId: this._state.tableId,
            modelProperty: {
                checkedProperty: checkedProperty,
                property: {
                    create: {
                        value: this._setPayloadCreateValue(inputSelection, inputSelectionExists, selectionAnchorOffset),
                        relativeProperty: createRelativeProperty,
                        ordering: createItemOrdering
                    },
                    update: update,
                    orderingList: itemsOrdering,
                    key: inputModelKey,
                    updateAndAddProperty: true
                }
            }
        };
        this._updateAndAddTriggeredBeforeUpdateDelay = true;
        //callback after update
        payload.refreshCallBack = this._refreshAndUpdateUICallBack.bind(this, inputSelectionExists, nextElInput, inputType, updateId);
        //update the item
        // debugger;
        this._state.eventHandlers.tableItemControllers.controlUpdateTableItem(payload, null, null, payload.modelProperty.property.key);
    }
    _getItemsOrdering(inputType, createRelativeProperty) {
        let incrementOrderingIndex = false;
        let createItemOrdering = null;
        const itemsOrdering = Array.from(document.querySelectorAll(`.slide-${inputType}-list li`)).map((item, i)=>{
            if (createRelativeProperty && item.dataset.id === createRelativeProperty) {
                incrementOrderingIndex = true;
                createItemOrdering = i + 2;
                return {
                    id: item.dataset.id,
                    ordering: i + 1
                };
            }
            return {
                id: item.dataset.id,
                ordering: incrementOrderingIndex ? i + 2 : i + 1
            };
        });
        return {
            createItemOrdering: createItemOrdering,
            itemsOrdering: itemsOrdering
        };
    }
    _setUpdateValueTextContent(updateVal, inputSelectionExists, inputSelection, selectionAnchorOffset) {
        if (updateVal) {
            if (inputSelectionExists && selectionAnchorOffset > 0 || !inputSelectionExists) updateVal.textContent = updateVal.textContent.trim();
            if (inputSelectionExists && selectionAnchorOffset === 0) updateVal.textContent = updateVal.textContent.split(inputSelection)[0].trim();
        }
    }
    _setPayloadCreateValue(inputSelection, inputSelectionExists, selectionAnchorOffset) {
        if (inputSelectionExists && selectionAnchorOffset > 0 || !inputSelectionExists) return "";
        if (inputSelectionExists && selectionAnchorOffset === 0) return inputSelection.trim();
    }
    _refreshAndUpdateUICallBack(inputSelectionExists, nextElInput, inputType, updateId) {
        const tableItemData = this._state.eventHandlers.tableItemControllers.controlGetTableItem(this._state.tableId, this._state.itemId);
        //refresh the content
        this.refreshContent(tableItemData);
        const relativeAddedItem = inputSelectionExists || nextElInput ? document.querySelector(`[data-id="${updateId}"]`)?.nextElementSibling?.querySelector(`.slide-${inputType}-input`) : null;
        //focus on the relative or last element on content refresh
        const updatedInputContainer = this._getInputContainer(null, inputType, true);
        const addedItemInput = !relativeAddedItem && updatedInputContainer.children[updatedInputContainer.children.length - 1].querySelector(`.slide-${inputType}-input`);
        if (relativeAddedItem) {
            relativeAddedItem.focus();
            this._moveCursorToTextEnd(relativeAddedItem);
        }
        if (!relativeAddedItem) {
            addedItemInput.focus();
            this._moveCursorToTextEnd(addedItemInput);
        }
        //reset the trigger state after content rerender
        this._updateAndAddTriggeredBeforeUpdateDelay = false;
    }
    _clearPreviousTimer() {
        clearInterval(this._timer);
        this._timer = null;
    }
    _handleInputUpdateEventDelay(e) {
        if (this._timer) this._clearPreviousTimer();
        this._timer = setTimeout(()=>{
            if (!this._updateAndAddTriggeredBeforeUpdateDelay) {
                this._handleInputUpdateEvent(e);
                this._updateAndAddTriggeredBeforeUpdateDelay = false;
            }
            if (this._updateAndAddTriggeredBeforeUpdateDelay) {
                clearInterval(this._timer);
                this._updateAndAddTriggeredBeforeUpdateDelay = false;
            }
        }, 2000);
    }
    _handleInputUpdateEvent(e) {
        if (this.getDeleteActivatedState()) {
            //prevent an update event from being triggered after a delete event
            this.setDeleteActivatedState(false);
            return;
        }
        const inputType = this._getInputType(e);
        const [inputContainer, checkedValue, updateVal, updateId] = this._getInputAndChecked(e, inputType);
        const inputContainsCheckbox = inputType === "action-items" ? true : false;
        const checkedProperty = this._constructCheckedProperty(inputContainsCheckbox, checkedValue);
        const inputModelKey = this._formatInputTypeCamelCase(inputType);
        const update = this._constructUpdateProperty(updateVal, inputModelKey, updateId);
        const payload = {
            itemId: this._state.itemId,
            tableId: this._state.tableId,
            modelProperty: {
                checkedProperty: checkedProperty,
                property: {
                    update: update
                },
                updateProperty: true
            }
        };
        // debugger;
        this._state.eventHandlers.tableItemControllers.controlUpdateTableItem(payload, null, null, payload.modelProperty.property.update.key);
    }
    _handleInputDeleteEvent(e) {
        this.setDeleteActivatedState(true);
        const inputType = this._formatInputType(e.target.closest(".slide-options").previousElementSibling.textContent.trim().toLowerCase());
        const inputContainer = e.target.closest("li");
        const input = e.target;
        const previousElInput = inputContainer?.previousElementSibling?.querySelector(`.slide-${inputType}-input`);
        const nextElInput = inputContainer?.nextElementSibling?.querySelector(`.slide-${inputType}-input`);
        const allInputTypeLength = Array.from(document.querySelectorAll(`.slide-${inputType}-input`)).length;
        //prevent delete of last and only item except updating it
        if (allInputTypeLength === 1) {
            this.setDeleteActivatedState(false);
            return;
        }
        const payload = {
            itemId: this._state.itemId,
            tableId: this._state.tableId,
            modelProperty: {
                property: {
                    delete: {
                        propertyId: inputContainer.dataset.id,
                        key: this._formatInputTypeCamelCase(inputType)
                    }
                }
            }
        };
        //add check against model access if empty value
        const propertyItems = inputContainer.closest(`.slide-${inputType}-list `);
        if (propertyItems.children.length >= 1) this._state.eventHandlers.tableItemControllers.controlDeleteTableItem(payload, null, inputType.trim(), false);
        if (!previousElInput && !nextElInput) return;
        if (previousElInput) {
            previousElInput.focus();
            this._moveCursorToTextEnd(previousElInput);
        }
        if (!previousElInput && nextElInput) {
            nextElInput.focus();
            this._moveCursorToTextEnd(nextElInput);
        }
        !input.textContent.length > 0 && inputContainer.remove();
    }
    _handleInputCheckboxEvent(e) {
        const inputType = this._formatInputType(e.target.closest(".slide-options").previousElementSibling.textContent.trim().toLowerCase());
        const actionCheckbox = e.target.closest(".slide-action-items-checkbox");
        const actionText = e.target.parentElement.nextElementSibling;
        const actionId = e.target.closest("li").dataset.id;
        this._implementCheckLogic(e, actionCheckbox, actionText);
        const payload = {
            itemId: this._state.itemId,
            tableId: this._state.tableId,
            modelProperty: {
                property: {
                    updateActionItem: {
                        checked: actionCheckbox.checked,
                        propertyId: actionId,
                        value: actionText.textContent,
                        key: this._formatInputTypeCamelCase(inputType)
                    }
                }
            }
        };
        //update the item intentions
        this._state.eventHandlers.tableItemControllers.controlUpdateTableItem(payload, null, null, "actionItems");
    }
    _handleCloseSliderEvent(e) {
        //remove slider styling from container
        const container = document.querySelector(".container");
        container.classList.toggle("side-peek");
        //url item remove
        // window.location.replace (`${window.location.origin}/#`)
        //reload not needed
        this.reloadTableComponent();
        //remove slider
        this.remove();
    }
    _handleNextSliderEvent(e) {
        const { item: item, position: position } = this._state.eventHandlers.tableItemControllers.controlGetTableItem(+this._state.tableId, +this._state.itemId, 1);
        this.reRenderSidePeek(item, position);
    }
    _handlePrevSliderEvent(e) {
        const { item: item, position: position } = this._state.eventHandlers.tableItemControllers.controlGetTableItem(+this._state.tableId, +this._state.itemId, -1);
        this.reRenderSidePeek(item, position);
    }
    _constructCheckedProperty(inputContainsCheckbox, checkedValue) {
        const checkedProperty = {
            checkbox: inputContainsCheckbox,
            checked: inputContainsCheckbox ? checkedValue.checked : false
        };
        return checkedProperty;
    }
    _constructUpdateProperty(updateVal, inputModelKey, updateId) {
        const update = {
            value: updateVal.textContent,
            key: inputModelKey,
            propertyId: updateId
        };
        return update;
    }
    _getInputContainer(e, inputType, refresh = false) {
        return refresh ? document.querySelector(`.slide-${inputType}-list`) : e.target.closest(`.slide-${inputType}-list`);
    }
    _getInputAndChecked(e, inputType) {
        const inputContainer = this._getInputContainer(e, inputType);
        const checkedValue = e.target?.closest("li")?.querySelector(".slide-action-items-checkbox");
        const updateVal = e.target.closest(`.slide-${inputType}-input`);
        const updateId = updateVal.closest("li").dataset.id;
        return [
            inputContainer,
            checkedValue,
            updateVal,
            updateId
        ];
    }
    _getInputType(e) {
        const type = this._formatInputType(e.target.closest(".slide-options").previousElementSibling.textContent.toLowerCase());
        return type;
    }
    _formatInputType(inputType) {
        const formatInput = inputType.includes(" ");
        const type = formatInput ? inputType.split(" ").join("-") : inputType;
        return type;
    }
    _formatInputTypeCamelCase(inputType) {
        const shouldFormatInput = inputType.includes("-");
        const formatInput = inputType.split("-");
        return shouldFormatInput ? formatInput[0] + (formatInput[1][0].toUpperCase() + formatInput[1].slice(1).toLowerCase()) : inputType;
    }
    _splitFromInputVal(inputContainer, inputVal, valToSplit) {
        const val = inputVal.split(valToSplit)[0];
        if (val) inputContainer.textContent = val;
        return val;
    }
    _moveCursorToTextEnd(textContainer) {
        const selection = document.getSelection();
        selection.selectAllChildren(textContainer);
        selection.collapseToEnd();
    }
    _implementCheckLogic(e, checkbox, checkText) {
        if (checkbox.checked) this._wrapAndReplaceNodeWithStrikeThrough(e, checkText);
        if (!checkbox.checked) this._removeStrikeThroughFromNode(e, checkText);
    }
    _wrapAndReplaceNodeWithStrikeThrough(e, node) {
        const nodeClone = node.cloneNode(true);
        node.remove();
        const strikeThroughEl = document.createElement("s");
        strikeThroughEl.insertAdjacentElement("afterbegin", nodeClone);
        //insert the node into parent
        e.target.parentElement.insertAdjacentElement("afterend", strikeThroughEl);
    }
    _removeStrikeThroughFromNode(e, node) {
        const nodeClone = node.children[0].cloneNode(true);
        node.remove();
        e.target.parentElement.insertAdjacentElement("afterend", nodeClone);
    }
    refreshContent(updatedData) {
        //reset component itemData value
        this.setItemDataState(updatedData);
        const itemPropertyContainer = document.querySelector(".slide-content");
        const contentContainer = document.querySelector(".container-slide-content");
        const tableItemTags = this._generateSlideTagsMarkup(updatedData);
        const contentMarkup = this._generateSlideContent(updatedData, tableItemTags);
        itemPropertyContainer.innerHTML = "";
        contentContainer.innerHTML = "";
        itemPropertyContainer.insertAdjacentHTML("beforeend", contentMarkup);
    }
    reloadTableComponent() {
        let table;
        table = this._state.eventHandlers.tableControllers.controlGetTable();
        if ((0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterMethod) table.tableItems = (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterMethod(table.tableItems);
        if ((0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).sortMethod) table.tableItems = (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).sortMethod(table.tableItems);
        (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).renderTableItem(table.tableItems, (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterMethod);
    }
    reRenderSidePeek(item, position) {
        [this._state.itemData, this._state.itemId, this._state.position, this._state.toggle] = [
            item,
            item.id,
            position,
            "null"
        ];
        this.remove();
        this.render();
    }
    remove() {
        const cls = this;
        this._events.forEach((ev)=>this._state.component.removeEventListener(ev, cls._handleEvents, true));
        this._state.component.remove();
    // delete this;
    }
} // export default new ContainerSidePeekComponentView();





class $d50a2a9c3981572e$var$TableBodyProcessorView {
    _parentElement = document.querySelector(`[role="tablebody"]`);
    _componentHandler = (0, $d2866451d1c7a9c0$export$721ff339e60fcc47).cls;
    _eventHandlers;
    _textInputActive = false;
    _currentTable;
    _currentTableSetter;
    _hoverActive = false;
    _tags;
    _tagsColor;
    _checkedInputs = [];
    _currentHoverId = null;
    _token;
    addHandlers(handlers, currentTableSetter) {
        this._eventHandlers = handlers;
        this._currentTableSetter = currentTableSetter;
    }
    addTagsMetaData(...tagsMetaData) {
        tagsMetaData = [
            ...tagsMetaData[0]
        ];
        [this._tags, this._tagsColor] = tagsMetaData;
    }
    resetTextInputActiveState() {
        this._textInputActive = false;
    }
    callUpdateItemHandler(updateObj, filter, sort, payloadType) {
        this._eventHandlers.tableItemControllers.controlUpdateTableItem(updateObj, filter, sort, payloadType);
    }
    render(currentTable) {
        //guard clause against logic trigger
        if (!currentTable || !currentTable?.tableItems?.length > 0) return;
        const markup = this._generateItemMarkup(currentTable.tableItems);
        const tableBody = document.querySelector(`[role="tablebody"]`);
        tableBody.innerHTML = "";
        tableBody.insertAdjacentHTML("afterbegin", markup);
    }
    renderTableInput(inputContainer, currentTable) {
        const cls = this;
        //if currentTable not passeed in, get the current table from the DOM
        this._currentTable = currentTable ? currentTable : document.querySelector(".table-row-active").dataset;
        //prevent Another textInput from being triggered
        this._textInputActive = true;
        const { top: top, left: left, width: width, height: height } = inputContainer.getBoundingClientRect();
        const textContainer = inputContainer.closest(".row-actions-segment").querySelector(".row-actions-text");
        const itemId = inputContainer.closest(".row-actions-handler-container").dataset.id;
        //instantiating an updateObj allows the updateModel to get assess to the updateObj(same reference)
        const updateObj = {
            tableId: +this._currentTable.id,
            itemId: +itemId
        };
        const componentObj = {
            top: top,
            left: left,
            width: width,
            height: height,
            selector: ".row-actions-text-input",
            table: inputContainer,
            component: textContainer,
            callBack: this.resetTextInputActiveState.bind(this),
            updateObj: updateObj,
            updateModel: this.callUpdateItemHandler.bind(this, updateObj)
        };
        const component = new (0, $9556d49524119337$export$2e2bcd8739ae039)(componentObj);
        component.render();
    }
    _addOrRemoveChecked = (input, specifier)=>{
        if (specifier === 1) {
            input.classList.add("highlight-rows");
            const inputCheckbox = input.querySelector(".checkboxInput");
            inputCheckbox.classList.add("visible");
            inputCheckbox.checked = true;
        }
        if (specifier === 0) {
            input.classList.remove("highlight-rows");
            const inputCheckbox = input.querySelector(".checkboxInput");
            inputCheckbox.classList.remove("visible");
            inputCheckbox.checked = false;
        }
    };
    matchEvent(e) {
        //if table item add checker before body event active
        if (this._itemAddChecker(e)) this._handleItemAdd(e);
        //checkbox container related events
        const checkTarget = e.target.closest("[role=tablehead]");
        if (checkTarget) //protect checker with guardclause
        {
            if (this._itemCheckboxChecker(e)) this._handleItemSelect(e);
        }
        this._handleCheckboxDelegationEvents(e);
    }
    _itemAddChecker(e) {
        if (e.type === "click") {
            const matchStrategy = e.target.classList.contains("row-adder-content") || e.target.closest(".row-adder-content");
            if (matchStrategy) {
                const filterExists = document.querySelector(".filter-added-rule"); //(".filter-added-rule-box");
                const filterContent = filterExists?.textContent?.trim().length > 0;
                const sortExists = document.querySelector(".sort-added-rule-box");
                if (filterExists && filterContent || sortExists) return false;
                //prevent add if search is active
                const tableSearchText = document.querySelector(".search-input");
                if (tableSearchText && tableSearchText.value.trim().length > 0) return false;
                if (!filterContent || !filterExists || !sortExists) return true;
            }
        }
    }
    _itemCheckboxChecker(e) {
        if (e.type === "click") {
            if (e.target.closest(".checkboxInput")) return true;
        }
    }
    _handleItemAdd(e) {
        //call controller to add new Item
        this._eventHandlers.tableItemControllers.controlAddTableItem();
    }
    _generateAndinsertCheckboxOption(container, itemCount) {
        const checkboxOptionMarkup = this._generateCheckboxOptionMarkup(itemCount);
        container.insertAdjacentHTML("beforeend", checkboxOptionMarkup);
    }
    _handleItemSelect(e) {
        let checkboxOptions;
        const toggleFunctionality = (input)=>{
            input.classList.toggle("highlight-rows");
            const inputCheckbox = input.querySelector(".checkboxInput");
            inputCheckbox.classList.toggle("visible");
        };
        //determine if body is clicked or had
        const selectAllItems = e.target.closest("[role=tablehead]");
        const selectItems = e.target.closest("[role=tablebody]");
        //use to show the checkbox option
        const tableHeadContainer = document.querySelector(".main-table-head");
        if (selectAllItems) {
            const allItemsSelected = Array.from(document.querySelectorAll("[role=tablecontent]"));
            const allSelectIsChecked = selectAllItems.querySelector(".checkboxInput");
            if (allSelectIsChecked.checked === true) {
                this._checkedInputs.length = 0;
                this._checkedInputs.push(...allItemsSelected);
                this._checkedInputs.forEach((input)=>{
                    this._addOrRemoveChecked(input, 1);
                });
            }
            if (!allSelectIsChecked.checked === true) {
                this._checkedInputs.forEach((input)=>{
                    this._addOrRemoveChecked(input, 0);
                    input.querySelector(".checkboxInput").checked = false;
                });
                this._checkedInputs.length = 0;
            }
        }
        if (selectItems && !selectAllItems) {
            const selectedItem = e.target.closest("[role=tablecontent]");
            const selectedItemIsChecked = selectedItem.querySelector(".checkboxInput");
            const allItemsSelector = document.querySelector("[role=tablehead]").querySelector(".checkboxInput").checked = false;
            if (selectedItemIsChecked.checked === true) {
                toggleFunctionality(selectedItem);
                this._checkedInputs.push(selectedItem);
            } else if (this._checkedInputs.length > 0) {
                const itemIndex = this._checkedInputs.findIndex((item)=>item === selectedItem);
                toggleFunctionality(selectedItem);
                this._checkedInputs.splice(itemIndex, 1);
                const allItemsSelector = document.querySelector("[role=tablehead]").querySelector.checked = false;
            }
        }
        //render checkboxOption and update Length
        const checkIfCheckboxOptionExists = document.querySelector(".checkbox-options");
        const checkedLength = this._checkedInputs.length;
        if (!checkIfCheckboxOptionExists && checkedLength) this._generateAndinsertCheckboxOption(tableHeadContainer, this._checkedInputs.length);
        if (checkIfCheckboxOptionExists) {
            if (!checkedLength) {
                checkIfCheckboxOptionExists.remove();
                this._checkedInputs.length = 0;
            }
            if (checkedLength) checkIfCheckboxOptionExists.querySelector(".checkbox-total").querySelector(".checkbox-text").textContent = `${this._checkedInputs.length} selected`;
        }
    }
    _handleDelegatedEvents(e) {
        //if table item add checker after body event active
        if (this._itemAddChecker(e)) this._handleItemAdd(e);
        //hover handler
        if (this._itemHoverMatchStrategy(e)) this._handleItemHoverEvents(e);
        //textInput switch handler
        const clickedNameColumn = this._itemNameClickStrategy(e);
        clickedNameColumn && this._handleNamePropertyClickEvent(e, clickedNameColumn);
        //tag options handler
        const clickedTagColumn = this._itemTagMatchStrategy(e);
        clickedTagColumn && this._handleTagPropertyClickEvent(e, clickedTagColumn);
        if (this._itemCheckboxChecker(e)) this._handleItemSelect(e);
        //hover action handler
        if (this._hoverActionAddChecker(e)) this._handleHoverActionAddEvent(e);
        //addTable item checker for the tablesearch
        if (this._tableSearchAddMatchStrategy(e)) this._handleTableSearchAddEvent(e);
        //side peek opener
        if (this._containerSidePeekMatchStrategy(e)) this._handleContainerSidePeekEvent(e);
    }
    _handleCheckboxDelegationEvents(e) {
        if (e.type !== "click") return;
        //checkbox text selected click
        if (this._checkboxTextSelectedMatchStrategy(e)) this._handleCheckboxTextSelectedEvent(e);
        //checkbox delete click
        if (this._checkboxDeleteMatchStrategy(e)) this._handleCheckboxDeleteEvent(e);
        //checkbox options option click
        if (this._checkboxDuplicateMatchStrategy(e)) this._handleCheckboxDuplicateEvent(e);
        //checkbox tags click
        if (this._checkboxTagsMatchStrategy(e)) this._handleCheckboxTagsEvent(e);
    }
    _handleContainerSidePeekEvent(e) {
        //remove the container if it currently exists
        const sliderAlreadyExists = document.querySelector(".container-slide-template");
        if (sliderAlreadyExists) {
            sliderAlreadyExists.remove();
            document.querySelector(".container").classList.remove("side-peek");
        }
        const layoutBreakpointTrigger = window.matchMedia((0, $ba30e20475feac5a$export$bcd5792a294b918c));
        if (layoutBreakpointTrigger.matches) {
            const container = document.querySelector(".container");
            const sideBarComponentCloseIcon = document.querySelector(".sidebar-close");
            if (!container.classList.contains("nav-hide")) sideBarComponentCloseIcon?.click();
        }
        const cls = this;
        const itemId = e.target.closest(".row-actions-handler-container").dataset.id;
        const { item: item, position: position } = this._eventHandlers.tableItemControllers.controlGetTableItem(+cls._currentTable.id, +itemId, null, true);
        const componentObj = (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).containerSidePeekComponentObj(itemId, item, position);
        const component = new (0, $176e612a1ce8accd$export$2e2bcd8739ae039)(componentObj);
        component.render();
    }
    _tableSearchAddMatchStrategy(e) {
        if (e.type === "click") {
            const tableSearchInput = document.querySelector(".search-input");
            const matchStrategy = e.target.classList.contains("row-adder-content") || e.target.closest(".row-adder-content");
            if (matchStrategy && tableSearchInput) {
                if (tableSearchInput.value.length > 0 && parseInt(getComputedStyle(tableSearchInput)["width"]) > 0 && !(0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterMethod && !(0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).sortMethod) return true;
            }
        }
    }
    _containerSidePeekMatchStrategy(e) {
        if (e.type === "click") {
            const matchStrategy = e.target.classList.contains("row-actions-render-text") || e.target.closest(".row-actions-render-text");
            return matchStrategy;
        }
    }
    _hoverActionAddChecker(e) {
        if (e.type === "click") {
            const matchStrategy = e.target.classList.contains("row-add-icon") || e.target.closest(".row-add-icon");
            if (matchStrategy) {
                const filterExists = document.querySelector(".added-rule"); //(".filter-added-rule-box");
                const filterContent = filterExists?.textContent?.trim().length > 0;
                const sortExists = document.querySelector(".sort-added-rule-box");
                if (filterExists && filterContent || sortExists) return false;
                if (!filterContent || !filterExists || !sortExists) return true;
            }
        }
    }
    _checkboxTextSelectedMatchStrategy(e) {
        const matchStrategy = e.target.classList.contains("checkbox-total") || e.target.closest(".checkbox-total");
        return matchStrategy;
    }
    _checkboxDeleteMatchStrategy(e) {
        const matchStrategy = e.target.classList.contains("checkbox-delete") || e.target.closest(".checkbox-delete");
        return matchStrategy;
    }
    _checkboxDuplicateMatchStrategy(e) {
        const matchStrategy = e.target.classList.contains("checkbox-clone") || e.target.closest(".checkbox-clone");
        return matchStrategy;
    }
    _checkboxTagsMatchStrategy(e) {
        const matchStrategy = e.target.classList.contains("checkbox-tags") || e.target.closest(".checkbox-tags");
        return matchStrategy;
    }
    _handleHoverActionAddEvent(e) {
        const targetContainer = e.target.closest(".row-actions-handler");
        this._eventHandlers.tableItemControllers.controlAddTableItem(null, +targetContainer.dataset.id);
    }
    _handleTableSearchAddEvent(e) {
        const searchInput = document.querySelector(".search-input");
        this._eventHandlers.tableItemControllers.controlAddTableItem(null);
        searchInput.value = "";
    }
    _handleCheckboxTextSelectedEvent(e) {
        const checkboxOptions = document.querySelector(".checkbox-options");
        const allInputSelector = document.querySelector("[role=tablehead] .checkboxInput");
        this._checkedInputs.forEach((input)=>{
            this._addOrRemoveChecked(input, 0);
        });
        checkboxOptions.remove();
        this._checkedInputs.length = 0;
        allInputSelector.checked = false;
    }
    _handleCheckboxDeleteEvent(e) {
        const selectedTableItems = this._checkedInputs.map((item)=>item.querySelector(".row-actions-handler-container").dataset.id);
        this._checkedInputs.length = 0;
        const currentTable = document.querySelector(".table-row-active");
        const updateObj = {
            tableId: +currentTable.dataset.id,
            items: selectedTableItems
        };
        //check if filterMethod exists
        // const filter = componentGlobalState.filterMethod ?? null;
        this._eventHandlers.tableItemControllers.controlDeleteTableItem(updateObj, (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterMethod, "deleteTableItems");
        //remove checkbox options container
        document.querySelector(".checkbox-options").remove();
    }
    _handleCheckboxDuplicateEvent(e) {
        const currentTable = document.querySelector(".table-row-active");
        const checkboxOptionsContainer = e.target.closest(".checkbox-options");
        checkboxOptionsContainer.remove();
        const selectedTableItems = this._checkedInputs.map((item)=>item.querySelector(".row-actions-handler-container").dataset.id);
        this._checkedInputs.length = 0;
        const updateObj = {
            tableId: +currentTable.dataset.id,
            items: selectedTableItems
        };
        this._eventHandlers.tableItemControllers.controlDuplicateTableItem(updateObj, (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterMethod, (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).sortMethod);
    }
    _handleCheckboxTagsEvent(e) {
        const cls = this;
        const checkboxOptionsContainer = e.target.closest(".checkbox-options");
        const tagViewportHolder = e.target.closest(".checkbox-tags");
        const { top: top, left: left, width: width, height: height } = tagViewportHolder.getBoundingClientRect();
        const currentTable = document.querySelector(".table-row-active");
        //clear the checkedInput
        this._checkedInputs.length = 0;
        const selectedTableItems = Array.from(document.querySelectorAll(".highlight-rows")).map((item)=>item.querySelector(".row-actions-handler-container").dataset.id);
        const updateObj = {
            itemIds: selectedTableItems,
            tableId: +currentTable.dataset.id
        };
        const getTableItemWithMaxTags = this._eventHandlers.tableItemControllers.controlGetTableItemWithMaxTags(updateObj.tableId, updateObj.itemIds);
        const componentObj = {
            table: tagViewportHolder,
            top: top,
            left: left,
            width: width,
            height: height,
            selector: ".options-markup",
            updateModel: cls.callUpdateItemHandler.bind(cls, updateObj),
            subComponentCallback: cls.callUpdateItemHandler.bind(cls),
            updateTag: true,
            eventHandlers: this._eventHandlers,
            updateObj: updateObj,
            tagItems: getTableItemWithMaxTags.itemTags,
            tags: this._tags,
            tagsColors: this._tagsColor,
            payloadType: "selectTags"
        };
        const component = new (0, $ab9fdfa0df6d04fe$export$2e2bcd8739ae039)(componentObj);
        component.render();
        //remove checkbox container
        checkboxOptionsContainer.remove();
    }
    _handleNamePropertyClickEvent(e, clickedContainer) {
        if (!this._textInputActive) {
            //run if no current textInput is active
            const inputContainer = clickedContainer.querySelector(".row-actions-segment");
            //reuse input render functionality
            this.renderTableInput(inputContainer);
        }
    }
    _handleTagPropertyClickEvent(e, clickedContainer) {
        const cls = this;
        if (this._textInputActive) return;
        const itemId = clickedContainer.closest(".row-actions-handler-container").dataset.id;
        const tagContainer = clickedContainer.querySelector(".table-item-tags");
        const currentTable = this._eventHandlers.tableControllers.controlGetTable();
        const getTableItemData = this._eventHandlers.tableItemControllers.controlGetTableItem(currentTable.id, +itemId);
        const { top: top, left: left, width: width, height: height } = tagContainer.getBoundingClientRect();
        //component code
        const updateObj = {
            tableId: currentTable.id,
            itemId: +itemId
        };
        const componentObj = {
            top: `${parseInt(top) - 80}`,
            left: left,
            width: width,
            height: height,
            selector: ".options-markup",
            table: tagContainer,
            updateModel: cls.callUpdateItemHandler.bind(cls, updateObj),
            subComponentCallback: cls.callUpdateItemHandler.bind(cls),
            updateTag: true,
            eventHandlers: this._eventHandlers,
            updateObj: updateObj,
            tagItems: getTableItemData.itemTags,
            itemId: itemId,
            tags: this._tags,
            tagsColors: this._tagsColor
        };
        const component = new (0, $ab9fdfa0df6d04fe$export$2e2bcd8739ae039)(componentObj);
        component.render();
    }
    _handleItemHoverEvents(e) {
        const cls = this;
        const hoverEl = (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).hoverEl;
        //guard clause against textinput and hover activation at the same time
        if (this._textInputActive) return;
        const tableItemContainer = e.target.closest(`[role="tablecontent"]`);
        const tableContentContainer = tableItemContainer.querySelector(`[role="rowgroup"]`);
        const tableItemRowId = tableContentContainer.children[0].dataset.id;
        const sliderTriggerEl = tableContentContainer.querySelector(".row-actions-render");
        sliderTriggerEl.classList.remove("hidden");
        hoverEl.dataset.id = tableItemRowId;
        tableContentContainer.insertAdjacentElement("beforeend", hoverEl);
        //add Copy functionality for the created property
        const copyTriggerEl = tableContentContainer.querySelector(".table-item-created .row-actions-render");
        copyTriggerEl.classList.remove("hidden");
        const parentEv = e;
        copyTriggerEl.addEventListener("click", function(e) {
            e.stopPropagation();
            cls._handleHoverCopyEvent(parentEv, e, copyTriggerEl);
        }, {
            once: true
        });
        //remove the hovered elements
        tableItemContainer.addEventListener("mouseleave", function() {
            hoverEl.remove();
            sliderTriggerEl.classList.add("hidden");
            copyTriggerEl.classList.add("hidden");
        });
    }
    _handleHoverCopyEvent(parentEv, e, copyTriggerEl) {
        const hoverItemId = parentEv?.target?.closest(".row-actions-handler-container")?.dataset?.id ?? null;
        if (!hoverItemId || +hoverItemId === this._currentHoverId) return;
        if (+hoverItemId != this._currentHoverId) this._currentHoverId = +hoverItemId;
        const copyContent = copyTriggerEl.previousElementSibling;
        navigator.clipboard.writeText(copyContent.textContent.trim());
        new (0, $c2721d55d807f8b0$export$caec2af78bcc877f)((0, $ba30e20475feac5a$export$3c216b31aa0f6ba8), null, "success").component();
    }
    _itemHoverMatchStrategy(e) {
        if (e.type === "mouseover") {
            const matchStrategy = e.target.role === "tablecontent" || e.target.closest(`[role="tablecontent"]`);
            return matchStrategy;
        }
    }
    _itemNameClickStrategy(e) {
        if (e.type === "click") {
            const matchStrategy = e.target.classList.contains("table-item-name") || e.target.classList.contains("row-actions-segment") || e.target.classList.contains("name-actions-text");
            return matchStrategy && e.target.closest(".row-actions-handler-container");
        }
    }
    _itemTagMatchStrategy(e) {
        if (e.type === "click") {
            const matchStrategy = e.target.classList.contains("table-item-tags") || e.target.closest(".table-item-tags");
            return matchStrategy && e.target.closest(".row-actions-handler-container");
        }
    }
    _generateItemMarkup(tableItems) {
        let itemMarkup = "";
        tableItems.forEach((item)=>{
            itemMarkup += `
        <div role="tablecontent">

          <div class="tableInput-container">
            <label class="tableInput">
              <input type="checkbox" name="" class="checkboxInput" autocomplete="off">
              
            </label>
          </div>
          <div role="rowgroup">
            <div role="row" class="row-actions-handler-container" data-id="${item.id}">
              <span role="cell" class="table-item table-item-name">
                <div class="row-actions-segment">
                    <div class="name-actions-text row-actions-text highlight-column">${item.itemTitle}</div>
                    <div class="row-actions-render hidden">
                      <div class="row-actions-render-icon">
                        ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("row-icon", "arrow-open")}
                      </div>
                      <div class="row-actions-render-text">OPEN</div>
                      <div class="row-actions-tooltip">
                        <div class="tooltip-text">
                          Open in side peek
                        </div>
                      </div>
                    </div>
                </div>
              </span>
              <span role="cell" class="table-item table-item-created">
                <div class="row-actions-segment">
                  <div class="created-actions-text row-actions-text">
                    ${(0, $bd02c871d9c5ba8e$export$b434509d4a847712)(item.created ?? item.id)}
                  </div>
                  <div class="row-actions-render hidden">
                    <div class="row-actions-render-icon">
                      ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("row-icon", "copy")}
                    </div>
                    <div class="row-actions-tooltip">
                      <div class="tooltip-text">
                        Copy to Clipboard
                      </div>
                    </div>
                  </div>
                </div>
              </span>
              <span role="cell" class="table-item table-item-tags">
              <div class="tags-actions-text row-actions-text">
                ${this._generateTagsItemMarkup(item.itemTags)}
              </div>
              </span>
            </div>
          </div>
        </div>
        
      `;
        });
        return itemMarkup;
    }
    _generateTagsItemMarkup(tags) {
        let itemTagsMarkup = "";
        const tagsExist = tags.length > 0;
        //get item tags markup
        if (tagsExist) tags.forEach((tag, i)=>{
            const tagProperty = this._tags.find((modelTag)=>modelTag.id === tag) //tag is an id
            ;
            if (!tagProperty || tagProperty === -1) tags.splice(i, 1);
            if (tagProperty || tagProperty > 0) itemTagsMarkup += `
          <div class="tag-tag ${tagProperty.color}">
            ${tagProperty.text}
          </div>
      `;
        });
        return itemTagsMarkup;
    }
    _generateCheckboxOptionMarkup(selectedLength) {
        return `
      <div class="checkbox-options">
        <div class="checkbox-options-box">
          <div class="checkbox-item checkbox-total hover">
            <div class="checkbox-text">

              ${selectedLength} selected
            </div>
          </div>
          <div class="checkbox-item checkbox-tags hover">
            ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("icon-md icon-active", "list-icon")}

            <div class="checkbox-text">
              Tags
            </div>
          </div>
          <div class="checkbox-item checkbox-delete hover">
            ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("icon-md icon-active", "trashcan-icon")}
          </div>
          <div class="checkbox-item checkbox-clone hover">
            ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("icon-md icon-active", "clone")}
          </div>
        </div>
      </div>
    `;
    }
    _generateHoverMarkupAndCreateElement(rowId) {
        const hoverMarkup = `
        <div class="row-actions-handler" data-id="${rowId}">
          <div class="row-actions-icon row-add-icon hover">
            ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("row-icon", "plus")}
          </div>
          <div class="row-actions-icon row-drag-icon hover">
            ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("row-icon", "drag-icon")}
          </div>
        </div>
    `;
        const hoverEl = this._componentHandler.createHTMLElement(hoverMarkup);
        return hoverEl;
    }
}
var $d50a2a9c3981572e$export$2e2bcd8739ae039 = new $d50a2a9c3981572e$var$TableBodyProcessorView();



class $c8032ca158e0e46f$var$TableBodyContainerListener {
    _parentElement;
    _events = [
        "mouseover",
        "click"
    ];
    _signals = (0, $c5e51a03d827fa5f$export$df67e14a9d881936).object ? (0, $c5e51a03d827fa5f$export$df67e14a9d881936).object : (0, $c5e51a03d827fa5f$export$df67e14a9d881936).object = (0, $c5e51a03d827fa5f$export$df67e14a9d881936).import();
    activateListener(element) {
        const cls = this;
        this._parentElement = element;
        this._events.forEach((ev)=>this._parentElement.addEventListener(ev, function(e) {
                e.stopPropagation();
                cls._registerSubscribers(e);
            }));
    }
    _registerSubscribers(e) {
        (0, $d50a2a9c3981572e$export$2e2bcd8739ae039)._handleDelegatedEvents(e);
        if (this._signals.eventsToListenFor().find((events)=>events === e.type)) this._signals.observe(e, "tablebody");
    }
    _subscribers() {}
    activate(element) {
        this.activateListener(element);
    }
}
const $c8032ca158e0e46f$export$4f3b7488aad41e57 = {
    import: ()=>new $c8032ca158e0e46f$var$TableBodyContainerListener(),
    object: null
};


class $c5e51a03d827fa5f$var$Signals {
    _subscribers = [];
    _eventsToListenFor = [
        "click"
    ];
    _listeners = [
        {
            listenerType: "tablebody",
            listener: (0, $c8032ca158e0e46f$export$4f3b7488aad41e57).object
        }
    ];
    observe(e, source) {
        this._subscribers.forEach((subscriber)=>{
            if (subscriber.source.find((src)=>src === source)) subscriber.component._handleEvents(e, true);
        });
    }
    subscribe(subscriberObj) {
        this._subscribers.push(subscriberObj);
    }
    unsubscribe(subscriber) {
        const subscriberToRemove = this._subscribers.findIndex((sub)=>sub.component === subscriber);
        this._subscribers.splice(subscriberToRemove, 1);
    }
    eventsToListenFor() {
        return this._eventsToListenFor;
    }
    activateListener(listenerToActivate, element) {
        const listenerClass = this._listeners.find((ls)=>ls.listenerType === listenerToActivate);
        listenerClass.listener.activate(element);
    }
}
const $c5e51a03d827fa5f$export$df67e14a9d881936 = {
    import: ()=>new $c5e51a03d827fa5f$var$Signals,
    object: null
};



// import componentOptionsView from "./componentOptionsView.js";







// import componentOptionsView from "../componentView/componentOptionsView.js";




class $9e4d3d9fdb95e33d$export$22578b9571b69853 {
    _eventListeners = [
        "submit",
        "keyup"
    ];
    activeFormErrors = false;
    _componentHandler = (0, $d2866451d1c7a9c0$export$721ff339e60fcc47).cls;
    component() {
        const cls = this;
        this.componentWrapperEl = this._componentHandler.createHTMLElement(this._componentWrapper(this.formType()));
        this._component = this._componentHandler.createHTMLElement(this._generateMarkup());
        // Wrap the element in its wrapper
        this.wrapperContent = this.componentWrapperEl.querySelector(".form-content-form");
        this.wrapperContent.insertAdjacentElement("afterbegin", this._component);
        this._eventListeners.forEach((ev)=>this._component.addEventListener(ev, cls._handleEvents.bind(cls)));
        return this._component;
    }
    addControlHandler(handler) {
        this.controlHandler = handler;
    }
    addToken(token) {
        this._token = token;
    }
    getComponent() {
        return this.componentWrapperEl;
    //this._component
    }
    createPayload(ev) {
        ev.preventDefault();
        const form = new FormData(this._component);
        let payload = null;
        try {
            this.formValidator(form);
            payload = {
                method: "POST",
                body: form
            };
            return payload;
        } catch (err) {
            new (0, $c2721d55d807f8b0$export$caec2af78bcc877f)(err, null, "error").component();
        } finally{
            return payload;
        }
    }
    destructureFormData(form) {
        const payload = {};
        if (form) {
            for (const [key, value] of form)payload[key] = value;
            return payload;
        }
        return null;
    }
    formValidator(data) {
        for (const [_, value] of data){
            if (value.length === 0) throw new Error(`Invalid Form, All Fields are Required`);
        }
        const password1 = data.get("password", null);
        const password2 = data.get("password2", null);
        if (password1 && password2) this._validatePasswordField(password1, password2, "password", "password2");
        const new_password1 = data.get("new_password1", null);
        const new_password2 = data.get("new_password2", null);
        if (new_password1 && new_password2) this._validatePasswordField(new_password1, new_password2, "new_password1", "new_password2");
        const email = data.get("email", null);
        if (email) {
            const validEmail = this._validateEmail(email);
            if (!validEmail) {
                this._renderFormErrors({
                    email: "Invalid Email"
                });
                throw new Error(INVALID_EMAIL_ERROR);
            }
        }
        const [firstName, lastName] = [
            data.get("first_name"),
            data.get("last_name")
        ];
        if (firstName, lastName) {
            const validFirstName = this._validateName(firstName);
            const validLastName = this._validateName(lastName);
            if (!validFirstName && !validLastName || !validFirstName || !validLastName) {
                const formErrors = {};
                !validFirstName && (formErrors.first_name = "Invalid First Name");
                !validLastName && (formErrors.last_name = "Invalid Last Name");
                this._renderFormErrors(formErrors);
                throw new Error((0, $ba30e20475feac5a$export$dd3f9e1f49e4b04));
            }
        }
        const username = data.get("username");
        if (username) {
            const validateUsername = this._validateName(username);
            if (!validateUsername) {
                const formErrors = {};
                formErrors.username = "Invalid Username";
                this._renderFormErrors(formErrors);
                throw new Error((0, $ba30e20475feac5a$export$d014f8f30ebed911));
            }
        }
    }
    // formComponent, 
    _componentWrapper(formType) {
        return `
            <div class="${formType}-form-container">
                ${this._generateCloseFormNudge()}
                <h1 class="form-heading">
                  ${this._formRenderHeading(formType)}
                </h1>
                <div class="form-content">
                  <div class="form-content-info">
                    Enter your information below to ${this._formRenderInfo(formType)}
                  </div>
                  <div class="form-content-form">
                    
                  </div>
                  ${this._formForgotBtnRender(formType) ?? ""}
                </div>
            </div>
        `;
    }
    _formForgotBtnRender(formType) {
        if (formType === "login") return `<a class="btn-reset" href="#">Forgot Password?</a>`;
    }
    _formRenderHeading(formType) {
        if (formType === "reset") return "Reset Password";
        if (formType === "create") return "Create Account";
        if (formType === "login") return formType.slice(0, 1).toUpperCase() + formType.slice(1);
        if (formType === "updateInfo") return "Update Your Info";
        if (formType === "updatePwd") return "Update Your Password";
    }
    _formRenderInfo(formType) {
        const requestType = {
            "login": "account",
            "create": "account",
            "reset": "password",
            "updateInfo": "information",
            "updatePwd": "password"
        };
        if (formType === "login") return `${formType} to your ${requestType[formType]}`;
        if (formType === "create") return `${formType} an ${requestType[formType]}`;
        if (formType === "reset") return `${formType} your ${requestType[formType]}`;
        if (formType === "updateInfo") return `update your ${requestType[formType]}`;
        if (formType === "updatePwd") return `update your ${requestType[formType]}`;
    }
    _renderFormErrors(errors, success = false) {
        let renderError;
        if (success) {
            this._clearForm();
            return;
        }
        if (errors) {
            const errorKeys = Object.getOwnPropertyNames(errors);
            errorKeys.forEach((formFieldKey)=>{
                const formField = (0, $bd02c871d9c5ba8e$export$aea217a45095ce11)(`[name=${formFieldKey.trim()}]`, this._component);
                if (formField) {
                    renderError = true;
                    formField.classList.add("form-field-error");
                }
            });
            if (renderError) this.activeFormErrors = true;
        }
    }
    _clearForm() {
        const formInputs = this._component.querySelectorAll("input");
        formInputs.forEach((input)=>input.value = "");
    }
    _clearErrorSignal() {
        const inputs = this._component.querySelectorAll("input");
        inputs.forEach((input)=>input.classList.contains("form-field-error") && input.classList.remove("form-field-error"));
    }
    _validatePasswordField(field1, field2, field1FieldName, field2FieldName) {
        if (field1.trim() !== field2.trim()) {
            const formPayloadError = {};
            if (field1) formPayloadError[field1FieldName] = "Password Does not Match";
            if (field2) formPayloadError[field2FieldName] = "Password Does not Match";
            this._renderFormErrors(formPayloadError);
            throw new Error((0, $ba30e20475feac5a$export$f960febbf0f9955e));
        }
    }
    _validateEmail(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
    _validateName(name) {
        if (name.trim().split(" ").length > 1) return false;
        return true;
    }
    _generateCloseFormNudge() {
        return `
            <div class="form-icon-box">
                ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("close-form", "xmark")}
            </div>
        `;
    }
    remove(removeComponent = false) {
        const cls = this;
        this._eventListeners.forEach((ev)=>this._component?.removeEventListener(ev, cls._handleSubmit));
        if (removeComponent) {
            this._component?.remove();
            this?.wrapperContent ?? (this.wrapperContent = null);
            delete this;
        }
    }
}



class $93f07be15ffae4c6$export$590193f5b399048b extends (0, $9e4d3d9fdb95e33d$export$22578b9571b69853) {
    constructor(){
        super();
    }
    _handleEvents(ev) {
        if (this.activeFormErrors) this._clearErrorSignal();
        if (ev.type === "submit") this._handleSubmit(ev);
    }
    _handleSubmit(ev) {
        const payload = this.createPayload(ev);
        if (!payload) return;
        //query create endpoint
        const queryObj = {
            endpoint: (0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.USER.CREATE,
            sec: null,
            actionType: "create",
            queryData: payload,
            callBack: this._renderFormErrors.bind(this),
            spinner: true,
            alert: true,
            successAlert: true
        };
        (0, $db1f432b457e32b4$export$2c4e825dc9120f87).queryAPI(queryObj);
    }
    _generateMarkup() {
        return `
      <form action="" enctype="multipart/form-data" id="create-form">
        <div class="form-div">
          <label for="first_name">First Name</label>
          <input type="text" class="first_name" id="first_name" name="first_name" placeholder="eg. John" required>
        </div>
        <div class="form-div">
          <label for="last_name">Last Name</label>
          <input type="text" class="last_name" id="last_name" name="last_name" placeholder="eg. Doe" required>
        </div>
        <div class="form-div">
          <label for="email">Email</label>
          <input type="email" class="email" name="email" id="email" placeholder="eg. johndoe@example.com" required>
        </div>
        <div class="form-div">
          <label for="username">Username</label>
          <input type="text" class="username" id="username" name="username" placeholder="johndoe" required>
        </div>
        <div class="form-div">
          <label for="password">Password</label>
          <input type="password" class="password" id="password" name="password" placeholder="Create a strong password" required>
        </div>
        <div class="form-div">
          <label for="Confirm password">Confirm Password</label>
          <input type="password" name="password2" class="password2" id="password2" placeholder="Re-type your password" required>
        </div>

        <button class="form-submit" type="submit">Create account</button>
      </form>
        `;
    }
    formType() {
        return "create";
    }
}




class $d1fbfec271fd25cc$export$1f58f750f20f344b extends (0, $9e4d3d9fdb95e33d$export$22578b9571b69853) {
    constructor(){
        super();
    }
    _handleEvents(ev) {
        if (ev.type === "submit") this._handleSubmit(ev);
    }
    _handleSubmit(ev) {
        const payload = this.createPayload(ev);
        if (!payload) return;
        //query create endpoint
        const queryObj = {
            endpoint: (0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.USER.TOKEN,
            sec: null,
            actionType: "login",
            queryData: payload,
            callBack: this.loginWithToken.bind(this),
            spinner: true,
            alert: true,
            successAlert: true
        };
        (0, $db1f432b457e32b4$export$2c4e825dc9120f87).queryAPI(queryObj);
    }
    loginWithToken(token, success) {
        //NOTE: do not remove success param
        if (token) //offload to controller
        this.controlHandler(token);
    }
    _generateMarkup() {
        return `
      <form action="">
        <div class="form-div">
          <label for="email">Email</label>
          <input type="email" class="email" id="email" name="email" placeholder="eg. johndoe@example.com" value="testuser123@email.com">
        </div>
        <div class="form-div">
          <label for="password">Password</label>
          <input type="password" class="password"  name="password" id="password" placeholder="Create a strong password" value="Testuser123">
        </div>
        <button class="form-submit" type="submit">Login</button>
      </form>
      `;
    }
    formType() {
        return "login";
    }
}





class $e1959294e8152bde$export$63c8992f7f80f11c extends (0, $9e4d3d9fdb95e33d$export$22578b9571b69853) {
    constructor(){
        super();
    }
    _handleEvents(ev) {
        if (this.activeFormErrors) this._clearErrorSignal();
        if (ev.type === "submit") this._handleSubmit(ev);
    }
    _handleSubmit(ev) {
        const payload = this.destructureFormData(this.createPayload(ev)?.body);
        if (!payload) return;
        //query create endpoint
        const queryObj = {
            endpoint: (0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.USER.UPDATE_INFO,
            token: this._token,
            sec: null,
            actionType: "updateInfo",
            queryData: payload,
            callBack: this._updateInfoAPICallback.bind(this),
            spinner: true,
            alert: true,
            successAlert: true,
            type: "PUT",
            callBackParam: true
        };
        (0, $db1f432b457e32b4$export$2c4e825dc9120f87).queryAPI(queryObj);
    }
    _updateInfoAPICallback(returnData, requestState = false) {
        this._renderFormErrors(returnData, requestState);
        if (requestState) {
            const usernameContainer = document.querySelector(".options-heading-title");
            usernameContainer.textContent = (0, $bd02c871d9c5ba8e$export$370b585cd97e8589)(returnData.username);
        }
    }
    _generateMarkup() {
        return `
      <form action="">
        <div class="form-div">
          <label for="first_name">First Name</label>
          <input type="text" class="first_name" id="first_name" name="first_name" placeholder="eg. John" required>
        </div>
        <div class="form-div">
          <label for="last_name">Last Name</label>
          <input type="text" class="last_name" id="last_name" name="last_name" placeholder="eg. Doe" required>
        </div>
        <div class="form-div">
          <label for="email">Email</label>
          <input type="email" class="email" id="email" name="email" placeholder="eg. johndoe@example.com" required>
        </div>
        <div class="form-div">
          <label for="username">Username</label>
          <input type="text" class="username" id="username" name="username" placeholder="johndoe" required>
        </div>
        <button class="form-submit" type="submit">Update Info</button>
      </form>   
    `;
    }
    formType() {
        return "updateInfo";
    }
}




class $e4f28fe2785407e8$export$1f7e25cfdc04fd88 extends (0, $9e4d3d9fdb95e33d$export$22578b9571b69853) {
    constructor(){
        super();
    }
    _handleEvents(ev) {
        if (this.activeFormErrors) this._clearErrorSignal();
        if (ev.type === "submit") this._handleSubmit(ev);
    }
    _handleSubmit(ev) {
        const payload = this.destructureFormData(this.createPayload(ev)?.body);
        if (!payload) return;
        //query create endpoint
        const queryObj = {
            endpoint: (0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.USER.UPDATE_PWD,
            token: this._token,
            sec: null,
            actionType: "updatePwd",
            queryData: payload,
            spinner: true,
            alert: true,
            successAlert: true,
            callBack: this._renderFormErrors.bind(this),
            callBackParam: true,
            type: "PUT"
        };
        (0, $db1f432b457e32b4$export$2c4e825dc9120f87).queryAPI(queryObj);
    }
    _generateMarkup() {
        return `
            <form action="">
              <div class="form-div">
                <label for="old_password">Old Password</label>
                <input type="password" class="old_password" id="old_password" name="old_password" placeholder="Old Password" required>
              </div>
              <div class="form-div">
                <label for="password">New Password</label>
                <input type="password" class="password" id="password" name="password" placeholder="Enter your new password" required>
              </div>
              <div class="form-div">
                <label for="password2">password2</label>
                <input type="password" class="password2" id="password2" name="password2" placeholder="Confirm password" required>
              </div>
              <button class="form-submit" type="submit">Update Password</button>
            </form>   
        `;
    }
    formType() {
        return "updatePwd";
    }
}





class $76396a66b675ad48$export$29f8ea18bcf9a8f3 extends (0, $9e4d3d9fdb95e33d$export$22578b9571b69853) {
    _token;
    constructor(){
        super();
    }
    _handleEvents(ev) {
        if (this.activeFormErrors) this._clearErrorSignal();
        if (ev.type === "submit") this._handleSubmit(ev);
    }
    _handleSubmit(ev) {
        if ((0, $bd02c871d9c5ba8e$export$1b32400f7b0a64cc)(ev, "reset-reset")) this._handleResetSubmit(ev);
        if ((0, $bd02c871d9c5ba8e$export$1b32400f7b0a64cc)(ev, "reset-confirm")) this._handleResetConfirmSubmit(ev);
    }
    _handleResetSubmit(ev) {
        const cls = this;
        let payload = this.destructureFormData(this.createPayload(ev).body);
        if (!payload) return;
        //entrypoint to api
        const queryObj = {
            endpoint: (0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.USER.RESET_PWD,
            sec: null,
            actionType: "resetPwd",
            queryData: payload,
            callBack: this._switchResetFormType.bind(cls),
            spinner: true,
            alert: true,
            successAlert: true,
            type: "POST"
        };
        (0, $db1f432b457e32b4$export$2c4e825dc9120f87).queryAPI(queryObj);
    }
    _switchResetFormType(returnData, success = false) {
        if (success) {
            const resetForm = (0, $bd02c871d9c5ba8e$export$aea217a45095ce11)(".reset-reset", this._component);
            resetForm.replaceWith(this.getResetConfirmForm());
        }
        if (!success) this._renderFormErrors(returnData);
    }
    _removeResetForm(returnData, success = false) {
        if (success) {
            this.controlHandler();
            // this.remove(true)
            return;
        }
        if (!success) this._renderFormErrors(returnData, success);
    }
    _handleResetConfirmSubmit(ev) {
        const cls = this;
        let payload = this.destructureFormData(this.createPayload(ev).body);
        if (!payload) return;
        //entrypoint to api
        const queryObj = {
            endpoint: (0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.USER.RESET_PWD_CONFIRM,
            sec: null,
            actionType: "resetConfirmPwd",
            queryData: payload,
            callBack: this._removeResetForm.bind(this),
            spinner: true,
            alert: true,
            successAlert: true,
            type: "POST"
        };
        (0, $db1f432b457e32b4$export$2c4e825dc9120f87).queryAPI(queryObj);
    }
    _generateMarkup() {
        return `
            <form action="" id="reset-pwd-form" class="form-class">
                <div class="reset-reset">
                    <div class="form-div">
                        <label for="email">Email</label>
                        <input type="email" name="email" placeholder="email" class="bd-radius" required>
                    </div>
                </div>
                <button class="form-submit">Submit</button>
            </form>

        `;
    }
    getResetConfirmForm() {
        const markup = this._generateResetConfirmMarkup();
        const markupEl = this._componentHandler.createHTMLElement(markup);
        return markupEl;
    }
    _generateResetConfirmMarkup() {
        return `
            <div class="reset-confirm">
                <div class="form-div">
                    <label for="token">Token</label>
                    <input type="text" name="token"  class="token" placeholder="eg. df93fa-vdsa23-klvadf32..." id="token" required>
                </div>
                <div class="form-div">
                    <label for="uid">UID</label>
                    <input type="text" name="uid" placeholder="eg. MQT" class="uid" id="uid" required>
                </div>
                <div class="form-div">
                    <label for="new_password1">New Password</label>
                    <input type="password" name="new_password1" placeholder="Create a strong password" class="new_password1" id="new_password1" required>
                </div>
                <div class="form-div">
                    <label for="new_password2">Confirm Password</label>
                    <input type="password" name="new_password2" placeholder="Re-type your password" class="new_password2" id="new_password2" required>
                </div>
            </div>
        `;
    }
    formType() {
        return "reset";
    }
}


class $a90ba183c2615987$export$a7fed597f4b8afd8 {
    static form(formType) {
        switch(formType){
            case "login":
                return new (0, $d1fbfec271fd25cc$export$1f58f750f20f344b)();
            case "sign up":
                return new (0, $93f07be15ffae4c6$export$590193f5b399048b)();
            case "reset":
                return new (0, $76396a66b675ad48$export$29f8ea18bcf9a8f3)();
            case "updateInfo":
                return new (0, $e1959294e8152bde$export$63c8992f7f80f11c)();
            case "updatePwd":
                return new (0, $e4f28fe2785407e8$export$1f7e25cfdc04fd88)();
        }
    }
}




class $5f1bb3a11090bdeb$var$SideBarComponentView {
    _parentElement = document.querySelector(".nav-sidebar");
    _eventHandlers = null;
    _events = [
        "click"
    ];
    _signals = (0, $c5e51a03d827fa5f$export$df67e14a9d881936).object;
    _children = [];
    _token;
    init(sideBarHandler, token) {
        this._token = token;
        sideBarHandler();
        this.addSideBarDelegationEventListener();
        this._signals.subscribe({
            component: this,
            source: [
                "journalInfo"
            ]
        });
    }
    addComponentHandlers(handlers) {
        this._eventHandlers = handlers;
    }
    addSideBarDelegationEventListener() {
        const cls = this;
        this._events.forEach((ev)=>this._parentElement.addEventListener(ev, cls._handleEvents.bind(cls)));
    }
    _handleEvents(e, signals = false) {
        if ((0, $bd02c871d9c5ba8e$export$b0cf5a82061b8f99)(e, "angles-icon")) this._handleSideBarCollapseEvent(e);
        if (!signals) {
            if ((0, $bd02c871d9c5ba8e$export$b0cf5a82061b8f99)(e, "table-list-arrow-render")) this._handleSideBarListTablesEvent(e);
            if ((0, $bd02c871d9c5ba8e$export$b0cf5a82061b8f99)(e, "update-list-arrow-render")) this._handleSideBarUpdateEvent(e);
            if ((0, $bd02c871d9c5ba8e$export$b0cf5a82061b8f99)(e, "tables-list-box")) this._handleSideBarRenderTableEvent(e);
            if ((0, $bd02c871d9c5ba8e$export$b0cf5a82061b8f99)(e, "update-user-info")) this._handleUpdateUserInfoEvent(e);
            if ((0, $bd02c871d9c5ba8e$export$b0cf5a82061b8f99)(e, "update-user-pwd")) this._handleUpdateUserPasswordEvent(e);
            if ((0, $bd02c871d9c5ba8e$export$b0cf5a82061b8f99)(e, "nav-options-logout")) (0, $db1f432b457e32b4$export$2c4e825dc9120f87).logoutUser();
        }
    }
    _handleSideBarCollapseEvent(e) {
        const container = document.querySelector(".container");
        container.classList.toggle("nav-hide");
        //add icon to uncollapse sidebar
        if (container.classList.contains("nav-hide")) {
            const sideBarVisibleMarkup = this._generateSideBarVisibilityIcon();
            const contentHeader = document.querySelector(".container-header");
            contentHeader.insertAdjacentHTML("afterbegin", sideBarVisibleMarkup);
        }
        if (!container.classList.contains("nav-hide")) {
            //removes the sidebar opener from the journalInfo component
            const sideBarOpen = document.querySelector(".sidebar-open");
            sideBarOpen.remove();
            const layoutBreakpointTrigger = window.matchMedia((0, $ba30e20475feac5a$export$bcd5792a294b918c));
            if (layoutBreakpointTrigger.matches) {
                const containerSideBeekCloseIcon = document.querySelector(".slide-nav-close");
                containerSideBeekCloseIcon?.click();
            }
        }
    }
    _handleSideBarListTablesEvent(e) {
        const sidebarJournalContainer = e.target.closest(".nav-options-journal");
        sidebarJournalContainer.classList.toggle("tables-open");
        this._renderSideBarList(e, sidebarJournalContainer);
    }
    _handleSideBarUpdateEvent(e) {
        const sidebarUpdateOptionContainer = e.target.closest(".nav-options-user");
        sidebarUpdateOptionContainer.classList.toggle("updates-open");
        const updateInfoContainer = sidebarUpdateOptionContainer.querySelector(".update-info-list");
        const sideBarUpdateIcon = e.target.closest(".nav-options-icon");
        const renderUpdatesOptions = sidebarUpdateOptionContainer.classList.contains("updates-open");
        if (renderUpdatesOptions) {
            const updateOptionsMarkup = this._generateSideBarUpdateOptionsMarkup();
            sideBarUpdateIcon.innerHTML = "";
            sideBarUpdateIcon.insertAdjacentHTML("afterbegin", (0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("update-list-arrow-render arrow-render arrow-down-icon icon icon-mid", "arrow-down"));
            updateInfoContainer.innerHTML = "";
            updateInfoContainer.insertAdjacentHTML("afterbegin", updateOptionsMarkup);
        }
        if (!renderUpdatesOptions) {
            updateInfoContainer.innerHTML = "";
            sideBarUpdateIcon.innerHTML = "";
            sideBarUpdateIcon.insertAdjacentHTML("afterbegin", (0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("update-list-arrow-render arrow-render arrow-right-icon icon icon-mid", "arrow-right"));
        }
    }
    _handleSideBarRenderTableEvent(e) {
        const tableId = e.target.closest(".tables-list-box").dataset.id;
        (0, $2f08e0265dc40b56$export$712e42d57dd318a8).object._activateTable(null, `.main-table-heading [data-id="${tableId}"]`, tableId);
        const sidebarJournalContainer = e.target.closest(".nav-options-journal") || document.querySelector(".nav-options-journal");
        this._renderSideBarList(null, sidebarJournalContainer);
    }
    _renderSideBarList(e, sidebarJournalContainer) {
        const sideBarJournalTableContainer = e?.target?.closest(".nav-options-journal")?.querySelector(".tables-list") ?? document.querySelector(".nav-options-journal .tables-list");
        const sideBarJournalIcon = e?.target.closest(".nav-options-icon");
        if (sidebarJournalContainer.classList.contains("tables-open")) {
            //let componentGlobal Keep state of its active status
            (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).sideBarListActive = true;
            const currentTable = this._eventHandlers.tableControllers.controlGetTable();
            const sideBarTablesMarkup = this._eventHandlers.tableControllers.controlGetTableHeads().map((table)=>this._generateSideBarTablesMarkup(table, currentTable.id)).join("");
            if (sideBarJournalIcon) {
                sideBarJournalIcon.innerHTML = "";
                sideBarJournalIcon.insertAdjacentHTML("afterbegin", (0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("table-list-arrow-render arrow-render arrow-down-icon icon icon-mid", "arrow-down"));
            }
            sideBarJournalTableContainer.innerHTML = "";
            sideBarJournalTableContainer.insertAdjacentHTML("afterbegin", sideBarTablesMarkup);
        }
        if (!sidebarJournalContainer.classList.contains("tables-open")) {
            sideBarJournalTableContainer.innerHTML = "";
            //disable the notifier from the global state for components
            (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).sideBarListActive = false;
            if (sideBarJournalIcon) {
                sideBarJournalIcon.innerHTML = "";
                sideBarJournalIcon.insertAdjacentHTML("afterbegin", (0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("table-list-arrow-render arrow-render arrow-right-icon icon icon-mid", "arrow-right"));
            }
        }
    }
    _handleUpdateUserInfoEvent(e) {
        const updateUserInfoForm = (0, $a90ba183c2615987$export$a7fed597f4b8afd8).form("updateInfo");
        updateUserInfoForm.addToken(this._token);
        updateUserInfoForm.component();
        const overlay = new (0, $09d840f20da32b41$export$c6fdb837b070b4ff)(updateUserInfoForm);
        this._children.push(updateUserInfoForm, overlay);
        overlay.render();
    }
    _handleUpdateUserPasswordEvent(e) {
        const updateUserPasswordForm = (0, $a90ba183c2615987$export$a7fed597f4b8afd8).form("updatePwd");
        updateUserPasswordForm.addToken(this._token);
        updateUserPasswordForm.component();
        const overlay = new (0, $09d840f20da32b41$export$c6fdb837b070b4ff)(updateUserPasswordForm);
        this._children.push(updateUserPasswordForm, overlay);
        overlay.render();
    }
    _generateSideBarTablesMarkup(table, currentTableId) {
        return `
      <div class="tables-list-box hover ${table[1] === currentTableId ? "hover-bg-stay" : ""}" data-id="${table[1]}">
        <div class="tables-list-disc"></div>
        <li class="tables-list-table">${table[0]}</li>
      </div>
    `;
    }
    _generateSideBarUpdateOptionsMarkup() {
        return `
      <div class="update-list-box update-user-info hover">
        <div class="update-list-disc"></div>
        <li class="update-option">Update User Info</li>
      </div>
      <div class="update-list-box update-user-pwd hover">
        <div class="update-list-disc"></div>
        <li class="update-option">Update Password</li>
      </div>

    `;
    }
    _generateSideBarHeadingMarkup(username) {
        return `
        <div class="nav-options-heading">
            <div class="options-heading-icon">${username[0]}</div>
            <div class="options-heading-title">${(0, $bd02c871d9c5ba8e$export$370b585cd97e8589)(username)}</div>

          ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("angles-icon sidebar-close icon", "angles-left")}
        </div>
    `;
    }
    _generateSideBarJournalMarkup(journalName) {
        return `
        <div class="nav-option nav-options-journal">
          <div class="nav-group">
            <div class="nav-options-icon">
              ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("table-list-arrow-render arrow-render arrow-right-icon icon icon-mid", "arrow-right")}
            </div>
    
            <div class="nav-icon-text">
              <div class="nav-options-journal-icon">
                ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("journal-icon icon", "journal-icon")}
              </div>

              <div class="nav-options-text">${journalName.length > 0 ? (0, $bd02c871d9c5ba8e$export$b895d9282c5668b2)(journalName, (0, $ba30e20475feac5a$export$5de39269fe3b794d)) : "Untitled"}</div>
      </div>
      </div>
      <div class="journal-tables-list">
      <ul class="tables-list">
      </ul>
      </div>
        </div>
    `;
    }
    _generateSideBarUserSettingsOption() {
        return `
      <div class="nav-option nav-options-user">
        <div class="nav-group">
          <div class="nav-options-icon">
            ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("update-list-arrow-render arrow-render arrow-right-icon icon icon-mid", "arrow-right")}
          </div>

          <div class="nav-icon-text">
            <div class="nav-options-journal-icon">
              ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("icon", "user-settings")}
            </div>
            <div class="nav-options-text">Update Info</div>
          </div>
        </div>
        <div class="journal-update-info-list">
          <ul class="update-info-list">

          </ul>
        </div>
      </div>
    `;
    }
    _generateSideBarLogoutMarkup() {
        return `
    <div class="nav-option nav-options-logout">
      <div class="nav-group">
        <div class="nav-icon-text">
          <div class="nav-options-journal-icon">
            ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("icon", "logout")}
          </div>
          <div class="nav-options-text">Logout</div>
        </div>
      </div>
    </div>
  `;
    }
    _generateMarkup(user, journal) {
        return `
        <div class="nav-sidebar-options">
            ${this._generateSideBarHeadingMarkup(user)}
            ${this._generateSideBarJournalMarkup(journal)}
            ${this._generateSideBarUserSettingsOption()}
            ${this._generateSideBarLogoutMarkup()}
            </div>
            `;
    }
    _generateSideBarVisibilityIcon() {
        return `
        <div class="sidebar-open nav-options-sidebar-open-icon">
          ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("angles-icon icon icon-lg", "angles-right")}
        </div>
    `;
    }
    render(dataObj) {
        const { username: username, journalName: journalName } = dataObj;
        const markup = this._generateMarkup(username, journalName);
        this._parentElement.innerHTML = "";
        this._parentElement.insertAdjacentHTML("beforeend", markup);
    }
}
const $5f1bb3a11090bdeb$export$4b8b7519249bbbe8 = {
    import: ()=>new $5f1bb3a11090bdeb$var$SideBarComponentView(),
    object: null
};



class $ce1cde5f46f2821c$export$2e2bcd8739ae039 {
    _componentHandler = (0, $d2866451d1c7a9c0$export$721ff339e60fcc47).object;
    _state;
    _events = [
        "click"
    ];
    _sidebarComponentView = (0, $5f1bb3a11090bdeb$export$4b8b7519249bbbe8).object;
    constructor(state){
        this._state = state;
    }
    _generateMarkup() {
        return `
          <div class="table-row-active--options component-options">
            <div class="table-options">
              <div class="table-options-edits--option">
                <div class="edit-content-container">
                  <div class="edit-content-box">
                    <div class="edit-content-form hidden">
                      <form action="" id="table-rename-form">
                        <input
                          type="text"
                          placeholder=""
                          class="table-rename component-form"
                          name="table-rename"
                        />
                      </form>
                    </div>
                    <div class="edit-content">
                      <div class="edit-content-icon">
                        ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("edit-icon", "pen-to-square")}
                      </div>
                      <div class="edit-text">Rename</div>
                    </div>
                    
                  </div>
                </div>
              </div>
              <div class="table-options-actions--option">
                <div class="actions-content-container">
                  <div class="actions-content-box">
                    <div class="action-content action-duplicate">
                      <div class="action-content-icon">
                        ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("action-icon", "clone")}
                      </div>
                      <div class="action-text">Duplicate</div>
                    </div>
                    <div class="action-content action-delete">
                      <div class="action-icon">
                        ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("action-icon", "trashcan-icon")}
                      </div>
                      <div class="action-text">Delete</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        `;
    }
    render() {
        const cls = this;
        this._state.markup = this._generateMarkup();
        const { overlay: overlay, overlayInterceptor: overlayInterceptor, component: component } = this._componentHandler._componentOverlay(this._state);
        this._state = {
            ...this._state,
            overlay: overlay,
            overlayInterceptor: overlayInterceptor,
            component: component
        };
        //overlay component handles its event
        overlayInterceptor.addEventListener("click", function(e) {
            cls._componentHandler._componentRemover(cls._state);
        }, {
            once: true
        });
        //component handles its event
        this._events.forEach((ev)=>{
            component.addEventListener(ev, this._handleEvents.bind(cls));
        });
    }
    _handleEvents(e) {
        if (this._renameMatchStrategy(e)) this._handleRenameEvent(e);
        if (this._deleteMatchStrategy(e)) this._handleDeleteEvent(e);
        if (this._duplicateMatchStrategy(e)) this._handleDuplicateEvent(e);
    }
    _renameMatchStrategy(e) {
        const matchStrategy = e.target.classList.contains("edit-content") || e.target.closest(".edit-content");
        return matchStrategy;
    }
    _deleteMatchStrategy(e) {
        const matchStrategy = e.target.classList.contains("action-delete") || e.target.closest(".action-delete");
        return matchStrategy;
    }
    _duplicateMatchStrategy(e) {
        {
            const matchStrategy = e.target.classList.contains("action-duplicate") || e.target.closest(".action-duplicate");
            return matchStrategy;
        }
    }
    _handleRenameEvent(e) {
        const cls = this;
        const state = this._state;
        const renameInputContainer = document.querySelector(".edit-content-form");
        const renameInputForm = document.querySelector("#table-rename-form");
        const renameInput = document.querySelector(".table-rename");
        //show the input container
        renameInputContainer.classList.toggle("hidden");
        //get the input value
        renameInput.value = state.table.dataset.name;
        renameInputForm.addEventListener("submit", function(e) {
            e.preventDefault();
            //format form data
            let formData = new FormData(e.target);
            [formData] = [
                ...formData
            ];
            //update model
            state.rename(formData[1], +state.table.dataset.id, cls._updateTableUI.bind(cls, renameInput, renameInputContainer));
        });
    }
    _handleDeleteEvent(e) {
        const state = this._state;
        this.remove();
        state.delete(+state.table.dataset.id);
        this._updateSideBarComponent();
    }
    _handleDuplicateEvent(e) {
        const state = this._state;
        this.remove();
        //hide the options
        state.duplicate(+state.table.dataset.id);
        this._updateSideBarComponent;
    }
    _updateTableUI(renameInput, renameInputContainer) {
        const cls = this;
        //set table UI value if exists
        this._state.updateUI(this._state.table, renameInput.value);
        //updateUi being updateUItableTitle
        //change the dataset name on the current table
        this._state.table.dataset.name = renameInput.value;
        //clear and hide form
        cls._hideInputcontainer(renameInputContainer);
        this._updateSideBarComponent();
    }
    _updateSideBarComponent() {
        //update sidebar tables if open
        if ((0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).sideBarListActive) {
            const sidebarJournalContainer = document.querySelector(".nav-options-journal");
            this._sidebarComponentView._renderSideBarList(null, sidebarJournalContainer);
        }
    }
    _hideInputcontainer(inputContainer) {
        inputContainer.classList.toggle("hidden");
    }
    remove() {
        const cls = this;
        this._state.overlayInterceptor.click();
        this._events.forEach((ev)=>this._state.component.removeEventListener(ev, cls._handleEvents, true));
        this._state.component.remove();
    }
}









class $1f792b9169210bf0$export$2e2bcd8739ae039 {
    _componentHandler = (0, $d2866451d1c7a9c0$export$721ff339e60fcc47).object;
    _state;
    _events = [
        "click",
        "keyup"
    ];
    constructor(state){
        this._state = state;
    }
    _generateTableViewOptionsMarkup(tables1) {
        let viewsMarkup = "";
        const tablesAvailable = tables1.length > 0;
        if (tablesAvailable) tables1.forEach((table)=>{
            const [tableName, tableId] = table;
            viewsMarkup += `
            <div class="table-list-content hover" >
              <div class="table-view-box">
    
                <div class="table-view-content">
                  <div class="table-row-icon">
                    ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("icon-active", "list-icon")}
                  </div>
                  <div class="table-row-text color-active">${tableName}</div>
                </div>
    
                <div class="table-view-options" data-name="${tableName}" data-id="${tableId}">
                  <div class="table-row-icon hover-dull">
                    ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("table-icon icon-lg", "ellipsis")}
                  </div>
                </div>
              </div>
            </div>
          `;
        });
        if (!tablesAvailable) viewsMarkup += `
            <div class="table-view-box">
              <div class="table-view-content">
                <div class="table-row-text">${0, $ba30e20475feac5a$export$1dd83cd16a72b5}</div>
              </div>
            </div>
          `;
        return viewsMarkup;
    }
    _generateMarkup(tables1) {
        const viewsMarkup = this._generateTableViewOptionsMarkup(tables1);
        return `
      <div class="table-view-list--options component-options">
        <div class="table-options">
          <div class="table-list--option">
            <div class="table-list-content-box">
              <div class="table-search-input">
                <input
                  type="text"
                  name="table-search"
                  class="table-search component-form"
                  placeholder="Search for a View..."
                />
              </div>
              <div class="table-content">
                <div class="add-table-content">
                  ${viewsMarkup}
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    `;
    }
    render() {
        const cls = this;
        this._state.markup = this._generateMarkup(this._state.tables);
        const { overlay: overlay, overlayInterceptor: overlayInterceptor, component: component } = this._componentHandler._componentOverlay(this._state);
        this._state = {
            ...this._state,
            overlay: overlay,
            overlayInterceptor: overlayInterceptor,
            component: component
        };
        //overlay component handles its event
        overlayInterceptor.addEventListener("click", function(e) {
            cls._componentHandler._componentRemover(cls._state);
        }, {
            once: true
        });
        //component handles its event
        this._events.forEach((ev)=>{
            component.addEventListener(ev, this._handleEvents.bind(cls));
        });
    }
    _handleEvents(e) {
        if (this._tableViewOptionsFormStrategy(e)) this._handleTableViewOptionForm(tables);
        if (this._tableViewOptionsOptionStrategy(e)) this._handleTableOptionsOption(e);
        if (this._tableViewOptionsTableActiveStrategy(e)) this._handleTableActiveEvent(e);
    }
    _tableViewOptionsFormStrategy(e) {
        const viewOptionsFormStrategy = e.type === "keyup" && (e.target.classList.contains(".table-search") || e.target.closest(".table-search-input"));
        return viewOptionsFormStrategy;
    }
    _tableViewOptionsOptionStrategy(e) {
        const viewOptionsOptionStrategy = e.type === "click" && (e.target.classList.contains("table-icon") || e.target.closest(".table-view-options"));
        return viewOptionsOptionStrategy;
    }
    _tableViewOptionsTableActiveStrategy(e) {
        return (0, $bd02c871d9c5ba8e$export$b0cf5a82061b8f99)(e, "table-view-content", "click");
    }
    _handleTableViewOptionForm(e) {
        const tables1 = this._state.tables;
        const tableViewOptionContainer = document.querySelector(".add-table-content");
        const tableViewForm = document.querySelector(".table-search");
        const renderTables = tables1.filter((table)=>table[0].toLowerCase().includes(tableViewForm.value));
        //if no filter matches, add a no match found message
        tableViewOptionContainer.innerHTML = "";
        tableViewOptionContainer.insertAdjacentHTML("beforeend", this._generateTableViewOptionsMarkup(renderTables));
    }
    _handleTableOptionsOption(e) {
        const renderViewOptions = e.target.closest(".table-view-options");
        //offload event handling to head process
        (0, $2f08e0265dc40b56$export$712e42d57dd318a8).object._renderAndListenForTableOptionsEvents(renderViewOptions, this.remove.bind(this));
    }
    _handleTableActiveEvent(e) {
        const tableId = e.target.closest(".table-view-content").nextElementSibling.dataset.id;
        (0, $2f08e0265dc40b56$export$712e42d57dd318a8).object._activateTable(null, `.main-table-heading [data-id="${tableId}"]`, tableId);
        this.remove();
    }
    remove() {
        const cls = this;
        this._state.overlayInterceptor.click();
        this._events.forEach((ev)=>this._state.component.removeEventListener(ev, cls._handleEvents, true));
        this._state?.component?.remove();
    }
}






class $a383de20bc2b29cf$export$b62e7a1e6548fae7 {
    _getCurrentTable() {
        return this._state.eventHandlers.tableControllers.controlGetTable();
    }
    _checkTableFuncActive(fnType) {
        let fnActive = false;
        const currentTable = this._getCurrentTable();
        const fnObj = this._state.eventHandlers.tableControllers.controlGetPersistedTableFunc(currentTable.id);
        if (fnObj) {
            const fn = fnObj[fnType];
            const fnProps = Object.keys(fn).map((fnKey)=>fn[fnKey] ? true : false);
            fnActive = fnProps.find((prop)=>prop === true) ? true : false;
            return fnActive;
        }
        return false;
    }
    _removeComponentTableFunc(fnType) {
        this._state.eventHandlers.tableControllers.controlRemovePersistedTableFunc(fnType);
    }
    _setFilterRuleBoxAddedValue(el) {
        const filterValue = this._getFunc("filter").value;
        const filterValueExists = filterValue?.length > 0;
        const filterType = this._getFunc("filter").type;
        const filterTags = this._getFunc("filter").tags;
        if (filterValueExists) {
            if (filterType === "itemTags" || filterType.toLowerCase() === "tags") {
                const textValue = filterTags.map((tag)=>tag.text).join(",");
                return textValue;
            }
            return filterValue;
        }
        if (!filterValueExists) {
            const conditionalsAllowedAsValue = [
                "Is empty",
                "Is not empty"
            ];
            const conditionalValue = this._getFunc("filter").conditional;
            const conditionalInConditionalsAllowedAsValue = conditionalsAllowedAsValue.find((value)=>value.toLowerCase() === conditionalValue.toLowerCase()) ? true : false;
            if (conditionalInConditionalsAllowedAsValue) return (0, $bd02c871d9c5ba8e$export$9a00dee1beb8f576)(conditionalValue);
            else return "";
        }
    }
    _renderFiltered(table) {
        if (table.tableItems.length > 0) {
            //filter the tablebody
            const filteredTableItems = this._state.filterMethod(table.tableItems);
            this._renderFilteredTableItems(filteredTableItems, true);
        }
        if (!table.tableItems.length > 0) this._renderFilteredTableItems([], true);
    }
    _renderSorted(table) {
        let filteredTableItems;
        if (table.tableItems.length > 0) {
            //check if filter methods exist
            if ((0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterMethod) filteredTableItems = (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterMethod(table.tableItems);
            const sortedTableItems = filteredTableItems?.length > 0 ? (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).sortMethod(filteredTableItems) : (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).sortMethod(table.tableItems);
            this._renderSortedTableItems(sortedTableItems);
        }
    }
    _renderSortedTableItems(sortedItems, filterPlaceHolder = false) {
        (0, $2d49e726836fb57f$export$6db5d748e242c31).object.renderTableItem(sortedItems, null);
    }
    _renderFilteredTableItems(filteredItems, filterPlaceHolder = false) {
        (0, $2d49e726836fb57f$export$6db5d748e242c31).object.renderTableItem(filteredItems, null, filterPlaceHolder);
    }
}


class $a8305e0dc1734493$export$2e2bcd8739ae039 {
    _mixinActive = false;
    _generateOptions(properties, propertyComponent) {
        let propertiesMarkup = "";
        properties.forEach((property)=>{
            propertiesMarkup += `
            <div class="${`${propertyComponent}-property-content`} action-property-content ${property.class ?? ""}">
              <div class="action-property-icon">
                ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("property-icon", `${property.icon}`)}
              </div>
              <div class="action-property-text">${property.text}</div>
            </div>       
          `;
        });
        return propertiesMarkup;
    }
    _generateAddedRuleMarkup(propertyComponent) {
        return `<div class="${propertyComponent}-added-rule added-rule"></div>`;
    }
    _generateRuleMarkup(property, propertyComponent) {
        //prettier-ignore
        return `
        <div class="${propertyComponent}-action-container property-action-container">
            <div class="${propertyComponent}-added-rule-box property-added-rule-box">
              <div class="property-added-rule-property">
                <div class="property-rule-icon">
                  ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("property-added-rule-icon", `${property.icon}`)}
                </div>
                <div class="${propertyComponent}-added-rule-name property-added-rule-name">${property.text}:</div>
              </div>
              ${propertyComponent === "filter" ? this._generateAddedRuleMarkup(propertyComponent) : ""}
              <div class="added-rule-icon">
                ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("rule-icon icon-sm", "arrow-down")}
              </div>
            </div>
    `;
    }
    _generateMarkup(properties, propertyComponent, form = true) {
        const placeHolder = propertyComponent[0].toUpperCase() + propertyComponent.slice(1);
        return `
          <div class="${propertyComponent}-add-action--options property-add-action--options component-options">
            <div class="property-options">
              <div class="property-options-property--option">
                <div class="property-content-box">
                ${form ? this._generateFormMarkup(propertyComponent, placeHolder) : ""}
                
                <div class="property-content">
                    <div class="${propertyComponent}-content-search property-content-search">
                      ${this._generateOptions(properties, propertyComponent)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        `;
    }
    _generateFormMarkup(propertyComponent, placeHolder) {
        return `
      <form action="" id="property-content-forms">
        <input
          type="text"
          name="${propertyComponent}-search property-search"
          class="${propertyComponent}-search property-search component-form"
          placeholder="${placeHolder} by..."
        />
      </form>
    `;
    }
    _propertyOptionFormStrategy(e, propertyComponent) {
        const propertyOptionsFormStrategy = e.type === "keyup" && e.target.classList.contains(`${propertyComponent}-search`);
        return propertyOptionsFormStrategy;
    }
    _handlePropertyOptionsForm(properties, propertyComponent) {
        const propertyOptionsContainer = document.querySelector(`.${propertyComponent}-content-search`);
        const propertyOptionForm = document.querySelector(`.${propertyComponent}-search`);
        const renderProperties = properties.filter((property)=>property.text.toLowerCase() !== "created").filter((property)=>property.text.toLowerCase().includes(propertyOptionForm.value.trim().toLowerCase()));
        propertyOptionsContainer.innerHTML = "";
        propertyOptionsContainer.insertAdjacentHTML("beforeend", this._generateOptions(renderProperties));
    }
    _propertyOptionsOptionStrategy(e) {
        const propertyOptionsOptionStrategy = e.type === "click" && (e.target.classList.contains("action-property-text") || e.target.closest(".action-property-content"));
        return propertyOptionsOptionStrategy;
    }
    _handlePropertyOptionsOption(e, options) {
        const clickedProperty = this._getClickedProperty({
            e: e,
            closest: ".action-property-content"
        }, options.property);
        const propertyContainer = document.querySelector(`.property-actions`);
        const selectedProperty = options.props.properties.find((property)=>property.text.toLowerCase() === clickedProperty);
        const propertyOptionsOptionMarkup = this._generateRuleMarkup(selectedProperty, options.property);
        if (options.property === "sort") //prevent multiple create of ruleboxes for sort component
        document.querySelector(`.sort-action-container`)?.remove();
        propertyContainer.insertAdjacentHTML(options.property === "sort" ? "afterbegin" : "beforeend", propertyOptionsOptionMarkup);
        options.state.property = selectedProperty;
        if (options.callBack) options.callBack(selectedProperty, options.state);
    }
    _handleRemoveRuleBoxEvent(e) {
        if (!this._state.ruleBoxActive) {
            this._state.children.forEach((child)=>child.remove(false));
            this._state.children = [];
        }
        if (this._state.ruleBoxActive) this._state.ruleBoxActive = false; //sets the component active state back to not just rendered
    }
    _getClickedProperty(eProps, type) {
        let clickedProperty;
        if (eProps.e) {
            if (eProps.closest && eProps.selector) clickedProperty = eProps.e.target.closest(eProps.closest).querySelector(eProps.selector);
            if (eProps.closest && !eProps.selector) clickedProperty = eProps.e.target.closest(eProps.closest);
            return clickedProperty.textContent.replace(":", "").trim().toLowerCase();
        }
        if (!eProps || !eProps.e) {
            const currentTable = this._getCurrentTable();
            const persistedFilter = this._state.eventHandlers.tableControllers.controlGetPersistedTableFunc(currentTable.id)[type];
            // return persistedFilter.type === "itemTitle" ? "name" : "tags"
            return this._clickedPropertyType(persistedFilter.type, type);
        }
    }
    _clickedPropertyType(typeValue, propertyType) {
        if (propertyType === "filter") return typeValue === "itemTitle" ? "name" : "tags";
        if (propertyType === "sort") return typeValue.toLowerCase() === "name" ? "name" : "tags";
    }
    _getFunc(fnType) {
        const currentTable = this._getCurrentTable();
        return this._state.eventHandlers.tableControllers.controlGetPersistedTableFunc(currentTable.id)[fnType];
    }
    _addMixin() {
        //copy mixin props
        const { constructor: constructor, ...prototypePatch } = Object.getOwnPropertyDescriptors((0, $a383de20bc2b29cf$export$b62e7a1e6548fae7).prototype);
        //add copied props to instance proto
        Object.defineProperties(Object.getPrototypeOf(this).__proto__, prototypePatch);
        this._mixinActive = true;
    }
}










class $4ca29cc2053959fb$export$2e2bcd8739ae039 {
    _componentHandler = (0, $d2866451d1c7a9c0$export$721ff339e60fcc47).object;
    _state;
    _events = [
        "click"
    ];
    constructor(state){
        this._state = state;
    }
    _generatePrepositionBoxMarkup(preposition) {
        return `
        <div class="action-filter-content">
            <div class="action-filter-text">${preposition.condition}</div>
        </div>
    `;
    }
    _generateMarkup(prepositions) {
        const prepositionsMarkup = prepositions.map((preposition)=>this._generatePrepositionBoxMarkup(preposition)).join("");
        return `
        <div class="filter-pre-action--options component-options">
          <div class="filter-options">
            <div class="filter-pre-filter--option">
              <div class="filter-content-box">
                <div class="filter-content">
                  <div class="add-action-filters">
                    ${prepositionsMarkup}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    `;
    }
    render() {
        const cls = this;
        this._state.markup = this._generateMarkup(this._state.conditional);
        const { overlay: overlay, overlayInterceptor: overlayInterceptor, component: component } = this._componentHandler._componentOverlay(this._state);
        this._state = {
            ...this._state,
            overlay: overlay,
            overlayInterceptor: overlayInterceptor,
            component: component
        };
        //overlay component handles its event
        overlayInterceptor.addEventListener("click", function(e) {
            cls._componentHandler._componentRemover(cls._state);
        }, {
            once: true
        });
        //component handles its event
        this._events.forEach((ev)=>{
            component.addEventListener(ev, this._handleEvents.bind(cls));
        });
    }
    _handleEvents(e) {
        if (this._prepositionSelectMatchStrategy(e)) this._handlePrepositionSelectEvent(e);
    }
    _prepositionSelectMatchStrategy(e) {
        const matchStrategy = e.target.classList.contains("action-filter-content") || e.target.closest(".action-filter-content");
        return matchStrategy;
    }
    _handlePrepositionSelectEvent(e) {
        const prepositionRemovesFilterInput = [
            "Is empty",
            "Is not empty"
        ];
        const prepositionContainer = document.querySelector(".filter-input-filter-text");
        const filterRuleInput = document.querySelector(".filter-input-container");
        const selectedPreposition = e.target.closest(".action-filter-content");
        const selectPrepositionValue = selectedPreposition.textContent.replace("\n", "").trim();
        //update the parent state
        this._state.parentState.preposition = selectPrepositionValue;
        const removeFilterInput = prepositionRemovesFilterInput.find((prep)=>prep.toLowerCase() === selectPrepositionValue.toLowerCase());
        const filterInputToExecute = this._state.property.text.toLowerCase() === "tags" ? (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterTagList : this._state.inputValue;
        prepositionContainer.textContent = selectPrepositionValue;
        //remove filter input if preposition doesn't require it
        if (!removeFilterInput && !filterRuleInput) this._state.generateInput();
        if (!removeFilterInput && filterRuleInput) this._state.executeFilter(filterInputToExecute);
        if (removeFilterInput && filterRuleInput) {
            //clear the filteredTagList from the global component state
            if ((0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061)?.filterTagList) (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterTagList.length = 0;
            filterRuleInput.remove();
            this._state.parent._handleEvents(e, null, true);
        }
        if (removeFilterInput && !filterRuleInput) {
            //clear the filteredTagList from the global component state
            if ((0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061)?.filterTagList) (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterTagList.length = 0;
            // this._state.executeFilter(null);
            this._state.parent._handleEvents(e, null, true);
        }
        this._state.component.remove();
        this._state.overlay.remove();
    }
}





class $e49efa9617bd8208$export$2e2bcd8739ae039 {
    _generateMarkup(markupComponentMarkup) {
        return `
      <div class="filter-input-option-option">
          <div class="filter-option-option">
            ${markupComponentMarkup}
          </div>
      </div>
    `;
    }
}



class $93a749eb703fa76a$export$2e2bcd8739ae039 extends (0, $e49efa9617bd8208$export$2e2bcd8739ae039) {
    _componentHandler = (0, $d2866451d1c7a9c0$export$721ff339e60fcc47).object;
    _state;
    _events = [
        "click"
    ];
    constructor(state){
        super();
        this._state = state;
    }
    _generateTagsSelectOption() {
        return `
      <div class="filter-option-action filter-option-tags hover">
        <div class="filter-option-icon">
          ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("filter-icon icon-md nav-icon-active", "list-icon")}
        </div>
        <div class="filter-option-text">Select Tags</div>
      </div>
    `;
    }
    _generateFilterDeleteMarkup() {
        return `
      <div
      class="filter-option-action filter-option-delete hover">
        <div class="filter-option-icon">
          ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("filter-icon icon-md nav-icon-active", "trashcan-icon")}
        </div>
        <div class="filter-option-text">Delete Filter</div>
      </div>
    `;
    }
    _generateMarkup() {
        const tagsSelectMarkup = this._state.property?.text.toLowerCase() === "tags" ? this._generateTagsSelectOption() : "";
        return `
        <div class="filter-input-option-option">
            <div class="filter-option-option">
              <div
                class="filter-option-action filter-option-delete hover"
              >
                <div class="filter-option-icon">
                  ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("filter-icon icon-md nav-icon-active", "trashcan-icon")}
                </div>
                <div class="filter-option-text">Delete Filter</div>
              </div>
              ${tagsSelectMarkup}
            </div>
        </div>
    `;
    }
    render() {
        const cls = this;
        const componentMarkup = this._generateFilterDeleteMarkup() + (this._state.property?.text.toLowerCase() === "tags" ? this._generateTagsSelectOption() : "");
        this._state.markup = this._generateMarkup(componentMarkup);
        const { overlay: overlay, overlayInterceptor: overlayInterceptor, component: component } = this._componentHandler._componentOverlay(this._state);
        this._state = {
            ...this._state,
            overlay: overlay,
            overlayInterceptor: overlayInterceptor,
            component: component
        };
        //overlay component handles its event
        overlayInterceptor.addEventListener("click", function(e) {
            cls._componentHandler._componentRemover(cls._state);
        }, {
            once: true
        });
        //component handles its event
        this._events.forEach((ev)=>{
            component.addEventListener(ev, this._handleEvents.bind(cls));
        });
    }
    _handleEvents(e) {
        if (this._deleteFilterRuleMatchStrategy(e)) this._handleDeleteFilterRuleEvent(e);
        if (this._tagSelectMatchStrategy(e)) this._handleTagSelectEvent(e);
    }
    _deleteFilterRuleMatchStrategy(e) {
        const matchStrategy = e.target.classList.contains("filter-option-delete") || e.target.closest(".filter-option-delete");
        return matchStrategy;
    }
    _tagSelectMatchStrategy(e) {
        const matchStrategy = e.target.classList.contains("filter-option-tags") || e.target.closest(".filter-option-tags");
        return matchStrategy;
    }
    _handleDeleteFilterRuleEvent(e) {
        const cls = this;
        this._state.component.remove();
        this._events.forEach((ev)=>this._state.component.removeEventListener(ev, cls._handleEvents, true));
        this._state.overlay.remove();
        this._state.removeAncestors.forEach((removeAncestor)=>removeAncestor());
        (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterTagList = [];
    }
    _handleTagSelectEvent(e) {
        const tagViewportHolder = e.target.closest(".filter-input-option-option");
        let { top: top, left: left, width: width, height: height } = tagViewportHolder.getBoundingClientRect();
        const queryPositioner = window.matchMedia("(max-width: 500px)");
        if (queryPositioner.matches) left = `${parseInt(left) - 50}`;
        const componentObj = {
            table: tagViewportHolder,
            top: top,
            left: left,
            width: width,
            height: height,
            selector: ".options-markup",
            updateModel: null,
            subComponentCallback: null,
            updateTag: null,
            updateObj: null,
            tags: (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).tags,
            tagsColors: (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).tagsColor,
            disableInput: true,
            callBack: this._resetGlobalStateFilterTagActive.bind(this),
            disableOptionsNudge: true
        };
        const component = new (0, $ab9fdfa0df6d04fe$export$2e2bcd8739ae039)(componentObj);
        //notify the global component state of active TagOption
        (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterTagOptionActive = true;
        //remove the options from the filterRule
        this._state.component.remove();
        this._state.overlay.remove();
        component.render();
    }
    _resetGlobalStateFilterTagActive() {
        (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterTagOptionActive = false;
    }
}






class $cf457c6ed3b126a5$export$2e2bcd8739ae039 {
    _componentHandler = (0, $d2866451d1c7a9c0$export$721ff339e60fcc47).object;
    _state;
    _events = [
        "click",
        "keyup"
    ];
    _signals = (0, $c5e51a03d827fa5f$export$df67e14a9d881936).object;
    _mixinActive = false;
    constructor(state){
        this._state = state;
    }
    _generateNameInput(inpVal = "") {
        return `
      <input
      type="text"
      class="filter-value component-form"
      placeholder="Type a Value..."
      value="${inpVal ? inpVal : ""}"
      />
    `;
    }
    _generateTagsInput(inpVal = "") {
        let tagsMarkup = "";
        if (Array.isArray(inpVal) && inpVal.length > 0) tagsMarkup = inpVal.map((val)=>(0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).tagItemMarkupFactory(val, true)).join("");
        return `
      <div
        contenteditable="false"
        class="filter-value-tags"
        aria-placeholder="Add Tags To Filter By"
      >
      ${tagsMarkup}
      </div>
    `;
    }
    _generateFilterInput(inpVal = "", property) {
        const inputMarkup = property.toLowerCase() === "tags" ? this._generateTagsInput(inpVal) : this._generateNameInput(inpVal);
        return `
      <div class="filter-input-container">
        ${inputMarkup}
      </div>
    `;
    }
    _generateMarkup(conditional, inpVal, property) {
        const removeFilterInput = [
            "Is empty",
            "Is not empty"
        ];
        const filterInputMarkup = this._state?.removeFilterInput || removeFilterInput.find((filter)=>filter.toLowerCase() === conditional?.toLowerCase()) ? "" : this._generateFilterInput(inpVal, property);
        return `
      <div class="filter-rule-input-box">
        <div class="filter-input-content">
          <div class="filter-input-content-box">
            <div class="filter-input-text">${property}</div>
            <div class="filter-input-filter hover">
              <div class="filter-input-filter-text">
                ${conditional.condition ?? (0, $bd02c871d9c5ba8e$export$9a00dee1beb8f576)(conditional)}
              </div>
              <div class="added-rule-icon">
                ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("filter-addeed-icon icon-sm nav-icon-active", "arrow-down")}
              </div>
            </div>
            <div class="div-filler"></div>
            <div class="filter-input-option hover">
              ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("filter-added-icon icon-md nav-icon-active", "ellipsis")}
            </div>
          </div>
          ${filterInputMarkup}

        </div>
      </div>
    `;
    }
    render() {
        // debugger;
        if (!this._mixinActive) this._addMixin();
        const cls = this;
        this._state.conditional = (0, $ba30e20475feac5a$export$2cb856a3d1493fda).filter((preposition)=>preposition[this._state.property.text.toLowerCase()] === true);
        const inputValue = this._state.property.text.toLowerCase() !== "tags" ? this._state.parentState.inputValue : (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterTagList;
        // const fnActive = this._checkTableFuncActive("filter")
        // if (!fnActive) {
        this._state.markup = this._generateMarkup(this._state.parentState.conditional ?? this._state.conditional[0].condition, inputValue, this._state.property.text);
        //set parent state conditional value if it doesn't exist
        this._setConditional();
        //disables the click interceptor|Allows click to be detected in background
        // this._state.disableOverlayInterceptor = true;
        const { overlay: overlay, overlayInterceptor: overlayInterceptor, component: component } = this._componentHandler._componentOverlay(this._state);
        this._state = {
            ...this._state,
            overlay: overlay,
            overlayInterceptor: overlayInterceptor,
            component: component
        };
        //overlay component handles its event
        overlayInterceptor.addEventListener("click", function(e) {
            cls._componentHandler._componentRemover(cls._state);
        }, {
            once: true
        });
        //component handles its event
        this._events.forEach((ev)=>{
            component.addEventListener(ev, this._handleEvents.bind(cls));
        });
        //register for events from tag Options
        this._signals.subscribe({
            component: this,
            source: [
                "tagadd"
            ]
        });
    }
    _insertFilterRuleInput() {
        const filterRuleInputParentContainer = document.querySelector(".filter-input-content-box");
        filterRuleInputParentContainer.insertAdjacentHTML("afterend", this._generateFilterInput(null, this._state.property.text));
    }
    _handleEvents(e, signals = false, childEvent = false) {
        if (!signals) {
            if (this._prepositionSelectMatchStrategy(e)) this._handlePrepositionSelectEvent(e);
            if (this._filterRuleInputMatchStrategy(e)) this._handleFilterRuleInputEvent(e);
            if (this._filterRuleOptionMatchStrategy(e)) this._handleFilterRuleOptionEvent(e);
            if (this._filterRuleRemoveTagMatchStrategy(e)) this._handleFilterRuleRemoveTagEvent(e);
        }
        if (childEvent) this._handleFilterRuleWithoutInputEvent(e);
        if (signals) this._handleFilterRuleTagAdd(e);
    }
    _itemAddFilterChecker(e) {
        if (e.type === "click") {
            if (e.target.classList.contains("row-adder-filter") || e.target.closest(".row-adder-filter")) return true;
        }
    }
    _prepositionSelectMatchStrategy(e) {
        if (e.type === "click") {
            const matchStrategy = e.target.classList.contains("filter-input-filter") || e.target.closest(".filter-input-filter");
            return matchStrategy;
        }
    }
    _filterRuleInputMatchStrategy(e) {
        if (e.type === "keyup") {
            const matchStrategy = e.target.classList.contains("filter-value") || e.target.closest(".filter-input-container");
            return matchStrategy;
        }
    }
    _filterRuleOptionMatchStrategy(e) {
        if (e.type === "click") {
            const matchStrategy = e.target.classList.contains("filter-input-option") || e.target.closest(".filter-input-option");
            return matchStrategy;
        }
    }
    _filterRuleRemoveTagMatchStrategy(e) {
        if (e.type === "click") {
            const matchStrategy = e.target.classList.contains("row-tag-icon") || e.target.closest(".row-tag-icon");
            return matchStrategy;
        }
    }
    _handlePrepositionSelectEvent(e) {
        const prepositionContainer = document.querySelector(".filter-input-content");
        const { top: top, left: left, width: width, height: height } = prepositionContainer.getBoundingClientRect();
        const componentObj = {
            top: `${parseInt(top) - (0, $ba30e20475feac5a$export$4548e099e938ee5)}`,
            left: left,
            width: width,
            height: height,
            conditional: this._state.conditional,
            property: this._state.property,
            selector: ".filter-pre-action--options",
            parentState: this._state,
            generateInput: this._insertFilterRuleInput.bind(this),
            executeFilter: this._executeFilterRule.bind(this),
            inputValue: this._state.parentState.inputValue,
            parent: this
        };
        const component = new (0, $4ca29cc2053959fb$export$2e2bcd8739ae039)(componentObj);
        component.render();
    }
    _handleFilterRuleOptionEvent(e) {
        const filterRuleOptionNudge = e.target.closest(".filter-input-option");
        const { top: top, left: left, width: width, height: height } = filterRuleOptionNudge.getBoundingClientRect();
        const componentObj = {
            top: top,
            left: `${parseInt(left) + 20}`,
            width: width,
            height: height,
            selector: ".filter-input-option-option",
            property: this._state.property,
            removeAncestors: [
                this._state.parent.remove.bind(this._state.parent),
                this.remove.bind(this)
            ]
        };
        const component = new (0, $93a749eb703fa76a$export$2e2bcd8739ae039)(componentObj);
        component.render();
    }
    _handleFilterRuleInputEvent(e) {
        const filterRuleBoxRuleAdded = document.querySelector(".filter-added-rule");
        const filterRuleInput = e.target.closest(".filter-value");
        //add the input value as the current filter
        filterRuleBoxRuleAdded.textContent = filterRuleInput.value;
        if (!filterRuleInput.value.length > 0) return;
        const filterInputValue = filterRuleInput.value.trim().toLowerCase();
        //adds input Value to parent state
        this._state.parentState.inputValue = filterInputValue;
        this._executeFilterRule(filterInputValue);
    }
    _handleFilterRuleWithoutInputEvent(e) {
        //add the conditional as the filter added value
        const filterRuleBoxRuleAdded = document.querySelector(".filter-added-rule");
        filterRuleBoxRuleAdded.textContent = this._state.preposition;
        this._executeFilterRule(null);
    }
    _handleFilterRuleTagAdd(e) {
        const filterRuleBoxRuleAdded = document.querySelector(".filter-added-rule");
        const tagToAdd = e.target.closest(".row-tag-tag") || e.target.querySelector(".row-tag-tag");
        const tagItemsContainer = document.querySelector(".filter-value-tags");
        const addedTagItems = Array.from(tagItemsContainer.children).map((tagItem)=>tagItem.textContent.trim()).filter((tagItem)=>tagItem.length > 0);
        const { createTagMarkup: createdItemTag, tagObj: tagObj } = (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).tagItemFactory(tagToAdd);
        //check if tag in addedTags
        const duplicateCheck = addedTagItems.length > 0 && addedTagItems.find((tag)=>tag.toLowerCase() === tagObj.text.toLowerCase());
        //prevents duplicate addition of tag to tag items
        if (!duplicateCheck) {
            tagItemsContainer.insertAdjacentHTML("beforeend", createdItemTag);
            if (!(0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterTagList) (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterTagList = [];
            (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterTagList.push(tagObj);
            filterRuleBoxRuleAdded.textContent = (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterTagList.map((tags)=>tags.text).join(", ");
            this._executeFilterRule((0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterTagList);
        }
    }
    _handleFilterRuleRemoveTagEvent(e) {
        const tagToRemove = e.target.closest(".tag-tag");
        const filterRuleBoxRuleAdded = document.querySelector(".filter-added-rule");
        //remove the tag from the componentGlobalState
        const tagToRemoveIndex = (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterTagList.findIndex((tag)=>tag.text.toLowerCase() === tagToRemove.textContent.trim().toLowerCase());
        (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterTagList.splice(tagToRemoveIndex, 1);
        filterRuleBoxRuleAdded.textContent = (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterTagList.map((tags)=>tags.text).join(", ");
        tagToRemove.remove();
        //run the filter again
        this._executeFilterRule((0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterTagList);
    }
    _executeFilterRule(input) {
        const currentTable = document.querySelector(".table-row-active");
        const conditionalValue = document.querySelector(".filter-input-filter").textContent.replace("\n", "").trim();
        const table = this._state.eventHandlers.tableControllers.controlGetTable(+currentTable.dataset.id);
        const filterType = this._getPropertyType();
        this._state.filterMethod = this._queryConditional(conditionalValue.toLowerCase(), filterType, input);
        //add the filterMethod to the parentState as well and the component Global State
        this._state.parentState.filterMethod = (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterMethod = this._state.filterMethod;
        this._state.parentState.conditional = (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).conditional = conditionalValue;
        //persist the filter properties
        this._state.eventHandlers.tableControllers.controlPersistTableFunc({
            tableId: +currentTable.dataset.id,
            type: filterType,
            conditional: conditionalValue.toLowerCase(),
            value: input,
            tags: (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterTagList,
            property: this._state.property.text.toLowerCase()
        }, "filter");
        //filter and render the table
        this._renderFiltered(table);
    }
    _queryConditional(conditional, property, input) {
        if (property === "itemTitle") return this._queryConditionalName(conditional, property, input);
        if (property === "itemTags") return this._queryConditionalTags(conditional, property, input);
    }
    _queryConditionalName(conditional, property, input) {
        let filterMethod;
        if (conditional === "contains") filterMethod = (property, input, tableItems)=>tableItems.filter((items)=>items[property].includes(input));
        if (conditional === "does not contain") filterMethod = (property, input, tableItems)=>tableItems.filter((items)=>!items[property].includes(input));
        if (conditional === "is empty") filterMethod = (property, input, tableItems)=>tableItems.filter((items)=>items[property].length === 0);
        if (conditional === "is not empty") filterMethod = (property, input, tableItems)=>tableItems.filter((items)=>items[property] !== null && items[property] !== "" && items[property].length > 0);
        if (conditional === "is") filterMethod = (property, input, tableItems)=>tableItems.filter((items)=>items[property] === input);
        if (conditional === "is not") filterMethod = (property, input, tableItems)=>tableItems.filter((items)=>items[property] !== input);
        if (conditional === "starts with") filterMethod = (property, input, tableItems)=>tableItems.filter((items)=>items[property].startsWith(input));
        if (conditional === "ends with") filterMethod = (property, input, tableItems)=>tableItems.filter((items)=>items[property].endsWith(input));
        //bind the property and input search and return the bound method
        return filterMethod.bind(null, property, input);
    }
    _queryConditionalTags(conditional, property, input) {
        let filterMethod;
        if (conditional === "contains") filterMethod = (property, input, tableItems)=>tableItems.filter((items)=>items[property].find((tag)=>input.find((filteredTag)=>Number(filteredTag.id) === tag)));
        if (conditional === "does not contain") filterMethod = (property, input, tableItems)=>tableItems.filter((items)=>!items[property].find((tag)=>input.find((filteredTag)=>Number(filteredTag.id) === tag)));
        if (conditional === "is empty") filterMethod = (property, input, tableItems)=>tableItems.filter((items)=>items[property].length === 0);
        if (conditional === "is not empty") filterMethod = (property, input, tableItems)=>tableItems.filter((items)=>items[property].length > 0);
        //bind the property and input search and return the bound method
        return filterMethod.bind(null, property, input);
    }
    _getPropertyType() {
        const property = document.querySelector(".filter-input-text");
        if (property) {
            const propertyValue = property.textContent.trim().toLowerCase();
            if (propertyValue === "name") return "itemTitle";
            if (propertyValue === "created") return "id";
            if (propertyValue === "tags") return "itemTags";
        }
    }
    _setConditional() {
        if (!this._state.parentState.conditional) this._state.parentState.conditional = this._state.conditional[0].condition;
    }
    // _renderFilteredTableItems(filteredItems, filterPlaceHolder = false) {
    // importTableComponentView.object.renderTableItem(filteredItems, null, filterPlaceHolder);
    // }
    _addMixin() {
        const { constructor: constructor, ...prototypePatch } = Object.getOwnPropertyDescriptors((0, $a383de20bc2b29cf$export$b62e7a1e6548fae7).prototype);
        //add copied props to instance proto
        Object.defineProperties(Object.getPrototypeOf(this).__proto__, prototypePatch);
        this._mixinActive = true;
    }
    remove(reset = true, parentRemove = false) {
        const cls = this;
        if (parentRemove) {
            //removes only the component and no rerender
            this._state.component.remove();
            this._events.forEach((ev)=>this._state.component.removeEventListener(ev, cls._handleEvents, true));
            if (!this._state.disableOverlayInterceptor) this._state.overlay.remove();
            return;
        }
        //reset tableItems to default
        const currentTable = document.querySelector(".table-row-active");
        const table = this._state.eventHandlers.tableControllers.controlGetTable(+currentTable.dataset.id);
        // if (table.tableItems.length === 0)
        //reset the table back to default
        if (reset) this._renderFilteredTableItems(table.tableItems);
        //unsubscribe from signals
        this._signals.unsubscribe(this);
        //remove its components
        this._state.component.remove();
        this._events.forEach((ev)=>this._state.component.removeEventListener(ev, cls._handleEvents, true));
        if (!this._state.disableOverlayInterceptor) this._state.overlay.remove();
    }
}






class $7016fdfe0e3f67a1$export$2e2bcd8739ae039 extends (0, $a8305e0dc1734493$export$2e2bcd8739ae039) {
    _componentHandler = (0, $d2866451d1c7a9c0$export$721ff339e60fcc47).object;
    _state;
    _events = [
        "click",
        "keyup"
    ];
    _signals = (0, $c5e51a03d827fa5f$export$df67e14a9d881936).object;
    constructor(state){
        super();
        this._state = state;
    }
    render() {
        if (!this._mixinActive) this._addMixin();
        const cls = this;
        const propertiesToRender = (0, $ba30e20475feac5a$export$ee96ddcc77a4b958).properties.filter((property)=>property.text.toLowerCase() !== "created");
        const fnActive = this._checkTableFuncActive("filter");
        if (!fnActive) {
            this._state.markup = this._generateMarkup(propertiesToRender, "filter");
            const { overlay: overlay, overlayInterceptor: overlayInterceptor, component: component } = this._componentHandler._componentOverlay(this._state);
            this._state = {
                ...this._state,
                overlay: overlay,
                overlayInterceptor: overlayInterceptor,
                component: component
            };
            //overlay component handles its event
            overlayInterceptor.addEventListener("click", function(e) {
                cls._componentHandler._componentRemover(cls._state);
            }, {
                once: true
            });
            //component handles its event
            this._events.forEach((ev)=>{
                component.addEventListener(ev, this._handleEvents.bind(cls));
            });
        }
        if (fnActive) {
            //generate filter rule markup
            this._handlePropertyOptionsOption(null, {
                property: "filter",
                state: this._state,
                callBack: null,
                props: (0, $ba30e20475feac5a$export$ee96ddcc77a4b958)
            });
            const fnData = this._getFunc("filter");
            this._state.conditional = fnData.conditional;
            const filterRuleBoxRuleAdded = document.querySelector(".filter-added-rule");
            filterRuleBoxRuleAdded.textContent = this._setFilterRuleBoxAddedValue(filterRuleBoxRuleAdded);
            this._state.filterMethod = (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterMethod = (0, $cf457c6ed3b126a5$export$2e2bcd8739ae039).prototype._queryConditional(this._state.conditional, fnData.type, fnData.value);
            const table = this._state.eventHandlers.tableControllers.controlGetTable(fnData.tableId);
            //filter and render the table
            this._renderFiltered(table);
        }
        //register the component as an observer
        this._signals.subscribe({
            component: this,
            source: [
                "tablebody",
                "content"
            ]
        });
    }
    _handleEvents(e, signal = false) {
        if (!signal) {
            if (this._propertyOptionFormStrategy(e, "filter")) this._handlePropertyOptionsForm((0, $ba30e20475feac5a$export$ee96ddcc77a4b958).properties, "filter");
            if (this._propertyOptionsOptionStrategy(e)) this._handlePropertyOptionsOption(e, {
                property: "filter",
                state: this._state,
                callBack: this._renderRule.bind(this),
                props: (0, $ba30e20475feac5a$export$ee96ddcc77a4b958)
            });
        }
        if (signal) {
            if (this._filterAddItemChecker(e)) this._handleFilterAddItem(e);
            if (this._filterAddRuleBoxStrategy(e)) {
                //execute if click event is by user interaction
                if (e.isTrusted) this._handleFilterAddRuleBoxEvent(e);
                if (!e.isTrusted) //remove the component but not its function is programmatically clicked
                this.remove(true);
            }
            if (this._removeFilterAddRuleBoxStrategy(e)) this._handleRemoveRuleBoxEvent(e);
            if (this._filterHoverAddStrategy(e)) this._handleFilterHoverAddStrategy(e);
        }
    }
    _filterOptionFormStrategy(e) {
        const filterOptionsFormStrategy = e.type === "keyup" && e.target.classList.contains("filter-search");
        return filterOptionsFormStrategy;
    }
    _filterOptionsOptionStrategy(e) {
        const filterOptionsOptionStrategy = e.type === "click" && (e.target.classList.contains("action-property-text") || e.target.closest(".action-property-content"));
        return filterOptionsOptionStrategy;
    }
    _filterAddRuleBoxStrategy(e) {
        const filterAddRuleBoxStrategy = e.type === "click" && e.target.classList.contains("filter-added-rule-box") || e.target.closest(".filter-added-rule-box");
        return filterAddRuleBoxStrategy;
    }
    _removeFilterAddRuleBoxStrategy(e) {
        const filterRuleBox = document.querySelector(".filter-input-content");
        if (filterRuleBox) {
            const matchStrategy = e.type === "click" && !e.target.classList.contains("filter-input-content") || !e.target.closest(".filter-input-content");
            return matchStrategy;
        }
    }
    _filterHoverAddStrategy(e) {
        if (e.type === "click") {
            const matchStrategy = e.target.classList.contains("row-add-icon") || e.target.closest(".row-add-icon");
            if (matchStrategy) {
                const ruleBoxExists = document.querySelector(".added-rule"); //(".filter-added-rule-box");
                if (ruleBoxExists?.textContent.trim().length > 0) return true;
            }
        }
    }
    _filterAddItemChecker(e) {
        if (e.type === "click") {
            const filterAddItemStrategy = e.target.classList.contains("row-adder-content") || e.target.closest(".row-adder-content") || e.target.classList.contains("row-adder-filter") || e.target.closest(".row-adder-filter");
            // filter-added-rule-name
            if (filterAddItemStrategy) {
                const currentProperty = this._state.property.text.toLowerCase();
                const ruleBoxExists = document.querySelector(".filter-added-rule");
                const ruleBoxAddedRule = document.querySelector(".filter-added-rule");
                if (ruleBoxAddedRule?.textContent.trim().length > 0) {
                    if (currentProperty !== "tags" && ruleBoxExists && ruleBoxExists?.textContent.trim().length > 0) return true;
                    if (currentProperty === "tags" && ruleBoxExists) return true;
                }
            }
        }
    }
    _handleRemoveFilterAddRuleBoxEvent(e) {
        if (!this._state.ruleBoxActive) {
            this._state.children.forEach((child)=>child.remove(false, true));
            this._state.children = [];
        }
    //   if (this._state.ruleBoxActive) this._state.ruleBoxActive = false; //sets the component active state back to not just rendered
    }
    _handleFilterOptionsForm(properties) {
        const filterOptionsContainer = document.querySelector(".filter-content-search");
        const filterOptionForm = document.querySelector(".filter-search");
        const renderProperties = properties.filter((property)=>property.text.toLowerCase().includes(filterOptionForm.value.trim().toLowerCase()));
        filterOptionsContainer.innerHTML = "";
        filterOptionsContainer.insertAdjacentHTML("beforeend", this._generateOptions(renderProperties));
    }
    _handleFilterAddRuleBoxEvent(e) {
        //should be called by the options option to add the rulebox
        const clickedProperty = this._getClickedProperty({
            e: e,
            closest: ".filter-added-rule-box",
            selector: ".filter-added-rule-name"
        });
        const selectedProperty = (0, $ba30e20475feac5a$export$ee96ddcc77a4b958).properties.find((property)=>property.text.toLowerCase() === clickedProperty);
        this._renderFilterRuleComponent(selectedProperty);
        //implement a notifier to the rulebox remover the component was just added
        this._state.ruleBoxActive = true;
    }
    _handleFilterAddItem(e) {
        this._executeItemAdder(e, null);
    }
    _handleFilterHoverAddStrategy(e) {
        const targetContainer = e.target.closest("[role=rowgroup]").querySelector(".row-actions-handler-container");
        this._executeItemAdder(e, +targetContainer.dataset.id);
    }
    _executeItemAdder(e, relativeItem) {
        const sliderConditional = this._state?.conditional?.toLowerCase() === "is not empty";
        const ruleBoxFilterText = document.querySelector(".filter-added-rule");
        const filterContainerInput = document.querySelector(".filter-value");
        const tableSearchInput = document.querySelector(".search-input");
        const itemTitle = filterContainerInput ? filterContainerInput.value.trim() : ruleBoxFilterText.textContent.replace(":", "").trim().toLowerCase();
        const updateAction = this._getConditionalAction(this._state.conditional?.toLowerCase() ?? (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).conditional.toLowerCase());
        const updateObj = {
            action: this._state.property.text.toLowerCase() === "tags" ? "createEmpty" : updateAction,
            itemTitle: this._state.property.text.toLowerCase() === "tags" ? "" : itemTitle,
            itemTags: updateAction === "createEmpty" ? [] : (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterTagList?.length > 0 ? [
                (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterTagList[0]
            ] : []
        };
        if (this._state.children.length > 0) {
            this._state.children.forEach((child)=>child.remove(false, true));
            this._state.children = [];
        }
        if (!sliderConditional) this._state.eventHandlers.tableItemControllers.controlAddTableItem(updateObj, relativeItem, this._state.filterMethod, (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).sortMethod);
        if (sliderConditional) {
            if (this._state.property.text.toLowerCase() === "tags") {
                if (updateObj.itemTags.length === 0) updateObj.itemTags.push((0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).tags[0]);
                this._state.eventHandlers.tableItemControllers.controlAddTableItem(updateObj, relativeItem, this._state.filterMethod, (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).sortMethod);
            } else //filter not added to allow render on table
            this._state.eventHandlers.tableItemControllers.controlAddTableItem(updateObj, relativeItem, null, (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).sortMethod, this._renderContainerSidePeekComponent.bind(this));
        }
        //clear the tableSearchInput if it exists
        tableSearchInput.value = "";
    }
    _renderRule(selectedProperty) {
        this._renderFilterRuleComponent(selectedProperty);
        this._state.component.remove();
        this._state.overlay.remove();
    }
    _renderFilterRuleComponent(selectedProperty) {
        const filterAddRuleBox = document.querySelector(".filter-added-rule-box");
        const { top: top, left: left, width: width, height: height } = filterAddRuleBox.getBoundingClientRect();
        //generate filter rule component
        const componentObj = {
            top: `${parseInt(top) - 20}`,
            left: left,
            width: width,
            height: height,
            selector: ".filter-rule-input-box",
            eventHandlers: this._state.eventHandlers,
            property: selectedProperty,
            updateModel: "",
            parentState: this._state,
            parent: this
        };
        const component = new (0, $cf457c6ed3b126a5$export$2e2bcd8739ae039)(componentObj);
        this._state.inputValue = this._state.inputValue ?? "";
        this._state.children.push(component);
        component.render();
    }
    _renderContainerSidePeekComponent(itemId) {
        //remove the container if it currently exists
        const sliderAlreadyExists = document.querySelector(".container-slide-template");
        if (sliderAlreadyExists) {
            sliderAlreadyExists.remove();
            document.querySelector(".container").classList.remove("side-peek");
        }
        const componentObj = (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).containerSidePeekComponentObj(itemId);
        const component = new (0, $176e612a1ce8accd$export$2e2bcd8739ae039)(componentObj);
        component.render();
    }
    _getConditionalAction(conditional) {
        const createEmptyItemConditional = [
            "Is not",
            "Does not contain",
            "Is empty",
            "Is not empty"
        ];
        const action = // this._state.property.toLowerCase() === "tags" ||
        createEmptyItemConditional.find((condition)=>condition.toLowerCase() === conditional) ? "createEmpty" : "createFromInput";
        return action;
    }
    remove(persistFunc = false) {
        const cls = this;
        const filterContainer = document.querySelector(".filter-action-container");
        this._state?.overlay?.click();
        this._events.forEach((ev)=>this._state?.component?.removeEventListener(ev, cls._handleEvents, true));
        filterContainer?.remove();
        if (!persistFunc) {
            const fnActive = this._checkTableFuncActive("filter");
            if (fnActive) this._removeComponentTableFunc("filter");
        }
        //unsubscribe from signal events
        this._signals.unsubscribe(this);
        (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterMethod = null;
        this._state = {};
        delete this;
    }
}












// import componentOptionsView from "../componentOptionsView.js";





class $750b35d89892d41f$export$2e2bcd8739ae039 extends (0, $e49efa9617bd8208$export$2e2bcd8739ae039) {
    _componentHandler = (0, $d2866451d1c7a9c0$export$721ff339e60fcc47).object;
    _state;
    _events = [
        "click"
    ];
    constructor(state){
        super();
        this._state = state;
    }
    pass() {}
    _generateActionSelectOption(options) {
        let markup = "";
        options.forEach((option)=>{
            markup += `
        <div class="filter-option-action filter-option-${option.text.toLowerCase()} hover">
          <div class="filter-option-icon">
            ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("filter-icon icon-md icon-active", `${option.icon}`)}
          </div>
          <div class="filter-option-text">${option.text}</div>
        </div>
    `;
        });
        return markup;
    }
    render() {
        const cls = this;
        const componentMarkup = this._generateActionSelectOption((0, $ba30e20475feac5a$export$7db8a6d9638b83c));
        this._state.markup = this._generateMarkup(componentMarkup);
        const { overlay: overlay, overlayInterceptor: overlayInterceptor, component: component } = this._componentHandler._componentOverlay(this._state);
        this._state = {
            ...this._state,
            overlay: overlay,
            overlayInterceptor: overlayInterceptor,
            component: component
        };
        //overlay component handles its event
        overlayInterceptor.addEventListener("click", function(e) {
            cls._componentHandler._componentRemover(cls._state);
        }, {
            once: true
        });
        //component handles its event
        this._events.forEach((ev)=>{
            component.addEventListener(ev, this._handleEvents.bind(cls));
        });
    }
    _handleEvents(e) {
        if (this._sortRuleMatchStrategy(e)) this._handleSortRuleEvent(e);
    }
    _sortRuleMatchStrategy(e) {
        const matchStrategy = e.target.classList.contains("filter-option-action ") || e.target.closest(".filter-option-action ");
        return matchStrategy;
    }
    _handleSortRuleEvent(e) {
        let filteredTableItems;
        const sortType = e.target?.textContent.trim();
        const sortEvent = new CustomEvent("sort", {
            detail: {
                sortType: sortType,
                optionObj: this
            }
        });
        this._state.parentState.component.dispatchEvent(sortEvent);
        this._setSortTypeSelectValue(sortType);
    }
    _setSortTypeSelectValue(value) {
        const sortTypeContainer = document.querySelector(".sort-type-options-box .action-filter-text");
        sortTypeContainer.textContent = value;
    }
    _resetGlobalStateFilterTagActive() {
        (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterTagOptionActive = false;
    }
    remove() {
        this._state.overlay.remove();
        this._state.component.remove();
    }
}



class $23296129ba7ea016$export$2e2bcd8739ae039 {
    _componentHandler = (0, $d2866451d1c7a9c0$export$721ff339e60fcc47).object;
    _state;
    _events = [
        "click"
    ];
    _mixinActive = false;
    constructor(state){
        this._state = state;
    }
    _generateMarkup(sortType, property) {
        return `
        <div class="sort-rules">
            <div class="sort-rules-container">
              <div class="sort-action-form">
                <div class="add-sort-rules-box">
                  <div class="sort-property-options">
                    <div class="sort-select sort-property-options-box">
                      <div class="sort-sort-icon">
                        ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("sort-icon icon-active icon-md", `${property.icon}`)}
                      </div>
                      <div class="action-filter-text">${property.text}</div>
                      <div class="sort-dropdown-icon">
                        ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("sort-icon icon-active icon-sm", "arrow-down")}
                      </div>
                    </div>
                  </div>
                  <div class="sort-type">
                    <div class="sort-type-options">
                      <div class="sort-type-options-box sort-select">
                        <div class="action-filter-text">${sortType}</div>
                        <div class="sort-dropdown-icon">
                          ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("sort-icon icon-active icon-sm", "arrow-down")}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="sort-delete-container">
                <div class="sort-action-box">
                  <div class="sort-delete-icon">
                    <div class="sort-sort-icon">
                      ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("icon-active icon-md", "trashcan-icon")}
                    </div>
                  </div>
                  <div class="sort-delete-text">Delete Sort</div>
                </div>
              </div>
            </div>
        </div>
    `;
    }
    render() {
        if (!this._mixinActive) this._addMixin();
        const cls = this;
        this._state.markup = this._generateMarkup(this._state.parentState.sortType ?? (0, $ba30e20475feac5a$export$7db8a6d9638b83c)[0].text, this._state.property);
        //disables the click interceptor|Allows click to be detected in background
        this._state.disableOverlayInterceptor = true;
        const { overlay: overlay, overlayInterceptor: overlayInterceptor, component: component } = this._componentHandler._componentOverlay(this._state, this._state.disableOverlayInterceptor);
        this._state = {
            ...this._state,
            overlay: overlay,
            overlayInterceptor: overlayInterceptor,
            component: component
        };
        //overlay component handles its event
        overlayInterceptor.addEventListener("click", function(e) {
            cls._componentHandler._componentRemover(cls._state);
        }, {
            once: true
        });
        //component handles its event
        this._events.forEach((ev)=>{
            component.addEventListener(ev, this._handleEvents.bind(cls));
        });
        //run initial sort here
        const sortType = this._state.parentState.sortType ?? (0, $ba30e20475feac5a$export$7db8a6d9638b83c)[0].text;
        this._executeSortRule(sortType);
        //listen for sort event
        component.addEventListener("sort", cls._handleSortEvent.bind(cls));
    }
    _handleEvents(e, signals = false) {
        if (!signals) {
            if (this._sortPropertySelectStrategy(e)) this._handleSortPropertySelectEvent(e);
            if (this._sortTypeSelectStrategy(e)) this._handleSortTypeSelectEvent(e);
            if (this._sortDeleteMatchStrategy(e)) this._handleSortDeleteEvent(e);
        }
    }
    _sortPropertySelectStrategy(e) {
        const matchStrategy = e.target.classList.contains(" sort-property-options-box") || e.target.closest(".sort-property-options-box");
        return matchStrategy;
    }
    _sortTypeSelectStrategy(e) {
        const matchStrategy = e.target.classList.contains("sort-type-options") || e.target.closest(".sort-type-options");
        return matchStrategy;
    }
    _sortDeleteMatchStrategy(e) {
        const matchStrategy = e.target.classList.contains("sort-delete-container") || e.target.closest(".sort-delete-container");
        return matchStrategy;
    }
    _handleSortPropertySelectEvent(e) {
        const setPropertySelector = this._setPropertySelectValue.bind(this);
        const propertySelectPosition = document.querySelector(".sort-property-options-box").getBoundingClientRect();
        const eventDetails = {
            detail: {
                callBack: setPropertySelector,
                positioner: propertySelectPosition
            }
        };
        const reuseEvent = new CustomEvent("reuse", eventDetails);
        this._state?.parentState?.component?.dispatchEvent(reuseEvent) ?? this._state.parent._handleEvents(null, null, eventDetails);
    }
    _handleSortTypeSelectEvent(e) {
        const sortTypeSelect = e.target.closest(".sort-type-options");
        const { top: top, left: left, width: width, height: height } = sortTypeSelect.getBoundingClientRect();
        const componentObj = {
            top: `${parseInt(top) + 30}`,
            left: left,
            width: width,
            height: height,
            selector: ".filter-input-option-option",
            eventHandlers: this._state.eventHandlers,
            property: this._state.property,
            parentState: this._state
        };
        const component = new (0, $750b35d89892d41f$export$2e2bcd8739ae039)(componentObj);
        component.render();
    }
    _handleSortDeleteEvent(e) {
        this.remove();
        this._state.parent.remove();
    }
    _querySort(property, sortType) {
        let sortMethod;
        if (property.toLowerCase() === "tags") sortMethod = (sortType, tableItems)=>tableItems.sort((a, d)=>{
                if (sortType.toLowerCase() === "ascending") {
                    if (a.itemTags[0] && d.itemTags[0]) {
                        if (a.itemTags[0].text < d.itemTags[0].text) return -1;
                        else return 1;
                    } else return -1;
                }
                if (sortType.toLowerCase() === "descending") {
                    if (a.itemTags[0] && d.itemTags[0]) {
                        if (a.itemTags[0].text > d.itemTags[0].text) return -1;
                        else return 1;
                    } else return 1;
                }
            });
        if (property.toLowerCase() === "name") sortMethod = (sortType, tableItems)=>tableItems.sort((a, d)=>{
                return sortType.toLowerCase() === "ascending" ? a.itemTitle < d.itemTitle ? -1 : 1 : a.itemTitle > d.itemTitle ? -1 : 1;
            });
        return sortMethod.bind(this, sortType);
    }
    _handleSortEvent(e) {
        const { sortType: sortType, optionObj: optionObj } = e.detail;
        this._state.parentState.sortType = sortType;
        this._executeSortRule(sortType.toLowerCase(), optionObj);
    }
    _executeSortRule(sortType, optionObj) {
        let filteredTableItems;
        const currentTable = document.querySelector(".table-row-active");
        const table = this._state.eventHandlers.tableControllers.controlGetTable(+currentTable.dataset.id);
        this._state.sortMethod = null;
        this._state.sortMethod = this._querySort(this._state.parentState.property.text, sortType.toLowerCase());
        (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).sortMethod = this._state.parentState.sortMethod = this._state.sortMethod;
        //persist the sort properties
        this._state.eventHandlers.tableControllers.controlPersistTableFunc({
            tableId: +currentTable.dataset.id,
            type: this._state.parentState.property.text,
            value: sortType.toLowerCase(),
            property: this._state.parentState.property
        }, "sort");
        if (table.tableItems.length > 0) {
            //check if filter methods exist
            if ((0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterMethod) filteredTableItems = (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterMethod(table.tableItems);
            const sortedTableItems = filteredTableItems?.length > 0 ? (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).sortMethod(filteredTableItems) : (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).sortMethod(table.tableItems);
            this._renderSortedTableItems(sortedTableItems);
        }
        optionObj && optionObj.remove();
    }
    _setPropertySelectValue(value, parentState) {
        const propertySelectContainer = document.querySelector(".sort-property-options-box");
        const sortTypeContainer = document.querySelector(".sort-type-options-box .action-filter-text");
        const containerText = propertySelectContainer.querySelector(".action-filter-text");
        const containerIcon = propertySelectContainer.querySelector(".sort-icon");
        containerText.textContent = value.text;
        containerIcon.src = value.icon;
        //switch the parentState to the newly created instance
        this._state.parentState = parentState;
        this._executeSortRule(sortTypeContainer.textContent.trim());
    }
    _addMixin() {
        const { constructor: constructor, ...prototypePatch } = Object.getOwnPropertyDescriptors((0, $a383de20bc2b29cf$export$b62e7a1e6548fae7).prototype);
        //add copied props to instance proto
        Object.defineProperties(Object.getPrototypeOf(this).__proto__, prototypePatch);
        this._mixinActive = true;
    }
    // _renderSortedTableItems(sortedItems, filterPlaceHolder = false) {
    // importTableComponentView.object.renderTableItem(sortedItems, null);
    // }
    remove(reset = true) {
        const cls = this;
        this._state?.overlay?.remove();
        this._events.forEach((ev)=>this._state.component.removeEventListener(ev, cls._handleEvents, true));
        this._state.component.remove();
    }
}


class $b493357bb1814c8a$export$2e2bcd8739ae039 extends (0, $a8305e0dc1734493$export$2e2bcd8739ae039) {
    _componentHandler = (0, $d2866451d1c7a9c0$export$721ff339e60fcc47).object;
    _state;
    _events = [
        "click",
        "keyup"
    ];
    _signals = (0, $c5e51a03d827fa5f$export$df67e14a9d881936).object;
    constructor(state){
        super();
        this._state = state;
    }
    render() {
        if (!this._mixinActive) this._addMixin();
        const cls = this;
        const propertiesToRender = (0, $ba30e20475feac5a$export$ee96ddcc77a4b958).properties.filter((property)=>property.text.toLowerCase() !== "created");
        const fnActive = this._checkTableFuncActive("sort");
        if (!fnActive) {
            this._state.markup = this._generateMarkup(propertiesToRender, "sort");
            const { overlay: overlay, overlayInterceptor: overlayInterceptor, component: component } = this._componentHandler._componentOverlay(this._state);
            this._state = {
                ...this._state,
                overlay: overlay,
                overlayInterceptor: overlayInterceptor,
                component: component
            };
            //overlay component handles its event
            overlayInterceptor.addEventListener("click", function(e) {
                cls._componentHandler._componentRemover(cls._state);
            }, {
                once: true
            });
            //component handles its event
            this._events.forEach((ev)=>{
                component.addEventListener(ev, this._handleEvents.bind(cls));
            });
            //listen for reuse events
            component.addEventListener("reuse", cls._reuseComponentListener.bind(cls));
        }
        if (fnActive) {
            //generate sort rule markup
            this._handlePropertyOptionsOption(null, {
                property: "sort",
                state: this._state,
                callBack: null,
                props: (0, $ba30e20475feac5a$export$ee96ddcc77a4b958)
            });
            this._state.property = this._getFunc("sort").property;
            this._state.sortMethod = (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).sortMethod = (0, $23296129ba7ea016$export$2e2bcd8739ae039).prototype._querySort(this._state.property.text, this._getFunc("sort").type);
            const table = this._state.eventHandlers.tableControllers.controlGetTable(this._getFunc("sort").tableId);
            //sort and render the table
            this._renderSorted(table);
        //remove persistedSort
        // this._removeComponentTableFunc("sort")
        }
        //register for events from the body
        if (!(0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).sortMethod || fnActive) //prevent subscribing multiple times if already subscribeed  or if fnActive subscribe for events
        this._signals.subscribe({
            component: this,
            source: [
                "tablebody",
                "content"
            ]
        });
    }
    _handleEvents(e, signal = false, childEvent = false) {
        if (!signal && !childEvent) {
            if (this._propertyOptionFormStrategy(e, "sort")) this._handlePropertyOptionsForm((0, $ba30e20475feac5a$export$ee96ddcc77a4b958).properties, "sort");
            if (this._propertyOptionsOptionStrategy(e)) this._handlePropertyOptionsOption(e, this._options(this._state.reuseCallBack));
        }
        if (signal) {
            if (this._removeSortRuleBoxStrategy(e)) this._handleRemoveRuleBoxEvent(e);
            if (this._sortAddRuleBoxStrategy(e)) {
                //execute if click event is by user interaction
                if (e.isTrusted) this._handleSortAddRuleBoxEvent(e);
                if (!e.isTrusted) //remove the component but not its function is programmatically clicked
                this.remove(true);
            }
            if (this._sortItemAddMatchStrategy(e)) this._handleSortAddItem(e);
            if (this._sortHoverAddStrategy(e)) this._handleSortHoverAddEvent(e);
        }
        if (childEvent) this._reuseComponentListener(childEvent);
    }
    _sortAddRuleBoxStrategy(e) {
        const matchStrategy = e.type === "click" && e.target.classList.contains("sort-added-rule-box") || e.target.closest(".sort-added-rule-box");
        return matchStrategy;
    }
    _removeSortRuleBoxStrategy(e) {
        const sortRuleBox = document.querySelector(".sort-rules");
        if (sortRuleBox) {
            const matchStrategy = e.type === "click" && !e.target.classList.contains("filter-input-content") || !e.target.closest(".filter-input-content");
            return matchStrategy;
        }
    }
    _sortItemAddMatchStrategy(e) {
        if (e.type === "click") {
            const matchStrategy = e.target.classList.contains("row-adder-content") || e.target.closest(".row-adder-content") || e.target.classList.contains("row-adder-filter") || e.target.closest(".row-adder-filter");
            //prevent event from matching if filter exists
            if (matchStrategy && !(0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterMethod) return true;
        }
    }
    _sortHoverAddStrategy(e) {
        if (e.type === "click") {
            const matchStrategy = e.target.classList.contains("row-add-icon") || e.target.closest(".row-add-icon");
            if (matchStrategy && !(0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterMethod) return true;
        }
    }
    _handleSortAddRuleBoxEvent(e) {
        this._renderSortRuleComponent(this._state.property);
    }
    _handleSortHoverAddEvent(e) {
        const targetContainer = e.target.closest("[role=rowgroup]").querySelector(".row-actions-handler-container");
        this._state.eventHandlers.tableItemControllers.controlAddTableItem({}, +targetContainer.dataset.id, null, this._state.sortMethod);
    }
    _handleSortAddItem(e) {
        const tableSearchInput = document.querySelector(".search-input");
        if (tableSearchInput) tableSearchInput.value = "";
        this._state.eventHandlers.tableItemControllers.controlAddTableItem({}, null, null, this._state.sortMethod);
    }
    _renderRule(selectedProperty) {
        const propertyContainer = document.querySelector(".property-actions").classList.toggle("show-border");
        this._renderSortRuleComponent(selectedProperty);
        this._state.component.remove();
        this._state.overlay.remove();
    }
    _renderSortRuleComponent(selectedProperty) {
        const sortAddRuleBox = document.querySelector(".sort-added-rule-box");
        const { top: top, left: left, width: width, height: height } = sortAddRuleBox.getBoundingClientRect();
        //generate filter rule component
        const componentObj = {
            top: `${parseInt(top) - 20}`,
            left: left,
            width: width,
            height: height,
            selector: ".sort-rules",
            eventHandlers: this._state.eventHandlers,
            property: selectedProperty,
            updateModel: "",
            parentState: this._state,
            parent: this
        };
        const component = new (0, $23296129ba7ea016$export$2e2bcd8739ae039)(componentObj);
        this._state.children.push(component);
        component.render();
    // this._state.ruleBoxActive = true;
    }
    _options(callBack) {
        return {
            property: "sort",
            state: this._state,
            callBack: callBack ?? this._renderRule.bind(this),
            props: (0, $ba30e20475feac5a$export$ee96ddcc77a4b958)
        };
    }
    _reuseComponentListener(e) {
        const { top: top, left: left, width: width, height: height } = e.detail.positioner;
        this._state.top = top, this._state.left = `${parseInt(left) + 150}`, this._state.width = width, this._state.height = height;
        this._removeComponentTableFunc("sort");
        this.render();
        this._state.reuseCallBack = (value, parentState)=>{
            e.detail.callBack(value, parentState);
            this._state.component.remove();
            this._state.overlay.remove();
        };
    }
    remove(persistFunc = false) {
        const cls = this;
        const sortActionContainer = document.querySelector(".sort-action-container ");
        this._state?.overlay?.remove();
        // this._state?.overlay?.remove();
        //unsubscribe from signal events
        this._signals.unsubscribe(this);
        this._events.forEach((ev)=>this._state?.component?.removeEventListener(ev, cls._handleEvents, true));
        this._state?.component?.remove();
        sortActionContainer?.remove();
        (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).sortMethod = null;
        if (!persistFunc) {
            const fnActive = this._checkTableFuncActive("sort");
            if (fnActive) this._removeComponentTableFunc("sort");
        }
        this._state = {};
        delete this;
    }
}











class $ca7e0f9c5caee292$export$c91f0198ea4ccc40 extends (0, $a8305e0dc1734493$export$2e2bcd8739ae039) {
    _componentHandler = (0, $d2866451d1c7a9c0$export$721ff339e60fcc47).object;
    _state;
    _events = [
        "click"
    ];
    constructor(state){
        super();
        this._state = state;
    }
    render() {
        const cls = this;
        this._state.markup = this._generateMarkup((0, $ba30e20475feac5a$export$227dd4c68037d33c).properties, "table-head-actions", false);
        const { overlay: overlay, overlayInterceptor: overlayInterceptor, component: component } = this._componentHandler._componentOverlay(this._state);
        this._state = {
            ...this._state,
            overlay: overlay,
            overlayInterceptor: overlayInterceptor,
            component: component
        };
        //overlay component handles its event
        overlayInterceptor.addEventListener("click", function(e) {
            cls._componentHandler._componentRemover(cls._state);
        }, {
            once: true
        });
        //component handles its event
        this._events.forEach((ev)=>{
            component.addEventListener(ev, this._handleEvents.bind(cls));
        });
    }
    _handleEvents(e) {
        //route events to the parent component
        (0, $333e267f766eff38$export$2e2bcd8739ae039).matchEvent(e, this.remove.bind(this));
    }
    remove() {
        const cls = this;
        this._state?.overlayInterceptor?.click();
        this._events.forEach((ev)=>this._state?.component?.removeEventListener(ev, cls._handleEvents, true));
    }
}


class $333e267f766eff38$var$TableActionsProcessorView {
    _eventHandlers;
    _children = [];
    addHandlers(handlers) {
        this._eventHandlers = handlers;
    }
    matchEvent(e, eventRouterComponent) {
        const cls = this;
        //table adder
        if (cls._tableAddMatchStrategy(e)) {
            const adderContainer = e.target.closest(".table-column-adder");
            cls._handleAddTableJournal();
        }
        //render journals in option view
        const journalOptionsContainer = this._tableViewStrategy(e);
        if (journalOptionsContainer) this._handleTableViewOptions(e, journalOptionsContainer);
        //filter functionality in table head
        const filterContainer = this._tableFilterStrategy(e);
        if (filterContainer) this._handleFilterOption(e, filterContainer, eventRouterComponent);
        //sort functionality in table head
        const sortContainer = this._tableSortStrategy(e);
        if (sortContainer) this._handleSortOption(e, sortContainer, eventRouterComponent);
        if (this._tableSearchMatchStrategy(e)) this._handleTableSearchEvent(e);
        if (this._tableNewBtnMatchStrategy(e)) this._handleTableNewBtnEvent(e, eventRouterComponent);
        if (this._tableActionOptionsStrategy(e)) this._handleActionOptionsEvent(e);
    }
    _tableActionOptionsStrategy(e) {
        return (0, $bd02c871d9c5ba8e$export$b0cf5a82061b8f99)(e, "table-row-options");
    }
    _tableAddMatchStrategy(e) {
        const addMatchStrategy = e.target.classList.contains("table-column-adder") || e.target.closest(".table-column-adder");
        return addMatchStrategy;
    }
    _tableViewStrategy(e) {
        if (e.target.classList.contains("table-column-options") || e.target.closest(".table-column-options")) {
            const TableViewStrategy = e.target?.closest(".table-column-options");
            return TableViewStrategy;
        }
    }
    _tableFilterStrategy(e) {
        const matchStrategy = e.target.classList.contains("table-filter") || e.target.closest(".table-filter");
        if (matchStrategy) return e.target.closest(".table-filter");
        return matchStrategy;
    }
    _tableSortStrategy(e) {
        const matchStrategy = e.target.classList.contains("table-sort") || e.target.closest(".table-sort");
        if (matchStrategy) return e.target.closest(".table-sort");
        return matchStrategy;
    }
    _tableSearchMatchStrategy(e) {
        const matchStrategy = e.target.classList.contains("table-row-search") || e.target.closest(".table-row-search");
        return matchStrategy;
    }
    _tableNewBtnMatchStrategy(e) {
        const matchStrategy = e.target.classList.contains("table-button-content") || e.target.closest(".table-button-content");
        return matchStrategy;
    }
    _handleTableViewOptions(e, container) {
        const cls = this;
        const tables = this._eventHandlers.tableControllers.controlGetTableHeads();
        const { top: top, left: left, width: width, height: height } = container.getBoundingClientRect();
        const componentObj = {
            top: top,
            left: left,
            width: width,
            height: height,
            tables: tables,
            selector: ".table-view-list--options"
        };
        const component = new (0, $1f792b9169210bf0$export$2e2bcd8739ae039)(componentObj);
        component.render();
    }
    _updateSideBarList() {
        //update sidebar tables if open
        if ((0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).sideBarListActive) {
            const sidebarJournalContainer = document.querySelector(".nav-options-journal");
            (0, $5f1bb3a11090bdeb$export$4b8b7519249bbbe8).object._renderSideBarList(null, sidebarJournalContainer);
        }
    }
    _handleAddTableJournal() {
        this._eventHandlers.tableControllers.controlAddNewTable(this._updateSideBarList.bind(this));
    }
    _handleFilterOption(e, container, eventRouterComponent) {
        const cls = this;
        const filterExists = document.querySelector(".filter-added-rule-box");
        if (filterExists) return;
        //logic to prevent re-render of container
        const { top: top, left: left, width: width, height: height } = container.getBoundingClientRect();
        const componentObj = {
            top: top,
            left: left,
            width: width,
            height: height,
            selector: ".filter-add-action--options",
            eventHandlers: cls._eventHandlers,
            updateModel: "",
            children: []
        };
        const component = new (0, $7016fdfe0e3f67a1$export$2e2bcd8739ae039)(componentObj);
        component.render();
        if (eventRouterComponent) eventRouterComponent();
    }
    _handleSortOption(e, container, eventRouterComponent) {
        const cls = this;
        const sortExists = document.querySelector(".sort-added-rule-box");
        if (sortExists) return;
        //logic to prevent re-render of container
        // this._optionsView._optionsActive = true;
        const { top: top, left: left, width: width, height: height } = container.getBoundingClientRect();
        const componentObj = {
            top: top,
            left: left,
            width: width,
            height: height,
            selector: ".sort-add-action--options",
            eventHandlers: cls._eventHandlers,
            updateModel: "",
            children: []
        };
        const component = new (0, $b493357bb1814c8a$export$2e2bcd8739ae039)(componentObj);
        component.render();
        if (eventRouterComponent) eventRouterComponent();
    }
    _handleTableSearchEvent(e) {
        let filteredSearchValue;
        const cls = this;
        const currentTable = document.querySelector(".table-row-active");
        const searchInput = document.querySelector(".search-input");
        searchInput && searchInput.classList.toggle("hide-search-input");
        //add event listeners
        searchInput.addEventListener("keyup", function(e) {
            const inputVal = searchInput.value.trim();
            const table = cls._eventHandlers.tableControllers.controlGetTable(+currentTable.dataset.id);
            filteredSearchValue = table.tableItems.filter((tableItem)=>tableItem.itemTitle.toLowerCase().includes(inputVal.toLowerCase()));
            if ((0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterMethod) filteredSearchValue = (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterMethod(filteredSearchValue);
            (0, $2d49e726836fb57f$export$6db5d748e242c31).object.renderTableItem(filteredSearchValue, (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterMethod);
        });
    }
    _handleTableNewBtnEvent(e, eventRouterComponent) {
        if (eventRouterComponent) eventRouterComponent();
        const sidePeekCallBack = (itemId)=>{
            const componentObj = (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).containerSidePeekComponentObj(itemId);
            const component = new (0, $176e612a1ce8accd$export$2e2bcd8739ae039)(componentObj);
            component.render();
        };
        const updateObj = {};
        this._eventHandlers.tableItemControllers.controlAddTableItem(updateObj, null, null, (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).sortMethod, sidePeekCallBack);
    }
    _handleActionOptionsEvent(e) {
        const actionOptionContainer = document.querySelector(".table-row-options");
        let { top: top, left: left, width: width, height: height } = actionOptionContainer.getBoundingClientRect();
        const componentObj = {
            top: top,
            left: `${parseInt(left) - 50}`,
            width: width,
            height: height,
            eventHandlers: this._eventHandlers,
            selector: ".table-head-actions-add-action--options",
            updateModel: ""
        };
        const component = new (0, $ca7e0f9c5caee292$export$c91f0198ea4ccc40)(componentObj);
        component.render();
    }
}
var $333e267f766eff38$export$2e2bcd8739ae039 = new $333e267f766eff38$var$TableActionsProcessorView();


class $2f08e0265dc40b56$var$TableHeadProcessorView {
    _optionsView;
    _renameOption;
    _duplicateOption;
    _deleteOption;
    _active = false;
    _eventHandlers;
    _currentTableSetter;
    _sidebarComponentView = (0, $5f1bb3a11090bdeb$export$4b8b7519249bbbe8).object //? importSideBarComponentView.object : (importSideBarComponentView.object = importSideBarComponentView.import())
    ;
    addHandlers(handlers, currentTableSetter) {
        this._eventHandlers = handlers.optionControllers;
        this._currentTableSetter = currentTableSetter;
    }
    matchEvent(e) {
        //journals table matching strategy
        if (this._tableMatchChecker(e)) this._handleTableOptions(e);
    }
    _tableMatchChecker(e) {
        const match = e.target.classList.contains("table-journal") || e.target.closest(".table-journal");
        return match;
    }
    _tableMatchStrategy(e) {
        const matchChecker = this._tableMatchChecker(e);
        const matchStrategy = matchChecker && !this._optionsView._optionsActive || matchChecker && this._optionsView._optionsActive;
        return matchStrategy;
    }
    _handleTableOptions(e) {
        const tableViewOptionRender = window.matchMedia((0, $ba30e20475feac5a$export$65c9bf95558790f6));
        if (tableViewOptionRender.matches) this._renderTableViewOptions(e);
        if (!tableViewOptionRender.matches) this._renderTableOptions(e);
    }
    _renderTableOptions(e) {
        const { currentTable: currentTable, currentTableIsActiveTable: currentTableIsActiveTable } = this._activateTable(e);
        //use overlay imp instead
        if (currentTableIsActiveTable) this._renderAndListenForTableOptionsEvents(currentTable);
    }
    _renderTableViewOptions(e) {
        const container = document.querySelector(".table-row-active");
        (0, $333e267f766eff38$export$2e2bcd8739ae039)._handleTableViewOptions(e, container);
    }
    /**
   * Reuseable for Wherever the component is rendered
   * * @param {Object} currentTable  The specific table to process events on if supplied
   */ _renderAndListenForTableOptionsEvents(currentTable, callerCallBack) {
        const cls = this;
        if (!this._active) {
            this._active = true;
            //get position of the currentTable
            let { top: top, left: left, width: width, height: height } = currentTable.getBoundingClientRect();
            const queryPositioner = window.matchMedia("(max-width: 500px)");
            if (queryPositioner.matches) left = `${parseInt(left) - 180}`;
            const componentObj = {
                top: top,
                left: left,
                width: width,
                height: height,
                callBack: callerCallBack ? [
                    cls._resetActiveState.bind(cls),
                    callerCallBack
                ] : cls._resetActiveState.bind(cls),
                selector: ".table-row-active--options",
                table: currentTable,
                updateUI: cls._updateUITableTitle.bind(cls),
                rename: cls._eventHandlers.controlRenameOption,
                delete: cls._eventHandlers.controlDeleteOption,
                duplicate: cls._eventHandlers.controlDuplicateOption
            };
            const component = new (0, $ce1cde5f46f2821c$export$2e2bcd8739ae039)(componentObj).render();
        }
    }
    _activateTable(e, currentTableSelector = false, tableToDisplayId) {
        const allTables = document.querySelectorAll(".table-journal");
        const currentTable = currentTableSelector ? document.querySelector(currentTableSelector) : e.target.closest(".table-journal");
        const currentTableIsActiveTable = currentTable?.classList?.contains("table-row-active");
        //activate table if table is not active
        if (!currentTableIsActiveTable) this._activator(currentTable, allTables, tableToDisplayId);
        return {
            currentTable: currentTable,
            currentTableIsActiveTable: currentTableIsActiveTable
        };
    }
    _activator(currentTable, allTables, tableToDisplayId) {
        allTables.forEach((table)=>table.classList.remove("table-row-active"));
        if (currentTable) {
            currentTable.classList.add("table-row-active");
            this._currentTableSetter(+currentTable.dataset.id);
            //update sidebar tables if open
            if ((0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).sideBarListActive) {
                const sidebarJournalContainer = document.querySelector(".nav-options-journal");
                this._sidebarComponentView._renderSideBarList(null, sidebarJournalContainer);
            }
        }
        if (!currentTable) this._currentTableSetter(null, tableToDisplayId);
        // notify tableComponentView of Current Table
        this._active = false;
    }
    _updateUITableTitle(currentTable, titleValue) {
        const tableTitles = Array.from(document.querySelectorAll(`[data-id="${currentTable.dataset.id}"]`));
        tableTitles.forEach((title)=>{
            if (+title.dataset.id === +currentTable.dataset.id) {
                //update table render
                if (title.classList.contains("table-journal")) title.querySelector(".table-row-text").textContent = titleValue;
                //update options render
                if (title.classList.contains("table-view-options")) title.closest(".table-view-box").querySelector(".table-row-text").textContent = titleValue;
            }
        });
    }
    _resetActiveState() {
        this._active = false;
    }
}
const $2f08e0265dc40b56$export$712e42d57dd318a8 = {
    import: ()=>new $2f08e0265dc40b56$var$TableHeadProcessorView(),
    object: null
};




class $2d49e726836fb57f$var$TableComponentView {
    _parentElement = document.querySelector(".content-container");
    _tableElement = document.querySelector(".main-table");
    _tableHeadElement = document.querySelector(".main-table-head-box");
    _tableBodyElement = document.querySelector(`[role="tablerow"]`);
    _signals = (0, $c5e51a03d827fa5f$export$df67e14a9d881936).object ? (0, $c5e51a03d827fa5f$export$df67e14a9d881936).object : (0, $c5e51a03d827fa5f$export$df67e14a9d881936).object = (0, $c5e51a03d827fa5f$export$df67e14a9d881936).import();
    _tableBodyItemElement;
    _tableViewOptionsActive = false;
    _currentTable;
    _currentTableItem;
    _currentTableHandler;
    _tableHeadEventProcessor = (0, $2f08e0265dc40b56$export$712e42d57dd318a8).object ? (0, $2f08e0265dc40b56$export$712e42d57dd318a8).object : (0, $2f08e0265dc40b56$export$712e42d57dd318a8).object = (0, $2f08e0265dc40b56$export$712e42d57dd318a8).import();
    _tableActionsEventProcessor = (0, $333e267f766eff38$export$2e2bcd8739ae039);
    _tableBodyEventProcessor = (0, $d50a2a9c3981572e$export$2e2bcd8739ae039);
    _bodyEventListenerActive = false;
    _token;
    init(tableHandler, currentTableHandler, tables, currentTable) {
        //add handleer to set currentTable in the model
        this._currentTableHandler = currentTableHandler;
        tableHandler();
        this._currentTable = currentTable;
        //generate table head markup
        const markup = this._generateMarkup(tables, currentTable.id);
        //load initial UI data
        this._tableHeadElement.innerHTML = "";
        this._tableHeadElement.insertAdjacentHTML("afterbegin", markup);
        // this._tableBodyElement.innerHTML = "";
        this._tableBodyElement.insertAdjacentHTML("beforeend", this._generateBodyMarkup());
        this._tableBodyEventProcessor._currentTable = currentTable;
        this._tableBodyEventProcessor.render(this._currentTable);
        //set the table body item element to the component private variable
        this._tableBodyItemElement = document.querySelector(`[role="tablebody"]`);
        //add the renderTableItem as a componentGlobalState method
        (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).renderTableItem = this.renderTableItem.bind(this);
        //add body event listener for the table body items if they exist on page load
        if (this._currentTable && this._currentTable?.tableItems?.length > 0 && !this._bodyEventListenerActive) {
            this.addBodyDelegationEventListener();
            this.setBodyEventListenerState(true);
        }
    }
    addComponentHandlers(handlers) {
        this._tableActionsEventProcessor.addHandlers(handlers);
        this._tableHeadEventProcessor.addHandlers(handlers, this.setCurrentTableAndPersistInModel.bind(this));
        this._tableBodyEventProcessor.addHandlers(handlers, this.setCurrentTableAndPersistInModel.bind(this));
    }
    setCurrentTableAndPersistInModel(currentTable, tableToDisplayId) {
        if (currentTable) this._currentTable = currentTable;
        //perist currentTable in the model
        this._currentTableHandler(currentTable, tableToDisplayId);
    }
    setBodyEventListenerState(value) {
        this._bodyEventListenerActive = value;
    }
    addTableTagMetaData(...data) {
        this._tableBodyEventProcessor.addTagsMetaData(data);
        [(0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).tags, (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).tagsColor] = data;
    }
    addDelegationEventListener(e) {
        const cls = this;
        e.stopPropagation();
        //process events related to the main-heading section
        cls._tableHeadEventProcessor.matchEvent(e);
        //process events related to the main-actions section
        cls._tableActionsEventProcessor.matchEvent(e);
        //process events related to the table body section
        cls._tableBodyEventProcessor.matchEvent(e);
        //register the event as a signal as well
        if (this._signals.eventsToListenFor().find((events)=>e.type === events)) this._signals.observe(e, "content");
    }
    addBodyDelegationEventListener() {
        (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).hoverEl = this._tableBodyEventProcessor._generateHoverMarkupAndCreateElement();
        this.listen();
    }
    render(tables, currentTable) {
        const cls = this;
        //set currentTable
        if (currentTable) this._currentTable = currentTable;
        // //generate table head markup
        const markup = this._generateMarkup(tables, currentTable?.id);
        // //load initial UI data
        this._tableHeadElement.innerHTML = "";
        this._tableHeadElement.insertAdjacentHTML("afterbegin", markup);
    }
    addActiveTableFunc(tableFunc) {
        this._clearTableFunc();
        this._activateTableFunc(tableFunc);
    }
    _clearTableFunc() {
        //programmatically click on the element to remove itself
        document.querySelector(".filter-added-rule-box")?.click();
        document.querySelector(".sort-added-rule-box")?.click();
        //clear the componentGlobalState
        (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).sortMethod = null;
        (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).filterMethod = null;
    }
    _activateTableFunc(activeTableFunc) {
        const filter = activeTableFunc?.filter > 0;
        const sort = activeTableFunc?.sort > 0;
        if (filter) document.querySelector(".table-filter").click();
        if (sort) document.querySelector(".table-sort").click();
    }
    renderTableItem(tableItems, filter, filterPlaceHolder = false, clearTableFunc, activeTableFunc) {
        const itemsExists = tableItems.length > 0;
        this._tableBodyItemElement.innerHTML = "";
        if (itemsExists) this._tableBodyItemElement.insertAdjacentHTML("beforeend", this._tableBodyEventProcessor._generateItemMarkup(tableItems));
        if (!itemsExists) this._tableBodyItemElement.insertAdjacentHTML("beforeend", this._generateBodyMarkup(true, filterPlaceHolder));
        if (clearTableFunc) this._clearTableFunc();
        //apply filters to currently set tables if it exists
        if (activeTableFunc) this._activateTableFunc(activeTableFunc);
    }
    updateTableItem(currentTable, tableItems, itemId, callBack) {
        if (tableItems.length > 0) {
            this._tableBodyItemElement.innerHTML = "";
            this._tableBodyItemElement.insertAdjacentHTML("beforeend", this._tableBodyEventProcessor._generateItemMarkup(tableItems));
        }
        //triggers slider and prevents input render
        if (callBack) {
            callBack(itemId);
            return;
        }
        //add the Input for the name property for the currently created item
        const addedItemRow = document.querySelector(`.row-actions-handler-container[data-id="${itemId}"] .row-actions-segment`);
        if (addedItemRow) this._tableBodyEventProcessor.renderTableInput(addedItemRow, currentTable);
        //add body event listener for the table body items if they exist on page load
        if (!this._bodyEventListenerActive) {
            this.addBodyDelegationEventListener();
            this.setBodyEventListenerState(true);
        }
    }
    listen() {
        this._signals.activateListener("tablebody", this._tableBodyItemElement);
    }
    _generateMarkup(journals, currentTableId) {
        const headMarkup = this._generateHeadMarkup(journals, currentTableId);
        const markup = headMarkup + this._generateActionsMarkup();
        return markup;
    }
    _generateHeadMarkup(journals, currentTableId) {
        let journalsMarkup = "";
        const switchTableAdd = journals.length >= 5;
        journals = (0, $bd02c871d9c5ba8e$export$3c6dd118695d0c81)(journals, currentTableId);
        journals.forEach((journal, i)=>{
            const [journalName, journalId] = journal;
            const activeTable = (0, $bd02c871d9c5ba8e$export$4b9d67a8dfcf66c6)(currentTableId, journalId, i);
            if (i < 4) journalsMarkup += `
        <div class="table-row table-journal ${activeTable}" data-name="${journalName}" data-id="${journalId}">
          
          <div class="table-row-icon">
            ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("table-icon", "list-icon")}
          </div>
          <div class="table-row-text">${journalName}</div>
          ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("table-icon table-head-selector", "arrow-down")}
        </div>
      `;
        });
        if (!switchTableAdd) return `
        <div class="main-table-heading">
          ${journalsMarkup}
  
          <div class="table-column-adder table-row">
            ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("table-icon", "plus")}
          </div>
        </div>
      `;
        if (switchTableAdd) return `
        <div class="main-table-heading">
          ${journalsMarkup}
  
          <div class="table-column-options table-row">
          <div class="table-row-text">${journals.length - (0, $ba30e20475feac5a$export$32db47f5115d9b9f)} more...</div>
          </div>
        </div>
      `;
    }
    _generateBodyPlaceholder(placeholder = false) {
        return `
      <div role="rowgroup" class="rowfill">
        <div role="row">
            <div class="${placeholder ? "row-adder-filter" : "row-adder-content"}">
              <div class="row-adder-text color-dull">${placeholder ? (0, $ba30e20475feac5a$export$70effd399f9b6579) : (0, $ba30e20475feac5a$export$4d8370550bad0e65)}</div>
            </div>
        </div>
      </div>

    `;
    }
    _generateBodyMarkup(body = false, placeholder = false) {
        let markup = "";
        const tableBodyExists = document.querySelector(`[role="tablebody"]`);
        if (tableBodyExists) markup = this._generateBodyPlaceholder(placeholder);
        if (!tableBodyExists) markup = `
      <div role="tablebody">
        ${this._generateBodyPlaceholder(placeholder)}
      </div>
    `;
        const adderMarkup = `
      <div role="tableadd">
          <div role="rowgroup" class="rowfill">
            <div role="row" class="row-adder">
              <div class="row-adder-content">
                <div class="row-adder-icon">
                  ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("row-icon", "plus")}
                </div>
                <div class="row-adder-text color-dull">New</div>
              </div>
            </div>
          </div>
      </div>
    `;
        if (!body) return markup += adderMarkup;
        if (body) return markup;
    }
    _generateActionsMarkup() {
        return `
      <div class="main-table-actions">
        <div class="table-row table-action-row table-filter">
          <div class="table-row-text">Filter</div>
        </div>
        <div class="table-row table-action-row table-sort">
          <div class="table-row-text">Sort</div>
        </div>
        <div class="table-row table-action-row table-row-search">
          <div class="table-row-icon">
            ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("table-icon", "search-icon")}
          </div>
        </div>
        <div class="table-row-search--form table-action-row">
          <input type="text" class="search-input hide-search-input" placeholder="Type to search..." />
        </div>
        <div class="table-row-button table-action-row">
          <div class="table-button">
            <div class="table-button-content">
              <div class="table-button-text table-row-text">New</div>
            </div>
          </div>
        </div>
        <div class="table-row-options table-row">
          <div class="table-row-icon">
            ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("table-icon", "ellipsis")}
          </div>
        </div>

      </div>
    `;
    }
}
const $2d49e726836fb57f$export$6db5d748e242c31 = {
    import: ()=>new $2d49e726836fb57f$var$TableComponentView(),
    object: null
};





class $cc3231bfb767bcb8$var$JournalInfoComponentView {
    _parentElement = document.querySelector(".container-main-content .row");
    _eventHandlers;
    _events = [
        "keyup",
        "click"
    ];
    _timer;
    //init import of signal
    _signals = (0, $c5e51a03d827fa5f$export$df67e14a9d881936).object = (0, $c5e51a03d827fa5f$export$df67e14a9d881936).import();
    //signals to route sidebarclose event to sidebar component
    init(modelHandler) {
        modelHandler();
    }
    pass() {}
    addComponentHandlers(handlers) {
        this._eventHandlers = handlers;
    }
    addDelegationEventListener(e) {
        e.stopPropagation();
        this._events.find((evt)=>evt === e.type) ? this._handleEvents(e) : this.pass();
    }
    _handleEvents(e) {
        if (this._journalNameChangeMatchStrategy(e)) this._handleJournalEventDelay(e, this._handleJournalNameChangeEvent.bind(this), this._changeName) //this._handleJournalNameChangeEvent(e);
        ;
        if (this._journalDescChangeMatchStrategy(e)) this._handleJournalEventDelay(e, this._handleJournalDescChangeEvent.bind(this)); //this._handleJournalDescChangeEvent(e);
        this._signals.observe(e, "journalInfo");
    }
    _journalNameChangeMatchStrategy(e) {
        if (e.type === "keyup") {
            const matchStrategy = e.target.classList.contains("journal-title-input") || e.target.closest(".journal-title-input");
            return matchStrategy;
        }
    }
    _journalDescChangeMatchStrategy(e) {
        if (e.type === "keyup") {
            const matchStrategy = e.target.classList.contains("content-description-input") || e.target.closest(".content-description-input");
            return matchStrategy;
        }
    }
    _clearPreviousTimer() {
        clearInterval(this._timer);
        this._timer = null;
    }
    _handleJournalEventDelay(e, eventToTrigger, exec) {
        if (this._timer) this._clearPreviousTimer();
        if (exec) exec(e);
        this._timer = setTimeout(()=>{
            eventToTrigger(e);
        }, 2000);
    }
    _changeName(e) {
        const nameInputVal = e.target.textContent.trim();
        const sideBarJournalTitle = document.querySelector(".nav-options-journal .nav-options-text");
        const headerTitle = document.querySelector(".container-header .nav-options-text");
        headerTitle.textContent = nameInputVal.length > 0 ? (0, $bd02c871d9c5ba8e$export$b895d9282c5668b2)(nameInputVal, 24) : "Untitled";
        sideBarJournalTitle.textContent = nameInputVal.length > 0 ? (0, $bd02c871d9c5ba8e$export$b895d9282c5668b2)(nameInputVal, 14) : "Untitled";
    }
    _handleJournalNameChangeEvent(e) {
        const nameInputVal = e.target.textContent.trim();
        const payload = {
            name: nameInputVal
        };
        this._eventHandlers.controlUpdateJournalInfo(payload);
    }
    _handleJournalDescChangeEvent(e) {
        const descInputVal = e.target.innerHTML;
        const payload = {
            description: descInputVal
        };
        this._eventHandlers.controlUpdateJournalInfo(payload);
    }
    _generateHeader(journal) {
        return `
        <div class="container-header">
            <div class="nav-options-journal-icon">
              ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("journal-icon icon", "journal-icon")}
            </div>

            <div class="nav-options-text">${journal.name.length > 0 ? journal.name : "Untitled"}</div>
        </div>
    `;
    }
    _generateMainContent(journal) {
        return `
        <div class="main-content-info">
            <div class="main-content-heading">
              <div class="nav-options-journal-icon">
                ${(0, $bd02c871d9c5ba8e$export$576702248a2b11e2)("journal-icon icon", "journal-icon")}
              </div>

              <h2
                class="journal-title-input"
                contenteditable="true"
                placeholder="Untitled"
              >${journal.name.trim()}</h2>
            </div>
            <div class="main-content-description">
              <div
                class="content-description-input"
                contenteditable="true"
              >
                ${journal.description}
              </div>
            </div>
        </div>
    `;
    }
    render(model) {
        //add header
        const headerMarkup = this._generateHeader(model);
        const headerContainer = document.querySelector(".content-container .row");
        headerContainer.insertAdjacentHTML("afterbegin", headerMarkup);
        //add info
        const contentInfoMarkup = this._generateMainContent(model);
        this._parentElement.insertAdjacentHTML("afterbegin", contentInfoMarkup);
    }
}
const $cc3231bfb767bcb8$export$5fbf02ecfc8f146 = {
    import: ()=>new $cc3231bfb767bcb8$var$JournalInfoComponentView(),
    object: null
};










var $f1q41 = parcelRequire("f1q41");
class $28dcee160b6fe878$var$SyncLocalStorageToAPI {
    _container = document.querySelector(".container .row");
    _modelState;
    _diffState;
    _componentHandler = (0, $d2866451d1c7a9c0$export$721ff339e60fcc47).cls;
    _token;
    _syncNotifyActive = false;
    _init;
    _syncState = {
        count: 0
    };
    _eventListeners = [
        "click"
    ];
    startModelInit(init) {
        this._init = init;
        this._createLoader();
        this._loader.component();
        this._handleStartSync();
    }
    _completeSyncAndLoadData() {
        if (this._syncState.count <= 0) {
            this._syncState.count = 0;
            this._diffState.diffActive = false;
            if (!this._diffObj) {
                this._removeLoader();
                this._component.remove();
                if (this._persistDiff) this._persistDiff();
            }
            if (this._diffObj) {
                this._removeLoader();
                this._diffObj = this._diffState;
                if (this._persistDiff) this._persistDiff();
                this._init();
                this._clearInitData();
            }
        }
    }
    _clearInitData() {
        this._init = this._loader = this._modelState = this._diffState = this._diffObj = null;
    }
    notifyUIToSyncChanges() {
        if (this._syncNotifyActive) return;
        this._container.insertAdjacentElement("afterbegin", this._component);
    }
    component() {
        const cls = this;
        this._component = this._componentHandler.createHTMLElement(this._generateMarkup());
        this._eventListeners.forEach((ev)=>this._component.addEventListener(ev, cls._handleEvents.bind(cls)));
    }
    addModelData(modelState, diffState, diffObj, persistDiff, token) {
        this._modelState = modelState;
        this._diffState = diffState;
        this._diffObj = diffObj;
        this._persistDiff = persistDiff;
        if (!this._token && token) this._token = token;
    }
    _handleEvents(ev) {
        if ((0, $bd02c871d9c5ba8e$export$1cb11c76e8737f84)(ev, "btn-sync-now")) this._handleStartSync(ev);
        if ((0, $bd02c871d9c5ba8e$export$1cb11c76e8737f84)(ev, "btn-sync-later")) this._removeNotifier();
    }
    _initializeSyncProperties() {
        this.pendingTables = this._diffState.tableToCreate;
        this.pendingTableItems = this._diffState.tableItemToCreate;
        this.pendingTablesToDelete = this._diffState.tableToDelete;
        this.pendingTableItemToDelete = this._diffState.tableItemToDelete;
        this.pendingTableToUpdate = this._diffState.tableToUpdate;
        this.pendingTableItemToUpdate = this._diffState.tableItemToUpdate;
        this.pendingTableToDuplicate = this._diffState.pendingTableToDuplicate;
        this.pendingTableItemToDuplicate = this._diffState.pendingTableItemToDuplicate;
        this.pendingJournalInfoToUpdate = this._diffState.JournalInfoToUpdate;
        //submodels
        this.pendingSubmodelToCreate = this._diffState.submodelToCreate;
        this.pendingSubmodelToUpdate = this._diffState.submodelToUpdate;
        this.pendingSubmodelToDelete = this._diffState.submodelToDelete;
        //tags
        this.pendingTagsToDelete = Array.from(new Set(this._diffState.tagToDelete));
        this.pendingTagsToUpdate = this._diffState.tagsToUpdate;
        this.pendingTags = this._diffState.tagsToCreate;
        this.createPendingTable = [];
        this.createPendingTableToUpdate = [];
        this.createPendingTableItem = [];
        this.createPendingTableToUpdate = [];
        this.createPendingTags = [];
        this.createPendingTagsToUpdate = [];
        this.createPendingSubmodels = [];
        this.createPendingSubmodelsToUpdate = [];
        this.createPendingTableItemLinkedToAPITableItem = [];
        this.createPendingSubmodelLinkedToAPISubmodel = [];
        this.createPendingTableItemLinkedToAPITodoToUpdate = [];
        this.createTagsPayload = {
            payload: [],
            ids: []
        };
        this.createTagsToUpdatePayload = {
            payload: [],
            ids: []
        };
        this.createSubmodelsPayload = {
            payload: [],
            ids: []
        };
        this.createSubmodlsToUpdatePayload = {
            payload: [],
            ids: []
        };
    // this.createTodoPayload = { payload: [], ids: [] }
    // this.createTaskPayload = { payload: [], ids: [] }
    // this.createTodoToUpdatePayload = { payload: [], ids: [] };
    // this.createTaskToUpdatePayload = { payload: [], ids: [] };
    //
    }
    _handleStartSync() {
        if (!this._diffObj) {
            this._createLoader();
            this._loader.component();
        }
        //make new token request
        // this.
        this._initializeSyncProperties();
        this._filterProperties();
        this._createPropertiesPayload();
        this._makePropertiesRequest();
        //try to complete sync if no data is to be synced after request
        this._completeSyncAndLoadData();
    }
    _filterProperties() {
        /**Done */ //tag to create passes deleted check
        // this._filterDeletedObjectsFromObjects(this.pendingTags, this.pendingTagsToDelete, null, this.createPendingTags, "tags")
        //tag to update passes deleted check
        // this._filterDeletedObjectsFromObjects(this.pendingTagsToUpdate, this.pendingTagsToDelete, null, this.createPendingTagsToUpdate, "tags")
        /**End of done */ //submodels to create passes delete cheeck
        this._filterDeletedObjectsFromObjects(this.pendingSubmodelToCreate, this.pendingSubmodelToDelete, null, this.createPendingSubmodels, "submodels");
        //submodels to update passes delete cheeck
        this._filterDeletedObjectsFromObjects(this.pendingSubmodelToUpdate, this.pendingSubmodelToDelete, null, this.createPendingSubmodelsToUpdate, "submodels");
    // this._filterDeletedObjectsFromObjects(this.pendingTodoToUpdate, this.pendingTodosToDelete, null, this.createPendingTodosToUpdate, "todo")
    //
    // task to create passes deleted check
    // this._filterDeletedObjectsFromObjects(this.pendingTasks, this.pendingTasksToDelete, this.pendingTodosToDelete, this.createPendingTasks, "task")
    //
    // task to update passes deleted check
    // this._filterDeletedObjectsFromObjects(this.pendingTaskToUpdate, this.pendingTasksToDelete, this.pendingTodosToDelete, this.createPendingTasksToUpdate, "task")
    }
    _createPropertiesPayload() {
        //create tags payload
        this._createTagsPayload(this.createPendingTags, this.createTagsPayload);
        //create tags update payload
        this._createTagToUpdatePayload(this.createPendingTagsToUpdate, this.createPendingTags, this.createTagsToUpdatePayload);
        //create submodels payload
        this._createSubmodelsPayload(this.createPendingSubmodels, this.createSubmodelsPayload);
    //create submodels update payload
    // this._createTodoPayload(this.pendingTodos, this.createPendingTodos, this.createTodoPayload)
    //create todo to update payload
    // this._createTodoUpdatePayload(this.pendingTodoToUpdate, this.createPendingTodosToUpdate, this.createPendingTodos, this.createTodoToUpdatePayload)
    //sort tasks which are not linked to todos to create
    // this._filterPendingTaskLinkedToAPITodo(this.pendingTasks, this.createPendingTasks, this.createPendingTodos, this.createPendingTaskLinkedToAPITodo)
    //sort tasks which are not linked to todos to update
    // this._filterPendingTaskLinkedToAPITodo(this.pendingTaskToUpdate, this.createPendingTasksToUpdate, this.createPendingTodos, this.createPendingTaskLinkedToAPITodoToUpdate)
    //task not linked to todos to create payload body
    // this._createTaskLinkedToAPITodoBody(this.pendingTasks, this.createPendingTaskLinkedToAPITodo, this.createTaskPayload)
    //sort tasks which are to be updated not in createPendingTaskLinkedToAPITodo Array
    // this._createTaskToUpdateBody(this.pendingTaskToUpdate, this.createPendingTaskLinkedToAPITodoToUpdate, this.createPendingTaskLinkedToAPITodo, this.createTaskToUpdatePayload)
    }
    _makePropertiesRequest() {
        //create batch tags
        this._makeTagRequest(this.createTagsPayload, this.pendingTags, "POST");
        //batch delete tags
        this._makeTagRequest(this.pendingTagsToDelete, this.pendingTagsToDelete, "DELETE");
        //update batch tags
        this._makeTagRequest(this.createTagsToUpdatePayload, this.pendingTagsToUpdate, "PATCH");
    //create batch taskToCreate
    // this._makeTaskToCreateRequest(this.createTaskPayload, this.pendingTasks)
    //
    // create batch taskToDelete
    // this._makeTaskToDeleteRequest(this.pendingTasksToDelete)
    //
    // create batch taskToUpdate
    // this._makeTaskToUpdateRequest(this.createTaskToUpdatePayload, this.pendingTaskToUpdate)
    //
    // update ordering todo
    // if (this.pendingTodoOrdering.length > 0) {
    // this._syncState.count += 1
    // this._makeOrderingUpdateRequest(this.pendingTodoOrdering, "todo", this._updateTodoOrderingBatchCallback)
    // }
    //update ordering task
    // if (this.pendingTaskOrdering.length > 0) {
    // this._syncState.count += 1
    // this._makeOrderingUpdateRequest(this.pendingTaskOrdering, "task", this._updateTaskOrderingBatchCallBack)
    // }
    }
    _batchTagRequestCallBack(diffPayload, requestMethod, returnData, requestState = false) {
        if (requestState) {
            if (requestMethod === "POST") {
                returnData.forEach((data)=>{
                    //replace model data for other diffs that need to call the api with the updated data
                    const formattedReturnData = (0, $bd02c871d9c5ba8e$export$8c27844e107da08)(data, "apiTags");
                    const modelItemIndex = this._modelState.tags.findIndex((modelTag)=>modelTag.text.toLowerCase() === data.tag_name.toLowerCase());
                    this._modelState.tags.splice(modelItemIndex, 1);
                    this._modelState.tags.splice(modelItemIndex, 0, formattedReturnData);
                });
                //TODO: match diff data that need tags with text
                this._diffState.pendingTags = [];
                this._syncState.count -= 1;
            }
            if (requestMethod === "PATCH") {
                returnData.forEach((data)=>{
                    const formattedReturnData = (0, $bd02c871d9c5ba8e$export$8c27844e107da08)(data, "apiTags");
                    const modelItemIndex = this._modelState.tags.findIndex((modelTag)=>modelTag.id === data.id);
                    this._modelState.tags.splice(modelItemIndex, 1);
                    this._modelState.tags.splice(modelItemIndex, 0, formattedReturnData);
                });
                this._diffState.pendingTags = [];
                this._syncState.count -= 1;
            }
            if (requestMethod === "DELETE") {
                this._diffState.pendingTags = [];
                this._syncState.count -= 1;
            }
        }
    }
    _makeTagRequest(tagPayload, diffPayload, requestMethod) {
        const payloadLength = tagPayload?.length ? tagPayload.length > 0 : tagPayload?.payload?.length > 0;
        if (payloadLength) {
            this._makeBatchRequest((0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.TAG.BATCH_TAG, this._batchRequestWrapper(tagPayload?.payload ?? tagPayload, "tags"), diffPayload, "batchTags", this._batchTagRequestCallBack.bind(this, diffPayload, requestMethod), requestMethod, true);
            this._syncState.count += 1;
        }
    }
    _makeTodoCreateRequest(createTodoPayload, pendingTodos) {
        //create batch todoToCreate
        if (createTodoPayload.payload.length > 0) {
            const createTodoPayloadLength = createTodoPayload.payload.length;
            if (createTodoPayloadLength > 1) {
                this._makeBatchRequest((0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.TODO.BATCH_CREATE, this._batchRequestWrapper(createTodoPayload.payload, "batch_create"), pendingTodos, "createBatchTodo", this._createTodoBatchCallBack.bind(this, createTodoPayload.ids), "POST", true);
                this._syncState.count += 1;
            }
            if (createTodoPayloadLength == 1) {
                this._makeBatchRequest((0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.TODO.CREATE, createTodoPayload.payload[0], pendingTodos, "createTodo", this._createTodoBatchCallBack.bind(this, createTodoPayload.ids), "POST", true);
                this._syncState.count += 1;
            }
        }
    }
    _makeTodoDeleteRequest(pendingTodosToDelete) {
        //create batch todoToDelete
        if (pendingTodosToDelete.length > 0) {
            const todosToDeleteLength = pendingTodosToDelete.length;
            //if todo doesn't exist in API it should return a NOT FOUND so no need to keep track of type of todo
            if (todosToDeleteLength > 1) {
                this._makeBatchRequest((0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.TODO.BATCH_DELETE, this._batchRequestWrapper(pendingTodosToDelete, "batch_delete"), pendingTodosToDelete, "deleteTodoBatch", this._deleteTodoBatchCallBack.bind(this, pendingTodosToDelete), "DELETE", true);
                this._syncState.count += 1;
            }
            if (todosToDeleteLength == 1) {
                this._makeBatchRequest((0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.TODO.DELETE(pendingTodosToDelete[0]), pendingTodosToDelete[0], pendingTodosToDelete, "deleteTodo", this._deleteTodoBatchCallBack.bind(this, pendingTodosToDelete[0]), "DELETE", true);
                this._syncState.count += 1;
            }
        }
    }
    _makeTodoUpdateRequest(createTodoToUpdatePayload, pendingTodoToUpdate) {
        //create batch todoUpdate
        if (createTodoToUpdatePayload.payload.length > 0) {
            const todosToUpdateLength = createTodoToUpdatePayload.payload.length;
            if (todosToUpdateLength > 1) {
                this._makeBatchRequest((0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.TODO.BATCH_UPDATE, this._batchRequestWrapper(createTodoToUpdatePayload.payload, "batch_update"), pendingTodoToUpdate, "updateBatchTodo", this._updateTodoBatchCallBack.bind(this, createTodoToUpdatePayload.ids), "PATCH", true);
                this._syncState.count += 1;
            }
            if (todosToUpdateLength == 1) {
                this._makeBatchRequest((0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.TODO.PATCH(Number(createTodoToUpdatePayload.payload[0].id)), createTodoToUpdatePayload.payload[0], pendingTodoToUpdate, "updateTodo", this._updateTodoBatchCallBack.bind(this, createTodoToUpdatePayload.ids), "PATCH", true);
                this._syncState.count += 1;
            }
        }
    }
    _makeTaskToCreateRequest(createTasksPayload, pendingTasks) {
        //create batch taskToCreate
        if (createTasksPayload.payload.length > 0) {
            const tasksToCreateLength = createTasksPayload.payload.length;
            if (tasksToCreateLength > 1) {
                this._makeBatchRequest((0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.TASK.BATCH_CREATE, this._batchRequestWrapper(createTasksPayload.payload, "batch_create"), pendingTasks, "createBatchTask", this._createTaskBatchCallBack.bind(this, createTasksPayload.ids), "POST", true);
                this._syncState.count += 1;
            }
            if (tasksToCreateLength == 1) {
                this._makeBatchRequest((0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.TASK.CREATE, createTasksPayload.payload[0], pendingTasks, "createTask", this._createTaskBatchCallBack.bind(this, createTasksPayload.ids), "POST", true);
                this._syncState.count += 1;
            }
        }
    }
    _makeTaskToDeleteRequest(pendingTasksToDelete) {
        //create batch taskToDelete
        if (pendingTasksToDelete.length > 0) {
            const tasksToDeleteLength = pendingTasksToDelete.length;
            const pendingTasksToDeletePayload = pendingTasksToDelete.map((task)=>task.taskId);
            if (tasksToDeleteLength > 1) {
                this._makeBatchRequest((0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.TASK.BATCH_DELETE, this._batchRequestWrapper(pendingTasksToDeletePayload, "batch_delete"), pendingTasksToDelete, "deleteBatchTask", this._deleteTaskBatchCallBack.bind(this, pendingTasksToDelete), "DELETE", true);
                this._syncState.count += 1;
            }
            if (tasksToDeleteLength == 1) {
                this._makeBatchRequest((0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.TASK.DELETE(pendingTasksToDeletePayload[0]), pendingTasksToDeletePayload[0], pendingTasksToDelete, "deleteTask", this._deleteTaskBatchCallBack.bind(this, pendingTasksToDelete), "DELETE", true);
                this._syncState.count += 1;
            }
        }
    }
    _makeTaskToUpdateRequest(createTaskToUpdatePayload, pendingTaskToUpdate) {
        //create batch taskToUpdate
        if (pendingTaskToUpdate.length > 0) {
            const taskToUpdateLength = createTaskToUpdatePayload.payload.length;
            if (taskToUpdateLength > 1) {
                this._makeBatchRequest((0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.TASK.BATCH_UPDATE, this._batchRequestWrapper(createTaskToUpdatePayload.payload, "batch_update"), pendingTaskToUpdate, "updateBatchTask", this._updateTaskBatchCallBack.bind(this, createTaskToUpdatePayload.ids), "PATCH", true);
                this._syncState.count += 1;
            }
            if (taskToUpdateLength == 1) {
                this._makeBatchRequest((0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.TASK.PATCH(createTaskToUpdatePayload.payload[0].id), createTaskToUpdatePayload.payload[0], pendingTaskToUpdate, "updateTask", this._updateTaskBatchCallBack.bind(this, createTaskToUpdatePayload.ids), "PATCH", true);
                this._syncState.count += 1;
            }
        }
    }
    _getOrderingUrlFromType(orderingLength, orderingType, objId) {
        if (orderingLength > 1) {
            if (orderingType === "todo") return (0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.TODO.BATCH_UPDATE_ORDERING;
            if (orderingType === "task") return (0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.TASK.BATCH_UPDATE_ORDERING;
        }
        if (orderingLength === 1) {
            if (orderingType === "todo") return (0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.TODO.PATCH(objId);
            if (orderingType === "task") return (0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.TASK.PATCH(objId);
        }
    }
    _makeOrderingUpdateRequest(orderingPayload, type, orderingCallBack) {
        if (orderingPayload.length > 1) this._makeBatchRequest(this._getOrderingUrlFromType(orderingPayload.length, type), this._batchRequestWrapper(orderingPayload, "batch_update_ordering"), null, "updateOrdering", orderingCallBack, "PATCH", true);
        if (orderingPayload.length === 1) this._makeBatchRequest(this._getOrderingUrlFromType(orderingPayload.length, type, orderingPayload[0].id), orderingPayload, null, "updateOrdering", orderingCallBack, "PATCH", true);
    }
    _formatBatchCreatedReturnData(returnData, objType) {
        let formattedReturnedData = [];
        if (Array.isArray(returnData)) returnData.forEach((data, i)=>formattedReturnedData.push((0, $bd02c871d9c5ba8e$export$dad11d50b7e7c865)(data, objType)));
        if (!Array.isArray(returnData)) formattedReturnedData.push((0, $bd02c871d9c5ba8e$export$dad11d50b7e7c865)(returnData, objType));
        return formattedReturnedData;
    }
    _createTodoBatchCallBack(payloadIds, returnData, requestStatus) {
        if (requestStatus) {
            const formattedReturnedData = this._formatBatchCreatedReturnData(returnData, "todo");
            payloadIds.forEach((payloadId, i)=>{
                let todo = this._modelState.todo.find((todoId)=>todoId.todoId === payloadId);
                if (todo) todo = formattedReturnedData[i];
                if (this.pendingTodoOrdering.length > 0) {
                    const todoOrderingIdUpdateIfCreatedByFallback = this.pendingTodoOrdering.find((todoOrder)=>todoOrder.id === payloadId);
                    if (todoOrderingIdUpdateIfCreatedByFallback) todoOrderingIdUpdateIfCreatedByFallback.id = todo.todoId;
                }
            });
            //clear the data from the diff
            this._diffState.todoToCreate = [];
        }
        this._syncState.count -= 1;
        this._completeSyncAndLoadData();
    }
    _deleteTodoBatchCallBack(deletePayload, returnData, requestStatus) {
        if (requestStatus) this._diffState.todoToDelete = [];
        this._syncState.count -= 1;
        this._completeSyncAndLoadData();
    }
    _updateTodoBatchCallBack(payloadIds, returnData, requestStatus) {
        if (requestStatus) this._diffState.todoToUpdate = [];
        this._syncState.count -= 1;
        this._completeSyncAndLoadData();
    }
    _updateTodoOrderingBatchCallback(returnData, requestStatus) {
        if (requestStatus) this._diffState.todoOrdering = [];
        this._syncState.count -= 1;
        this._completeSyncAndLoadData();
    }
    _createTaskBatchCallBack(payloadIds, returnData, requestStatus) {
        if (requestStatus) {
            const formattedReturnedData = this._formatBatchCreatedReturnData(returnData, "task");
            payloadIds.forEach((payloadId, i)=>{
                let task = this._filterToGetTaskBody(payloadId.taskId, payloadId.todoId, false);
                if (task) task = formattedReturnedData[i];
                if (this.pendingTaskOrdering.length > 0) {
                    const taskOrderingIdUpdateIfCreatedByFallback = this.pendingTaskOrdering.find((taskOrder)=>taskOrder.id === payloadId.taskId);
                    if (taskOrderingIdUpdateIfCreatedByFallback) taskOrderingIdUpdateIfCreatedByFallback.id = task.taskId;
                }
            });
            //clear the data from the diff
            this._diffState.taskToCreate = [];
        }
        this._syncState.count -= 1;
        this._completeSyncAndLoadData();
    }
    _deleteTaskBatchCallBack(payloadIds, returnData, requestStatus) {
        if (requestStatus) this._diffState.taskToDelete = [];
        this._syncState.count -= 1;
        this._completeSyncAndLoadData();
    }
    _updateTaskBatchCallBack(payloadIds, returnData, requestStatus) {
        if (requestStatus) this._diffState.taskToUpdate = [];
        this._syncState.count -= 1;
        this._completeSyncAndLoadData();
    }
    _updateTaskOrderingBatchCallBack(returnData, requestStatus) {
        if (requestStatus) this._diffState.taskOrdering = [];
        this._syncState.count -= 1;
        this._completeSyncAndLoadData();
    }
    _filterDeletedObjectsFromObjects(object, deletedObjects, deletedObjectParent, returnList, objectType) {
        if (object.length > 0) {
            const deletedObjectsExists = deletedObjects.length > 0;
            if (deletedObjectsExists) object.forEach((obj)=>{
                let deletedObjectExistsInObject;
                if (objectType.toLowerCase() !== "submodels") deletedObjectExistsInObject = deletedObjects.some((deletedObjId)=>this._returnDeleteObjId(objectType, deletedObjId) === this._returnObjType(objectType, obj));
                if (objectType.toLowerCase() === "submodels") {
                    const deletedObjectsWithSameModels = deletedObjects.filter((delObj)=>delObj.subModel.toLowerCase() === obj.subModel.toLowerCase());
                    deletedObjectExistsInObject = deletedObjectsWithSameModels.some((delObj)=>delObj.id === obj.id);
                }
                if (!deletedObjectExistsInObject) returnList.push(obj);
            });
            if (!deletedObjectsExists) returnList.push(...object); // && objectType === "todo"
            //FIXME: adapt to code
            if (objectType === "tableItems" && returnList.length > 0) for(let i = returnList.length - 1; i > -1; i--){
                const taskTodoIdInTodoToDeleteExists = deletedObjectParent.some((objId)=>objId === returnList[i].todoId);
                //check against null values
                if (Object.keys(returnList[i]).includes("todoId")) {
                    if (!returnList[i]?.todoId) returnList.splice(i, 1);
                }
                if (taskTodoIdInTodoToDeleteExists) returnList.splice(i, 1);
            }
        }
    }
    _createTagsPayload(tagsToCreateFilteredArray, tagsToCreatePayloadArray) {
        //create tag payload
        if (tagsToCreateFilteredArray.length > 0) tagsToCreateFilteredArray.forEach((tag)=>{
            //get tag from modelStatee
            const modelTags = this._modelState.tags;
            const tagModelIndex = modelTags.findIndex((modelTag)=>modelTag.id === tag.id);
            const tagBody = modelTags[tagModelIndex];
            tagsToCreatePayloadArray.ids.push(tagBody.id);
            //add formatted data to tags to create
            const formattedTagBody = (0, $bd02c871d9c5ba8e$export$da1e021e040b8232)(tagBody, true, this._modelState.tagsColor);
            tagsToCreatePayloadArray["payload"].push(formattedTagBody);
        });
        else this._diffState.tagsToCreate = [];
    }
    _createTagToUpdatePayload(tagToUpdateFilteredArray, tagToCreateFilteredArray, tagToUpdatePayloadArray) {
        if (tagToUpdateFilteredArray.length > 0) tagToUpdateFilteredArray.forEach((tag)=>{
            const tagToUpdateExistsInTagToCreate = tagToCreateFilteredArray.some((createTag)=>createTag.id === tag.id);
            if (!tagToUpdateExistsInTagToCreate) {
                tagToUpdatePayloadArray.ids.push(tag.id);
                tagToUpdatePayloadArray.payload.push((0, $bd02c871d9c5ba8e$export$da1e021e040b8232)(tag, true, this._modelState.tagsColor));
            }
            if (tagToUpdateExistsInTagToCreate) {
                const tagIndex = tagToUpdateFilteredArray.findIndex((updateTag)=>updateTag.id === tag.id);
                tagToUpdateFilteredArray.splice(tagIndex, 1);
            }
        });
        else this._diffState.tagsToUpdate = [];
    }
    _createSubmodelsPayload(submodelsToCreateFilteredArray, submodelsToCreatePayloadArray) {
        //create submodel payload
        if (submodelsToCreateFilteredArray.length > 0) submodelsToCreateFilteredArray.forEach((submodel)=>{
            //get submodel from modelState
            const subModelTable = this._modelState.tables.find((table)=>table.id === submodel.table);
            //TODO: get the submodel type from the payload
            const subModelTableItem = subModelTable.tableItems.find((tableItem)=>tableItem.id === submodel.item);
            const subModelItem = subModelTableItem[submodel.subModel].find((id)=>id === submodel.id);
            const submodelPayload = subModelItem;
        });
    }
    _createTodoUpdatePayload(todoToUpdateDiffArray, todoToUpdateFilteredArray, todoToCreateFilteredArray, todoToUpdatePayloadArray) {
        //create todo to update payload
        if (todoToUpdateDiffArray.length > 0 && todoToUpdateFilteredArray.length > 0) todoToUpdateFilteredArray.forEach((todo)=>{
            const todoToUpdateExistsInTodoToCreate = todoToCreateFilteredArray.some((pendingTodo)=>pendingTodo.todoId === todo.todoId);
            if (!todoToUpdateExistsInTodoToCreate) {
                todoToUpdatePayloadArray.payload.push((0, $bd02c871d9c5ba8e$export$afb3565a72efce83)(todo, "todo", "update"));
                todoToUpdatePayloadArray.ids.push(todo.todoId);
            }
            if (todoToUpdateExistsInTodoToCreate) {
                //fallback for removing the object from the diffState if it already exists elsewhere
                const todoIndex = todoToUpdateDiffArray.findIndex((updateTodo)=>updateTodo.todoId === todo.todoId);
                if (todoIndex > -1) this._diffState.todoToUpdate.splice(todoIndex, 1);
            }
        });
        else this._diffState.todoToUpdate = [];
    }
    _filterPendingTaskLinkedToAPITodo(tasksToCreateDiffArray, tasksToCreateFilteredArray, todoToCreateFilteredArray, pendingTaskLinkedToAPITodoArray) {
        //sort tasks which are not linked to todos to create
        if (tasksToCreateDiffArray.length > 0 && tasksToCreateFilteredArray.length > 0) tasksToCreateFilteredArray.forEach((task)=>{
            const pendingTaskTodoExistsInPendingTodos = todoToCreateFilteredArray.some((todo)=>todo.todoId === task.todoId);
            if (!pendingTaskTodoExistsInPendingTodos) pendingTaskLinkedToAPITodoArray.push(task);
        });
    }
    _createTaskLinkedToAPITodoBody(taskToCreateDiffArray, pendingTaskLinkedToAPITodoArray, taskToCreatePayloadArray) {
        //task not linked to todos to create payload body
        if (taskToCreateDiffArray.length > 0 && pendingTaskLinkedToAPITodoArray.length > 0) pendingTaskLinkedToAPITodoArray.forEach((task)=>{
            const taskBody = this._filterToGetTaskBody(task.taskId, task.todoId);
            if (taskBody) {
                taskToCreatePayloadArray.ids.push({
                    taskId: task.taskId,
                    todoId: task.todoId
                });
                //add todoId to taskBody
                taskBody.todoId = task.todoId;
                //remove id from task
                delete taskBody.taskId;
                //add formatted data to tasks to create
                taskToCreatePayloadArray.payload.push((0, $bd02c871d9c5ba8e$export$afb3565a72efce83)(taskBody, "task", "create"));
            }
            if (!taskBody) {
                //fallback for deleting the task from the diffState incase the task has already been deleted and passed through the filter
                const taskIndex = this._diffState.taskToCreate.findIndex((createTask)=>createTask.taskId === task.taskId);
                if (taskIndex > -1) this._diffState.taskToCreate.splice(taskIndex, 1);
            }
        });
        else this._diffState.taskToCreate = [];
    }
    _createTaskToUpdateBody(taskToUpdateDiffArray, pendingTaskLinkedToAPITodoToUpdate, pendingTaskLinkedToAPITodo, taskToUpdatePayloadArray) {
        //sort tasks which are to be updated not in createPendingTaskLinkedToAPITodo Array
        if (taskToUpdateDiffArray.length > 0 && pendingTaskLinkedToAPITodoToUpdate.length > 0) pendingTaskLinkedToAPITodoToUpdate.forEach((task)=>{
            // const taskToUpdateExists
            const taskToUpdateExistsInTaskAPITodo = pendingTaskLinkedToAPITodo.some((APITodoTask)=>APITodoTask.taskId === task.taskId);
            if (!taskToUpdateExistsInTaskAPITodo) {
                const taskBody = this._filterToGetTaskBody(task.taskId, task.todoId);
                if (taskBody) {
                    taskToUpdatePayloadArray.ids.push({
                        taskId: task.taskId,
                        todoId: task.todoId
                    });
                    //add the time added to the taskBody
                    taskBody.todoLastAdded = task.todoLastAdded;
                    //remove id from task
                    // delete taskBody.taskId
                    taskToUpdatePayloadArray.payload.push((0, $bd02c871d9c5ba8e$export$afb3565a72efce83)(taskBody, "task", "update"));
                }
                if (!taskBody) {
                    //fallback for deleting objects from the diffState if they passed through the filter
                    const taskIndex = this._diffState.taskToUpdate.findIndex((updateTask)=>updateTask.taskId === task.taskId);
                    if (taskIndex > -1) this._diffState.taskToUpdate.splice(taskIndex, 1);
                }
            }
        });
        else this._diffState.taskToUpdate = [];
    }
    _filterToGetTaskBody(taskId, todoId, clone = true) {
        //get todo from modelState
        const modelTodos = this._modelState.todo;
        const todoModelIndex = this._modelState.todo.findIndex((modelTodo)=>modelTodo.todoId === todoId);
        const taskIndex = modelTodos[todoModelIndex].tasks.findIndex((modelTask)=>modelTask.taskId === taskId);
        if (!clone) return modelTodos[todoModelIndex]?.tasks[taskIndex];
        const taskBody = modelTodos[todoModelIndex]?.tasks[taskIndex];
        return taskBody ? (0, $f1q41.cloneDeep)(taskBody) : taskBody;
    }
    _makeBatchRequest(requestURL, requestPayload, requestDiffArray, requestActionType, requestCallBack, requestType, requestCallBackParam = false) {
        const queryObj = {
            endpoint: requestURL,
            token: this._token.value,
            sec: 5,
            actionType: requestActionType,
            queryData: requestPayload,
            callBack: requestCallBack.bind(this),
            spinner: false,
            alert: false,
            type: requestType,
            callBackParam: requestCallBackParam
        };
        (0, $db1f432b457e32b4$export$2c4e825dc9120f87).queryAPI(queryObj);
    }
    _wrapper(wrapperName, requestBody) {
        const wrapper = {};
        wrapper[wrapperName] = requestBody;
        return wrapper;
    }
    _batchRequestWrapper(requestBody, requestType) {
        if (requestType === "tags") return this._wrapper("tags_list", requestBody);
        if (requestType === "batch_update") return this._wrapper("update_list", requestBody);
        if (requestType === "batch_update_ordering") return this._wrapper("ordering_list", requestBody);
        if (requestType === "batch_create") return this._wrapper("create_list", requestBody);
        if (requestType === "batch_delete") return this._wrapper("delete_list", requestBody);
    }
    updateAndGetToken() {}
    _returnObjType(objType, obj) {
        if (objType === "tags") return obj.id;
        if (objType === "task") return obj.taskId;
    }
    _returnDeleteObjId(objType, deleteObj) {
        if (objType === "tags") return deleteObj;
        if (objType === "task") return deleteObj.taskId;
    }
    _generateMarkup() {
        return `
                <div class="sync-alert">
                    <div class="sync-msg">
                      Network Connectivity Issue Detected, its advisable to save data now to prevent data Loss If connectivity Still available
                    </div>
                    <div class="sync-btns">
                      <button class="btn-sync btn-sync-now bd-radius">Sync Now</button>
                      <button class="btn-sync btn-sync-later bd-radius">Sync Later</button>
                    </div>
                </div>
            `;
    }
    _createLoader() {
        this._loader = new (0, $6d26a31173b096a8$export$3b0d6d7590275603)(null, null, true);
    }
    _removeLoader() {
        if (this._loader) this._loader.remove();
        this._loader = null;
    }
    _removeNotifier() {
        const cls = this;
        this._eventListeners.forEach((ev)=>this._component.removeEventListener(ev, cls._handleEvents));
        this._component.remove();
        this._syncNotifyActive = false;
    }
    remove() {
        this._removeNotifier();
        this._component = null;
        delete this;
    }
}
const $28dcee160b6fe878$export$2a320cc9f8744ee5 = ()=>new $28dcee160b6fe878$var$SyncLocalStorageToAPI();





class $c44b042802bfa45d$var$Login {
    _listenerNodes = [];
    _eventListeners = [
        "click",
        "keyup"
    ];
    _children = [];
    pass() {}
    updateListenerNodeState(node, handler, temp = false) {
        const nodeExists = this._listenerNodes.find((listenerNode)=>listenerNode.node === node);
        if (nodeExists) return;
        const nodeObj = {};
        nodeObj.node = node;
        nodeObj.ev = this._eventListeners;
        nodeObj.handler = handler;
        nodeObj.temp = temp;
        this._listenerNodes.push(nodeObj);
    }
    addEventListeners(controlHandler) {
        //handler that gets called on login
        this.controlHandler = controlHandler.bind(this, this.remove.bind(this));
        const cls = this;
        const loginBtns = document.querySelectorAll(".cta-btn");
        //each node should return self
        loginBtns.forEach((btn)=>{
            this._eventListeners.forEach((ev)=>btn.addEventListener(ev, this._handleEvents.bind(cls)));
            this.updateListenerNodeState(btn, this._handleEvents);
        });
    }
    _handleEvents(ev) {
        ev.stopPropagation();
        //login ev
        if ((0, $bd02c871d9c5ba8e$export$a621ca3319930c36)(ev, "cta-btn")) this.handleAuth(ev.target.textContent.trim().toLowerCase());
        //reset ev
        if ((0, $bd02c871d9c5ba8e$export$a621ca3319930c36)(ev, "btn-reset")) this.handleAuth("reset");
    }
    handleAuth(authType) {
        this._removeChildren();
        this._generateAuthComponent(authType);
        this.form.component();
        //add event to temp node
        if (authType === "login") this._insertTempNodeToComponent(this.form.getComponent().querySelector(".btn-reset"), "click");
        this._overlay = new (0, $09d840f20da32b41$export$c6fdb837b070b4ff)(this.form);
        this._children.push(this._overlay);
        this._overlay.render();
    }
    _handleResetCallBack() {
        this._removeChildren();
        this.remove(true);
    // this._reRenderComponentContent("login")
    }
    _generateAuthComponent(authType) {
        this._removeChildren();
        if (this.form) this.form.remove(true);
        this.form = (0, $a90ba183c2615987$export$a7fed597f4b8afd8).form(authType);
        //add control handler to form
        this.form.addControlHandler(this._getFormCallBack(authType));
        this._children.push(this.form);
    }
    _reRenderComponentContent(authType) {
        this._generateAuthComponent(authType);
    }
    _getFormCallBack(authType) {
        if (authType === "reset") return this._handleResetCallBack.bind(this);
        return this.controlHandler;
    }
    getComponent() {
        return this._component;
    }
    component(formComponent, cls) {
        return this._component;
    }
    _insertTempNodeToComponent(tempNode, eventType = false) {
        const cls = this;
        if (eventType) tempNode.addEventListener(eventType, cls._handleEvents.bind(cls));
        if (!eventType) this._eventListeners.forEach((ev)=>tempNode.addEventListener(ev, cls._handleEvents.bind(cls)));
        this.updateListenerNodeState(tempNode, cls._handleEvents, true);
    }
    _removeTempNodes() {
        const cls = this;
        const tempNodes = [];
        this._listenerNodes.forEach((node, i)=>node.temp === true ? tempNodes.push([
                node,
                i
            ]) : this.pass());
        tempNodes.forEach((node, i)=>{
            node[0].ev.forEach((nodeEv)=>node[0].node.removeEventListener(nodeEv, cls._handleEvents));
            node[0].node.remove(true);
            tempNodes.splice(i, 1);
            this._listenerNodes.splice(node[1], 1);
        });
    }
    _removeResetActive() {
        this._component.classList.remove("reset-active");
    }
    _removeChildren() {
        for(let i = this._children.length - 1; i > -1; i--){
            this._children[i].remove(true);
            this._children.splice(i, 1);
        }
    }
    remove(children = false) {
        if (children) this._removeChildren();
        if (!children) {
            this._listenerNodes.forEach((listenerNode)=>{
                listenerNode.ev.forEach((e)=>listenerNode.node.removeEventListener(e, listenerNode.handler));
            });
            this._removeChildren();
            this._removeTempNodes();
            delete this;
        }
    }
}
var $c44b042802bfa45d$export$2e2bcd8739ae039 = new $c44b042802bfa45d$var$Login();





parcelRequire("f1q41");
let $f50bd1f2915ed0f2$var$contentContainerListener;
let $f50bd1f2915ed0f2$var$sidebarComponentView;
let $f50bd1f2915ed0f2$var$tableComponentView;
let $f50bd1f2915ed0f2$var$journalInfoComponentView;
let $f50bd1f2915ed0f2$var$syncComponentView;
const $f50bd1f2915ed0f2$var$pass = ()=>{};
const $f50bd1f2915ed0f2$var$controlGetJournalNameAndUsername = function() {
    return {
        journalName: $0f1d4402dffacf5b$export$ca000e230c0caa3e.name,
        username: $0f1d4402dffacf5b$export$ca000e230c0caa3e.username
    };
};
const $f50bd1f2915ed0f2$var$controlUpdateJournalInfo = function(updateVal) {
    const apiPayload = {};
    if (updateVal.name) apiPayload.journal_name = updateVal.name;
    if (updateVal.description) apiPayload.journal_description = updateVal.description;
    const queryObj = {
        endpoint: (0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.JOURNAL.PATCH($0f1d4402dffacf5b$export$ca000e230c0caa3e.id),
        token: $0f1d4402dffacf5b$export$9e1725a4cfeada27.value,
        sec: null,
        queryData: apiPayload,
        actionType: "updateJournalInfo",
        spinner: false,
        alert: true,
        successAlert: false,
        type: "PATCH"
    };
    (0, $db1f432b457e32b4$export$2c4e825dc9120f87).queryAPI(queryObj);
};
const $f50bd1f2915ed0f2$var$controlGetModel = function() {
    return $0f1d4402dffacf5b$export$ca000e230c0caa3e;
};
const $f50bd1f2915ed0f2$var$controlAddSideBar = function() {
    $f50bd1f2915ed0f2$var$sidebarComponentView.render($f50bd1f2915ed0f2$var$controlGetJournalNameAndUsername());
};
const $f50bd1f2915ed0f2$var$controlAddJournalInfo = function() {
    $f50bd1f2915ed0f2$var$journalInfoComponentView.render($f50bd1f2915ed0f2$var$controlGetModel());
};
const $f50bd1f2915ed0f2$var$controlGetTableHeads = function() {
    return $0f1d4402dffacf5b$export$ca000e230c0caa3e.tables.map((table)=>[
            table.tableTitle,
            table.id
        ]);
};
const $f50bd1f2915ed0f2$var$controlRenderUpdatedTableHeads = (tableId)=>{
    let tableHeads;
    $0f1d4402dffacf5b$export$8d21f17684deada9(+tableId);
    const getTable = $0f1d4402dffacf5b$export$a8d54db9d8ae6ee7(+tableId);
    const formatTable = [
        getTable.tableTitle,
        getTable.id
    ];
    tableHeads = $f50bd1f2915ed0f2$var$controlGetTableHeads();
    if (tableHeads.length > 4) tableHeads = (0, $bd02c871d9c5ba8e$export$ea06af93a82ca6d)(tableHeads, formatTable);
    $f50bd1f2915ed0f2$var$tableComponentView.render(tableHeads, getTable);
    $f50bd1f2915ed0f2$var$tableComponentView.renderTableItem(getTable.tableItems);
};
const $f50bd1f2915ed0f2$var$controlGetActiveTableFuncType = function(currentTable) {
    let fnActive;
    const funcType = {
        sort: false,
        filter: false
    };
    const tableFunc = $f50bd1f2915ed0f2$var$controlGetPersistedTableFunc(currentTable.id);
    if (tableFunc) {
        const fnTypes = Object.keys(tableFunc);
        fnTypes.forEach((type)=>{
            const fn = tableFunc[type];
            const fnProps = Object.keys(fn).map((fnKey)=>fn[fnKey] ? true : false);
            fnActive = fnProps.find((prop)=>prop === true) ? true : false;
            if (fnActive) funcType[type] = true;
        });
        return funcType;
    }
    return false;
};
const $f50bd1f2915ed0f2$var$controlSetCurrentTable = function(currentTable, tableToDisplayId) {
    if (!tableToDisplayId) {
        $0f1d4402dffacf5b$export$8d21f17684deada9(currentTable);
        const table = $0f1d4402dffacf5b$export$a8d54db9d8ae6ee7(currentTable);
        const activeFuncTypes = $f50bd1f2915ed0f2$var$controlGetActiveTableFuncType(table);
        if (!activeFuncTypes) $f50bd1f2915ed0f2$var$tableComponentView.renderTableItem(table.tableItems, null, null, true, null);
        if (activeFuncTypes) $f50bd1f2915ed0f2$var$tableComponentView.renderTableItem(table.tableItems, null, null, true, activeFuncTypes);
    }
    //render to display currentTable
    if (tableToDisplayId) $f50bd1f2915ed0f2$var$controlRenderUpdatedTableHeads(tableToDisplayId);
};
const $f50bd1f2915ed0f2$var$controlPersistTableFunc = function(fnProps, fnType) {
    const tableId = fnProps.tableId;
    const tableFnExists = $0f1d4402dffacf5b$export$72cf72d213e5d45[tableId] ?? null;
    if (!tableFnExists) (0, $bd02c871d9c5ba8e$export$782f00d935ef8172)(tableId, $0f1d4402dffacf5b$export$72cf72d213e5d45);
    $0f1d4402dffacf5b$export$72cf72d213e5d45[tableId][fnType] = fnProps;
    $0f1d4402dffacf5b$export$91159f5f50f54fc1();
    const apiPayload = {
        journal_table_func: $0f1d4402dffacf5b$export$72cf72d213e5d45
    };
    const queryObj = {
        endpoint: (0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.JOURNAL.PATCH($0f1d4402dffacf5b$export$ca000e230c0caa3e.id),
        token: $0f1d4402dffacf5b$export$9e1725a4cfeada27.value,
        sec: null,
        queryData: apiPayload,
        actionType: "updateJournal",
        spinner: false,
        alert: false,
        type: "PATCH"
    };
    (0, $db1f432b457e32b4$export$2c4e825dc9120f87).queryAPI(queryObj);
};
const $f50bd1f2915ed0f2$var$controlGetPersistedTableFunc = function(tableId) {
    return $0f1d4402dffacf5b$export$72cf72d213e5d45[tableId] ?? false;
};
const $f50bd1f2915ed0f2$var$controlRemovePersistedTableFunc = function(fnType) {
    const currentTable = $0f1d4402dffacf5b$export$a8d54db9d8ae6ee7();
    $0f1d4402dffacf5b$export$72cf72d213e5d45[currentTable.id][fnType] = {};
    $0f1d4402dffacf5b$export$91159f5f50f54fc1();
    const apiPayload = {
        journal_table_func: $0f1d4402dffacf5b$export$72cf72d213e5d45
    };
    const queryObj = {
        endpoint: (0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.JOURNAL.PATCH($0f1d4402dffacf5b$export$ca000e230c0caa3e.id),
        token: $0f1d4402dffacf5b$export$9e1725a4cfeada27.value,
        sec: null,
        queryData: apiPayload,
        actionType: "updateJournal",
        spinner: false,
        alert: false,
        type: "PATCH"
    };
    (0, $db1f432b457e32b4$export$2c4e825dc9120f87).queryAPI(queryObj);
};
const $f50bd1f2915ed0f2$var$controlGetTable = function(tableId) {
    return $0f1d4402dffacf5b$export$a8d54db9d8ae6ee7(tableId);
};
const $f50bd1f2915ed0f2$var$controlAddTable = function() {
    //add the initial tags from the model
    $f50bd1f2915ed0f2$var$tableComponentView.addTableTagMetaData($0f1d4402dffacf5b$export$ca000e230c0caa3e.tags, $0f1d4402dffacf5b$export$ca000e230c0caa3e.tagsColor);
};
const $f50bd1f2915ed0f2$var$controlRenameOptionFallback = function(renameParam, returnData, requestStatus) {
    //NOTE: Sync missing
    if (requestStatus) {
        $0f1d4402dffacf5b$export$fb2abcfc348c747(...[
            renameParam.payload.table_name,
            renameParam.payload.journal
        ]);
        //update the table UI
        renameParam.callBack();
    }
};
const $f50bd1f2915ed0f2$var$controlRenameOption = function(tableName, journalId, callBack) {
    const apiPayload = {
        table_name: tableName,
        journal: journalId
    };
    const queryObj = {
        endpoint: (0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.JOURNAL_TABLES.PATCH(apiPayload.journal),
        token: $0f1d4402dffacf5b$export$9e1725a4cfeada27.value,
        sec: null,
        queryData: apiPayload,
        actionType: "updateTableName",
        spinner: false,
        alert: true,
        successAlert: false,
        type: "PATCH",
        callBack: $f50bd1f2915ed0f2$var$controlRenameOptionFallback.bind(null, {
            payload: apiPayload,
            callBack: callBack
        }),
        callBackParam: true
    };
    (0, $db1f432b457e32b4$export$2c4e825dc9120f87).queryAPI(queryObj);
};
const $f50bd1f2915ed0f2$var$controlAPIDuplicateTableFallback = function(payload, returnData, requestStatus) {
    // NOTE: Sync missing
    if (requestStatus) {
        const formattedData = (0, $bd02c871d9c5ba8e$export$8c27844e107da08)(returnData, "journalTables");
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.tables.push(formattedData);
        $f50bd1f2915ed0f2$var$controlRenderUpdatedTableHeads(returnData.id);
    }
    payload = {};
};
const $f50bd1f2915ed0f2$var$controlDuplicateOption = function(tableId) {
    const apiPayload = {
        journal_table: tableId,
        journal: $0f1d4402dffacf5b$export$ca000e230c0caa3e.id,
        duplicate: true
    };
    const queryObj = {
        endpoint: (0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.JOURNAL_TABLES.CREATE,
        token: $0f1d4402dffacf5b$export$9e1725a4cfeada27.value,
        sec: null,
        queryData: apiPayload,
        actionType: "duplicateTable",
        spinner: true,
        alert: true,
        successAlert: false,
        type: "POST",
        callBack: $f50bd1f2915ed0f2$var$controlAPIDuplicateTableFallback.bind(null, {
            payload: apiPayload
        }),
        callBackParam: true
    };
    (0, $db1f432b457e32b4$export$2c4e825dc9120f87).queryAPI(queryObj);
};
const $f50bd1f2915ed0f2$var$controlAPIDeleteTableFallback = function(tableId, returnData, requestStatus) {
    //NOTE: Sync missing
    if (requestStatus) {
        $0f1d4402dffacf5b$export$ee0f503fde5c3c2d(tableId);
        const tableHeads = $f50bd1f2915ed0f2$var$controlGetTableHeads();
        $f50bd1f2915ed0f2$var$controlRenderUpdatedTableHeads(tableHeads[0][1]);
        //update the tableFunc
        delete $0f1d4402dffacf5b$export$72cf72d213e5d45[tableId];
        $0f1d4402dffacf5b$export$91159f5f50f54fc1();
        const apiPayload = {
            journal_table_func: $0f1d4402dffacf5b$export$72cf72d213e5d45
        };
        const queryObj = {
            endpoint: (0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.JOURNAL.PATCH($0f1d4402dffacf5b$export$ca000e230c0caa3e.id),
            token: $0f1d4402dffacf5b$export$9e1725a4cfeada27.value,
            sec: null,
            queryData: apiPayload,
            actionType: "updateJournal",
            spinner: false,
            alert: false,
            type: "PATCH"
        };
        (0, $db1f432b457e32b4$export$2c4e825dc9120f87).queryAPI(queryObj);
    }
};
const $f50bd1f2915ed0f2$var$controlDeleteOption = function(journalId) {
    const queryObj = {
        endpoint: (0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.JOURNAL_TABLES.DELETE(journalId),
        token: $0f1d4402dffacf5b$export$9e1725a4cfeada27.value,
        sec: null,
        actionType: "deleteTable",
        spinner: false,
        alert: true,
        successAlert: false,
        type: "DELETE",
        callBack: $f50bd1f2915ed0f2$var$controlAPIDeleteTableFallback.bind(null, journalId),
        callBackParam: true
    };
    (0, $db1f432b457e32b4$export$2c4e825dc9120f87).queryAPI(queryObj);
};
const $f50bd1f2915ed0f2$var$controlAPIAddNewTableFallback = function(callBack, returnData, requestState) {
    let tableId;
    //NOTE: Sync missing
    if (requestState) {
        const formattedData = (0, $bd02c871d9c5ba8e$export$8c27844e107da08)(returnData, "journalTables");
        tableId = formattedData.id;
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.tables.push(formattedData);
        const tableHeads = $f50bd1f2915ed0f2$var$controlGetTableHeads();
        if (callBack) callBack();
        if (tableHeads.length <= 4) {
            const table = $0f1d4402dffacf5b$export$a8d54db9d8ae6ee7(tableId);
            $f50bd1f2915ed0f2$var$tableComponentView.render(tableHeads);
            $f50bd1f2915ed0f2$var$tableComponentView.renderTableItem(table.tableItems);
        }
        if (tableHeads.length > 4) $f50bd1f2915ed0f2$var$controlRenderUpdatedTableHeads(tableId);
    }
};
const $f50bd1f2915ed0f2$var$controlAddNewTable = function(callBack) {
    const apiPayload = {
        journal: $0f1d4402dffacf5b$export$ca000e230c0caa3e.id
    };
    const queryObj = {
        endpoint: (0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.JOURNAL_TABLES.CREATE,
        token: $0f1d4402dffacf5b$export$9e1725a4cfeada27.value,
        sec: null,
        queryData: apiPayload,
        actionType: "createNewTable",
        spinner: false,
        alert: true,
        successAlert: false,
        type: "POST",
        callBack: $f50bd1f2915ed0f2$var$controlAPIAddNewTableFallback.bind(null, callBack)
    };
    (0, $db1f432b457e32b4$export$2c4e825dc9120f87).queryAPI(queryObj);
};
const $f50bd1f2915ed0f2$var$filterSortRenderTableItem = function(addTableItemParam, renderAddedItem = false, renderUpdatedItem = false) {
    //currentTable, filter, sort, itemId) {
    let tableItems;
    //returns the filtered tableItems using the filterMethod from the Component or returns all the tableItems for the current Table
    addTableItemParam.filter ? tableItems = addTableItemParam.filter(addTableItemParam.currentTable.tableItems) : tableItems = addTableItemParam.currentTable.tableItems;
    addTableItemParam.sort ? addTableItemParam.sort(tableItems) : $f50bd1f2915ed0f2$var$pass();
    if (tableItems && !Array.isArray(tableItems)) tableItems = [
        tableItems
    ];
    if (renderAddedItem) $f50bd1f2915ed0f2$var$tableComponentView.updateTableItem(addTableItemParam.currentTable, tableItems, addTableItemParam.itemId, addTableItemParam.callBack);
    if (renderUpdatedItem) $f50bd1f2915ed0f2$var$tableComponentView.renderTableItem(tableItems, addTableItemParam.filter);
    //free mem
    addTableItemParam = {};
};
const $f50bd1f2915ed0f2$var$controlAddTableItemFallback = function(addTableItemParam, returnData, requestStatus = false) {
    const currentTable = $0f1d4402dffacf5b$export$a8d54db9d8ae6ee7();
    //NOTE:SYNC missing
    if (requestStatus) {
        const formattedAPIResp = (0, $bd02c871d9c5ba8e$export$224e4749c4a088cf)([
            returnData
        ]);
        const itemId = $0f1d4402dffacf5b$export$7ab2b02c37be05a8(...formattedAPIResp, addTableItemParam.relativeItem, true);
        addTableItemParam.currentTable = currentTable;
        addTableItemParam.itemId = itemId;
        //filter,sort and render the table items
        $f50bd1f2915ed0f2$var$filterSortRenderTableItem(addTableItemParam, true);
    }
};
const $f50bd1f2915ed0f2$var$controlAPIAddTagFallback = function(addTagParams, returnData, requestState = false) {
    if (requestState) {
        const formattedData = (0, $bd02c871d9c5ba8e$export$a9405bec26d98673)(Array.isArray(returnData) ? returnData : [
            returnData
        ], "apiTags");
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.tags.push(...formattedData);
        //update the tagObj id with the id from the api created tag
        addTagParams.callBack(formattedData[0].id);
    }
//NOTE: Sync missing
};
const $f50bd1f2915ed0f2$var$controlAddTag = function(payload, callBack) {
    const queryObj = {
        endpoint: (0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.TAG.CREATE,
        token: $0f1d4402dffacf5b$export$9e1725a4cfeada27.value,
        sec: null,
        queryData: payload,
        actionType: "createTag",
        spinner: false,
        alert: true,
        successAlert: false,
        type: "POST",
        callBack: $f50bd1f2915ed0f2$var$controlAPIAddTagFallback.bind(null, {
            callBack: callBack,
            payload: payload
        })
    };
    (0, $db1f432b457e32b4$export$2c4e825dc9120f87).queryAPI(queryObj);
};
/**
 *
 * @param {*Object} payload - To add new Item to the curreentTable
 * @param {*Number } relativeItem  - If this controller is called from the Hover itemAdd create, it positions the createdItem relative to the Hovered Item
 * @param {*function} filter - The filter component uses this to filter  the rendered result for the table when the filter is Active
 */ const $f50bd1f2915ed0f2$var$controlAddTableItem = function(payload, relativeItem, filter = false, sort = false, callBack = false) {
    const currentTableBeforeUpdate = $0f1d4402dffacf5b$export$a8d54db9d8ae6ee7();
    const apiPayload = (0, $bd02c871d9c5ba8e$export$4b9b5189b0a2dc1f)(currentTableBeforeUpdate, relativeItem);
    const queryObj = {
        endpoint: (0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.ACTIVITIES.CREATE,
        token: $0f1d4402dffacf5b$export$9e1725a4cfeada27.value,
        sec: null,
        queryData: apiPayload,
        actionType: "createTableItem",
        spinner: false,
        alert: true,
        successAlert: false,
        type: "POST",
        callBack: $f50bd1f2915ed0f2$var$controlAddTableItemFallback.bind(null, {
            payload: payload,
            relativeItem: relativeItem,
            filter: filter,
            sort: sort,
            callBack: callBack
        }),
        callBackParam: true
    };
    (0, $db1f432b457e32b4$export$2c4e825dc9120f87).queryAPI(queryObj);
};
const $f50bd1f2915ed0f2$var$controlGetTableItem = function(tableId, itemId, position, tableLength) {
    const table = $0f1d4402dffacf5b$export$a8d54db9d8ae6ee7(tableId);
    const tableItem = $0f1d4402dffacf5b$export$b3980c840b43297a(table, itemId, position, tableLength);
    //returns an obj if position is supplied
    return tableItem;
};
const $f50bd1f2915ed0f2$var$controlGetTableItemWithMaxTags = function(tableId, itemsId) {
    const table = $0f1d4402dffacf5b$export$a8d54db9d8ae6ee7(tableId);
    const tableItemWithMaxTags = $0f1d4402dffacf5b$export$1d31bd7424f68508(table, itemsId);
    return tableItemWithMaxTags;
};
const $f50bd1f2915ed0f2$var$controlUpdateTableItemFallback = function(addTableItemParam, returnData, requestStatus = false) {
    const currentTable = $0f1d4402dffacf5b$export$a8d54db9d8ae6ee7();
    const batchItems = [
        "selectTags",
        "deleteActivities"
    ];
    //NOTE: Sync missing
    if (requestStatus) {
        const formattedData = (0, $bd02c871d9c5ba8e$export$224e4749c4a088cf)(Array.isArray(returnData) ? returnData : [
            returnData
        ]);
        const batchTypes = addTableItemParam.payloadType === batchItems.find((item)=>item === addTableItemParam.payloadType);
        if (!batchTypes) $0f1d4402dffacf5b$export$97a438877dd4f86f(formattedData[0], true, currentTable.id);
        if (batchTypes) formattedData.forEach((data)=>$0f1d4402dffacf5b$export$7e6499f51ff337f6(data));
    }
    if (requestStatus || addTableItemParam.payloadType === "selectTags") {
        //callback for the sidepeekinput
        if (addTableItemParam.payload.refreshCallBack) addTableItemParam.payload.getUpdatedData ? addTableItemParam.payload.refreshCallBack($f50bd1f2915ed0f2$var$controlGetTableItem(addTableItemParam.payload.tableId, addTableItemParam.payload.itemId)) : addTableItemParam.payload.refreshCallBack();
        addTableItemParam.currentTable = currentTable;
        $f50bd1f2915ed0f2$var$filterSortRenderTableItem(addTableItemParam, null, addTableItemParam.updateUI ? true : null);
    }
    //free mem
    addTableItemParam = {};
};
const $f50bd1f2915ed0f2$var$controlUpdateTableItem = function(payload, filter, sort = false, payloadType, updateUI = true) {
    let tableItems;
    if (!payload) return;
    let apiPayload = (0, $bd02c871d9c5ba8e$export$484d39074d488c85)(payload, payloadType);
    if (payloadType === "tags") apiPayload = {
        tags: apiPayload
    };
    (0, $bd02c871d9c5ba8e$export$a7d3715ebfc4ab5b)(apiPayload, payload, $0f1d4402dffacf5b$export$ca000e230c0caa3e, payloadType);
    const batchTypes = [
        "selectTags"
    ];
    const batchAction = payloadType === batchTypes.find((type)=>type === payloadType);
    let queryObj;
    const submodels = [
        "intentions",
        "happenings",
        "actionItems",
        "gratefulFor"
    ];
    const submodelType = submodels.find((submodel)=>submodel.toLowerCase() === payloadType.toLowerCase());
    if (batchAction) queryObj = {
        endpoint: (0, $db1f432b457e32b4$export$2c4e825dc9120f87).getBatchEndpoint(payloadType),
        token: $0f1d4402dffacf5b$export$9e1725a4cfeada27.value,
        sec: null,
        queryData: apiPayload,
        actionType: "batchAddTags",
        spinner: false,
        alert: true,
        successAlert: false,
        type: "PATCH",
        callBack: $f50bd1f2915ed0f2$var$controlUpdateTableItemFallback.bind(null, {
            payload: payload,
            filter: filter,
            sort: sort,
            updateUI: updateUI,
            payloadType: payloadType
        }),
        callBackParam: true
    };
    if (!batchAction) queryObj = {
        endpoint: (0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.ACTIVITIES.PATCH(payload.itemId),
        token: $0f1d4402dffacf5b$export$9e1725a4cfeada27.value,
        sec: null,
        queryData: apiPayload,
        actionType: "updateTableItem",
        spinner: false,
        alert: true,
        successAlert: false,
        type: "PATCH",
        callBack: $f50bd1f2915ed0f2$var$controlUpdateTableItemFallback.bind(null, {
            payload: payload,
            filter: filter,
            sort: sort,
            updateUI: updateUI,
            payloadType: payloadType
        }),
        callBackParam: true
    };
    (0, $db1f432b457e32b4$export$2c4e825dc9120f87).queryAPI(queryObj);
};
const $f50bd1f2915ed0f2$var$controlUpdateTagFallback = function(updateTagParam, returnData, requestStatus) {
    //NOTE: sync missing
    if (requestStatus) {
        //val updated from thee tagEdit comp
        const formattedData = (0, $bd02c871d9c5ba8e$export$8c27844e107da08)(returnData, "tags");
        $0f1d4402dffacf5b$export$897cf354c93223ff(formattedData);
        //update the tag option UI
        updateTagParam.callBack();
    }
    updateTagParam = {};
};
const $f50bd1f2915ed0f2$var$controlUpdateTag = function(payload, payloadType, callBack) {
    const apiPayload = (0, $bd02c871d9c5ba8e$export$7e2f5a5c02c1c762)(payload, payloadType);
    const queryObj = {
        endpoint: (0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.TAG.PATCH(payload.tag.id),
        token: $0f1d4402dffacf5b$export$9e1725a4cfeada27.value,
        sec: null,
        queryData: apiPayload,
        actionType: "updateTag",
        spinner: false,
        alert: true,
        successAlert: false,
        type: "PATCH",
        callBack: $f50bd1f2915ed0f2$var$controlUpdateTagFallback.bind(null, {
            payload: payload.tag,
            callBack: callBack
        })
    };
    (0, $db1f432b457e32b4$export$2c4e825dc9120f87).queryAPI(queryObj);
};
const $f50bd1f2915ed0f2$var$controlAPIDeleteTagFallback = function(deleteTagParam, returnData, requestStatus) {
    //NOTE: Sync missing
    if (requestStatus) {
        $0f1d4402dffacf5b$export$2895d72886bc0b68(deleteTagParam.tagId);
        deleteTagParam.callBack();
    }
    deleteTagParam = {};
};
const $f50bd1f2915ed0f2$var$controlDeleteTag = function(tagId, callBack) {
    const queryObj = {
        endpoint: (0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.TAG.DELETE(tagId),
        token: $0f1d4402dffacf5b$export$9e1725a4cfeada27.value,
        sec: null,
        actionType: "deleteTag",
        spinner: false,
        alert: true,
        successAlert: false,
        type: "DELETE",
        callBack: $f50bd1f2915ed0f2$var$controlAPIDeleteTagFallback.bind(null, {
            tagId: tagId,
            callBack: callBack
        })
    };
    (0, $db1f432b457e32b4$export$2c4e825dc9120f87).queryAPI(queryObj);
};
const $f50bd1f2915ed0f2$var$controlDeleteTableItemFallback = function(deleteTableItemParam, returnData, requestStatus = false) {
    let tableItems;
    const currentTable = $0f1d4402dffacf5b$export$a8d54db9d8ae6ee7();
    //NOTE: Sync missing
    if (requestStatus) $0f1d4402dffacf5b$export$88107ff569e983a5(deleteTableItemParam.payload);
    deleteTableItemParam.filter ? tableItems = deleteTableItemParam.filter(currentTable.tableItems) : tableItems = currentTable.tableItems;
    if (tableItems && !Array.isArray(tableItems)) tableItems = [
        tableItems
    ];
    //render current table
    deleteTableItemParam.updateUI ? $f50bd1f2915ed0f2$var$tableComponentView.renderTableItem(tableItems) : $f50bd1f2915ed0f2$var$pass();
    //free mem
    deleteTableItemParam = {};
};
const $f50bd1f2915ed0f2$var$controlDeleteTableItem = function(payload, filter, payloadType, updateUI = true) {
    let tableItems;
    if (!payload) return;
    const batchType = [
        "deleteTableItems"
    ];
    const apiPayload = (0, $bd02c871d9c5ba8e$export$484d39074d488c85)(payload, payloadType);
    //API.getSubmodelEndpoint(payloadType, "DELETE", apiPayload[payloadType].delete.id)
    const queryObj = {
        endpoint: payloadType === "deleteTableItems" ? (0, $db1f432b457e32b4$export$2c4e825dc9120f87).getBatchEndpoint(payloadType) : (0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.SUBMODEL.DELETE(payloadType, apiPayload[payloadType].delete.id),
        token: $0f1d4402dffacf5b$export$9e1725a4cfeada27.value,
        sec: null,
        actionType: "deleteTableItem",
        spinner: false,
        alert: true,
        successAlert: false,
        type: "DELETE",
        callBack: $f50bd1f2915ed0f2$var$controlDeleteTableItemFallback.bind(null, {
            payload: payload,
            filter: filter,
            payloadType: payloadType,
            updateUI: updateUI
        }),
        callBackParam: true
    };
    if (payloadType === "deleteTableItems") queryObj["queryData"] = apiPayload;
    (0, $db1f432b457e32b4$export$2c4e825dc9120f87).queryAPI(queryObj);
};
const $f50bd1f2915ed0f2$var$controlDuplicateTableItemFallback = function(duplicateTableItemParam, returnData, requestStatus = false) {
    const currentTable = $0f1d4402dffacf5b$export$a8d54db9d8ae6ee7();
    duplicateTableItemParam.currentTable = currentTable;
    //NOTE: Sync missing
    if (requestStatus) {
        const formattedData = (0, $bd02c871d9c5ba8e$export$224e4749c4a088cf)(Array.isArray(returnData) ? returnData : [
            returnData
        ]);
        currentTable.tableItems.push(...formattedData);
    }
    $f50bd1f2915ed0f2$var$filterSortRenderTableItem(duplicateTableItemParam, null, duplicateTableItemParam.updateUI ? true : null);
    //free mem
    duplicateTableItemParam = {};
};
const $f50bd1f2915ed0f2$var$controlDuplicateTableItem = function(payload, filter, sort, updateUI = true) {
    const apiPayload = (0, $bd02c871d9c5ba8e$export$484d39074d488c85)(payload, "duplicateTableItems");
    const queryObj = {
        endpoint: (0, $db1f432b457e32b4$export$2c4e825dc9120f87).APIEnum.ACTIVITIES.BATCH_DUPLICATE_ACTIVITIES,
        token: $0f1d4402dffacf5b$export$9e1725a4cfeada27.value,
        sec: null,
        queryData: apiPayload,
        actionType: "duplicateTableItems",
        spinner: true,
        alert: true,
        successAlert: false,
        type: "POST",
        callBack: $f50bd1f2915ed0f2$var$controlDuplicateTableItemFallback.bind(null, {
            apiPayload: apiPayload,
            filter: filter,
            sort: sort,
            updateUI: updateUI
        }),
        callBackParam: true
    };
    (0, $db1f432b457e32b4$export$2c4e825dc9120f87).queryAPI(queryObj);
};
const $f50bd1f2915ed0f2$var$controlLogin = function(loginComponentCallBack, token) {
    const loader = new (0, $6d26a31173b096a8$export$3b0d6d7590275603)((0, $ba30e20475feac5a$export$70e52e314dd3934f));
    loader.component();
    //set model token
    $0f1d4402dffacf5b$export$9e1725a4cfeada27.value = token;
    $0f1d4402dffacf5b$export$89dfc02f4e66af51();
    //remove auth components
    loginComponentCallBack();
    //switch template
    $f50bd1f2915ed0f2$var$init();
    loader.remove();
};
const $f50bd1f2915ed0f2$var$controlAddTemplate = function(templateType) {
    if (templateType === "login") {
        document.body.classList.remove("journal-template");
        document.body.classList.add("login-template");
        document.body.innerHTML = (0, $69ae69596111f54f$export$54c8ec317c198e64).template();
        // LoginTemplate.templateStyling();
        (0, $c44b042802bfa45d$export$2e2bcd8739ae039).addEventListeners($f50bd1f2915ed0f2$var$controlLogin);
    }
    if (templateType === "journal") {
        document.body.innerHTML = "";
        document.body.classList.remove("login-template");
        document.body.classList.add("journal-template");
        document.body.innerHTML = (0, $a260c124cbafa3c3$export$c6dda8e9cdb07ecc).template();
        (0, $a260c124cbafa3c3$export$c6dda8e9cdb07ecc).templateStyling();
    }
};
const $f50bd1f2915ed0f2$var$controlLoadUI = function() {
    const infoControllers = {
        controlGetJournalNameAndUsername: $f50bd1f2915ed0f2$var$controlGetJournalNameAndUsername,
        controlUpdateJournalInfo: $f50bd1f2915ed0f2$var$controlUpdateJournalInfo
    };
    const tableControllers = {
        controlAddNewTable: $f50bd1f2915ed0f2$var$controlAddNewTable,
        controlGetTableHeads: $f50bd1f2915ed0f2$var$controlGetTableHeads,
        controlGetTable: $f50bd1f2915ed0f2$var$controlGetTable,
        controlGetJournalNameAndUsername: $f50bd1f2915ed0f2$var$controlGetJournalNameAndUsername,
        controlSetCurrentTable: $f50bd1f2915ed0f2$var$controlSetCurrentTable,
        controlPersistTableFunc: $f50bd1f2915ed0f2$var$controlPersistTableFunc,
        controlGetPersistedTableFunc: $f50bd1f2915ed0f2$var$controlGetPersistedTableFunc,
        controlRemovePersistedTableFunc: $f50bd1f2915ed0f2$var$controlRemovePersistedTableFunc
    };
    const tableItemControllers = {
        controlAddTableItem: $f50bd1f2915ed0f2$var$controlAddTableItem,
        controlDeleteTableItem: $f50bd1f2915ed0f2$var$controlDeleteTableItem,
        controlUpdateTableItem: $f50bd1f2915ed0f2$var$controlUpdateTableItem,
        controlGetTableItem: $f50bd1f2915ed0f2$var$controlGetTableItem,
        controlGetTableItemWithMaxTags: $f50bd1f2915ed0f2$var$controlGetTableItemWithMaxTags,
        controlDuplicateTableItem: $f50bd1f2915ed0f2$var$controlDuplicateTableItem,
        controlAddTag: $f50bd1f2915ed0f2$var$controlAddTag,
        controlDeleteTag: $f50bd1f2915ed0f2$var$controlDeleteTag,
        controlUpdateTag: $f50bd1f2915ed0f2$var$controlUpdateTag
    };
    const optionControllers = {
        controlRenameOption: $f50bd1f2915ed0f2$var$controlRenameOption,
        controlDuplicateOption: $f50bd1f2915ed0f2$var$controlDuplicateOption,
        controlDeleteOption: $f50bd1f2915ed0f2$var$controlDeleteOption
    };
    const componentControllers = {
        tableControllers: tableControllers,
        tableItemControllers: tableItemControllers,
        optionControllers: optionControllers
    };
    const [tableHeads, currentTable] = [
        $f50bd1f2915ed0f2$var$controlGetTableHeads(),
        $0f1d4402dffacf5b$export$a8d54db9d8ae6ee7()
    ];
    //create module objects
    (0, $c8032ca158e0e46f$export$4f3b7488aad41e57).object = (0, $c8032ca158e0e46f$export$4f3b7488aad41e57).import();
    $f50bd1f2915ed0f2$var$contentContainerListener = (0, $b2b83d5c51b10d56$export$72b89280ca08eaee).object = (0, $b2b83d5c51b10d56$export$72b89280ca08eaee).import();
    $f50bd1f2915ed0f2$var$journalInfoComponentView = (0, $cc3231bfb767bcb8$export$5fbf02ecfc8f146).object = (0, $cc3231bfb767bcb8$export$5fbf02ecfc8f146).import();
    //init the componentOptionsView
    (0, $d2866451d1c7a9c0$export$721ff339e60fcc47).object = (0, $d2866451d1c7a9c0$export$721ff339e60fcc47).import();
    $f50bd1f2915ed0f2$var$sidebarComponentView = (0, $5f1bb3a11090bdeb$export$4b8b7519249bbbe8).object = (0, $5f1bb3a11090bdeb$export$4b8b7519249bbbe8).import();
    $f50bd1f2915ed0f2$var$tableComponentView = (0, $2d49e726836fb57f$export$6db5d748e242c31).object = (0, $2d49e726836fb57f$export$6db5d748e242c31).import();
    $f50bd1f2915ed0f2$var$contentContainerListener.init($f50bd1f2915ed0f2$var$journalInfoComponentView, $f50bd1f2915ed0f2$var$tableComponentView);
    // contentContainerListener.activateListener();
    $f50bd1f2915ed0f2$var$sidebarComponentView.init($f50bd1f2915ed0f2$var$controlAddSideBar, $0f1d4402dffacf5b$export$9e1725a4cfeada27.value);
    $f50bd1f2915ed0f2$var$journalInfoComponentView.init($f50bd1f2915ed0f2$var$controlAddJournalInfo);
    $f50bd1f2915ed0f2$var$tableComponentView.init($f50bd1f2915ed0f2$var$controlAddTable, $f50bd1f2915ed0f2$var$controlSetCurrentTable, tableHeads, currentTable);
    $f50bd1f2915ed0f2$var$sidebarComponentView.addComponentHandlers(componentControllers);
    $f50bd1f2915ed0f2$var$journalInfoComponentView.addComponentHandlers(infoControllers);
    $f50bd1f2915ed0f2$var$tableComponentView.addComponentHandlers(componentControllers);
    //get and apply currentTable tableFunc
    const persistedFunc = $f50bd1f2915ed0f2$var$controlGetActiveTableFuncType(currentTable);
    $f50bd1f2915ed0f2$var$tableComponentView.addActiveTableFunc(persistedFunc);
    //componentGlobalState inherits all controller methods all components have
    (0, $97dbb4b1f2916e69$export$a1546ac3b9a8c061).eventHandlers = {
        infoControllers: infoControllers,
        tableControllers: tableControllers,
        tableItemControllers: tableItemControllers,
        optionControllers: optionControllers,
        componentControllers: componentControllers
    };
};
const $f50bd1f2915ed0f2$var$init = function(loadTemplate = true) {
    $0f1d4402dffacf5b$export$1718d02e8422300d();
    if ($0f1d4402dffacf5b$export$9e1725a4cfeada27.value) {
        if (loadTemplate) {
            $f50bd1f2915ed0f2$var$controlAddTemplate("journal");
            $0f1d4402dffacf5b$export$2cd8252107eb640b($f50bd1f2915ed0f2$var$init);
        }
        if (!loadTemplate) $f50bd1f2915ed0f2$var$controlLoadUI();
    }
    if (!$0f1d4402dffacf5b$export$9e1725a4cfeada27.value) $f50bd1f2915ed0f2$var$controlAddTemplate("login");
};
$f50bd1f2915ed0f2$var$init();


//# sourceMappingURL=index.5529fd78.js.map
